<template>
    <div id="ctWrap" >
        <div class="popup-out" v-if="popupShow">
            <div class="popup-top">
                <img src="/img/popup/popup-referral-king-20220427.jpg">
            </div>
            <div class="popup-bottom">
                <a href="#" @click="closeToday">Don't show again today</a>
                <a href="#" @click="closePopup">Close</a>
            </div>
        </div>
        <div class="top-txt">
            <h1 class="h1_color">RIPPLE INVESTMENT RIGHT AWAY!</h1>
            Maximizing returns and minimizing risks with Smart<br/>
            Contract driven Ripple Investment Platform, powered by Ripple.
        </div>
        <div class="visual-zone">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 1100 870" style="enable-background:new 0 0 1100 870;" xml:space="preserve">
		<g id="box">
	<g id="Illustration_00000117671861459991373910000010115363824688646535_">
		<defs>
			<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="12.6" y="132" width="1073.4" height="1034.3">
				<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
			</filter>
		</defs>

        <mask maskUnits="userSpaceOnUse" x="12.6" y="132" width="1073.4" height="1034.3" id="blockchain_00000041977787574089627330000005119195968121597627_">
			<g class="st0">
				<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-83.24" y1="491.7576" x2="1195.0322" y2="491.7576">
					<stop  offset="3.448280e-02" style="stop-color:#000000"/>
                    <stop  offset="0.1396" style="stop-color:#333333"/>
                    <stop  offset="0.2645" style="stop-color:#686868"/>
                    <stop  offset="0.391" style="stop-color:#979797"/>
                    <stop  offset="0.5165" style="stop-color:#BCBCBC"/>
                    <stop  offset="0.6408" style="stop-color:#D9D9D9"/>
                    <stop  offset="0.7636" style="stop-color:#EEEEEE"/>
                    <stop  offset="0.8842" style="stop-color:#FBFBFB"/>
                    <stop  offset="1" style="stop-color:#FFFFFF"/>
				</linearGradient>
                <rect x="-83.2" y="78" class="st1" width="1278.3" height="827.5"/>
			</g>
		</mask>

        <g id="blockchain_00000090985462102965355640000018310983661638638233_" style="mask:url(#blockchain_00000041977787574089627330000005119195968121597627_);">
			<g>
				<g class="st3">
					<g>

							<rect x="648.3" y="224.9" transform="matrix(0.1576 -0.9875 0.9875 0.1576 217.05 923.0339)" class="st4" width="2.5" height="218.8"/>

                        <rect x="687.3" y="437.7" transform="matrix(0.855 -0.5186 0.5186 0.855 -120.3428 447.4067)" class="st4" width="105.4" height="2.5"/>

                        <rect x="477.7" y="358.8" transform="matrix(0.9163 -0.4005 0.4005 0.9163 -119.6012 225.204)" class="st4" width="2.5" height="79.8"/>

                        <rect x="188.6" y="390.2" transform="matrix(0.8607 -0.5091 0.5091 0.8607 -160.3238 197.0168)" class="st4" width="182.4" height="2.5"/>

                        <rect x="291" y="442.8" transform="matrix(0.1636 -0.9865 0.9865 0.1636 -257.5249 713.8577)" class="st4" width="2.5" height="132"/>

                        <rect x="178.3" y="536.5" transform="matrix(0.9126 -0.4087 0.4087 0.9126 -231.7428 126.2509)" class="st4" width="2.5" height="137.7"/>
                        <polygon class="st4" points="314.9,686.7 313.6,684.6 408.8,626.4 410.1,628.5 						"/>

                        <rect x="449" y="652" transform="matrix(0.1581 -0.9874 0.9874 0.1581 -373.0133 1085.7804)" class="st4" width="2.5" height="219.2"/>

                        <rect x="616.8" y="655.5" transform="matrix(0.9068 -0.4215 0.4215 0.9068 -236.1069 325.4644)" class="st4" width="2.5" height="82.4"/>

                        <rect x="728.4" y="703.9" transform="matrix(0.8602 -0.51 0.51 0.8602 -244.8711 517.1832)" class="st4" width="184.5" height="2.5"/>

                        <rect x="805.1" y="521.2" transform="matrix(0.166 -0.9861 0.9861 0.166 93.5361 1284.8956)" class="st4" width="2.5" height="131.9"/>

                        <rect x="917.4" y="422.7" transform="matrix(0.9128 -0.4085 0.4085 0.9128 -120.5481 418.1252)" class="st4" width="2.5" height="137.2"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000039111328744369020500000004983008927013685893_" gradientUnits="userSpaceOnUse" x1="532.0182" y1="655.2607" x2="565.943" y2="441.0687">
							<stop  offset="0.3333" style="stop-color:#85E9FF"/>
                                <stop  offset="0.4105" style="stop-color:#80E4FC"/>
                                <stop  offset="0.5007" style="stop-color:#73D6F5"/>
                                <stop  offset="0.5975" style="stop-color:#5CBEE8"/>
                                <stop  offset="0.699" style="stop-color:#3D9ED6"/>
                                <stop  offset="0.8032" style="stop-color:#1574C0"/>
                                <stop  offset="0.8314" style="stop-color:#0967B9"/>
                                <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000039111328744369020500000004983008927013685893_);" d="M696.2,461.7l-198-30.6
							c-2.3-0.4-4.6,0.1-6.6,1.2l-139.4,80.5c-3.8,2.2-5.3,6.9-3.5,10.9l48.9,105.4c1.5,3.3,4.6,5.6,8.2,6.2l193.8,30
							c2.8,0.4,5.6-0.1,8-1.5L745,584.5c4.6-2.7,6.5-8.4,4.2-13.3l-49.6-107C698.9,462.9,697.6,461.9,696.2,461.7z M595.4,656.1
							l-177.9-27.5c-3.6-0.6-6.7-2.9-8.2-6.2l-46.2-99.4c-1-2.1-0.2-4.7,1.8-5.8l130.9-75.6c2-1.2,4.3-1.6,6.6-1.2l182,28.2
							c1.5,0.2,2.7,1.2,3.3,2.5L735,572.5c1.3,2.7,0.2,6-2.4,7.5l-129.2,74.6C601,656,598.1,656.5,595.4,656.1z"/>

                        <linearGradient id="SVGID_00000070095028836616187490000018068044843154741660_" gradientUnits="userSpaceOnUse" x1="806.4317" y1="433.9136" x2="917.9202" y2="301.0468">
							<stop  offset="0.1839" style="stop-color:#85E9FF"/>
                            <stop  offset="0.3189" style="stop-color:#69CBEF"/>
                            <stop  offset="0.6113" style="stop-color:#2080C6"/>
                            <stop  offset="0.7011" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000070095028836616187490000018068044843154741660_);" d="M938.7,320.1l-102.5-15.9
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7L889.5,431
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5L945,324.8C943.8,322.3,941.5,320.5,938.7,320.1z M887.2,426l-95.2-14.7
							c-2.7-0.4-5.1-2.2-6.2-4.7l-24.5-52.9c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8l-70.2,40.6C890.2,425.9,888.7,426.2,887.2,426z"/>

                        <linearGradient id="SVGID_00000050620897105372636010000002188637733256637629_" gradientUnits="userSpaceOnUse" x1="920.8072" y1="680.6286" x2="1032.2957" y2="547.7618">
							<stop  offset="0.1341" style="stop-color:#85E9FF"/>
                            <stop  offset="0.2701" style="stop-color:#69CBEF"/>
                            <stop  offset="0.5647" style="stop-color:#2080C6"/>
                            <stop  offset="0.6552" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000050620897105372636010000002188637733256637629_);" d="M1053.1,566.8l-102.5-15.9
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7l103.9,16.1
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5l-26.3-56.6C1058.2,569,1055.8,567.2,1053.1,566.8z M1001.5,672.7
							l-95.2-14.7c-2.7-0.4-5.1-2.2-6.2-4.7l-24.5-52.9c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8l-70.2,40.6C1004.6,672.6,1003,672.9,1001.5,672.7z"/>

                        <linearGradient id="SVGID_00000126304864984549347090000018083821361089929119_" gradientUnits="userSpaceOnUse" x1="652.2816" y1="728.4758" x2="675.72" y2="861.4019">
							<stop  offset="0.2031" style="stop-color:#85E9FF"/>
                            <stop  offset="0.2828" style="stop-color:#7FE3FC"/>
                            <stop  offset="0.3937" style="stop-color:#6ED1F2"/>
                            <stop  offset="0.523" style="stop-color:#51B3E2"/>
                            <stop  offset="0.6649" style="stop-color:#2A8ACC"/>
                            <stop  offset="0.7701" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000126304864984549347090000018083821361089929119_);" d="M740.5,747.4L638,731.6
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7l103.9,16.1
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5l-26.3-56.6C745.6,749.6,743.3,747.8,740.5,747.4z M689,853.3
							l-95.2-14.7c-2.7-0.4-5.1-2.2-6.2-4.7L563,781c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8l-70.2,40.6C692,853.3,690.5,853.5,689,853.3z"/>

                        <linearGradient id="SVGID_00000161621574412686474910000009664981034272507055_" gradientUnits="userSpaceOnUse" x1="325.8066" y1="693.0817" x2="147.9286" y2="764.949">
							<stop  offset="3.831420e-03" style="stop-color:#85E9FF"/>
                            <stop  offset="0.1739" style="stop-color:#69CBEF"/>
                            <stop  offset="0.5421" style="stop-color:#2080C6"/>
                            <stop  offset="0.6552" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000161621574412686474910000009664981034272507055_);" d="M313.4,681.5l-102.5-15.9
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7l103.9,16.1
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5l-26.3-56.6C318.5,683.7,316.1,682,313.4,681.5z M261.8,787.4
							l-95.2-14.7c-2.7-0.4-5.1-2.2-6.2-4.7l-24.5-52.9c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8l-70.2,40.6C264.9,787.4,263.3,787.7,261.8,787.4z"/>

                        <linearGradient id="SVGID_00000031889819203743352000000003718100901444718223_" gradientUnits="userSpaceOnUse" x1="230.3466" y1="476.4687" x2="13.7226" y2="487.8215">
							<stop  offset="3.831420e-03" style="stop-color:#85E9FF"/>
                            <stop  offset="0.1739" style="stop-color:#69CBEF"/>
                            <stop  offset="0.5421" style="stop-color:#2080C6"/>
                            <stop  offset="0.6552" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000031889819203743352000000003718100901444718223_);" d="M198.6,434.6L96.1,418.8
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7l103.9,16.1
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5l-26.3-56.6C203.7,436.8,201.3,435.1,198.6,434.6z M147,540.5
							l-95.2-14.7c-2.7-0.4-5.1-2.2-6.2-4.7L21,468.2c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8l-70.2,40.6C150.1,540.5,148.5,540.8,147,540.5z"/>

                        <linearGradient id="SVGID_00000013172770749889963320000004084990141210305463_" gradientUnits="userSpaceOnUse" x1="432.7673" y1="363.826" x2="437.127" y2="238.9806">
							<stop  offset="0.1303" style="stop-color:#85E9FF"/>
                            <stop  offset="0.2673" style="stop-color:#69CBEF"/>
                            <stop  offset="0.564" style="stop-color:#2080C6"/>
                            <stop  offset="0.6552" style="stop-color:#0967B9"/>
                            <stop  offset="1" style="stop-color:#021C73"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000013172770749889963320000004084990141210305463_);" d="M511.5,253.9L409,238.1
							c-2.4-0.4-4.8,0.1-6.9,1.3l-74.6,43.1c-1.8,1-2.4,3.2-1.6,5l26.3,56.6c1.2,2.5,3.5,4.3,6.2,4.7l103.9,16.1
							c1.5,0.2,3-0.1,4.4-0.8l75.8-43.8c1.8-1,2.4-3.2,1.6-5l-26.3-56.6C516.6,256.1,514.2,254.4,511.5,253.9z M459.9,359.8
							l-95.2-14.7c-2.7-0.4-5.1-2.2-6.2-4.7l-24.5-52.9c-0.5-1.1-0.1-2.4,1-3l69.5-40.1c2.1-1.2,4.5-1.7,6.9-1.3l93.9,14.5
							c2.7,0.4,5.1,2.2,6.2,4.7l24.3,52.4c0.6,1.4,0.1,3-1.2,3.8L464.3,359C463,359.8,461.4,360.1,459.9,359.8z"/>
					</g>
				</g>
                <g>
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000109748106839427719840000016155253434707395215_" filterUnits="userSpaceOnUse" x="678.5" y="390.8" width="128" height="99.2">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="678.5" y="390.8" width="128" height="99.2" id="blockchain_00000041977787574089627330000005119195968121597627_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000109748106839427719840000016155253434707395215_);">

								<linearGradient id="SVGID_00000064340739035211293430000012351198237311735465_" gradientUnits="userSpaceOnUse" x1="626.3724" y1="478.064" x2="783.9686" y2="478.064" gradientTransform="matrix(0.8596 -0.511 0.5101 0.8579 -107.3699 392.8606)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000064340739035211293430000012351198237311735465_);" points="818.1,430.7 697.4,502.5
								668.5,453.8 789.1,382.1 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000034769932822291681070000018377867402253239720_" gradientUnits="userSpaceOnUse" x1="706.1447" y1="499.5785" x2="706.1447" y2="452.9461" gradientTransform="matrix(0.8596 -0.511 0.5101 0.8579 -107.3699 392.8606)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>
                    <polygon style="fill:url(#SVGID_00000034769932822291681070000018377867402253239720_);" points="806.5,426.5 699.6,490
						678.5,454.4 785.3,390.8 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000095336688664001023050000011487947376804258981_" filterUnits="userSpaceOnUse" x="743" y="561.6" width="129.2" height="60.1">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="743" y="561.6" width="129.2" height="60.1" id="SVGID_00000132801471790228924070000016023082060434203323_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000095336688664001023050000011487947376804258981_);">

								<linearGradient id="SVGID_00000033371154883877096250000014434378945522175382_" gradientUnits="userSpaceOnUse" x1="819.2141" y1="527.76" x2="976.8073" y2="527.76" gradientTransform="matrix(0.9881 0.154 -0.1537 0.9862 9.665382e-02 -65.3037)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000033371154883877096250000014434378945522175382_);" points="872,632.3 733.3,610.7
								742,554.8 880.7,576.4 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000147918631514900464870000007972522723663005059_" gradientUnits="userSpaceOnUse" x1="898.9848" y1="549.2698" x2="898.9848" y2="502.6464" gradientTransform="matrix(0.9881 0.154 -0.1537 0.9862 9.665382e-02 -65.3037)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000132801471790228924070000016023082060434203323_);fill:url(#SVGID_00000147918631514900464870000007972522723663005059_);" points="
						865.8,621.7 743,602.5 749.4,561.6 872.2,580.7 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000003823473772020675660000010911227415487340181_" filterUnits="userSpaceOnUse" x="584.7" y="651.7" width="63.9" height="95.4">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="584.7" y="651.7" width="63.9" height="95.4" id="SVGID_00000036221088833206815920000012814471992451614393_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000003823473772020675660000010911227415487340181_);">

								<linearGradient id="SVGID_00000162352929690314639030000000399503508280985493_" gradientUnits="userSpaceOnUse" x1="888.0637" y1="384.0967" x2="1003.2529" y2="384.0967" gradientTransform="matrix(0.3973 0.9177 -0.916 0.3965 591.1601 -320.7722)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000162352929690314639030000000399503508280985493_);" points="616.6,755.1 575.9,661
								613.8,644.5 654.6,738.7 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000094600429228289695620000008428916315527283360_" gradientUnits="userSpaceOnUse" x1="946.3704" y1="399.82" x2="946.3704" y2="365.7393" gradientTransform="matrix(0.3973 0.9177 -0.916 0.3965 591.1601 -320.7722)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000036221088833206815920000012814471992451614393_);fill:url(#SVGID_00000094600429228289695620000008428916315527283360_);" points="
						620.8,747.1 584.7,663.7 612.5,651.7 648.6,735.1 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000118370733773698365300000009658041511360125858_" filterUnits="userSpaceOnUse" x="305.2" y="618.8" width="104.3" height="77.2">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="305.2" y="618.8" width="104.3" height="77.2" id="SVGID_00000039835283045302341640000011402719093031080622_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000118370733773698365300000009658041511360125858_);">

								<linearGradient id="SVGID_00000082341572419556584890000002031975406465284796_" gradientUnits="userSpaceOnUse" x1="703.9885" y1="156.4279" x2="819.1832" y2="156.4279" gradientTransform="matrix(-0.9825 0.5604 -0.4945 -0.867 1182.9175 364.6021)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000082341572419556584890000002031975406465284796_);" points="296.1,666.8 396.9,609.3
								417.4,645.3 316.6,702.8 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000183953492502497146660000013119975483798385542_" gradientUnits="userSpaceOnUse" x1="762.298" y1="172.1501" x2="762.298" y2="138.0723" gradientTransform="matrix(-0.9825 0.5604 -0.4945 -0.867 1182.9175 364.6021)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000039835283045302341640000011402719093031080622_);fill:url(#SVGID_00000183953492502497146660000013119975483798385542_);" points="
						305.2,669.7 394.5,618.8 409.5,645.1 320.2,696.1 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000106831679759147760140000008897018841048865154_" filterUnits="userSpaceOnUse" x="230.5" y="483.4" width="117" height="45.7">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="230.5" y="483.4" width="117" height="45.7" id="SVGID_00000093888366176067330890000005092802496613555111_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000106831679759147760140000008897018841048865154_);">

								<linearGradient id="SVGID_00000142135838922968815640000004147686660856278183_" gradientUnits="userSpaceOnUse" x1="576.72" y1="206.9607" x2="691.9067" y2="206.9607" gradientTransform="matrix(-1.2419 -0.1732 0.1378 -0.9885 1049.2947 819.3422)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000142135838922968815640000004147686660856278183_);" points="228.6,475.4 356,493.2
								350.3,534.2 222.9,516.4 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000110429958536394430570000008252814589213430459_" gradientUnits="userSpaceOnUse" x1="635.0256" y1="222.6839" x2="635.0256" y2="188.603" gradientTransform="matrix(-1.2419 -0.1732 0.1378 -0.9885 1049.2947 819.3422)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000093888366176067330890000005092802496613555111_);fill:url(#SVGID_00000110429958536394430570000008252814589213430459_);" points="
						234.6,483.4 347.5,499.1 343.3,529.1 230.5,513.4 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000091009560628464446940000000756833269503147939_" filterUnits="userSpaceOnUse" x="453.4" y="357.4" width="57.2" height="79.5">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="453.4" y="357.4" width="57.2" height="79.5" id="SVGID_00000124875606314154985130000009562343215253353894_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000091009560628464446940000000756833269503147939_);">

								<linearGradient id="SVGID_00000115486920524751844570000000484778576941645452_" gradientUnits="userSpaceOnUse" x1="292.4095" y1="423.1853" x2="407.6072" y2="423.1853" gradientTransform="matrix(-0.3241 -0.741 0.9144 -0.4 210.0896 825.6663)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000115486920524751844570000000484778576941645452_);" points="485.8,350.4 519,426.4
								481.1,443 447.9,366.9 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000168074947159280079420000005171288303098131593_" gradientUnits="userSpaceOnUse" x1="350.7204" y1="438.9077" x2="350.7204" y2="404.8286" gradientTransform="matrix(-0.3241 -0.741 0.9144 -0.4 210.0896 825.6663)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000124875606314154985130000009562343215253353894_);fill:url(#SVGID_00000168074947159280079420000005171288303098131593_);" points="
						481.2,357.4 510.6,424.7 482.9,436.8 453.4,369.5 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000018228451770361282340000006127482462809476277_" filterUnits="userSpaceOnUse" x="870.8" y="413.8" width="96.9" height="143.1">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="870.8" y="413.8" width="96.9" height="143.1" id="SVGID_00000146497873440903980500000008824811193665608612_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000018228451770361282340000006127482462809476277_);">

								<linearGradient id="SVGID_00000096020718311164687540000013210050576922534813_" gradientUnits="userSpaceOnUse" x1="275.8073" y1="475.2437" x2="448.7106" y2="475.2437" gradientTransform="matrix(-0.4057 -0.914 0.9122 -0.405 635.1576 1009.002)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000096020718311164687540000013210050576922534813_);" points="918.5,401.7 981,542.5
								924.3,567.7 861.8,426.9 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000005244005943450059730000011730969054527326397_" gradientUnits="userSpaceOnUse" x1="363.3278" y1="498.8456" x2="363.3278" y2="447.688" gradientTransform="matrix(-0.4057 -0.914 0.9122 -0.405 635.1576 1009.002)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000146497873440903980500000008824811193665608612_);fill:url(#SVGID_00000005244005943450059730000011730969054527326397_);" points="
						912.4,413.8 967.7,538.4 926.1,556.9 870.8,432.2 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000111155656657050709830000016037648906192784298_" filterUnits="userSpaceOnUse" x="735.8" y="642.8" width="165.2" height="123.7">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="735.8" y="642.8" width="165.2" height="123.7" id="SVGID_00000037674563565980313980000017143966268680251803_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000111155656657050709830000016037648906192784298_);">

								<linearGradient id="SVGID_00000143581533508612492140000007901319010404041344_" gradientUnits="userSpaceOnUse" x1="514.2815" y1="-202.7716" x2="687.1816" y2="-202.7716" gradientTransform="matrix(-1.0404 0.6205 -0.5112 -0.8572 1339.6998 155.56)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000143581533508612492140000007901319010404041344_);" points="721.5,723.7 881.8,628.2
								913.6,681.5 753.3,777 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000079457396748288774240000007640595510266768030_" gradientUnits="userSpaceOnUse" x1="601.8002" y1="-179.1695" x2="601.8002" y2="-230.3273" gradientTransform="matrix(-1.0404 0.6205 -0.5112 -0.8572 1339.6998 155.56)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000037674563565980313980000017143966268680251803_);fill:url(#SVGID_00000079457396748288774240000007640595510266768030_);" points="
						735.8,727.5 877.7,642.8 901,681.9 759.1,766.5 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000017516409772744299050000010960348609897010623_" filterUnits="userSpaceOnUse" x="342" y="721.6" width="214.2" height="73.3">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="342" y="721.6" width="214.2" height="73.3" id="SVGID_00000088117761478595800600000003800779053823544762_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000017516409772744299050000010960348609897010623_);">

								<linearGradient id="SVGID_00000021119423315459699050000015959730681847906209_" gradientUnits="userSpaceOnUse" x1="607.6887" y1="-121.9835" x2="780.5936" y2="-121.9835" gradientTransform="matrix(-1.5253 -0.2075 0.1345 -0.989 1526.147 779.6628)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000021119423315459699050000015959730681847906209_);" points="336.5,709.4 571.4,741.3
								563,802.8 328.2,770.9 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000065760142490586389490000013111547337667562123_" gradientUnits="userSpaceOnUse" x1="695.21" y1="-98.3832" x2="695.21" y2="-149.5375" gradientTransform="matrix(-1.5253 -0.2075 0.1345 -0.989 1526.147 779.6628)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000088117761478595800600000003800779053823544762_);fill:url(#SVGID_00000065760142490586389490000013111547337667562123_);" points="
						348.1,721.6 556.1,749.9 550,794.9 342,766.6 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000128456191232336902160000003324646176747184830_" filterUnits="userSpaceOnUse" x="134" y="533.4" width="93" height="138.4">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="134" y="533.4" width="93" height="138.4" id="SVGID_00000047055103260579521810000012109272258229908398_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000128456191232336902160000003324646176747184830_);">

								<linearGradient id="SVGID_00000039856612523545100990000015887363364744496571_" gradientUnits="userSpaceOnUse" x1="497.6912" y1="-0.3841" x2="670.5922" y2="-0.3841" gradientTransform="matrix(-0.3754 -0.8846 0.9188 -0.3899 402.6343 1119.2802)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000039856612523545100990000015887363364744496571_);" points="182.4,521.8 240.2,658
								183,682.2 125.2,546 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000049192947070211140670000002860901258733974923_" gradientUnits="userSpaceOnUse" x1="585.2109" y1="23.2179" x2="585.2109" y2="-27.9389" gradientTransform="matrix(-0.3754 -0.8846 0.9188 -0.3899 402.6343 1119.2802)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000047055103260579521810000012109272258229908398_);fill:url(#SVGID_00000049192947070211140670000002860901258733974923_);" points="
						175.9,533.4 227.1,654.1 185.2,671.8 134,551.2 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000065076659691299505220000014999433396173805968_" filterUnits="userSpaceOnUse" x="190.3" y="331.5" width="174.9" height="126.5">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="190.3" y="331.5" width="174.9" height="126.5" id="SVGID_00000168818147218950440790000018105510056626044068_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000065076659691299505220000014999433396173805968_);">

								<linearGradient id="SVGID_00000104676619285375227490000008822932847215265459_" gradientUnits="userSpaceOnUse" x1="584.3533" y1="418.5573" x2="757.2509" y2="418.5573" gradientTransform="matrix(1.1167 -0.6381 0.4952 0.8666 -678.7337 462.7035)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000104676619285375227490000008822932847215265459_);" points="379.9,374.7 207.9,473
								177.1,419.1 349.1,320.8 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000048460518507614464090000005773307222776922770_" gradientUnits="userSpaceOnUse" x1="671.8705" y1="442.1566" x2="671.8705" y2="391.0048" gradientTransform="matrix(1.1167 -0.6381 0.4952 0.8666 -678.7337 462.7035)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000168818147218950440790000018105510056626044068_);fill:url(#SVGID_00000048460518507614464090000005773307222776922770_);" points="
						365.1,371 212.9,458 190.3,418.6 342.6,331.5 					"/>
                    <defs>

							<filter id="Adobe_OpacityMaskFilter_00000140733315976835883640000003059643582584596410_" filterUnits="userSpaceOnUse" x="542.3" y="298.3" width="213.3" height="73">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="542.3" y="298.3" width="213.3" height="73" id="SVGID_00000162339538103138510710000017284896446229967234_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000140733315976835883640000003059643582584596410_);">

								<linearGradient id="SVGID_00000064353220306630934910000008875398075807918775_" gradientUnits="userSpaceOnUse" x1="897.91" y1="494.5129" x2="1070.8071" y2="494.5129" gradientTransform="matrix(1.5198 0.205 -0.1335 0.9891 -782.9169 -354.1035)">
								<stop  offset="0.1303" style="stop-color:#000000"/>
                                    <stop  offset="0.1615" style="stop-color:#090909"/>
                                    <stop  offset="0.2127" style="stop-color:#222222"/>
                                    <stop  offset="0.2776" style="stop-color:#4A4A4A"/>
                                    <stop  offset="0.3536" style="stop-color:#828282"/>
                                    <stop  offset="0.4379" style="stop-color:#C8C8C8"/>
                                    <stop  offset="0.4981" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.5573" style="stop-color:#C9C9C9"/>
                                    <stop  offset="0.6314" style="stop-color:#8D8D8D"/>
                                    <stop  offset="0.7029" style="stop-color:#5B5B5B"/>
                                    <stop  offset="0.7696" style="stop-color:#333333"/>
                                    <stop  offset="0.8306" style="stop-color:#171717"/>
                                    <stop  offset="0.8838" style="stop-color:#060606"/>
                                    <stop  offset="0.9234" style="stop-color:#000000"/>
							</linearGradient>
                            <polygon style="fill:url(#SVGID_00000064353220306630934910000008875398075807918775_);" points="761.1,383.5 527.1,352
								535.4,290.4 769.4,322 							"/>
						</g>
					</mask>

                    <linearGradient id="SVGID_00000069356688921546294620000007297580714869506222_" gradientUnits="userSpaceOnUse" x1="985.4272" y1="518.1152" x2="985.4272" y2="466.9569" gradientTransform="matrix(1.5198 0.205 -0.1335 0.9891 -782.9169 -354.1035)">
						<stop  offset="9.195400e-02" style="stop-color:#000000;stop-opacity:0"/>
                        <stop  offset="0.1397" style="stop-color:#010506;stop-opacity:0.1005"/>
                        <stop  offset="0.2043" style="stop-color:#051317;stop-opacity:0.2365"/>
                        <stop  offset="0.2786" style="stop-color:#0B2A34;stop-opacity:0.3929"/>
                        <stop  offset="0.3601" style="stop-color:#144A5B;stop-opacity:0.5645"/>
                        <stop  offset="0.4475" style="stop-color:#1F738E;stop-opacity:0.7484"/>
                        <stop  offset="0.5385" style="stop-color:#2CA4CB;stop-opacity:0.9399"/>
                        <stop  offset="0.5671" style="stop-color:#31B5E0"/>
                        <stop  offset="0.574" style="stop-color:#30B0D9;stop-opacity:0.9839"/>
                        <stop  offset="0.639" style="stop-color:#2382A0;stop-opacity:0.8339"/>
                        <stop  offset="0.704" style="stop-color:#185A6F;stop-opacity:0.6836"/>
                        <stop  offset="0.7679" style="stop-color:#103A47;stop-opacity:0.5361"/>
                        <stop  offset="0.8302" style="stop-color:#092028;stop-opacity:0.3922"/>
                        <stop  offset="0.8906" style="stop-color:#040E12;stop-opacity:0.2527"/>
                        <stop  offset="0.9482" style="stop-color:#010405;stop-opacity:0.1197"/>
                        <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
					</linearGradient>

                    <polygon style="mask:url(#SVGID_00000162339538103138510710000017284896446229967234_);fill:url(#SVGID_00000069356688921546294620000007297580714869506222_);" points="
						749.6,371.4 542.3,343.4 548.4,298.3 755.7,326.3 					"/>
				</g>
                <g>
					<g>
						<path class="st48" d="M545.6,635.2c-40.9,0-79.5-9.1-108.8-25.5c-30.4-17.1-47.3-40.2-47.6-65c-0.3-24.6,15.8-47.9,45.4-65.6
							c30.3-18,70.7-28,113.9-28c40.9,0,79.5,9.1,108.8,25.5c30.4,17.1,47.3,40.2,47.6,65c0.3,24.6-15.8,47.9-45.4,65.6
							C629.2,625.2,588.8,635.2,545.6,635.2z M548.6,453.9c-42.7,0-82.6,9.8-112.5,27.6c-28.7,17.1-44.4,39.5-44.1,63.1
							c0.3,23.8,16.7,46,46.2,62.6c28.8,16.2,67,25.1,107.4,25.1c42.7,0,82.6-9.8,112.5-27.6c28.7-17.1,44.4-39.5,44.1-63.1
							c-0.3-23.8-16.7-46-46.2-62.6C627.1,462.8,589,453.9,548.6,453.9z"/>
					</g>
                    <path class="st49" d="M452.4,597.4c-52.2-29.3-53-77.9-1.8-108.3c51.2-30.5,134.9-31.4,187.1-2.1c52.2,29.3,53,77.9,1.8,108.3
						C588.3,625.8,504.5,626.7,452.4,597.4z"/>

                    <ellipse transform="matrix(1 -8.235627e-03 8.235627e-03 1 -4.4465 4.5069)" class="st50" cx="545" cy="542.2" rx="107.1" ry="62"/>

                    <radialGradient id="SVGID_00000165931241358694204020000001403223897870420895_" cx="298.9032" cy="451.5098" r="173.9132" gradientTransform="matrix(-1 0 0 1 848.9235 0)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#82ECFF"/>
                        <stop  offset="9.140421e-02" style="stop-color:#7BDFF1;stop-opacity:0.9079"/>
                        <stop  offset="0.2646" style="stop-color:#68BDCC;stop-opacity:0.7334"/>
                        <stop  offset="0.5013" style="stop-color:#498590;stop-opacity:0.4949"/>
                        <stop  offset="0.7891" style="stop-color:#20393E;stop-opacity:0.2048"/>
                        <stop  offset="0.9923" style="stop-color:#000000;stop-opacity:0"/>
					</radialGradient>
                    <path style="fill:url(#SVGID_00000165931241358694204020000001403223897870420895_);" d="M387.3,539.3l-0.4-108.4l0.3,0
						c-0.3-23.5,14.8-47.2,45.5-65.5c61.5-36.7,162.3-37.8,225-2.5c33.7,19,49.6,44.6,47.5,70v99.6c0.2,3,0.2,6,0,8.9v0.9l-0.1,0
						C703,563.8,688,585,660,601.7c-61.5,36.7-162.3,37.8-225,2.5c-31.1-17.5-47-40.6-47.6-64h0l0-0.5
						C387.3,539.6,387.3,539.4,387.3,539.3z"/>
                    <g>
						<defs>
							<path id="SVGID_00000067915803569064654630000004383873594275517622_" d="M386.9,430.9l0.3,0c-0.3-23.5,14.8-47.2,45.5-65.5
								c61.5-36.7,162.3-37.8,225-2.5c33.7,19,49.6,44.6,47.5,70l-1.9,110.2c-1.4,26.9-19.6,48.7-43.5,62.2
								c-68.5,38.9-171.9,34-227.5-1.1c-30.4-19.2-40.3-39.7-41-63.1L386.9,430.9z"/>
						</defs>
                        <clipPath id="SVGID_00000085246632064174691030000009197838938305225622_">
							<use xlink:href="#SVGID_00000067915803569064654630000004383873594275517622_"  style="overflow:visible;"/>
						</clipPath>
                        <g style="clip-path:url(#SVGID_00000085246632064174691030000009197838938305225622_);">
							<g>
								<path class="st48" d="M512.7,1158c-0.8,0-1.4-0.6-1.4-1.4l-0.2-69.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.2,69.2
									C514.1,1157.3,513.5,1158,512.7,1158z"/>
                                <path class="st48" d="M512.3,1088.4c-3.1,0-5.6-2.5-5.6-5.5c0-3.1,2.5-5.6,5.5-5.6c3.1,0,5.6,2.5,5.6,5.5
									c0,1.5-0.6,2.9-1.6,4C515.2,1087.8,513.8,1088.4,512.3,1088.4L512.3,1088.4z M512.3,1080c-0.8,0-1.5,0.3-2,0.8
									c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c0.7,0,1.4-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
									C515,1081.2,513.8,1080,512.3,1080z"/>
                                <path class="st48" d="M512.7,1166.4c-3.1,0-5.6-2.5-5.6-5.5c0-1.5,0.6-2.9,1.6-4c1-1.1,2.4-1.7,3.9-1.7
									c3.1,0,5.6,2.5,5.6,5.5C518.4,1163.8,515.9,1166.3,512.7,1166.4L512.7,1166.4z M512.7,1158c-0.8,0-1.5,0.3-2,0.8
									c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C515.5,1159.2,514.3,1158,512.7,1158z"/>
							</g>
                            <g>
								<g>
									<path class="st48" d="M624.5,1151c-0.8,0-1.4-0.6-1.4-1.4l0.3-229.8c0-0.5,0.3-1,0.7-1.2l26.5-15.3v-64.1
										c0-0.5,0.3-1,0.7-1.2l27.2-15.6v-49.5c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v50.3c0,0.5-0.3,1-0.7,1.2L653.4,840
										v64.1c0,0.5-0.3,1-0.7,1.2l-26.5,15.3l-0.3,229C625.9,1150.3,625.2,1151,624.5,1151z"/>
                                    <path class="st48" d="M679.9,774.2c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C685.5,771.7,683,774.2,679.9,774.2z M679.9,765.8c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C682.8,767.1,681.5,765.8,679.9,765.8z"/>
                                    <path class="st48" d="M624.5,1159.4c-1.5,0-2.9-0.6-4-1.6c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.6c1.1,1.1,1.6,2.5,1.6,4C630.1,1156.9,627.6,1159.4,624.5,1159.4z M624.5,1151c-1.5,0-2.8,1.3-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C625.9,1151.3,625.2,1151,624.5,1151z"/>
								</g>
                                <g>
									<path class="st48" d="M597.2,997.5c-0.8,0-1.4-0.6-1.4-1.4l0.9-156.7c0-0.5,0.3-0.9,0.7-1.2l54.2-32.2l-0.9-177.6
										c0-0.8,0.6-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.9,178.4c0,0.5-0.3,1-0.7,1.2l-54.2,32.2l-0.9,156
										C598.5,996.8,597.9,997.5,597.2,997.5z"/>
                                    <path class="st48" d="M652,629.8c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.6,3.9-1.7c3.1,0,5.6,2.5,5.6,5.6
										c0,1.5-0.6,2.9-1.6,4C655,629.2,653.6,629.8,652,629.8L652,629.8z M652,621.4c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2
										c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C654.8,622.6,653.6,621.4,652,621.4z"/>
                                    <path class="st48" d="M597.2,1005.8L597.2,1005.8c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7c1,1.1,1.6,2.5,1.6,4C602.7,1003.4,600.2,1005.8,597.2,1005.8z M597.2,997.5c-1.6,0-2.8,1.2-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C598.6,997.8,597.9,997.5,597.2,997.5z"/>
								</g>
                                <g>
									<path class="st48" d="M625.1,884c-0.8,0-1.4-0.6-1.4-1.4v-23.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v23.2
										C626.5,883.3,625.8,884,625.1,884z"/>
                                    <path class="st48" d="M625.1,860.7c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C630.7,858.2,628.1,860.7,625.1,860.7z M625.1,852.3c-1.5,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										S626.6,852.3,625.1,852.3z"/>
                                    <path class="st48" d="M625.1,892.3c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C630.7,889.8,628.1,892.3,625.1,892.3z M625.1,884c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C627.9,885.2,626.6,884,625.1,884z"/>
								</g>
                                <g>
									<path class="st48" d="M680.9,1121.2c-0.8,0-1.4-0.6-1.4-1.4v-102.9l-28-15.9c-0.4-0.2-0.7-0.7-0.7-1.2l-0.3-59.3
										c0-0.8,0.6-1.4,1.4-1.4c0.8-0.1,1.4,0.6,1.4,1.4l0.3,58.5l28,15.9c0.4,0.2,0.7,0.7,0.7,1.2v103.7
										C682.3,1120.6,681.6,1121.2,680.9,1121.2z"/>
                                    <path class="st48" d="M651.1,941.7c-3,0-5.5-2.5-5.6-5.5c0-3.1,2.4-5.6,5.5-5.7c3.1,0,5.6,2.5,5.7,5.5
										C656.7,939.1,654.3,941.6,651.1,941.7L651.1,941.7z M651.1,933.3c-1.6,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4
										c1.5,0,2.8-1.3,2.8-2.8C653.9,934.5,652.6,933.3,651.1,933.3z"/>
                                    <path class="st48" d="M680.9,1129.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C686.5,1127.1,684,1129.6,680.9,1129.6z M680.9,1121.2c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										c1.5,0,2.8-1.3,2.8-2.8C683.7,1122.5,682.4,1121.2,680.9,1121.2z"/>
								</g>
                                <g>
									<path class="st48" d="M652.4,1080c-0.8,0-1.4-0.6-1.4-1.4l0.5-42.6c0-0.8,0.7-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.5,42.6
										C653.8,1079.4,653.2,1080,652.4,1080z"/>
                                    <path class="st48" d="M653,1037.5L653,1037.5c-3.1,0-5.6-2.6-5.6-5.7c0-3,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.7
										C658.5,1035,656,1037.5,653,1037.5z M653,1029.1c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4
										c1.5,0,2.8-1.2,2.8-2.8C655.8,1030.4,654.5,1029.1,653,1029.1z"/>
                                    <path class="st48" d="M652,1088.7L652,1088.7c-3.1,0-5.6-2.6-5.6-5.7c0-3,2.5-5.5,5.6-5.5c1.6,0,3,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C657.6,1086.2,655.1,1088.7,652,1088.7z M652.1,1080.3c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8
										l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8C654.9,1081.5,653.6,1080.3,652.1,1080.3z"/>
								</g>
                                <g>
									<path class="st48" d="M624.1,787.2c-0.8,0-1.4-0.6-1.4-1.4l-0.3-94.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l0.3,94.6C625.5,786.6,624.9,787.2,624.1,787.2z"/>
                                    <path class="st48" d="M623.8,692.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C626.7,692,625.3,692.6,623.8,692.6z M623.8,684.2c-0.7,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C626.6,685.4,625.3,684.2,623.8,684.2z"/>
                                    <path class="st48" d="M624.1,795.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C627,795,625.6,795.6,624.1,795.6z M624.1,787.2c-0.7,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C626.9,788.5,625.7,787.2,624.1,787.2z"/>
								</g>
                                <g>
									<path class="st48" d="M541.3,1100.7c-0.8,0-1.4-0.6-1.4-1.4V936.1c0-0.5,0.3-1,0.7-1.2l27.2-15.4l-0.2-95.9
										c0-0.5,0.3-0.9,0.7-1.2L595,806l0.1-145c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.1,145.8c0,0.5-0.3,0.9-0.7,1.2
										l-26.7,16.3l0.2,96c0,0.5-0.3,1-0.7,1.2l-27.2,15.4v162.5C542.7,1100.1,542.1,1100.7,541.3,1100.7z"/>
                                    <path class="st48" d="M596.5,662.3c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c1.5,0,2.9,0.6,4,1.6
										c1.1,1.1,1.6,2.5,1.6,4C602,659.8,599.5,662.3,596.5,662.3z M596.5,653.9c-0.7,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2
										c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-0.7-0.3-1.5-0.8-2C597.9,654.2,597.2,653.9,596.5,653.9z"/>
                                    <path class="st48" d="M541.3,1109.1c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C546.9,1106.6,544.4,1109.1,541.3,1109.1z M541.3,1100.7c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										c1.5,0,2.8-1.3,2.8-2.8C544.1,1102,542.9,1100.7,541.3,1100.7z"/>
								</g>
                                <g>
									<path class="st48" d="M597.2,1093.8c-0.8,0-1.4-0.6-1.4-1.4v-57.9l-28.2-18.2c-0.4-0.3-0.6-0.7-0.6-1.2v-59.1
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v58.3l28.2,18.2c0.4,0.3,0.6,0.7,0.6,1.2v58.6
										C598.5,1093.1,597.9,1093.8,597.2,1093.8z"/>
                                    <path class="st48" d="M568.3,957.5c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C573.9,955,571.4,957.5,568.3,957.5z M568.3,949.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C571.1,950.3,569.9,949.1,568.3,949.1z"/>
                                    <path class="st48" d="M597.2,1102.2c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C602.7,1099.7,600.2,1102.2,597.2,1102.2z M597.2,1093.8c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										c1.5,0,2.8-1.3,2.8-2.8C600,1095,598.7,1093.8,597.2,1093.8z"/>
								</g>
                                <g>
									<path class="st48" d="M456.7,1096.8c-0.8,0-1.4-0.6-1.4-1.4l0.5-46.7c0-0.5,0.3-1,0.7-1.2l27.2-15.4v-96.9
										c0-0.5,0.3-0.9,0.7-1.2l26.8-16.3l0.9-159.2c0-0.5,0.3-0.9,0.7-1.2l54.2-31.7l-0.2-24.4c0-0.8,0.6-1.4,1.4-1.4
										c0.8,0,1.4,0.6,1.4,1.4l0.2,25.2c0,0.5-0.3,1-0.7,1.2l-54.2,31.7l-0.9,159.2c0,0.5-0.3,0.9-0.7,1.2l-26.8,16.3v96.9
										c0,0.5-0.3,1-0.7,1.2l-27.2,15.4l-0.5,45.9C458.1,1096.2,457.4,1096.8,456.7,1096.8z"/>
                                    <path class="st48" d="M568.1,702.3c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C571,701.7,569.6,702.3,568.1,702.3z M568.1,693.9c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C570.9,695.2,569.6,693.9,568.1,693.9z"/>
                                    <path class="st48" d="M456.7,1105.2L456.7,1105.2c-3.1,0-5.6-2.6-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c1.5,0,2.9,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C462.2,1102.7,459.7,1105.2,456.7,1105.2z M456.7,1096.8c-1.6,0-2.8,1.2-2.8,2.8
										c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8C459.5,1098,458.2,1096.8,456.7,1096.8z"/>
								</g>
                                <g>
									<path class="st48" d="M540.2,900.8c-0.8,0-1.4-0.6-1.4-1.4l0.2-92.5c0-0.5,0.3-1,0.7-1.2l27.4-15.5v-27.6
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v28.4c0,0.5-0.3,1-0.7,1.2l-27.4,15.5l-0.2,91.7
										C541.6,900.1,540.9,900.8,540.2,900.8z"/>
                                    <path class="st48" d="M568.5,764c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6S571.6,764,568.5,764z
										 M568.5,755.6c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8C571.3,756.8,570,755.6,568.5,755.6z"/>
                                    <path class="st48" d="M540.2,909.3c-1.5,0-2.9-0.6-4-1.6c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c3.1,0,5.6,2.5,5.6,5.6C545.8,906.8,543.2,909.3,540.2,909.3z M540.2,900.9c-1.5,0-2.8,1.3-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C543,902.2,541.7,900.9,540.2,900.9z"/>
								</g>
                                <g>
									<path class="st48" d="M484.6,1132.4c-0.8,0-1.4-0.6-1.4-1.4l0.3-66.4c0-0.5,0.3-0.9,0.7-1.2l26.9-16.3l-0.1-91
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.1,91.8c0,0.5-0.3,0.9-0.7,1.2l-26.9,16.3L486,1131
										C486,1131.7,485.4,1132.4,484.6,1132.4z"/>
                                    <path class="st48" d="M512.4,957.4c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c2.1-2.1,5.8-2.1,7.9,0
										c1.1,1.1,1.6,2.5,1.6,4c0,1.5-0.6,2.9-1.6,4C515.3,956.8,513.9,957.4,512.4,957.4z M512.4,949c-0.7,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C515.2,950.2,514,949,512.4,949z
										"/>
                                    <path class="st48" d="M484.6,1140.8L484.6,1140.8c-3.1,0-5.6-2.6-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.6,5.6,5.6
										C490.2,1138.3,487.6,1140.8,484.6,1140.8z M484.6,1132.4c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4
										c1.5,0,2.8-1.2,2.8-2.8C487.4,1133.6,486.1,1132.4,484.6,1132.4z"/>
								</g>
                                <g>
									<path class="st48" d="M428.9,1056.1c-0.8,0-1.4-0.6-1.4-1.4v-22.6c0-0.5,0.3-0.9,0.7-1.2l27.8-17v-94.1
										c0-0.5,0.2-0.9,0.6-1.2l28-17.7l-1.4-159.7c0-0.5,0.3-1,0.7-1.2l55.3-30.5L539,587.2c0-0.8,0.6-1.4,1.4-1.4
										c0.8,0,1.4,0.6,1.4,1.4l0.2,123c0,0.5-0.3,1-0.7,1.2L486,742l1.4,159.6c0,0.5-0.2,0.9-0.6,1.2l-28,17.7v94.1
										c0,0.5-0.3,0.9-0.7,1.2l-27.8,17v21.8C430.3,1055.4,429.7,1056.1,428.9,1056.1z"/>
                                    <path class="st48" d="M540.4,588.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.6,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.6C546,586.1,543.5,588.6,540.4,588.6z M540.4,580.2c-1.6,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C543.2,581.5,541.9,580.2,540.4,580.2z"/>
                                    <path class="st48" d="M428.9,1064.5c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C434.5,1062,432,1064.5,428.9,1064.5z M428.9,1056.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C431.7,1057.3,430.5,1056.1,428.9,1056.1z"/>
								</g>
                                <g>
									<path class="st48" d="M512.7,690.9c-0.8,0-1.4-0.6-1.4-1.4l-0.2-81.1c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l0.2,81.1C514.1,690.3,513.5,690.9,512.7,690.9z"/>
                                    <path class="st48" d="M512.3,609.5c-3.1,0-5.6-2.5-5.6-5.5c0-1.5,0.6-2.9,1.6-4c1-1.1,2.4-1.7,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.5c0,1.5-0.6,2.9-1.6,4C515.2,608.9,513.8,609.5,512.3,609.5L512.3,609.5z M512.3,601.1
										c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c0.7,0,1.4-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C515,602.4,513.8,601.1,512.3,601.1z"/>
                                    <path class="st48" d="M512.7,699.3c-3.1,0-5.6-2.5-5.6-5.5c0-1.5,0.6-2.9,1.6-4c1-1.1,2.4-1.7,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.5C518.4,696.7,515.9,699.3,512.7,699.3L512.7,699.3z M512.7,690.9c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C515.5,692.2,514.3,690.9,512.7,690.9z"/>
								</g>
                                <g>
									<path class="st48" d="M400.9,1018.9c-0.8,0-1.4-0.6-1.4-1.4V887.7c0-0.5,0.3-0.9,0.7-1.2l27.2-16.3l0.5-63.5
										c0-0.5,0.3-0.9,0.7-1.2l26.8-16.2v-63.4c0-0.5,0.3-1,0.7-1.2l27.2-15.2V689c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										v21.2c0,0.5-0.3,1-0.7,1.2l-27.2,15.2V790c0,0.5-0.3,0.9-0.7,1.2l-26.8,16.2l-0.5,63.5c0,0.5-0.3,0.9-0.7,1.2l-27.2,16.3
										v129C402.3,1018.2,401.6,1018.9,400.9,1018.9z"/>
                                    <path class="st48" d="M484.8,690.2L484.8,690.2c-3.1,0-5.6-2.6-5.6-5.7c0-3.1,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.7
										C490.4,687.8,487.9,690.2,484.8,690.2z M484.9,681.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4v-1.4
										c1.5,0,2.8-1.2,2.8-2.8C487.6,683.1,486.4,681.9,484.9,681.8z"/>
                                    <path class="st48" d="M400.9,1027.3c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C406.5,1024.7,403.9,1027.3,400.9,1027.3z M400.9,1018.9c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										c1.5,0,2.8-1.3,2.8-2.8C403.7,1020.1,402.4,1018.9,400.9,1018.9z"/>
								</g>
                                <g>
									<path class="st48" d="M429.2,997.5c-0.8,0-1.4-0.6-1.4-1.4l0.9-93c0-0.5,0.3-1,0.7-1.2l25.8-13.6v-60.5
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v61.4c0,0.5-0.3,1-0.7,1.2l-25.8,13.6l-0.9,92.2
										C430.6,996.8,430,997.5,429.2,997.5z"/>
                                    <path class="st48" d="M456.7,829.1c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C462.3,826.6,459.8,829.1,456.7,829.1z M456.7,820.7c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C459.5,822,458.2,820.7,456.7,820.7z"/>
                                    <path class="st48" d="M429.2,1005.8L429.2,1005.8c-1.5,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.5,5.6-5.5
										c3.1,0,5.6,2.6,5.6,5.6C434.8,1003.4,432.3,1005.8,429.2,1005.8z M429.3,997.5c-1.6,0-2.8,1.2-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8C432.1,998.7,430.8,997.5,429.3,997.5z"/>
								</g>
                                <g>
									<path class="st48" d="M567.8,1136.1c-0.8,0-1.4-0.6-1.4-1.4l0.9-81.8c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l-0.9,81.8C569.2,1135.5,568.6,1136.1,567.8,1136.1z"/>
                                    <path class="st48" d="M568.8,1054.2L568.8,1054.2c-3.2,0-5.6-2.6-5.6-5.7c0-3,2.6-5.5,5.6-5.5c1.6,0,3,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C574.3,1051.7,571.8,1054.2,568.8,1054.2z M568.8,1045.8c-1.6,0-2.8,1.2-2.8,2.8
										c0,1.5,1.2,2.8,2.8,2.8l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2C570.3,1046.1,569.6,1045.8,568.8,1045.8z"/>
                                    <path class="st48" d="M567.8,1144.5L567.8,1144.5c-3.2,0-5.6-2.6-5.6-5.7c0-3,2.6-5.5,5.6-5.5c1.6,0,3,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C573.4,1142,570.9,1144.5,567.8,1144.5z M567.9,1136.1c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8
										l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2C569.3,1136.4,568.6,1136.1,567.9,1136.1z"/>
								</g>
                                <g>
									<path class="st48" d="M680.2,981.1c-0.8,0-1.4-0.6-1.4-1.4l-0.2-121.3c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l0.2,121.3C681.6,980.5,681,981.1,680.2,981.1z"/>
                                    <path class="st48" d="M679.9,859.8c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										c0,1.5-0.6,2.9-1.6,4C682.9,859.2,681.5,859.8,679.9,859.8L679.9,859.8z M679.9,851.4c-1.6,0-2.8,1.3-2.8,2.8
										c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C682.7,852.6,681.5,851.4,679.9,851.4z"/>
                                    <path class="st48" d="M680.6,989.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.7,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C683.6,989,682.2,989.6,680.6,989.6L680.6,989.6z M680.6,981.2
										c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8
										c0.5-0.5,0.8-1.2,0.8-2C683.4,982.4,682.2,981.2,680.6,981.2z"/>
								</g>
                                <g>
									<path class="st48" d="M424.5,774.6c-0.2,0-0.5-0.1-0.7-0.2l-23.6-13.9c-0.4-0.2-0.7-0.7-0.7-1.2l0.7-256.5
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.7,255.7l22.9,13.5c0.7,0.4,0.9,1.2,0.5,1.9
										C425.4,774.4,424.9,774.6,424.5,774.6z"/>
                                    <path class="st48" d="M401.6,504.2L401.6,504.2c-1.5,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7c1,1.1,1.6,2.5,1.6,4C407.1,501.7,404.6,504.2,401.6,504.2z M401.6,495.8c-1.6,0-2.8,1.2-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C403,496.1,402.3,495.8,401.6,495.8z"/>
                                    <path class="st48" d="M428.1,780.9c-1,0-2-0.3-2.8-0.8c-1.3-0.8-2.2-2-2.6-3.4c-0.4-1.4-0.2-3,0.6-4.2
										c1.5-2.6,5.1-3.5,7.7-2c2.7,1.6,3.5,5,2,7.7C431.9,779.9,430,780.9,428.1,780.9z M428.1,772.6c-1,0-1.9,0.5-2.4,1.4
										c-0.4,0.6-0.5,1.4-0.3,2.1c0.2,0.7,0.6,1.3,1.3,1.7c1.3,0.8,3.1,0.3,3.8-1c0.8-1.3,0.3-3.1-1-3.8
										C429.1,772.7,428.6,772.6,428.1,772.6z"/>
								</g>
                                <g>
									<path class="st48" d="M429.7,739.8c-0.8,0-1.4-0.6-1.4-1.4V710c0-0.5,0.3-0.9,0.7-1.2l26.8-16.3v-66.4
										c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v67.2c0,0.5-0.3,0.9-0.7,1.2l-26.8,16.3v27.6C431.1,739.1,430.5,739.8,429.7,739.8z
										"/>
                                    <path class="st48" d="M457.1,627.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6
										C462.7,624.9,460.2,627.4,457.1,627.4z M457.1,619.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C459.9,620.3,458.7,619.1,457.1,619.1z"/>
                                    <path class="st48" d="M429.7,748.2c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C435.3,745.6,432.8,748.2,429.7,748.2z M429.7,739.8c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C432.5,741,431.2,739.8,429.7,739.8z"/>
								</g>
                                <g>
									<path class="st48" d="M428.9,674.9c-0.8,0-1.4-0.6-1.4-1.4l0.2-29.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l-0.2,29.2C430.3,674.3,429.6,674.9,428.9,674.9z"/>
                                    <path class="st48" d="M429.5,645.6h-0.1c-1.5,0-2.9-0.6-3.9-1.7c-1-1.1-1.6-2.5-1.5-4c0.1-3,2.6-5.5,5.6-5.5
										c1.6,0,3,0.6,4.1,1.7c1,1.1,1.6,2.5,1.5,4C435,643.1,432.5,645.6,429.5,645.6z M429.5,637.2c-1.6,0-2.8,1.2-2.9,2.7
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.9,2,0.9l0.1,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.7c0-0.7-0.3-1.5-0.8-2
										C431,637.5,430.3,637.2,429.5,637.2z"/>
                                    <path class="st48" d="M428.8,683.3h-0.1c-1.5,0-2.9-0.6-3.9-1.7c-1-1.1-1.6-2.5-1.5-4c0.1-3,2.6-5.5,5.6-5.5
										c1.6,0,3,0.6,4.1,1.7c1,1.1,1.6,2.5,1.5,4C434.3,680.8,431.8,683.3,428.8,683.3z M428.8,674.9c-1.6,0-2.8,1.2-2.9,2.7
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.9l0.1,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.7c0-0.7-0.3-1.5-0.8-2
										C430.3,675.2,429.6,674.9,428.8,674.9z"/>
								</g>
                                <g>
									<path class="st48" d="M400.7,852.9c-0.8,0-1.4-0.6-1.4-1.4l0.3-56.6c0-0.8,0.7-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l-0.3,56.6C402.1,852.3,401.5,852.9,400.7,852.9z"/>
                                    <path class="st48" d="M401.1,796.3L401.1,796.3c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c3.1,0,5.6,2.5,5.6,5.6C406.7,793.8,404.2,796.3,401.1,796.3z M401.1,787.9c-1.6,0-2.8,1.3-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C403.9,789.2,402.7,787.9,401.1,787.9z"/>
                                    <path class="st48" d="M400.7,861.3L400.7,861.3c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7c1.1,1.1,1.6,2.5,1.6,4C406.3,858.8,403.8,861.3,400.7,861.3z M400.7,852.9c-1.6,0-2.8,1.2-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C402.2,853.2,401.5,852.9,400.7,852.9z"/>
								</g>
							</g>
                            <g>
								<g>
									<path class="st48" d="M624.5,656.5c-0.8,0-1.4-0.6-1.4-1.4l0.3-216.3c0-0.5,0.3-1,0.7-1.2l26.5-15.3v-64.1
										c0-0.5,0.3-1,0.7-1.2l27.2-15.6V259c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v83.2c0,0.5-0.3,1-0.7,1.2L653.4,359v64.1
										c0,0.5-0.3,1-0.7,1.2l-26.5,15.3l-0.3,215.5C625.9,655.9,625.2,656.5,624.5,656.5z"/>
                                    <path class="st48" d="M679.9,260.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C685.5,257.9,683,260.4,679.9,260.4z M679.9,252c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C682.8,253.3,681.5,252,679.9,252z"/>
                                    <path class="st48" d="M624.5,664.9c-1.5,0-2.9-0.6-4-1.6c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.6c1.1,1.1,1.6,2.5,1.6,4C630.1,662.4,627.6,664.9,624.5,664.9z M624.5,656.5c-1.5,0-2.8,1.3-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C625.9,656.8,625.2,656.5,624.5,656.5z"/>
								</g>
                                <g>
									<path class="st48" d="M597.2,516.5c-0.8,0-1.4-0.6-1.4-1.4l0.9-156.7c0-0.5,0.3-0.9,0.7-1.2l54.2-32.2l-0.9-153.4
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.9,154.2c0,0.5-0.3,1-0.7,1.2l-54.2,32.2l-0.9,156
										C598.5,515.9,597.9,516.5,597.2,516.5z"/>
                                    <path class="st48" d="M652,173c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.7,3.9-1.7c3.1,0,5.6,2.5,5.6,5.6
										C657.6,170.5,655.2,173,652,173L652,173z M652,164.6c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8
										l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C654.8,165.9,653.6,164.6,652,164.6z"/>
                                    <path class="st48" d="M597.2,524.9L597.2,524.9c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c3.1,0,5.6,2.5,5.6,5.6C602.7,522.4,600.2,524.9,597.2,524.9z M597.2,516.5c-1.6,0-2.8,1.2-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2C598.6,516.8,597.9,516.5,597.2,516.5z"/>
								</g>
                                <g>
									<path class="st48" d="M625.1,403c-0.8,0-1.4-0.6-1.4-1.4v-23.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v23.2
										C626.5,402.4,625.8,403,625.1,403z"/>
                                    <path class="st48" d="M625.1,379.8c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C630.7,377.3,628.1,379.8,625.1,379.8z M625.1,371.4c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C627.9,372.6,626.6,371.4,625.1,371.4z"/>
                                    <path class="st48" d="M625.1,411.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C630.7,408.9,628.1,411.4,625.1,411.4z M625.1,403c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C627.9,404.3,626.6,403,625.1,403z"/>
								</g>
                                <g>
									<path class="st48" d="M680.9,738.1c-0.8,0-1.4-0.6-1.4-1.4V535.9l-28-15.9c-0.4-0.2-0.7-0.7-0.7-1.2l-0.3-59.3
										c0-0.8,0.7-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.3,58.5l28,15.9c0.4,0.2,0.7,0.7,0.7,1.2v201.6
										C682.3,737.5,681.6,738.1,680.9,738.1z"/>
                                    <path class="st48" d="M651.1,460.7c-3,0-5.5-2.5-5.6-5.5c0-3.1,2.4-5.6,5.5-5.7c3.1,0,5.6,2.5,5.7,5.5
										C656.7,458.1,654.3,460.7,651.1,460.7L651.1,460.7z M651.1,452.3c-1.6,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4
										c1.5,0,2.8-1.3,2.8-2.8C653.9,453.5,652.6,452.3,651.1,452.3z"/>
                                    <path class="st48" d="M680.9,746.5c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6S684,746.5,680.9,746.5z
										 M680.9,738.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8C683.7,739.4,682.4,738.1,680.9,738.1z"
                                    />
								</g>
                                <g>
									<path class="st48" d="M652.4,593.5c-0.8,0-1.4-0.6-1.4-1.4l0.5-37c0-0.8,0.7-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.5,37
										C653.8,592.9,653.2,593.5,652.4,593.5z"/>
                                    <path class="st48" d="M653,556.5L653,556.5c-3.1,0-5.6-2.6-5.6-5.7c0-3,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.7
										C658.5,554,656,556.5,653,556.5z M653,548.1c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4
										c1.5,0,2.8-1.2,2.8-2.8C655.8,549.4,654.5,548.1,653,548.1z"/>
                                    <path class="st48" d="M652,602.1L652,602.1c-3.1,0-5.6-2.6-5.6-5.7c0-3,2.5-5.5,5.6-5.5c1.6,0,3,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C657.6,599.6,655.1,602.1,652,602.1z M652.1,593.7c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8
										l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2C653.5,594,652.8,593.7,652.1,593.7z"/>
								</g>
                                <g>
									<path class="st48" d="M624.1,306.2c-0.8,0-1.4-0.6-1.4-1.4l-0.3-74.7c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l0.3,74.7C625.5,305.6,625,306.4,624.1,306.2z"/>
                                    <path class="st48" d="M623.8,231.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C626.7,231,625.3,231.6,623.8,231.6z M623.8,223.2c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C626.6,224.4,625.3,223.2,623.8,223.2z"/>
                                    <path class="st48" d="M624.1,314.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C627,314.1,625.6,314.6,624.1,314.6z M624.1,306.2c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C626.9,307.5,625.7,306.2,624.1,306.2z"/>
								</g>
                                <g>
									<path class="st48" d="M541.3,552.5c-0.8,0-1.4-0.6-1.4-1.4v-96c0-0.5,0.3-1,0.7-1.2l27.2-15.4l-0.2-95.9
										c0-0.5,0.3-0.9,0.7-1.2L595,325l0.1-126.5c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.1,127.2c0,0.5-0.3,0.9-0.7,1.2
										l-26.7,16.3l0.2,96c0,0.5-0.3,1-0.7,1.2l-27.2,15.4v95.2C542.7,551.9,542.1,552.5,541.3,552.5z"/>
                                    <path class="st48" d="M596.5,200c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c1.5,0,2.9,0.6,4,1.6c1.1,1.1,1.6,2.5,1.6,4
										c0,1.5-0.6,2.9-1.6,4C599.4,199.4,597.9,200,596.5,200z M596.5,191.6c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8
										c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2c0-0.7-0.3-1.5-0.8-2C597.9,191.8,597.2,191.6,596.5,191.6z"/>
                                    <path class="st48" d="M541.3,560.9c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C546.9,558.4,544.4,560.9,541.3,560.9z M541.3,552.5c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C544.1,553.8,542.9,552.5,541.3,552.5z"/>
								</g>
                                <g>
									<path class="st48" d="M597.2,626.3c-0.8,0-1.4-0.6-1.4-1.4v-71.3l-28.2-18.2c-0.4-0.3-0.6-0.7-0.6-1.2v-59.1
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v58.3l28.2,18.2c0.4,0.3,0.6,0.7,0.6,1.2v72.1
										C598.5,625.6,597.9,626.3,597.2,626.3z"/>
                                    <path class="st48" d="M568.3,476.5c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C573.9,474,571.4,476.5,568.3,476.5z M568.3,468.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C571.1,469.4,569.9,468.1,568.3,468.1z"/>
                                    <path class="st48" d="M597.2,634.7c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C602.7,632.2,600.2,634.7,597.2,634.7z M597.2,626.3c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C600,627.5,598.7,626.3,597.2,626.3z"/>
								</g>
                                <g>
									<path class="st48" d="M456.7,591.4L456.7,591.4c-0.8,0-1.4-0.7-1.4-1.4l0.5-22.3c0-0.5,0.3-0.9,0.7-1.2l27.2-15.4v-96.9
										c0-0.5,0.3-0.9,0.7-1.2l26.8-16.3l0.9-159.2c0-0.5,0.3-0.9,0.7-1.2l54.2-31.7l-0.2-23.9c0-0.8,0.6-1.4,1.4-1.4
										c0.8-0.1,1.4,0.6,1.4,1.4l0.2,24.7c0,0.5-0.3,1-0.7,1.2l-54.2,31.7l-0.9,159.2c0,0.5-0.3,0.9-0.7,1.2L486.4,455v96.9
										c0,0.5-0.3,1-0.7,1.2l-27.2,15.4l-0.4,21.5C458.1,590.8,457.4,591.4,456.7,591.4z"/>
                                    <path class="st48" d="M568.1,221.8c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1.1-1.1,2.5-1.6,3.9-1.6
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C571,221.2,569.6,221.8,568.1,221.8z M568.1,213.4c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C570.9,214.7,569.6,213.4,568.1,213.4z"/>
                                    <path class="st48" d="M456.7,599.8L456.7,599.8c-3.1,0-5.6-2.6-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.6,5.6,5.6
										C462.2,597.3,459.7,599.8,456.7,599.8z M456.7,591.4c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4
										c1.5,0,2.8-1.2,2.8-2.8C459.5,592.7,458.2,591.4,456.7,591.4z"/>
								</g>
                                <g>
									<path class="st48" d="M540.2,419.8c-0.8,0-1.4-0.6-1.4-1.4l0.2-92.5c0-0.5,0.3-1,0.7-1.2l27.4-15.5v-27.6
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4V310c0,0.5-0.3,1-0.7,1.2l-27.4,15.5l-0.2,91.7
										C541.6,419.2,540.9,419.8,540.2,419.8z"/>
                                    <path class="st48" d="M568.5,283c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C574.1,280.5,571.6,283,568.5,283z M568.5,274.6c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C571.3,275.9,570,274.6,568.5,274.6z"/>
                                    <path class="st48" d="M540.2,428.4c-1.5,0-2.9-0.6-4-1.6c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c3.1,0,5.6,2.5,5.6,5.6C545.8,425.9,543.2,428.4,540.2,428.4z M540.2,420c-1.5,0-2.8,1.3-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C543,421.2,541.7,420,540.2,420z"/>
								</g>
                                <g>
									<path class="st48" d="M484.6,654.2c-0.8,0-1.4-0.6-1.4-1.4l0.3-69.2c0-0.5,0.3-0.9,0.7-1.2l26.9-16.3l-0.1-91
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.1,91.8c0,0.5-0.3,0.9-0.7,1.2l-26.9,16.3l-0.3,68.4
										C486,653.6,485.4,654.2,484.6,654.2z"/>
                                    <path class="st48" d="M512.4,476.4c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c2.1-2.1,5.8-2.1,7.9,0
										c1.1,1.1,1.6,2.5,1.6,4c0,1.5-0.6,2.9-1.6,4C515.3,475.8,513.9,476.4,512.4,476.4z M512.4,468c-0.7,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C515.2,469.3,514,468,512.4,468z
										"/>
                                    <path class="st48" d="M484.6,662.6L484.6,662.6c-3.1,0-5.6-2.6-5.6-5.6c0-3.1,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.6
										C490.2,660.1,487.6,662.6,484.6,662.6z M484.6,654.2c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4l0-1.4
										c1.5,0,2.8-1.2,2.8-2.8C487.4,655.5,486.1,654.2,484.6,654.2z"/>
								</g>
                                <g>
									<path class="st48" d="M428.9,609.5c-0.8,0-1.4-0.6-1.4-1.4v-57c0-0.5,0.3-0.9,0.7-1.2l27.8-17v-94.1c0-0.5,0.2-0.9,0.6-1.2
										l28-17.7l-1.4-159.7c0-0.5,0.3-1,0.7-1.2l55.3-30.5L539,192c0-0.8,0.6-1.4,1.4-1.4c0.7,0,1.4,0.6,1.4,1.4l0.2,37.2
										c0,0.5-0.3,1-0.7,1.2L486,261l1.4,159.6c0,0.5-0.2,0.9-0.6,1.2l-28,17.7v94.1c0,0.5-0.3,0.9-0.7,1.2l-27.8,17v56.2
										C430.3,608.9,429.7,609.5,428.9,609.5z"/>
                                    <path class="st48" d="M540.4,193.4c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.6,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.6C546,190.9,543.5,193.4,540.4,193.4z M540.4,185c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2
										c0,1.5,1.3,2.8,2.8,2.8v1.4v-1.4c1.5,0,2.8-1.3,2.8-2.8C543.2,186.3,541.9,185,540.4,185z"/>
                                    <path class="st48" d="M428.9,617.9c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6S432,617.9,428.9,617.9z
										 M428.9,609.5c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8C431.7,610.8,430.5,609.5,428.9,609.5z"
                                    />
								</g>
                                <g>
									<path class="st48" d="M512.7,210c-0.8,0-1.4-0.6-1.4-1.4l-0.2-36.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0.2,36.6
										C514.1,209.3,513.5,210,512.7,210z"/>
                                    <path class="st48" d="M512.3,173c-3.1,0-5.6-2.5-5.6-5.5c0-1.5,0.6-2.9,1.6-4c1-1.1,2.4-1.7,3.9-1.7c3.1,0,5.6,2.5,5.6,5.5
										c0,1.5-0.6,2.9-1.6,4C515.2,172.4,513.8,173,512.3,173L512.3,173z M512.3,164.6c-0.8,0-1.5,0.3-2,0.8
										c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c0.7,0,1.4-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2
										C515,165.9,513.8,164.6,512.3,164.6z"/>
                                    <path class="st48" d="M512.7,218.4c-3.1,0-5.6-2.5-5.6-5.5c0-3.1,2.5-5.6,5.5-5.6c3.1,0,5.6,2.5,5.6,5.5
										C518.4,215.8,515.9,218.3,512.7,218.4L512.7,218.4z M512.7,210c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2
										c0,1.5,1.3,2.8,2.8,2.8v1.4l0-1.4c1.5,0,2.8-1.3,2.8-2.8C515.5,211.2,514.3,210,512.7,210z"/>
								</g>
                                <g>
									<path class="st48" d="M400.9,468.1c-0.8,0-1.4-0.6-1.4-1.4v-60c0-0.5,0.3-0.9,0.7-1.2l27.2-16.3l0.5-63.5
										c0-0.5,0.3-0.9,0.7-1.2l26.8-16.2v-63.4c0-0.5,0.3-1,0.7-1.2l27.2-15.2v-16.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										v17.1c0,0.5-0.3,1-0.7,1.2l-27.2,15.2v63.4c0,0.5-0.3,0.9-0.7,1.2l-26.8,16.2l-0.5,63.5c0,0.5-0.3,0.9-0.7,1.2l-27.2,16.3
										v59.2C402.3,467.5,401.6,468.1,400.9,468.1z"/>
                                    <path class="st48" d="M484.8,213.4L484.8,213.4c-3.1,0-5.6-2.6-5.6-5.7c0-3.1,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.7
										C490.4,211,487.9,213.4,484.8,213.4z M484.9,205c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8l0,1.4v-1.4
										c1.5,0,2.8-1.2,2.8-2.8C487.6,206.3,486.4,205.1,484.9,205z"/>
                                    <path class="st48" d="M400.9,476.5c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C406.5,474,403.9,476.5,400.9,476.5z M400.9,468.1c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C403.7,469.4,402.4,468.1,400.9,468.1z"/>
								</g>
                                <g>
									<path class="st48" d="M429.2,516.5c-0.8,0-1.4-0.6-1.4-1.4l0.9-93c0-0.5,0.3-1,0.7-1.2l25.8-13.6v-60.5
										c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v61.4c0,0.5-0.3,1-0.7,1.2l-25.8,13.6l-0.9,92.2
										C430.6,515.9,430,516.5,429.2,516.5z"/>
                                    <path class="st48" d="M456.7,348.1c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C462.3,345.6,459.8,348.1,456.7,348.1z M456.7,339.7c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C459.5,341,458.2,339.7,456.7,339.7z"/>
                                    <path class="st48" d="M429.2,524.9L429.2,524.9c-1.5,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.5,5.6-5.5
										c3.1,0,5.6,2.6,5.6,5.6C434.8,522.4,432.3,524.9,429.2,524.9z M429.3,516.5c-1.6,0-2.8,1.2-2.8,2.8c0,0.7,0.3,1.5,0.8,2
										c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8C432.1,517.8,430.8,516.5,429.3,516.5z"/>
								</g>
                                <g>
									<path class="st48" d="M567.8,666.3c-0.8,0-1.4-0.6-1.4-1.4l0.9-93c0-0.8,0.8-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.9,93
										C569.2,665.7,568.6,666.3,567.8,666.3z"/>
                                    <path class="st48" d="M568.8,573.3L568.8,573.3c-3.2,0-5.6-2.6-5.6-5.7c0-3,2.6-5.5,5.6-5.5c1.6,0,3,0.6,4,1.7
										c1,1.1,1.6,2.5,1.6,4C574.3,570.8,571.8,573.3,568.8,573.3z M568.8,564.9c-1.6,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8
										l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2C570.3,565.2,569.6,564.9,568.8,564.9z"/>
                                    <path class="st48" d="M567.8,674.7L567.8,674.7c-1.6,0-3-0.6-4-1.7c-1-1.1-1.6-2.5-1.6-4c0-3,2.6-5.5,5.6-5.5
										c1.6,0,3,0.6,4,1.7c1,1.1,1.6,2.5,1.6,4C573.4,672.2,570.9,674.7,567.8,674.7z M567.9,666.3c-1.6,0-2.8,1.2-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.9l0,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C569.3,666.6,568.6,666.3,567.9,666.3z"/>
								</g>
                                <g>
									<path class="st48" d="M680.2,500.1c-0.8,0-1.4-0.6-1.4-1.4l-0.2-121.3c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l0.2,121.3C681.6,499.5,681,500.1,680.2,500.1z"/>
                                    <path class="st48" d="M679.9,378.8c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										c0,1.5-0.6,2.9-1.6,4C682.9,378.2,681.5,378.8,679.9,378.8L679.9,378.8z M679.9,370.4c-1.6,0-2.8,1.3-2.8,2.8
										c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2C682.7,371.7,681.5,370.4,679.9,370.4z"/>
                                    <path class="st48" d="M680.6,508.6c-3.1,0-5.6-2.5-5.6-5.6c0-1.5,0.6-2.9,1.6-4c1-1.1,2.5-1.7,3.9-1.7
										c3.1,0,5.6,2.5,5.6,5.6c0,1.5-0.6,2.9-1.6,4C683.6,508,682.2,508.6,680.6,508.6L680.6,508.6z M680.6,500.2
										c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2c0,1.5,1.3,2.8,2.8,2.8l0,1.4l0-1.4c0.7,0,1.5-0.3,2-0.8
										c0.5-0.5,0.8-1.2,0.8-2C683.4,501.5,682.2,500.2,680.6,500.2z"/>
								</g>
                                <g>
									<path class="st48" d="M424.5,293.7c-0.2,0-0.5-0.1-0.7-0.2l-23.6-13.9c-0.4-0.3-0.7-0.7-0.7-1.2l0.7-60.3
										c0-0.8,0.7-1.3,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.7,59.5l22.9,13.5c0.7,0.4,0.9,1.2,0.5,1.9
										C425.4,293.4,424.9,293.7,424.5,293.7z"/>
                                    <path class="st48" d="M401.6,219.5L401.6,219.5c-1.5,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7s1.6,2.5,1.6,4C407.1,217,404.6,219.5,401.6,219.5z M401.6,211.1c-1.6,0-2.8,1.2-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C403,211.4,402.3,211.1,401.6,211.1z"/>
                                    <path class="st48" d="M428.1,300c-1,0-2-0.3-2.8-0.8c-1.3-0.8-2.2-2-2.6-3.4c-0.4-1.4-0.2-3,0.6-4.2c1.5-2.5,5.1-3.5,7.7-2
										c2.7,1.6,3.5,5,2,7.7C431.9,298.9,430,300,428.1,300z M428.1,291.6c-1,0-1.9,0.5-2.4,1.4c-0.4,0.6-0.5,1.4-0.3,2.1
										c0.2,0.7,0.6,1.3,1.3,1.7c1.3,0.8,3.1,0.3,3.8-1c0.8-1.3,0.3-3.1-1-3.8C429.1,291.7,428.6,291.6,428.1,291.6z"/>
								</g>
                                <g>
									<path class="st48" d="M429.7,258.8c-0.8,0-1.4-0.6-1.4-1.4V229c0-0.5,0.3-0.9,0.7-1.2l26.8-16.3v-24.1
										c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v24.9c0,0.5-0.3,0.9-0.7,1.2l-26.8,16.3v27.6C431.1,258.2,430.5,258.8,429.7,258.8z
										"/>
                                    <path class="st48" d="M457.1,188.8c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6
										C462.7,186.3,460.2,188.8,457.1,188.8z M457.1,180.4c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C459.9,181.6,458.7,180.4,457.1,180.4z"/>
                                    <path class="st48" d="M429.7,267.2c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6
										C435.3,264.7,432.8,267.2,429.7,267.2z M429.7,258.8c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8
										C432.5,260.1,431.2,258.8,429.7,258.8z"/>
								</g>
                                <g>
									<path class="st48" d="M428.9,193.9c-0.8,0-1.4-0.6-1.4-1.4l0.2-20.8c0-0.8,0.5-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
										l-0.2,20.8C430.3,193.3,429.6,193.9,428.9,193.9z"/>
                                    <path class="st48" d="M429.5,173l-0.1,0c-1.5,0-2.9-0.6-3.9-1.7c-1-1.1-1.6-2.5-1.5-4c0.1-3,2.6-5.5,5.6-5.5
										c1.6,0,3,0.7,4.1,1.7c1,1.1,1.6,2.5,1.5,4C435,170.6,432.5,173,429.5,173z M429.5,164.6c-1.6,0-2.8,1.2-2.9,2.7
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.9l0.1,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.7c0-0.7-0.3-1.5-0.8-2
										C431,164.9,430.3,164.6,429.5,164.6z"/>
                                    <path class="st48" d="M428.8,202.3l-0.1,0c-3.1-0.1-5.5-2.6-5.5-5.7c0.1-3,2.6-5.5,5.6-5.5c1.6,0,3,0.7,4.1,1.7
										c1,1.1,1.6,2.5,1.5,4C434.3,199.9,431.8,202.3,428.8,202.3z M428.9,193.9c-1.6,0-2.8,1.2-2.9,2.7c0,1.5,1.2,2.8,2.7,2.9
										l0.1,1.4v-1.4c1.5,0,2.8-1.2,2.8-2.7c0-0.7-0.3-1.5-0.8-2C430.3,194.2,429.6,193.9,428.9,193.9z"/>
								</g>
                                <g>
									<path class="st48" d="M400.7,372c-0.8,0-1.4-0.6-1.4-1.4l0.3-56.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l-0.3,56.6
										C402.1,371.3,401.5,372,400.7,372z"/>
                                    <path class="st48" d="M401.1,315.3L401.1,315.3c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7c1.1,1.1,1.6,2.5,1.6,4C406.7,312.8,404.2,315.3,401.1,315.3z M401.1,306.9c-1.6,0-2.8,1.3-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C402.6,307.2,401.9,307,401.1,306.9z"/>
                                    <path class="st48" d="M400.7,380.3L400.7,380.3c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.5-1.6-4c0-3.1,2.5-5.6,5.6-5.6
										c1.5,0,2.9,0.6,4,1.7c1.1,1.1,1.6,2.5,1.6,4C406.3,377.9,403.8,380.3,400.7,380.3z M400.7,372c-1.6,0-2.8,1.3-2.8,2.8
										c0,0.7,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,2,0.8l0,1.4l0-1.4c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.3-1.5-0.8-2
										C402.2,372.3,401.5,372,400.7,372z"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
            <g>
				<g>
					<g>
						<path class="st53" d="M939.4,382.5c4.5-2.6,4.6-6.9,0-9.5L865,330.5c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43
							c-4.5,2.6-4.6,6.9,0,9.5l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L939.4,382.5z"/>
                        <path class="st54" d="M939.1,382.3c4.5-2.6,4.5-6.9,0-9.5L865,330.5c-4.5-2.6-11.8-2.6-16.4,0l-71.6,42.7
							c-4.5,2.6-4.6,6.9,0,9.5l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L939.1,382.3z"/>
                        <path class="st55" d="M938.9,382.1c4.5-2.6,4.5-6.8,0-9.5L865,330.5c-4.5-2.6-11.8-2.6-16.3,0L777.5,373
							c-4.5,2.6-4.5,6.8,0,9.5l69,39.4c7.4,3.8,19.6,4.7,27-0.7L938.9,382.1z"/>
                        <path class="st56" d="M938.6,382c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0l-70.9,42.2c-4.5,2.6-4.5,6.8,0,9.4
							l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L938.6,382z"/>
                        <path class="st57" d="M938.3,381.8c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L938.3,381.8z"/>
                        <path class="st58" d="M938,381.6c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L938,381.6z"/>
                        <path class="st59" d="M937.7,381.4c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L937.7,381.4z"/>
                        <path class="st60" d="M937.4,381.2c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L937.4,381.2z"/>
                        <path class="st61" d="M937.1,381.1c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L937.1,381.1z"/>
                        <path class="st62" d="M936.8,380.9c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L936.8,380.9z"/>
                        <path class="st63" d="M936.5,380.7c4.4-2.6,4.4-6.7,0-9.3l-71.3-40.8c-4.4-2.6-11.6-2.5-16,0l-68.7,40.6
							c-4.4,2.6-4.4,6.7,0,9.3l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L936.5,380.7z"/>
                        <path class="st64" d="M936.2,380.5c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0L781,371c-4.4,2.6-4.4,6.7,0,9.2
							l65.3,37.4c6.6,3.5,20.8,4.6,27.3-0.1L936.2,380.5z"/>
                        <path class="st65" d="M936,380.3c4.4-2.5,4.4-6.7,0-9.2l-70.6-40.5c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1c-4.4,2.5-4.4,6.7,0,9.2
							l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L936,380.3z"/>
                        <path class="st66" d="M935.7,380.2c4.4-2.5,4.4-6.7,0-9.2l-70.3-40.3c-4.4-2.5-11.5-2.5-15.9,0l-67.7,39.8
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L935.7,380.2z"/>
                        <path class="st67" d="M935.4,380c4.4-2.5,4.4-6.6,0-9.2l-70-40.1c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6c-4.4,2.5-4.4,6.6,0,9.2
							l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L935.4,380z"/>
                        <path class="st68" d="M935.1,379.8c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L935.1,379.8z"/>
                        <path class="st69" d="M934.8,379.6c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0L783,369.9
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L934.8,379.6z"/>
                        <path class="st70" d="M934.5,379.5c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0l-66.4,38.9
							c-4.3,2.5-4.4,6.6,0,9.1l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L934.5,379.5z"/>
                        <path class="st71" d="M934.2,379.3c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0l-66.1,38.7
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L934.2,379.3z"/>
                        <path class="st72" d="M933.9,379.1c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0l-65.8,38.4c-4.3,2.5-4.3,6.5,0,9
							l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L933.9,379.1z"/>
                        <path class="st73" d="M933.6,378.9c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0L784.6,369c-4.3,2.5-4.3,6.5,0,9
							l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L933.6,378.9z"/>
                        <path class="st74" d="M933.4,378.7c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0L785,368.8c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L933.4,378.7z"/>
                        <path class="st75" d="M933.1,378.6c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0l-64.8,37.7c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L933.1,378.6z"/>
                        <path class="st76" d="M932.8,378.4c4.3-2.5,4.3-6.5,0-8.9l-67.1-38.6c-4.3-2.5-11.2-2.5-15.4,0l-64.5,37.5
							c-4.3,2.5-4.3,6.5,0,8.9l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L932.8,378.4z"/>
                        <path class="st77" d="M932.5,378.2c4.3-2.5,4.3-6.5,0-8.9l-66.8-38.4c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L932.5,378.2z"/>
                        <path class="st78" d="M932.2,378c4.2-2.5,4.3-6.4,0-8.9l-66.4-38.3c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37c-4.2,2.5-4.3,6.4,0,8.9
							l59.6,34.3c5.4,3,22.6,4.5,28,0.9L932.2,378z"/>
                        <path class="st79" d="M931.9,377.8c4.2-2.5,4.3-6.4,0-8.9l-66.1-38.1c-4.2-2.4-11.1-2.4-15.3,0L787,367.7
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L931.9,377.8z"/>
                        <path class="st80" d="M931.6,377.7c4.2-2.4,4.2-6.4,0-8.8l-65.8-37.9c-4.2-2.4-11-2.4-15.3,0l-63.2,36.5
							c-4.2,2.4-4.2,6.4,0,8.8l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L931.6,377.7z"/>
                        <path class="st81" d="M931.3,377.5c4.2-2.4,4.2-6.4,0-8.8l-65.5-37.7c-4.2-2.4-11-2.4-15.2,0l-62.9,36.3
							c-4.2,2.4-4.2,6.4,0,8.8l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L931.3,377.5z"/>
                        <path class="st82" d="M931,377.3c4.2-2.4,4.2-6.4,0-8.8l-65.2-37.6c-4.2-2.4-11-2.4-15.2,0l-62.5,36c-4.2,2.4-4.2,6.4,0,8.8
							l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L931,377.3z"/>
                        <path class="st83" d="M930.8,377.1c4.2-2.4,4.2-6.3,0-8.8L866,331c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L930.8,377.1z"/>
                        <path class="st84" d="M930.5,376.9c4.2-2.4,4.2-6.3,0-8.7L866,331c-4.2-2.4-10.9-2.4-15.1,0L789,366.5c-4.2,2.4-4.2,6.3,0,8.7
							l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L930.5,376.9z"/>
                        <path class="st85" d="M930.2,376.8c4.2-2.4,4.2-6.3,0-8.7L866,331c-4.1-2.4-10.9-2.4-15,0l-61.6,35.3c-4.2,2.4-4.2,6.3,0,8.7
							l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L930.2,376.8z"/>
                        <path class="st86" d="M929.9,376.6c4.2-2.4,4.2-6.3,0-8.7L866.1,331c-4.1-2.4-10.9-2.4-15,0l-61.3,35.1
							c-4.2,2.4-4.2,6.3,0,8.7l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L929.9,376.6z"/>
                        <path class="st87" d="M929.6,376.4c4.1-2.4,4.2-6.3,0-8.7L866.1,331c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L929.6,376.4z"/>
                        <path class="st88" d="M929.3,376.2c4.1-2.4,4.1-6.3,0-8.6L866.1,331c-4.1-2.4-10.8-2.4-14.9,0l-60.6,34.6
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L929.3,376.2z"/>
                        <path class="st89" d="M929,376.1c4.1-2.4,4.1-6.2,0-8.6l-62.9-36.4c-4.1-2.4-10.8-2.4-14.9,0L791,365.4
							c-4.1,2.4-4.1,6.2,0,8.6l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L929,376.1z"/>
                        <path class="st90" d="M928.7,375.9c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1
							c-4.1,2.4-4.1,6.2,0,8.6l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L928.7,375.9z"/>
                        <path class="st91" d="M928.4,375.7c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0L791.8,365
							c-4.1,2.4-4.1,6.2,0,8.6l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L928.4,375.7z"/>
                        <path class="st92" d="M928.2,375.5c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L928.2,375.5z"/>
                        <path class="st93" d="M927.9,375.3c4.1-2.4,4.1-6.2,0-8.5l-61.6-35.7c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4
							c-4.1,2.4-4.1,6.2,0,8.5l53.4,31c4.1,2.4,24.5,4.4,28.6,2L927.9,375.3z"/>
                        <path class="st94" d="M927.6,375.2c4.1-2.3,4.1-6.1,0-8.5l-61.3-35.5c-4-2.3-10.6-2.3-14.7,0L793,364.3
							c-4.1,2.3-4.1,6.1,0,8.5l53,30.7c4,2.3,24.6,4.4,28.7,2.1L927.6,375.2z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000136395589330607787740000017616261157418999965_" gradientUnits="userSpaceOnUse" x1="277.269" y1="276.8793" x2="353.8152" y2="409.4613" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000136395589330607787740000017616261157418999965_);" d="M791,374l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C785.8,368.9,787.5,372,791,374z"/>

                        <linearGradient id="SVGID_00000058586189326384600870000002324538920779822244_" gradientUnits="userSpaceOnUse" x1="280.2301" y1="266.1826" x2="360.8282" y2="405.7827" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000058586189326384600870000002324538920779822244_);" d="M786.1,363.9l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C779.5,357.8,781.6,361.2,786.1,363.9z"/>
                        <g>
							<path class="st97" d="M779.9,345.4c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.6c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C779.8,351,779.9,348.2,779.9,345.4z"/>
                            <path class="st98" d="M779.8,336.7c0-1,0-2,0-2.8h0C779.8,334.9,779.8,335.9,779.8,336.7z"/>
						</g>

                        <linearGradient id="SVGID_00000082353331205327060940000013229679578351165328_" gradientUnits="userSpaceOnUse" x1="278.8185" y1="267.7737" x2="379.54" y2="392.1549" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000082353331205327060940000013229679578351165328_);" d="M786.1,342.3l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C779.5,336.2,781.6,339.7,786.1,342.3z"/>

                        <linearGradient id="SVGID_00000116950478145741769000000000993404486435548084_" gradientUnits="userSpaceOnUse" x1="411.3634" y1="342.8669" x2="282.4026" y2="285.4496" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000116950478145741769000000000993404486435548084_);" d="M791,330.9l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L791,314.2
							C783.1,318.8,783.1,326.3,791,330.9z"/>
                        <g>
							<path class="st48" d="M860.2,351.1c-3.6,0-7-0.8-9.6-2.3L815,328.2c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C867.2,350.3,863.8,351.1,860.2,351.1z M860.2,294.6c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C867,295.4,863.7,294.6,860.2,294.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000111187386370639265000000014882486753264415149_" cx="668.2251" cy="-1325.7668" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000111187386370639265000000014882486753264415149_);" d="M853,396.3
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C837,383.2,853.9,394.7,853,396.3z"/>

                            <radialGradient id="SVGID_00000093148004003280503760000001881131235146767770_" cx="668.5901" cy="-1339.7548" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000093148004003280503760000001881131235146767770_);" d="M855.9,393.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C839.9,380.7,856.8,392.3,855.9,393.9z"
                            />

                            <radialGradient id="SVGID_00000067958759547483938900000017309994496470376089_" cx="668.8502" cy="-1353.4803" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000067958759547483938900000017309994496470376089_);" d="M858.4,391.3
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C842.4,378.1,859.4,389.7,858.4,391.3z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000140729139257733124780000001269602712800571794_" cx="547.9155" cy="-371.0684" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000140729139257733124780000001269602712800571794_);" d="M864.6,397.4
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C880.6,384.2,863.6,395.8,864.6,397.4z"
                            />

                            <radialGradient id="SVGID_00000164496244041184176150000013933864942065888944_" cx="548.2805" cy="-385.0563" r="13.1621" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000164496244041184176150000013933864942065888944_);" d="M861.7,395
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C877.7,381.8,860.7,393.4,861.7,395z"/>

                            <radialGradient id="SVGID_00000073720788907982612190000013519635368555225217_" cx="548.5406" cy="-398.7811" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000073720788907982612190000013519635368555225217_);" d="M859.1,392.4
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C875.1,379.2,858.2,390.8,859.1,392.4z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000151502847335621035600000007801617749471156403_" gradientUnits="userSpaceOnUse" x1="307.1188" y1="247.0296" x2="383.665" y2="379.6116" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000151502847335621035600000007801617749471156403_);" d="M791,331.8l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C785.8,326.7,787.5,329.8,791,331.8z"/>

                        <linearGradient id="SVGID_00000060723416345050062080000018000806647665171104_" gradientUnits="userSpaceOnUse" x1="310.0799" y1="236.3329" x2="390.678" y2="375.933" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000060723416345050062080000018000806647665171104_);" d="M786.1,321.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C779.5,315.6,781.6,319,786.1,321.6z"/>
                        <g>
							<path class="st97" d="M779.9,303.1c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C779.8,308.8,779.9,306,779.9,303.1z"/>
                            <path class="st98" d="M779.8,294.5c0-1,0-2,0-2.8l0,0C779.8,292.7,779.8,293.7,779.8,294.5z"/>
						</g>

                        <linearGradient id="SVGID_00000046318678856909678020000005838152687328901521_" gradientUnits="userSpaceOnUse" x1="308.6682" y1="237.9241" x2="409.3897" y2="362.3052" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000046318678856909678020000005838152687328901521_);" d="M786.1,300.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C779.5,294,781.6,297.5,786.1,300.1z"/>

                        <linearGradient id="SVGID_00000053524299183921607270000002630095910561951158_" gradientUnits="userSpaceOnUse" x1="441.2131" y1="313.0174" x2="312.2523" y2="255.6" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000053524299183921607270000002630095910561951158_);" d="M791,288.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L791,272
							C783.1,276.6,783.1,284.1,791,288.7z"/>
                        <g>
							<path class="st48" d="M860.2,308.9c-3.6,0-7-0.8-9.6-2.3L815,286c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C867.2,308.1,863.8,308.9,860.2,308.9z M860.2,252.4c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C867,253.1,863.7,252.4,860.2,252.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000137827091342046333770000000471472498356974721_" cx="662.1215" cy="-1468.7642" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000137827091342046333770000000471472498356974721_);" d="M853,354.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C837,340.9,853.9,352.5,853,354.1z"/>

                            <radialGradient id="SVGID_00000054966948244469597400000012139624579263533475_" cx="662.4865" cy="-1482.7521" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000054966948244469597400000012139624579263533475_);" d="M855.9,351.7
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C839.9,338.5,856.8,350.1,855.9,351.7z"
                            />

                            <radialGradient id="SVGID_00000150092067388707963720000014058560529195221649_" cx="662.7466" cy="-1496.4764" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000150092067388707963720000014058560529195221649_);" d="M858.4,349.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C842.4,335.9,859.4,347.5,858.4,349.1z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000037674005907753420900000012766391454647345572_" cx="541.812" cy="-514.0644" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000037674005907753420900000012766391454647345572_);" d="M864.6,355.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C880.6,342,863.6,353.6,864.6,355.2z"/>

                            <radialGradient id="SVGID_00000030445338475371897180000004391797631323131558_" cx="542.1769" cy="-528.0527" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000030445338475371897180000004391797631323131558_);" d="M861.7,352.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C877.7,339.6,860.7,351.1,861.7,352.7z"
                            />

                            <radialGradient id="SVGID_00000129178366536212448090000001416991235436581766_" cx="542.437" cy="-541.778" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000129178366536212448090000001416991235436581766_);" d="M859.1,350.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C875.1,337,858.2,348.6,859.1,350.2z"/>
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000109027806624891204360000017953047815123107762_" gradientUnits="userSpaceOnUse" x1="336.8357" y1="217.3127" x2="413.3819" y2="349.8947" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000109027806624891204360000017953047815123107762_);" d="M791,289.8l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C785.8,284.7,787.5,287.7,791,289.8z"/>

                        <linearGradient id="SVGID_00000049218262746106738720000017546035079511817857_" gradientUnits="userSpaceOnUse" x1="339.7968" y1="206.616" x2="420.3949" y2="346.2161" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000049218262746106738720000017546035079511817857_);" d="M786.1,279.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C779.5,273.6,781.6,277,786.1,279.6z"/>
                        <g>
							<path class="st97" d="M779.9,261.1c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C779.8,266.8,779.9,264,779.9,261.1z"/>
                            <path class="st98" d="M779.8,252.5c0-1,0-2,0-2.8h0C779.8,250.7,779.8,251.6,779.8,252.5z"/>
						</g>

                        <linearGradient id="SVGID_00000059299020062477228850000009349632673808774282_" gradientUnits="userSpaceOnUse" x1="338.3851" y1="208.2071" x2="439.1067" y2="332.5882" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000059299020062477228850000009349632673808774282_);" d="M786.1,258.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C779.5,252,781.6,255.5,786.1,258.1z"/>

                        <linearGradient id="SVGID_00000065785742200872046910000009586324851907090334_" gradientUnits="userSpaceOnUse" x1="470.93" y1="283.3004" x2="341.9691" y2="225.8831" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000065785742200872046910000009586324851907090334_);" d="M791,246.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L791,230
							C783.1,234.6,783.1,242.1,791,246.7z"/>
                        <g>
							<path class="st48" d="M860.2,266.9c-3.6,0-7-0.8-9.6-2.3L815,244c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C867.2,266.1,863.8,266.9,860.2,266.9z M860.2,210.3c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								s1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								s-1.3-3.8-3.8-5.2l-35.7-20.6C867,211.1,863.7,210.3,860.2,210.3z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000029759231867123585940000000648288600618905504_" cx="656.0451" cy="-1611.1244" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000029759231867123585940000000648288600618905504_);" d="M853,312.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C837,298.9,853.9,310.5,853,312.1z"/>

                            <radialGradient id="SVGID_00000121975892078179462650000010649548711662178492_" cx="656.41" cy="-1625.1124" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000121975892078179462650000010649548711662178492_);" d="M855.9,309.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C839.9,296.5,856.8,308,855.9,309.6z"/>

                            <radialGradient id="SVGID_00000118368875695477022150000009614187873027596169_" cx="656.6702" cy="-1638.8367" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000118368875695477022150000009614187873027596169_);" d="M858.4,307.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C842.4,293.9,859.4,305.5,858.4,307.1z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000054948902669522554070000000941544787010971297_" cx="535.7355" cy="-656.4247" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000054948902669522554070000000941544787010971297_);" d="M864.6,313.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C880.6,300,863.6,311.6,864.6,313.2z"/>

                            <radialGradient id="SVGID_00000049922463858050534770000007859181420436773539_" cx="536.1005" cy="-670.413" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000049922463858050534770000007859181420436773539_);" d="M861.7,310.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C877.7,297.5,860.7,309.1,861.7,310.7z"
                            />

                            <radialGradient id="SVGID_00000132790838869547284740000004582917295215409847_" cx="536.3606" cy="-684.1382" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000132790838869547284740000004582917295215409847_);" d="M859.1,308.1
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C875.1,295,858.2,306.5,859.1,308.1z"/>
						</g>
					</g>
				</g>
                <g>
					<g>
						<path class="st53" d="M1054,630.8c4.5-2.6,4.6-6.9,0-9.5l-74.5-42.5c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43
							c-4.5,2.6-4.6,6.9,0,9.5l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L1054,630.8z"/>
                        <path class="st54" d="M1053.7,630.7c4.5-2.6,4.5-6.9,0-9.5l-74.2-42.3c-4.5-2.6-11.8-2.6-16.4,0l-71.6,42.7
							c-4.5,2.6-4.6,6.9,0,9.5l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L1053.7,630.7z"/>
                        <path class="st55" d="M1053.5,630.5c4.5-2.6,4.5-6.8,0-9.5l-73.8-42.2c-4.5-2.6-11.8-2.6-16.3,0l-71.3,42.5
							c-4.5,2.6-4.5,6.8,0,9.5l69,39.4c7.4,3.8,19.6,4.7,27-0.7L1053.5,630.5z"/>
                        <path class="st56" d="M1053.2,630.3c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0l-70.9,42.2
							c-4.5,2.6-4.5,6.8,0,9.4l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L1053.2,630.3z"/>
                        <path class="st57" d="M1052.9,630.1c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L1052.9,630.1z"/>
                        <path class="st58" d="M1052.6,629.9c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L1052.6,629.9z"/>
                        <path class="st59" d="M1052.3,629.8c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L1052.3,629.8z"/>
                        <path class="st60" d="M1052,629.6c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L1052,629.6z"/>
                        <path class="st61" d="M1051.7,629.4c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L1051.7,629.4z"/>
                        <path class="st62" d="M1051.4,629.2c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L1051.4,629.2z"/>
                        <path class="st63" d="M1051.1,629c4.4-2.6,4.4-6.7,0-9.3L979.9,579c-4.4-2.6-11.6-2.5-16,0l-68.7,40.6c-4.4,2.6-4.4,6.7,0,9.3
							l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L1051.1,629z"/>
                        <path class="st64" d="M1050.9,628.9c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0l-68.4,40.3
							c-4.4,2.6-4.4,6.7,0,9.2L961,666c6.6,3.5,20.8,4.6,27.3-0.1L1050.9,628.9z"/>
                        <path class="st65" d="M1050.6,628.7c4.4-2.5,4.4-6.7,0-9.2L980,579c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1c-4.4,2.5-4.4,6.7,0,9.2
							l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L1050.6,628.7z"/>
                        <path class="st66" d="M1050.3,628.5c4.4-2.5,4.4-6.7,0-9.2L980,579c-4.4-2.5-11.5-2.5-15.9,0l-67.7,39.8
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L1050.3,628.5z"/>
                        <path class="st67" d="M1050,628.3c4.4-2.5,4.4-6.6,0-9.2L980,579c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6c-4.4,2.5-4.4,6.6,0,9.2
							l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L1050,628.3z"/>
                        <path class="st68" d="M1049.7,628.1c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L1049.7,628.1z"/>
                        <path class="st69" d="M1049.4,628c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0l-66.7,39.1
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L1049.4,628z"/>
                        <path class="st70" d="M1049.1,627.8c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0L898,618c-4.3,2.5-4.4,6.6,0,9.1
							l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L1049.1,627.8z"/>
                        <path class="st71" d="M1048.8,627.6c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0l-66.1,38.7
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L1048.8,627.6z"/>
                        <path class="st72" d="M1048.5,627.4c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0l-65.8,38.4
							c-4.3,2.5-4.3,6.5,0,9l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L1048.5,627.4z"/>
                        <path class="st73" d="M1048.3,627.3c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0l-65.5,38.2
							c-4.3,2.5-4.3,6.5,0,9l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L1048.3,627.3z"/>
                        <path class="st74" d="M1048,627.1c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0l-65.1,37.9c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L1048,627.1z"/>
                        <path class="st75" d="M1047.7,626.9c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0L900,616.9c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L1047.7,626.9z"/>
                        <path class="st76" d="M1047.4,626.7c4.3-2.5,4.3-6.5,0-8.9l-67.1-38.6c-4.3-2.5-11.2-2.5-15.4,0l-64.5,37.5
							c-4.3,2.5-4.3,6.5,0,8.9l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L1047.4,626.7z"/>
                        <path class="st77" d="M1047.1,626.5c4.3-2.5,4.3-6.5,0-8.9l-66.8-38.4c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L1047.1,626.5z"/>
                        <path class="st78" d="M1046.8,626.4c4.2-2.5,4.3-6.4,0-8.9l-66.4-38.3c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37
							c-4.2,2.5-4.3,6.4,0,8.9l59.6,34.3c5.4,3,22.6,4.5,28,0.9L1046.8,626.4z"/>
                        <path class="st79" d="M1046.5,626.2c4.2-2.5,4.3-6.4,0-8.9l-66.1-38.1c-4.2-2.4-11.1-2.4-15.3,0L901.6,616
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L1046.5,626.2z"/>
                        <path class="st80" d="M1046.2,626c4.2-2.4,4.2-6.4,0-8.8l-65.8-37.9c-4.2-2.4-11-2.4-15.3,0L902,615.8c-4.2,2.4-4.2,6.4,0,8.8
							l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L1046.2,626z"/>
                        <path class="st81" d="M1045.9,625.8c4.2-2.4,4.2-6.4,0-8.8l-65.5-37.7c-4.2-2.4-11-2.4-15.2,0l-62.9,36.3
							c-4.2,2.4-4.2,6.4,0,8.8l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L1045.9,625.8z"/>
                        <path class="st82" d="M1045.7,625.6c4.2-2.4,4.2-6.4,0-8.8l-65.2-37.6c-4.2-2.4-11-2.4-15.2,0l-62.5,36
							c-4.2,2.4-4.2,6.4,0,8.8l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L1045.7,625.6z"/>
                        <path class="st83" d="M1045.4,625.5c4.2-2.4,4.2-6.3,0-8.8l-64.8-37.4c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L1045.4,625.5z"/>
                        <path class="st84" d="M1045.1,625.3c4.2-2.4,4.2-6.3,0-8.7l-64.5-37.2c-4.2-2.4-10.9-2.4-15.1,0l-61.9,35.5
							c-4.2,2.4-4.2,6.3,0,8.7l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L1045.1,625.3z"/>
                        <path class="st85" d="M1044.8,625.1c4.2-2.4,4.2-6.3,0-8.7l-64.2-37.1c-4.1-2.4-10.9-2.4-15,0L904,614.6
							c-4.2,2.4-4.2,6.3,0,8.7l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L1044.8,625.1z"/>
                        <path class="st86" d="M1044.5,624.9c4.2-2.4,4.2-6.3,0-8.7l-63.9-36.9c-4.1-2.4-10.9-2.4-15,0l-61.3,35.1
							c-4.2,2.4-4.2,6.3,0,8.7l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L1044.5,624.9z"/>
                        <path class="st87" d="M1044.2,624.7c4.1-2.4,4.2-6.3,0-8.7l-63.6-36.7c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L1044.2,624.7z"/>
                        <path class="st88" d="M1043.9,624.6c4.1-2.4,4.1-6.3,0-8.6l-63.2-36.6c-4.1-2.4-10.8-2.4-14.9,0L905.2,614
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L1043.9,624.6z"/>
                        <path class="st89" d="M1043.6,624.4c4.1-2.4,4.1-6.2,0-8.6l-62.9-36.4c-4.1-2.4-10.8-2.4-14.9,0l-60.3,34.4
							c-4.1,2.4-4.1,6.2,0,8.6l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L1043.6,624.4z"/>
                        <path class="st90" d="M1043.3,624.2c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1
							c-4.1,2.4-4.1,6.2,0,8.6l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L1043.3,624.2z"/>
                        <path class="st91" d="M1043,624c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0l-59.6,33.9c-4.1,2.4-4.1,6.2,0,8.6
							l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L1043,624z"/>
                        <path class="st92" d="M1042.8,623.8c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L1042.8,623.8z"/>
                        <path class="st93" d="M1042.5,623.7c4.1-2.4,4.1-6.2,0-8.5l-61.6-35.7c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4
							c-4.1,2.4-4.1,6.2,0,8.5l53.4,31c4.1,2.4,24.5,4.4,28.6,2L1042.5,623.7z"/>
                        <path class="st94" d="M1042.2,623.5c4.1-2.3,4.1-6.1,0-8.5l-61.3-35.5c-4-2.3-10.6-2.3-14.7,0l-58.7,33.2
							c-4.1,2.3-4.1,6.1,0,8.5l53,30.7c4,2.3,24.6,4.4,28.7,2.1L1042.2,623.5z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000165941406400600731920000003096384051072492701_" gradientUnits="userSpaceOnUse" x1="20.6283" y1="371.4402" x2="97.1746" y2="504.0223" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000165941406400600731920000003096384051072492701_);" d="M905.7,622.4l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C900.4,617.2,902.1,620.3,905.7,622.4z"/>

                        <linearGradient id="SVGID_00000050623298988646929740000010646438717838123904_" gradientUnits="userSpaceOnUse" x1="23.5895" y1="360.7435" x2="104.1875" y2="500.3434" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000050623298988646929740000010646438717838123904_);" d="M900.7,612.2l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C894.1,606.1,896.2,609.6,900.7,612.2z"/>
                        <g>
							<path class="st97" d="M894.5,593.7c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C894.5,599.4,894.5,596.6,894.5,593.7z"/>
                            <path class="st98" d="M894.4,585c0-1,0-2,0-2.8h0C894.5,583.2,894.4,584.2,894.4,585z"/>
						</g>

                        <linearGradient id="SVGID_00000043449127912218593820000003597095673505385121_" gradientUnits="userSpaceOnUse" x1="22.1777" y1="362.3347" x2="122.8991" y2="486.7156" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000043449127912218593820000003597095673505385121_);" d="M900.7,590.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L899.9,569c0,0-5.4,9.1-5.6,12.1
							C894.1,584.6,896.2,588,900.7,590.6z"/>

                        <linearGradient id="SVGID_00000083076122084683048760000000361249126259388307_" gradientUnits="userSpaceOnUse" x1="154.7225" y1="437.4279" x2="25.7617" y2="380.0105" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000083076122084683048760000000361249126259388307_);" d="M905.7,579.3l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7L989.2,531c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C897.7,567.2,897.7,574.7,905.7,579.3z"/>
                        <g>
							<path class="st48" d="M974.8,599.5c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C981.8,598.6,978.4,599.5,974.8,599.5z M974.8,542.9c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								s1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C981.6,543.7,978.3,542.9,974.8,542.9z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000011713762062942485150000001440481929556221571_" cx="732.6718" cy="-709.8645" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000011713762062942485150000001440481929556221571_);" d="M967.6,644.7
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C951.6,631.5,968.5,643.1,967.6,644.7z"
                            />

                            <radialGradient id="SVGID_00000032641415481288866010000016882362840946482352_" cx="733.0367" cy="-723.8524" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000032641415481288866010000016882362840946482352_);" d="M970.5,642.2
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C954.5,629,971.4,640.6,970.5,642.2z"/>

                            <radialGradient id="SVGID_00000018212026815210727940000011315796011190494393_" cx="733.2969" cy="-737.5773" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000018212026815210727940000011315796011190494393_);" d="M973,639.6
								c-0.9,1.6-19.4-7.4-41.2-20C910,606.9,893,595.4,894,593.8c0.9-1.6,19.4,7.4,41.2,20C957,626.5,974,638,973,639.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000109022143639249917400000000815541224506192829_" cx="555.2819" cy="695.4797" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000109022143639249917400000000815541224506192829_);" d="M979.2,645.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C995.2,632.6,978.2,644.1,979.2,645.7z"
                            />

                            <radialGradient id="SVGID_00000101096312107191321650000007946737909316236193_" cx="555.6468" cy="681.4909" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000101096312107191321650000007946737909316236193_);" d="M976.3,643.3
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C992.3,630.1,975.3,641.7,976.3,643.3z"
                            />

                            <radialGradient id="SVGID_00000166650575114793581240000013148083561431122344_" cx="555.9069" cy="667.7674" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000166650575114793581240000013148083561431122344_);" d="M973.7,640.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C989.7,627.5,972.8,639.1,973.7,640.7z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000174578946816099970030000006396785633854922174_" gradientUnits="userSpaceOnUse" x1="50.4779" y1="341.5905" x2="127.0243" y2="474.1727" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000174578946816099970030000006396785633854922174_);" d="M905.7,580.2l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C900.4,575,902.1,578.1,905.7,580.2z"/>

                        <linearGradient id="SVGID_00000148645144304176868990000003121537283398364300_" gradientUnits="userSpaceOnUse" x1="53.4391" y1="330.894" x2="134.0371" y2="470.4938" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000148645144304176868990000003121537283398364300_);" d="M900.7,570l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6L894.5,540c0,0,0.1,17.5-0.1,20.5
							C894.1,563.9,896.2,567.4,900.7,570z"/>
                        <g>
							<path class="st97" d="M894.5,551.5c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C894.5,557.1,894.5,554.4,894.5,551.5z"/>
                            <path class="st98" d="M894.4,542.8c0-1,0-2,0-2.8h0C894.5,541,894.4,542,894.4,542.8z"/>
						</g>

                        <linearGradient id="SVGID_00000056402316346599272560000014941162192095718067_" gradientUnits="userSpaceOnUse" x1="52.0274" y1="332.485" x2="152.7487" y2="456.866" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000056402316346599272560000014941162192095718067_);" d="M900.7,548.4l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C894.1,542.4,896.2,545.8,900.7,548.4z"/>

                        <linearGradient id="SVGID_00000112621628578605260470000008682713265681949578_" gradientUnits="userSpaceOnUse" x1="184.5722" y1="407.5782" x2="55.6113" y2="350.1608" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000112621628578605260470000008682713265681949578_);" d="M905.7,537l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C897.7,525,897.7,532.4,905.7,537z"/>
                        <g>
							<path class="st48" d="M974.8,557.2c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3L1020,523c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7L984.3,555
								C981.8,556.4,978.4,557.2,974.8,557.2z M974.8,500.7c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C981.6,501.5,978.3,500.7,974.8,500.7z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000078725996978815308380000005351708319367897472_" cx="726.5682" cy="-852.8605" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000078725996978815308380000005351708319367897472_);" d="M967.6,602.5
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C951.6,589.3,968.5,600.9,967.6,602.5z"
                            />

                            <radialGradient id="SVGID_00000160178057575690538670000010732134667116888729_" cx="726.9331" cy="-866.8484" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000160178057575690538670000010732134667116888729_);" d="M970.5,600
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C954.5,586.8,971.4,598.4,970.5,600z"/>

                            <radialGradient id="SVGID_00000183219053436350914510000008418085584645643152_" cx="727.1933" cy="-880.5733" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000183219053436350914510000008418085584645643152_);" d="M973,597.4
								c-0.9,1.6-19.4-7.4-41.2-20C910,564.7,893,553.1,894,551.5c0.9-1.6,19.4,7.4,41.2,20C957,584.3,974,595.8,973,597.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000091705577136207376240000009280562617115445428_" cx="549.1782" cy="552.4837" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000091705577136207376240000009280562617115445428_);" d="M979.2,603.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C995.2,590.4,978.2,601.9,979.2,603.5z"
                            />

                            <radialGradient id="SVGID_00000011733348171994257970000010640668888972067498_" cx="549.5432" cy="538.4945" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000011733348171994257970000010640668888972067498_);" d="M976.3,601.1
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C992.3,587.9,975.3,599.5,976.3,601.1z"
                            />

                            <radialGradient id="SVGID_00000108306310238331794280000014780389919709714580_" cx="549.8033" cy="524.7714" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000108306310238331794280000014780389919709714580_);" d="M973.7,598.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C989.7,585.3,972.8,596.9,973.7,598.5z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000079478536486487557670000007075865427788274097_" gradientUnits="userSpaceOnUse" x1="80.1948" y1="311.8737" x2="156.7412" y2="444.4558" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000079478536486487557670000007075865427788274097_);" d="M905.7,538.1l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C900.4,533,902.1,536.1,905.7,538.1z"/>

                        <linearGradient id="SVGID_00000089531749430524696440000009453255885828031920_" gradientUnits="userSpaceOnUse" x1="83.1561" y1="301.177" x2="163.7541" y2="440.7769" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000089531749430524696440000009453255885828031920_);" d="M900.7,527.9l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6L894.5,498c0,0,0.1,17.5-0.1,20.5
							C894.1,521.9,896.2,525.3,900.7,527.9z"/>
                        <g>
							<path class="st97" d="M894.5,509.5c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C894.5,515.1,894.5,512.3,894.5,509.5z"/>
                            <path class="st98" d="M894.4,500.8c0-1,0-2,0-2.8l0,0C894.5,499,894.4,500,894.4,500.8z"/>
						</g>

                        <linearGradient id="SVGID_00000169517262040175553460000007936864880974822299_" gradientUnits="userSpaceOnUse" x1="81.7442" y1="302.7682" x2="182.4656" y2="427.1491" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000169517262040175553460000007936864880974822299_);" d="M900.7,506.4l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C894.1,500.3,896.2,503.8,900.7,506.4z"/>

                        <linearGradient id="SVGID_00000103250277589964712930000002003995754152885380_" gradientUnits="userSpaceOnUse" x1="214.2891" y1="377.8613" x2="85.3283" y2="320.4439" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000103250277589964712930000002003995754152885380_);" d="M905.7,495l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C897.7,482.9,897.7,490.4,905.7,495z"/>
                        <g>
							<path class="st48" d="M974.8,515.2c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3L1020,481c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C981.8,514.4,978.4,515.2,974.8,515.2z M974.8,458.7c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C981.6,459.5,978.3,458.7,974.8,458.7z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000038408095134671663360000006236054505246403774_" cx="720.4917" cy="-995.2221" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000038408095134671663360000006236054505246403774_);" d="M967.6,560.4
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C951.6,547.3,968.5,558.8,967.6,560.4z"
                            />

                            <radialGradient id="SVGID_00000022521717878690169370000012847791943352614792_" cx="720.8567" cy="-1009.21" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000022521717878690169370000012847791943352614792_);" d="M970.5,558
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C954.5,544.8,971.4,556.4,970.5,558z"/>

                            <radialGradient id="SVGID_00000017495031314552470150000007897330205565080503_" cx="721.1169" cy="-1022.9336" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000017495031314552470150000007897330205565080503_);" d="M973,555.4
								c-0.9,1.6-19.4-7.4-41.2-20C910,522.7,893,511.1,894,509.5c0.9-1.6,19.4,7.4,41.2,20C957,542.2,974,553.8,973,555.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000010270656420519348200000009582974705688665000_" cx="543.1018" cy="410.1234" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000010270656420519348200000009582974705688665000_);" d="M979.2,561.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C995.2,548.3,978.2,559.9,979.2,561.5z"
                            />

                            <radialGradient id="SVGID_00000171679754804464672210000017774144238739419042_" cx="543.4667" cy="396.1346" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000171679754804464672210000017774144238739419042_);" d="M976.3,559.1
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C992.3,545.9,975.3,557.4,976.3,559.1z"
                            />

                            <radialGradient id="SVGID_00000152250665106683308870000000536198214337100431_" cx="543.7269" cy="382.4098" r="13.1624" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000152250665106683308870000000536198214337100431_);" d="M973.7,556.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C989.7,543.3,972.8,554.9,973.7,556.5z"
                            />
						</g>
					</g>
				</g>
                <g>
					<g>
						<path class="st53" d="M739.6,807.3c4.5-2.6,4.6-6.9,0-9.5l-74.5-42.5c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43
							c-4.5,2.6-4.6,6.9,0,9.5l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L739.6,807.3z"/>
                        <path class="st54" d="M739.3,807.1c4.5-2.6,4.5-6.9,0-9.5l-74.2-42.3c-4.5-2.6-11.8-2.6-16.4,0L577.2,798
							c-4.5,2.6-4.6,6.9,0,9.5l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L739.3,807.1z"/>
                        <path class="st55" d="M739,807c4.5-2.6,4.5-6.8,0-9.5l-73.8-42.2c-4.5-2.6-11.8-2.6-16.3,0l-71.3,42.5c-4.5,2.6-4.5,6.8,0,9.5
							l69,39.4c7.4,3.8,19.6,4.7,27-0.7L739,807z"/>
                        <path class="st56" d="M738.7,806.8c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0L578,797.6
							c-4.5,2.6-4.5,6.8,0,9.4l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L738.7,806.8z"/>
                        <path class="st57" d="M738.4,806.6c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L738.4,806.6z"/>
                        <path class="st58" d="M738.1,806.4c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L738.1,806.4z"/>
                        <path class="st59" d="M737.8,806.2c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L737.8,806.2z"/>
                        <path class="st60" d="M737.6,806.1c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L737.6,806.1z"/>
                        <path class="st61" d="M737.3,805.9c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L737.3,805.9z"/>
                        <path class="st62" d="M737,805.7c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L737,805.7z"/>
                        <path class="st63" d="M736.7,805.5c4.4-2.6,4.4-6.7,0-9.3l-71.3-40.8c-4.4-2.6-11.6-2.5-16,0L580.8,796
							c-4.4,2.6-4.4,6.7,0,9.3l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L736.7,805.5z"/>
                        <path class="st64" d="M736.4,805.3c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0l-68.4,40.3
							c-4.4,2.6-4.4,6.7,0,9.2l65.3,37.4c6.6,3.5,20.8,4.6,27.3-0.1L736.4,805.3z"/>
                        <path class="st65" d="M736.1,805.2c4.4-2.5,4.4-6.7,0-9.2l-70.6-40.5c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1
							c-4.4,2.5-4.4,6.7,0,9.2l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L736.1,805.2z"/>
                        <path class="st66" d="M735.8,805c4.4-2.5,4.4-6.7,0-9.2l-70.3-40.3c-4.4-2.5-11.5-2.5-15.9,0L582,795.4
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L735.8,805z"/>
                        <path class="st67" d="M735.5,804.8c4.4-2.5,4.4-6.6,0-9.2l-70-40.1c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6
							c-4.4,2.5-4.4,6.6,0,9.2l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L735.5,804.8z"/>
                        <path class="st68" d="M735.2,804.6c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L735.2,804.6z"/>
                        <path class="st69" d="M734.9,804.5c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0l-66.7,39.1
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L734.9,804.5z"/>
                        <path class="st70" d="M734.7,804.3c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0l-66.4,38.9
							c-4.3,2.5-4.4,6.6,0,9.1l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L734.7,804.3z"/>
                        <path class="st71" d="M734.4,804.1c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0L584,794.3
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L734.4,804.1z"/>
                        <path class="st72" d="M734.1,803.9c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0L584.4,794c-4.3,2.5-4.3,6.5,0,9
							l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L734.1,803.9z"/>
                        <path class="st73" d="M733.8,803.7c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0l-65.5,38.2c-4.3,2.5-4.3,6.5,0,9
							l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L733.8,803.7z"/>
                        <path class="st74" d="M733.5,803.6c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0l-65.1,37.9c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L733.5,803.6z"/>
                        <path class="st75" d="M733.2,803.4c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0l-64.8,37.7c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L733.2,803.4z"/>
                        <path class="st76" d="M732.9,803.2c4.3-2.5,4.3-6.5,0-8.9l-67.1-38.6c-4.3-2.5-11.2-2.5-15.4,0L586,793.1
							c-4.3,2.5-4.3,6.5,0,8.9l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L732.9,803.2z"/>
                        <path class="st77" d="M732.6,803c4.3-2.5,4.3-6.5,0-8.9l-66.8-38.4c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L732.6,803z"/>
                        <path class="st78" d="M732.3,802.8c4.2-2.5,4.3-6.4,0-8.9l-66.4-38.3c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37
							c-4.2,2.5-4.3,6.4,0,8.9l59.6,34.3c5.4,3,22.6,4.5,28,0.9L732.3,802.8z"/>
                        <path class="st79" d="M732.1,802.7c4.2-2.5,4.3-6.4,0-8.9L666,755.7c-4.2-2.4-11.1-2.4-15.3,0l-63.5,36.7
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L732.1,802.7z"/>
                        <path class="st80" d="M731.8,802.5c4.2-2.4,4.2-6.4,0-8.8L666,755.7c-4.2-2.4-11-2.4-15.3,0l-63.2,36.5
							c-4.2,2.4-4.2,6.4,0,8.8l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L731.8,802.5z"/>
                        <path class="st81" d="M731.5,802.3c4.2-2.4,4.2-6.4,0-8.8L666,755.7c-4.2-2.4-11-2.4-15.2,0L587.9,792c-4.2,2.4-4.2,6.4,0,8.8
							l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L731.5,802.3z"/>
                        <path class="st82" d="M731.2,802.1c4.2-2.4,4.2-6.4,0-8.8l-65.2-37.6c-4.2-2.4-11-2.4-15.2,0l-62.5,36c-4.2,2.4-4.2,6.4,0,8.8
							l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L731.2,802.1z"/>
                        <path class="st83" d="M730.9,801.9c4.2-2.4,4.2-6.3,0-8.8l-64.8-37.4c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L730.9,801.9z"/>
                        <path class="st84" d="M730.6,801.8c4.2-2.4,4.2-6.3,0-8.7l-64.5-37.2c-4.2-2.4-10.9-2.4-15.1,0l-61.9,35.5
							c-4.2,2.4-4.2,6.3,0,8.7l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L730.6,801.8z"/>
                        <path class="st85" d="M730.3,801.6c4.2-2.4,4.2-6.3,0-8.7l-64.2-37.1c-4.1-2.4-10.9-2.4-15,0l-61.6,35.3
							c-4.2,2.4-4.2,6.3,0,8.7l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L730.3,801.6z"/>
                        <path class="st86" d="M730,801.4c4.2-2.4,4.2-6.3,0-8.7l-63.9-36.9c-4.1-2.4-10.9-2.4-15,0l-61.3,35.1c-4.2,2.4-4.2,6.3,0,8.7
							l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L730,801.4z"/>
                        <path class="st87" d="M729.7,801.2c4.1-2.4,4.2-6.3,0-8.7l-63.5-36.7c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L729.7,801.2z"/>
                        <path class="st88" d="M729.5,801c4.1-2.4,4.1-6.3,0-8.6l-63.2-36.6c-4.1-2.4-10.8-2.4-14.9,0l-60.6,34.6
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L729.5,801z"/>
                        <path class="st89" d="M729.2,800.9c4.1-2.4,4.1-6.2,0-8.6l-62.9-36.4c-4.1-2.4-10.8-2.4-14.9,0l-60.3,34.4
							c-4.1,2.4-4.1,6.2,0,8.6l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L729.2,800.9z"/>
                        <path class="st90" d="M728.9,800.7c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1
							c-4.1,2.4-4.1,6.2,0,8.6l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L728.9,800.7z"/>
                        <path class="st91" d="M728.6,800.5c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0l-59.6,33.9
							c-4.1,2.4-4.1,6.2,0,8.6l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L728.6,800.5z"/>
                        <path class="st92" d="M728.3,800.3c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L728.3,800.3z"/>
                        <path class="st93" d="M728,800.2c4.1-2.4,4.1-6.2,0-8.5l-61.6-35.7c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4c-4.1,2.4-4.1,6.2,0,8.5
							l53.4,31c4.1,2.4,24.5,4.4,28.6,2L728,800.2z"/>
                        <path class="st94" d="M727.7,800c4.1-2.3,4.1-6.1,0-8.5L666.5,756c-4-2.3-10.6-2.3-14.7,0l-58.7,33.2c-4.1,2.3-4.1,6.1,0,8.5
							l53,30.7c4,2.3,24.6,4.4,28.7,2.1L727.7,800z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000145058241765525436140000009204105705152091838_" gradientUnits="userSpaceOnUse" x1="118.1941" y1="718.5936" x2="194.7405" y2="851.1757" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000145058241765525436140000009204105705152091838_);" d="M591.2,798.9l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C585.9,793.7,587.6,796.8,591.2,798.9z"/>

                        <linearGradient id="SVGID_00000011016709433740079470000009507985076006525075_" gradientUnits="userSpaceOnUse" x1="121.1553" y1="707.8969" x2="201.7533" y2="847.4968" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000011016709433740079470000009507985076006525075_);" d="M586.3,788.7l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6L580,758.7c0,0,0.1,17.5-0.1,20.5
							C579.6,782.6,581.8,786.1,586.3,788.7z"/>
                        <g>
							<path class="st97" d="M580,770.2c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C580,775.8,580,773.1,580,770.2z"/>
                            <path class="st98" d="M580,761.5c0-1,0-2,0-2.8h0C580,759.7,580,760.7,580,761.5z"/>
						</g>

                        <linearGradient id="SVGID_00000103953693831196445380000014997981145237052063_" gradientUnits="userSpaceOnUse" x1="119.7436" y1="709.488" x2="220.465" y2="833.869" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000103953693831196445380000014997981145237052063_);" d="M586.3,767.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C579.6,761.1,581.8,764.5,586.3,767.1z"/>

                        <linearGradient id="SVGID_00000171719535695473126900000016661134842969975692_" gradientUnits="userSpaceOnUse" x1="252.2885" y1="784.5812" x2="123.3276" y2="727.1639" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000171719535695473126900000016661134842969975692_);" d="M591.2,755.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C583.2,743.7,583.2,751.1,591.2,755.7z"/>
                        <g>
							<path class="st48" d="M660.3,775.9c-3.6,0-7-0.8-9.5-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C667.3,775.1,663.9,775.9,660.3,775.9z M660.3,719.4c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C667.1,720.2,663.8,719.4,660.3,719.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000098902721584768843080000014581706549029474211_" cx="679.8801" cy="506.2128" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000098902721584768843080000014581706549029474211_);" d="M653.2,821.2
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C637.1,808,654.1,819.6,653.2,821.2z"/>

                            <radialGradient id="SVGID_00000004508889946990487210000004851455402748023710_" cx="680.2449" cy="492.2241" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000004508889946990487210000004851455402748023710_);" d="M656,818.7
								c-0.9,1.6-19.4-7.4-41.2-20C593,786,576,774.4,577,772.8c0.9-1.6,19.4,7.4,41.2,20C640,805.5,657,817.1,656,818.7z"/>

                            <radialGradient id="SVGID_00000031892068314854493780000014430935002576553380_" cx="680.5051" cy="478.5005" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000031892068314854493780000014430935002576553380_);" d="M658.6,816.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C642.6,802.9,659.5,814.5,658.6,816.1z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000119801883691589998640000006834132908399531959_" cx="659.1087" cy="675.0653" r="13.1621" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000119801883691589998640000006834132908399531959_);" d="M664.7,822.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C680.7,809.1,663.8,820.6,664.7,822.2z"
                            />

                            <radialGradient id="SVGID_00000033332114156449660750000012055139772820306091_" cx="659.4736" cy="661.0768" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000033332114156449660750000012055139772820306091_);" d="M661.8,819.8
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C677.8,806.6,660.9,818.2,661.8,819.8z"
                            />

                            <radialGradient id="SVGID_00000030449696397346347180000018147922593750846089_" cx="659.7338" cy="647.3525" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000030449696397346347180000018147922593750846089_);" d="M659.3,817.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C675.3,804,658.3,815.6,659.3,817.2z"/>
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000109715527916317867160000015151449570902650511_" gradientUnits="userSpaceOnUse" x1="148.0436" y1="688.7438" x2="224.59" y2="821.326" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000109715527916317867160000015151449570902650511_);" d="M591.2,756.6l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C585.9,751.5,587.6,754.6,591.2,756.6z"/>

                        <linearGradient id="SVGID_00000062190350272433041810000004793666768566729347_" gradientUnits="userSpaceOnUse" x1="151.0049" y1="678.0472" x2="231.603" y2="817.6472" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000062190350272433041810000004793666768566729347_);" d="M586.3,746.5l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6L580,716.5c0,0,0.1,17.5-0.1,20.5
							C579.6,740.4,581.8,743.9,586.3,746.5z"/>
                        <g>
							<path class="st97" d="M580,728c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C580,733.6,580,730.8,580,728z"/>
                            <path class="st98" d="M580,719.3c0-1,0-2,0-2.8h0C580,717.5,580,718.5,580,719.3z"/>
						</g>

                        <linearGradient id="SVGID_00000025426440424577118610000007051510957696399794_" gradientUnits="userSpaceOnUse" x1="149.5933" y1="679.6383" x2="250.3146" y2="804.0193" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000025426440424577118610000007051510957696399794_);" d="M586.3,724.9l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C579.6,718.8,581.8,722.3,586.3,724.9z"/>

                        <linearGradient id="SVGID_00000067207335827594470780000016421198338571027896_" gradientUnits="userSpaceOnUse" x1="282.1381" y1="754.7316" x2="153.1773" y2="697.3142" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000067207335827594470780000016421198338571027896_);" d="M591.2,713.5l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C583.2,701.5,583.2,708.9,591.2,713.5z"/>
                        <g>
							<path class="st48" d="M660.3,733.7c-3.6,0-7-0.8-9.5-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C667.3,732.9,663.9,733.7,660.3,733.7z M660.3,677.2c-3.5,0-6.8,0.8-9.3,2.2L615.4,700c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2L651,731c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C667.1,678,663.8,677.2,660.3,677.2z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000179614341383173587250000011235364582922259120_" cx="673.7764" cy="363.2168" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000179614341383173587250000011235364582922259120_);" d="M653.2,778.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C637.1,765.8,654.1,777.3,653.2,778.9z"
                            />

                            <radialGradient id="SVGID_00000157278632741800408670000001340307845129549186_" cx="674.1414" cy="349.2277" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000157278632741800408670000001340307845129549186_);" d="M656,776.5
								c-0.9,1.6-19.4-7.4-41.2-20C593,743.8,576,732.2,577,730.6c0.9-1.6,19.4,7.4,41.2,20C640,763.3,657,774.9,656,776.5z"/>

                            <radialGradient id="SVGID_00000121971995820750224350000013577602116703723667_" cx="674.4016" cy="335.5032" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000121971995820750224350000013577602116703723667_);" d="M658.6,773.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C642.6,760.7,659.5,772.3,658.6,773.9z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000125593465681307695830000003672800449433590699_" cx="653.0051" cy="532.0693" r="13.1621" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000125593465681307695830000003672800449433590699_);" d="M664.7,780
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C680.7,766.8,663.8,778.4,664.7,780z"/>

                            <radialGradient id="SVGID_00000129910194249313899480000009799211619801088150_" cx="653.3701" cy="518.0809" r="13.1624" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000129910194249313899480000009799211619801088150_);" d="M661.8,777.6
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C677.8,764.4,660.9,776,661.8,777.6z"/>

                            <radialGradient id="SVGID_00000088848343656610869830000010559012121850828678_" cx="653.6302" cy="504.356" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000088848343656610869830000010559012121850828678_);" d="M659.3,775
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C675.3,761.8,658.3,773.4,659.3,775z"/>
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000016758818751752488270000002506973188829591984_" gradientUnits="userSpaceOnUse" x1="177.7605" y1="659.027" x2="254.3069" y2="791.6091" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000016758818751752488270000002506973188829591984_);" d="M591.2,714.6l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C585.9,709.5,587.6,712.5,591.2,714.6z"/>

                        <linearGradient id="SVGID_00000165936264405241737520000004073945372613804731_" gradientUnits="userSpaceOnUse" x1="180.7218" y1="648.3303" x2="261.3199" y2="787.9303" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000165936264405241737520000004073945372613804731_);" d="M586.3,704.4l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6L580,674.5c0,0,0.1,17.5-0.1,20.5
							C579.6,698.4,581.8,701.8,586.3,704.4z"/>
                        <g>
							<path class="st97" d="M580,685.9c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C580,691.6,580,688.8,580,685.9z"/>
                            <path class="st98" d="M580,677.3c0-1,0-2,0-2.8h0C580,675.5,580,676.5,580,677.3z"/>
						</g>

                        <linearGradient id="SVGID_00000041293058443867620260000005457628566651405199_" gradientUnits="userSpaceOnUse" x1="179.3101" y1="649.9214" x2="280.0315" y2="774.3024" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000041293058443867620260000005457628566651405199_);" d="M586.3,682.9l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C579.6,676.8,581.8,680.3,586.3,682.9z"/>

                        <linearGradient id="SVGID_00000093889119526618737910000003247283523810560685_" gradientUnits="userSpaceOnUse" x1="311.855" y1="725.0147" x2="182.8942" y2="667.5974" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000093889119526618737910000003247283523810560685_);" d="M591.2,671.5l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C583.2,659.4,583.2,666.9,591.2,671.5z"/>
                        <g>
							<path class="st48" d="M660.3,691.7c-3.6,0-7-0.8-9.5-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3s7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C667.3,690.9,663.9,691.7,660.3,691.7z M660.3,635.1c-3.5,0-6.8,0.8-9.3,2.2L615.4,658c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2L651,689c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C667.1,635.9,663.8,635.1,660.3,635.1z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000176040111811743405060000009119786455988558210_" cx="667.7" cy="220.8565" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000176040111811743405060000009119786455988558210_);" d="M653.2,736.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C637.1,723.7,654.1,735.3,653.2,736.9z"
                            />

                            <radialGradient id="SVGID_00000169526591535827828290000008827104083806450089_" cx="668.0649" cy="206.8678" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000169526591535827828290000008827104083806450089_);" d="M656,734.5
								c-0.9,1.6-19.4-7.4-41.2-20C593,701.8,576,690.2,577,688.6c0.9-1.6,19.4,7.4,41.2,20C640,721.3,657,732.9,656,734.5z"/>

                            <radialGradient id="SVGID_00000158028510413166469470000012999089779688893618_" cx="668.3251" cy="193.1429" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000158028510413166469470000012999089779688893618_);" d="M658.6,731.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C642.6,718.7,659.5,730.3,658.6,731.9z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000056422843641377150070000016983553722312507569_" cx="646.9286" cy="389.7077" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000056422843641377150070000016983553722312507569_);" d="M664.7,738
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C680.7,724.8,663.8,736.4,664.7,738z"/>

                            <radialGradient id="SVGID_00000062883367746679464840000006462098511585267125_" cx="647.2936" cy="375.7193" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000062883367746679464840000006462098511585267125_);" d="M661.8,735.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C677.8,722.4,660.9,733.9,661.8,735.5z"
                            />

                            <radialGradient id="SVGID_00000067228398183405071140000016350838715104409990_" cx="647.5538" cy="361.9962" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000067228398183405071140000016350838715104409990_);" d="M659.3,733
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C675.3,719.8,658.3,731.4,659.3,733z"/>
						</g>
					</g>
				</g>
                <g>
					<g>
						<path class="st53" d="M321.7,745.5c4.5-2.6,4.6-6.9,0-9.5l-74.5-42.5c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43
							c-4.5,2.6-4.6,6.9,0,9.5l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L321.7,745.5z"/>
                        <path class="st54" d="M321.4,745.3c4.5-2.6,4.5-6.9,0-9.5l-74.2-42.3c-4.5-2.6-11.8-2.6-16.4,0l-71.6,42.7
							c-4.5,2.6-4.6,6.9,0,9.5l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L321.4,745.3z"/>
                        <path class="st55" d="M321.1,745.1c4.5-2.6,4.5-6.8,0-9.5l-73.8-42.2c-4.5-2.6-11.8-2.6-16.3,0L159.7,736
							c-4.5,2.6-4.5,6.8,0,9.5l69,39.4c7.4,3.8,19.6,4.7,27-0.7L321.1,745.1z"/>
                        <path class="st56" d="M320.8,744.9c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0l-70.9,42.2
							c-4.5,2.6-4.5,6.8,0,9.4l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L320.8,744.9z"/>
                        <path class="st57" d="M320.5,744.8c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L320.5,744.8z"/>
                        <path class="st58" d="M320.2,744.6c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L320.2,744.6z"/>
                        <path class="st59" d="M319.9,744.4c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L319.9,744.4z"/>
                        <path class="st60" d="M319.6,744.2c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L319.6,744.2z"/>
                        <path class="st61" d="M319.3,744.1c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L319.3,744.1z"/>
                        <path class="st62" d="M319.1,743.9c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L319.1,743.9z"/>
                        <path class="st63" d="M318.8,743.7c4.4-2.6,4.4-6.7,0-9.3l-71.3-40.8c-4.4-2.6-11.6-2.5-16,0l-68.7,40.6
							c-4.4,2.6-4.4,6.7,0,9.3l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L318.8,743.7z"/>
                        <path class="st64" d="M318.5,743.5c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0L163.3,734
							c-4.4,2.6-4.4,6.7,0,9.2l65.3,37.4c6.6,3.5,20.8,4.6,27.3-0.1L318.5,743.5z"/>
                        <path class="st65" d="M318.2,743.3c4.4-2.5,4.4-6.7,0-9.2l-70.6-40.5c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1
							c-4.4,2.5-4.4,6.7,0,9.2l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L318.2,743.3z"/>
                        <path class="st66" d="M317.9,743.2c4.4-2.5,4.4-6.7,0-9.2l-70.3-40.3c-4.4-2.5-11.5-2.5-15.9,0l-67.7,39.8
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L317.9,743.2z"/>
                        <path class="st67" d="M317.6,743c4.4-2.5,4.4-6.6,0-9.2l-70-40.1c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6c-4.4,2.5-4.4,6.6,0,9.2
							l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L317.6,743z"/>
                        <path class="st68" d="M317.3,742.8c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L317.3,742.8z"/>
                        <path class="st69" d="M317,742.6c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0l-66.7,39.1
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L317,742.6z"/>
                        <path class="st70" d="M316.7,742.4c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0l-66.4,38.9
							c-4.3,2.5-4.4,6.6,0,9.1l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L316.7,742.4z"/>
                        <path class="st71" d="M316.4,742.3c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0L166,732.4
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L316.4,742.3z"/>
                        <path class="st72" d="M316.2,742.1c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0l-65.8,38.4c-4.3,2.5-4.3,6.5,0,9
							l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L316.2,742.1z"/>
                        <path class="st73" d="M315.9,741.9c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0L166.8,732c-4.3,2.5-4.3,6.5,0,9
							l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L315.9,741.9z"/>
                        <path class="st74" d="M315.6,741.7c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0l-65.1,37.9c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L315.6,741.7z"/>
                        <path class="st75" d="M315.3,741.5c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0l-64.8,37.7c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L315.3,741.5z"/>
                        <path class="st76" d="M315,741.4c4.3-2.5,4.3-6.5,0-8.9L248,693.8c-4.3-2.5-11.2-2.5-15.4,0L168,731.3c-4.3,2.5-4.3,6.5,0,8.9
							l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L315,741.4z"/>
                        <path class="st77" d="M314.7,741.2c4.3-2.5,4.3-6.5,0-8.9L248,693.9c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L314.7,741.2z"/>
                        <path class="st78" d="M314.4,741c4.2-2.5,4.3-6.4,0-8.9L248,693.9c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37c-4.2,2.5-4.3,6.4,0,8.9
							l59.6,34.3c5.4,3,22.6,4.5,28,0.9L314.4,741z"/>
                        <path class="st79" d="M314.1,740.8c4.2-2.5,4.3-6.4,0-8.9l-66.1-38.1c-4.2-2.4-11.1-2.4-15.3,0l-63.5,36.7
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L314.1,740.8z"/>
                        <path class="st80" d="M313.8,740.6c4.2-2.4,4.2-6.4,0-8.8l-65.8-37.9c-4.2-2.4-11-2.4-15.3,0l-63.2,36.5
							c-4.2,2.4-4.2,6.4,0,8.8l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L313.8,740.6z"/>
                        <path class="st81" d="M313.6,740.5c4.2-2.4,4.2-6.4,0-8.8l-65.5-37.7c-4.2-2.4-11-2.4-15.2,0L170,730.2
							c-4.2,2.4-4.2,6.4,0,8.8l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L313.6,740.5z"/>
                        <path class="st82" d="M313.3,740.3c4.2-2.4,4.2-6.4,0-8.8l-65.2-37.6c-4.2-2.4-11-2.4-15.2,0l-62.5,36c-4.2,2.4-4.2,6.4,0,8.8
							l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L313.3,740.3z"/>
                        <path class="st83" d="M313,740.1c4.2-2.4,4.2-6.3,0-8.8l-64.8-37.4c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L313,740.1z"/>
                        <path class="st84" d="M312.7,739.9c4.2-2.4,4.2-6.3,0-8.7L248.2,694c-4.2-2.4-10.9-2.4-15.1,0l-61.9,35.5
							c-4.2,2.4-4.2,6.3,0,8.7l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L312.7,739.9z"/>
                        <path class="st85" d="M312.4,739.8c4.2-2.4,4.2-6.3,0-8.7L248.2,694c-4.1-2.4-10.9-2.4-15,0l-61.6,35.3
							c-4.2,2.4-4.2,6.3,0,8.7l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L312.4,739.8z"/>
                        <path class="st86" d="M312.1,739.6c4.2-2.4,4.2-6.3,0-8.7L248.3,694c-4.1-2.4-10.9-2.4-15,0L172,729.1c-4.2,2.4-4.2,6.3,0,8.7
							l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L312.1,739.6z"/>
                        <path class="st87" d="M311.8,739.4c4.1-2.4,4.2-6.3,0-8.7L248.3,694c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L311.8,739.4z"/>
                        <path class="st88" d="M311.5,739.2c4.1-2.4,4.1-6.3,0-8.6L248.3,694c-4.1-2.4-10.8-2.4-14.9,0l-60.6,34.6
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L311.5,739.2z"/>
                        <path class="st89" d="M311.2,739c4.1-2.4,4.1-6.2,0-8.6L248.4,694c-4.1-2.4-10.8-2.4-14.9,0l-60.3,34.4
							c-4.1,2.4-4.1,6.2,0,8.6l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L311.2,739z"/>
                        <path class="st90" d="M311,738.9c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1c-4.1,2.4-4.1,6.2,0,8.6
							l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L311,738.9z"/>
                        <path class="st91" d="M310.7,738.7c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0L174,728c-4.1,2.4-4.1,6.2,0,8.6
							l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L310.7,738.7z"/>
                        <path class="st92" d="M310.4,738.5c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L310.4,738.5z"/>
                        <path class="st93" d="M310.1,738.3c4.1-2.4,4.1-6.2,0-8.5l-61.6-35.7c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4
							c-4.1,2.4-4.1,6.2,0,8.5l53.4,31c4.1,2.4,24.5,4.4,28.6,2L310.1,738.3z"/>
                        <path class="st94" d="M309.8,738.1c4.1-2.3,4.1-6.1,0-8.5l-61.3-35.5c-4-2.3-10.6-2.3-14.7,0l-58.7,33.2
							c-4.1,2.3-4.1,6.1,0,8.5l53,30.7c4,2.3,24.6,4.4,28.7,2.1L309.8,738.1z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000025418370709227583690000002167330895248042921_" gradientUnits="userSpaceOnUse" x1="457.4333" y1="970.389" x2="533.9796" y2="1102.9709" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000025418370709227583690000002167330895248042921_);" d="M173.3,737l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C168,731.9,169.7,735,173.3,737z"/>

                        <linearGradient id="SVGID_00000116234478757006613860000003239150830965420183_" gradientUnits="userSpaceOnUse" x1="460.3944" y1="959.6921" x2="540.9924" y2="1099.292" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000116234478757006613860000003239150830965420183_);" d="M168.4,726.8l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C161.7,720.8,163.9,724.2,168.4,726.8z"/>
                        <g>
							<path class="st97" d="M162.1,708.3c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C162.1,714,162.1,711.2,162.1,708.3z"/>
                            <path class="st98" d="M162,699.7c0-1,0-2,0-2.8h0C162.1,697.9,162.1,698.9,162,699.7z"/>
						</g>

                        <linearGradient id="SVGID_00000086656168438931049910000001100723966116483206_" gradientUnits="userSpaceOnUse" x1="458.9826" y1="961.2833" x2="559.704" y2="1085.6642" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000086656168438931049910000001100723966116483206_);" d="M168.4,705.3l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C161.7,699.2,163.9,702.7,168.4,705.3z"/>

                        <linearGradient id="SVGID_00000005227027838345316110000000402316613553747596_" gradientUnits="userSpaceOnUse" x1="591.5276" y1="1036.3765" x2="462.5667" y2="978.959" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000005227027838345316110000000402316613553747596_);" d="M173.3,693.9l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C165.3,681.8,165.3,689.3,173.3,693.9z"/>
                        <g>
							<path class="st48" d="M242.4,714.1c-3.6,0-7-0.8-9.5-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7s1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C249.4,713.3,246,714.1,242.4,714.1z M242.4,657.6c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C249.2,658.3,245.9,657.6,242.4,657.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000129164752499514746910000006898929523168933017_" cx="566.8664" cy="1118.413" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000129164752499514746910000006898929523168933017_);" d="M235.2,759.3
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C219.2,746.1,236.2,757.7,235.2,759.3z"
                            />

                            <radialGradient id="SVGID_00000127004287009195761720000004858363331303304077_" cx="567.2314" cy="1104.4242" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000127004287009195761720000004858363331303304077_);" d="M238.1,756.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C222.1,743.7,239.1,755.3,238.1,756.9z"
                            />

                            <radialGradient id="SVGID_00000096029726085629861080000001540331090656151698_" cx="567.4916" cy="1090.6993" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000096029726085629861080000001540331090656151698_);" d="M240.7,754.3
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C224.6,741.1,241.6,752.7,240.7,754.3z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000160910762516222664090000008523366042735669941_" cx="754.2419" cy="-356.0393" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000160910762516222664090000008523366042735669941_);" d="M246.8,760.4
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C262.8,747.2,245.8,758.8,246.8,760.4z"
                            />

                            <radialGradient id="SVGID_00000033347280089720742420000007477198987438994874_" cx="754.6069" cy="-370.028" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000033347280089720742420000007477198987438994874_);" d="M243.9,757.9
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C259.9,744.8,243,756.3,243.9,757.9z"/>

                            <radialGradient id="SVGID_00000006686267969657218290000014531339004607112071_" cx="754.8669" cy="-383.752" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000006686267969657218290000014531339004607112071_);" d="M241.3,755.4
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C257.4,742.2,240.4,753.8,241.3,755.4z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000178183332685037678410000003279030209975169419_" gradientUnits="userSpaceOnUse" x1="487.2831" y1="940.5392" x2="563.8293" y2="1073.1212" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000178183332685037678410000003279030209975169419_);" d="M173.3,694.8l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C168,689.7,169.7,692.7,173.3,694.8z"/>

                        <linearGradient id="SVGID_00000055706827461543803220000003664697661473011593_" gradientUnits="userSpaceOnUse" x1="490.2442" y1="929.8424" x2="570.8422" y2="1069.4423" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000055706827461543803220000003664697661473011593_);" d="M168.4,684.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C161.7,678.6,163.9,682,168.4,684.6z"/>
                        <g>
							<path class="st97" d="M162.1,666.1c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C162.1,671.8,162.1,669,162.1,666.1z"/>
                            <path class="st98" d="M162,657.5c0-1,0-2,0-2.8l0,0C162.1,655.7,162.1,656.6,162,657.5z"/>
						</g>

                        <linearGradient id="SVGID_00000160910714832618546900000017750975609367317433_" gradientUnits="userSpaceOnUse" x1="488.8323" y1="931.4335" x2="589.5537" y2="1055.8145" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000160910714832618546900000017750975609367317433_);" d="M168.4,663.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C161.7,657,163.9,660.5,168.4,663.1z"/>

                        <linearGradient id="SVGID_00000036236684117392711340000003926111423657955245_" gradientUnits="userSpaceOnUse" x1="621.3772" y1="1006.5268" x2="492.4164" y2="949.1094" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000036236684117392711340000003926111423657955245_);" d="M173.3,651.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L173.3,635
							C165.3,639.6,165.3,647.1,173.3,651.7z"/>
                        <g>
							<path class="st48" d="M242.4,671.9c-3.6,0-7-0.8-9.5-2.3L197.2,649c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C249.4,671.1,246,671.9,242.4,671.9z M242.4,615.3c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C249.2,616.1,245.9,615.3,242.4,615.3z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000059284118565961547790000011712996678120410283_" cx="560.7629" cy="975.4156" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000059284118565961547790000011712996678120410283_);" d="M235.2,717.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C219.2,703.9,236.2,715.5,235.2,717.1z"
                            />

                            <radialGradient id="SVGID_00000167357466326653864360000016178034555395580297_" cx="561.1278" cy="961.4269" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000167357466326653864360000016178034555395580297_);" d="M238.1,714.7
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C222.1,701.5,239.1,713.1,238.1,714.7z"
                            />

                            <radialGradient id="SVGID_00000044896836812569616630000016960466940483228572_" cx="561.388" cy="947.7029" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000044896836812569616630000016960466940483228572_);" d="M240.7,712.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C224.6,698.9,241.6,710.5,240.7,712.1z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000160168778617208056870000002230071433371882671_" cx="748.1383" cy="-499.0357" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000160168778617208056870000002230071433371882671_);" d="M246.8,718.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C262.8,705,245.8,716.6,246.8,718.2z"/>

                            <radialGradient id="SVGID_00000036961870265852238770000016848533484324275102_" cx="748.5032" cy="-513.0239" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000036961870265852238770000016848533484324275102_);" d="M243.9,715.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C259.9,702.6,243,714.1,243.9,715.7z"/>

                            <radialGradient id="SVGID_00000111912703753924294900000005029606052236389543_" cx="748.7634" cy="-526.7493" r="13.1624" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000111912703753924294900000005029606052236389543_);" d="M241.3,713.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C257.4,700,240.4,711.6,241.3,713.2z"/>
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000095322231040977510760000014891267588793174203_" gradientUnits="userSpaceOnUse" x1="517" y1="910.8224" x2="593.5463" y2="1043.4044" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000095322231040977510760000014891267588793174203_);" d="M173.3,652.8l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C168,647.6,169.7,650.7,173.3,652.8z"/>

                        <linearGradient id="SVGID_00000143616482030560318460000004212317334319674500_" gradientUnits="userSpaceOnUse" x1="519.9611" y1="900.1255" x2="600.5591" y2="1039.7253" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000143616482030560318460000004212317334319674500_);" d="M168.4,642.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C161.7,636.5,163.9,640,168.4,642.6z"/>
                        <g>
							<path class="st97" d="M162.1,624.1c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C162.1,629.8,162.1,627,162.1,624.1z"/>
                            <path class="st98" d="M162,615.4c0-1,0-2,0-2.8l0,0C162.1,613.7,162.1,614.6,162,615.4z"/>
						</g>

                        <linearGradient id="SVGID_00000145774583090427868020000006134279163966436525_" gradientUnits="userSpaceOnUse" x1="518.5493" y1="901.7166" x2="619.2707" y2="1026.0975" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000145774583090427868020000006134279163966436525_);" d="M168.4,621l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C161.7,615,163.9,618.4,168.4,621z"/>

                        <linearGradient id="SVGID_00000026878393194981184190000006919766651928534459_" gradientUnits="userSpaceOnUse" x1="651.0941" y1="976.8099" x2="522.1333" y2="919.3925" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000026878393194981184190000006919766651928534459_);" d="M173.3,609.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L173.3,593
							C165.3,597.6,165.3,605.1,173.3,609.7z"/>
                        <g>
							<path class="st48" d="M242.4,629.9c-3.6,0-7-0.8-9.5-2.3L197.2,607c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.5-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C249.4,629.1,246,629.9,242.4,629.9z M242.4,573.3c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C249.2,574.1,245.9,573.3,242.4,573.3z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000018931294966973084820000003125852635221681315_" cx="554.6864" cy="833.0553" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000018931294966973084820000003125852635221681315_);" d="M235.2,675.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C219.2,661.9,236.2,673.5,235.2,675.1z"
                            />

                            <radialGradient id="SVGID_00000103257961312885831570000004582108881861050008_" cx="555.0514" cy="819.0667" r="13.1622" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000103257961312885831570000004582108881861050008_);" d="M238.1,672.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C222.1,659.5,239.1,671,238.1,672.6z"/>

                            <radialGradient id="SVGID_00000013913633587490515380000016447053572274770831_" cx="555.3115" cy="805.343" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000013913633587490515380000016447053572274770831_);" d="M240.7,670.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C224.6,656.9,241.6,668.5,240.7,670.1z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000015316455597107378250000009193395285762995893_" cx="742.0619" cy="-641.396" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000015316455597107378250000009193395285762995893_);" d="M246.8,676.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C262.8,663,245.8,674.6,246.8,676.2z"/>

                            <radialGradient id="SVGID_00000153707392212531739030000015360511524057374349_" cx="742.4268" cy="-655.3842" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000153707392212531739030000015360511524057374349_);" d="M243.9,673.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C259.9,660.5,243,672.1,243.9,673.7z"/>

                            <radialGradient id="SVGID_00000145049078759079677500000012802136953279159738_" cx="742.687" cy="-669.1096" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000145049078759079677500000012802136953279159738_);" d="M241.3,671.1
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C257.4,658,240.4,669.5,241.3,671.1z"/>
						</g>
					</g>
				</g>
                <g>
					<g>
						<path class="st53" d="M204.4,499c4.5-2.6,4.6-6.9,0-9.5L129.9,447c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43c-4.5,2.6-4.6,6.9,0,9.5
							l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L204.4,499z"/>
                        <path class="st54" d="M204.1,498.8c4.5-2.6,4.5-6.9,0-9.5L130,447c-4.5-2.6-11.8-2.6-16.4,0L42,489.8c-4.5,2.6-4.6,6.9,0,9.5
							l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L204.1,498.8z"/>
                        <path class="st55" d="M203.8,498.7c4.5-2.6,4.5-6.8,0-9.5L130,447c-4.5-2.6-11.8-2.6-16.3,0l-71.3,42.5
							c-4.5,2.6-4.5,6.8,0,9.5l69,39.4c7.4,3.8,19.6,4.7,27-0.7L203.8,498.7z"/>
                        <path class="st56" d="M203.5,498.5c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0l-70.9,42.2
							c-4.5,2.6-4.5,6.8,0,9.4l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L203.5,498.5z"/>
                        <path class="st57" d="M203.2,498.3c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L203.2,498.3z"/>
                        <path class="st58" d="M202.9,498.1c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L202.9,498.1z"/>
                        <path class="st59" d="M202.7,497.9c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L202.7,497.9z"/>
                        <path class="st60" d="M202.4,497.8c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L202.4,497.8z"/>
                        <path class="st61" d="M202.1,497.6c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L202.1,497.6z"/>
                        <path class="st62" d="M201.8,497.4c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L201.8,497.4z"/>
                        <path class="st63" d="M201.5,497.2c4.4-2.6,4.4-6.7,0-9.3l-71.3-40.8c-4.4-2.6-11.6-2.5-16,0l-68.7,40.6
							c-4.4,2.6-4.4,6.7,0,9.3l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L201.5,497.2z"/>
                        <path class="st64" d="M201.2,497.1c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0L46,487.5c-4.4,2.6-4.4,6.7,0,9.2
							l65.3,37.4c6.6,3.5,20.8,4.6,27.3-0.1L201.2,497.1z"/>
                        <path class="st65" d="M200.9,496.9c4.4-2.5,4.4-6.7,0-9.2l-70.6-40.5c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1
							c-4.4,2.5-4.4,6.7,0,9.2l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L200.9,496.9z"/>
                        <path class="st66" d="M200.6,496.7c4.4-2.5,4.4-6.7,0-9.2l-70.3-40.3c-4.4-2.5-11.5-2.5-15.9,0l-67.7,39.8
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L200.6,496.7z"/>
                        <path class="st67" d="M200.3,496.5c4.4-2.5,4.4-6.6,0-9.2l-70-40.1c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6
							c-4.4,2.5-4.4,6.6,0,9.2l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L200.3,496.5z"/>
                        <path class="st68" d="M200.1,496.3c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L200.1,496.3z"/>
                        <path class="st69" d="M199.8,496.2c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0L48,486.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L199.8,496.2z"/>
                        <path class="st70" d="M199.5,496c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0l-66.4,38.9c-4.3,2.5-4.4,6.6,0,9.1
							l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L199.5,496z"/>
                        <path class="st71" d="M199.2,495.8c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0L48.8,486
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L199.2,495.8z"/>
                        <path class="st72" d="M198.9,495.6c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0l-65.8,38.4c-4.3,2.5-4.3,6.5,0,9
							l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L198.9,495.6z"/>
                        <path class="st73" d="M198.6,495.4c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0l-65.5,38.2c-4.3,2.5-4.3,6.5,0,9
							l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L198.6,495.4z"/>
                        <path class="st74" d="M198.3,495.3c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0L50,485.3c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L198.3,495.3z"/>
                        <path class="st75" d="M198,495.1c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0l-64.8,37.7c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L198,495.1z"/>
                        <path class="st76" d="M197.7,494.9c4.3-2.5,4.3-6.5,0-8.9l-67.1-38.6c-4.3-2.5-11.2-2.5-15.4,0l-64.5,37.5
							c-4.3,2.5-4.3,6.5,0,8.9l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L197.7,494.9z"/>
                        <path class="st77" d="M197.5,494.7c4.3-2.5,4.3-6.5,0-8.9l-66.8-38.4c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L197.5,494.7z"/>
                        <path class="st78" d="M197.2,494.5c4.2-2.5,4.3-6.4,0-8.9l-66.4-38.3c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37
							c-4.2,2.5-4.3,6.4,0,8.9l59.6,34.3c5.4,3,22.6,4.5,28,0.9L197.2,494.5z"/>
                        <path class="st79" d="M196.9,494.4c4.2-2.5,4.3-6.4,0-8.9l-66.1-38.1c-4.2-2.4-11.1-2.4-15.3,0L52,484.2
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L196.9,494.4z"/>
                        <path class="st80" d="M196.6,494.2c4.2-2.4,4.2-6.4,0-8.8l-65.8-37.9c-4.2-2.4-11-2.4-15.3,0L52.4,484c-4.2,2.4-4.2,6.4,0,8.8
							l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L196.6,494.2z"/>
                        <path class="st81" d="M196.3,494c4.2-2.4,4.2-6.4,0-8.8l-65.5-37.7c-4.2-2.4-11-2.4-15.2,0l-62.9,36.3c-4.2,2.4-4.2,6.4,0,8.8
							l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L196.3,494z"/>
                        <path class="st82" d="M196,493.8c4.2-2.4,4.2-6.4,0-8.8l-65.2-37.6c-4.2-2.4-11-2.4-15.2,0l-62.5,36c-4.2,2.4-4.2,6.4,0,8.8
							l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L196,493.8z"/>
                        <path class="st83" d="M195.7,493.7c4.2-2.4,4.2-6.3,0-8.8l-64.8-37.4c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L195.7,493.7z"/>
                        <path class="st84" d="M195.4,493.5c4.2-2.4,4.2-6.3,0-8.7L131,447.5c-4.2-2.4-10.9-2.4-15.1,0L54,483.1
							c-4.2,2.4-4.2,6.3,0,8.7l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L195.4,493.5z"/>
                        <path class="st85" d="M195.1,493.3c4.2-2.4,4.2-6.3,0-8.7L131,447.5c-4.1-2.4-10.9-2.4-15,0l-61.6,35.3
							c-4.2,2.4-4.2,6.3,0,8.7l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L195.1,493.3z"/>
                        <path class="st86" d="M194.9,493.1c4.2-2.4,4.2-6.3,0-8.7L131,447.5c-4.1-2.4-10.9-2.4-15,0l-61.3,35.1
							c-4.2,2.4-4.2,6.3,0,8.7l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L194.9,493.1z"/>
                        <path class="st87" d="M194.6,492.9c4.1-2.4,4.2-6.3,0-8.7l-63.5-36.7c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L194.6,492.9z"/>
                        <path class="st88" d="M194.3,492.8c4.1-2.4,4.1-6.3,0-8.6l-63.2-36.6c-4.1-2.4-10.8-2.4-14.9,0l-60.6,34.6
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L194.3,492.8z"/>
                        <path class="st89" d="M194,492.6c4.1-2.4,4.1-6.2,0-8.6l-62.9-36.4c-4.1-2.4-10.8-2.4-14.9,0L56,481.9c-4.1,2.4-4.1,6.2,0,8.6
							l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L194,492.6z"/>
                        <path class="st90" d="M193.7,492.4c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1
							c-4.1,2.4-4.1,6.2,0,8.6l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L193.7,492.4z"/>
                        <path class="st91" d="M193.4,492.2c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0l-59.6,33.9
							c-4.1,2.4-4.1,6.2,0,8.6l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L193.4,492.2z"/>
                        <path class="st92" d="M193.1,492c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L193.1,492z"/>
                        <path class="st93" d="M192.8,491.9c4.1-2.4,4.1-6.2,0-8.5l-61.6-35.7c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4
							c-4.1,2.4-4.1,6.2,0,8.5l53.4,31c4.1,2.4,24.5,4.4,28.6,2L192.8,491.9z"/>
                        <path class="st94" d="M192.5,491.7c4.1-2.3,4.1-6.1,0-8.5l-61.3-35.5c-4-2.3-10.6-2.3-14.7,0l-58.7,33.2
							c-4.1,2.3-4.1,6.1,0,8.5l53,30.7c4,2.3,24.6,4.4,28.7,2.1L192.5,491.7z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000116198750126131303970000017110533620018883767_" gradientUnits="userSpaceOnUse" x1="714.6259" y1="879.0285" x2="791.1721" y2="1011.6106" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000116198750126131303970000017110533620018883767_);" d="M56,490.6l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C50.8,485.4,52.4,488.5,56,490.6z"/>

                        <linearGradient id="SVGID_00000108303602810581545880000005732400976951369394_" gradientUnits="userSpaceOnUse" x1="717.5869" y1="868.3317" x2="798.185" y2="1007.9316" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000108303602810581545880000005732400976951369394_);" d="M51.1,480.4l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C44.5,474.3,46.6,477.8,51.1,480.4z"/>
                        <g>
							<path class="st97" d="M44.8,461.9c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C44.8,467.5,44.8,464.8,44.8,461.9z"/>
                            <path class="st98" d="M44.8,453.2c0-1,0-2,0-2.8h0C44.8,451.4,44.8,452.4,44.8,453.2z"/>
						</g>

                        <linearGradient id="SVGID_00000101782900165071202330000003312317304457822614_" gradientUnits="userSpaceOnUse" x1="716.1752" y1="869.9227" x2="816.8967" y2="994.3038" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000101782900165071202330000003312317304457822614_);" d="M51.1,458.8l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2l-149.5,0.4c0,0-5.4,9.1-5.6,12.1
							C44.5,452.8,46.6,456.2,51.1,458.8z"/>

                        <linearGradient id="SVGID_00000006681358204245512150000006093955088595714994_" gradientUnits="userSpaceOnUse" x1="848.7202" y1="945.0161" x2="719.7592" y2="887.5987" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000006681358204245512150000006093955088595714994_);" d="M56,447.4l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0L56,430.8
							C48,435.4,48,442.8,56,447.4z"/>
                        <g>
							<path class="st48" d="M125.1,467.6c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C132.1,466.8,128.7,467.6,125.1,467.6z M125.1,411.1c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C131.9,411.9,128.6,411.1,125.1,411.1z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000153669192334630401130000016537604343486227362_" cx="502.0298" cy="514.0704" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000153669192334630401130000016537604343486227362_);" d="M118,512.9
								c-0.9,1.6-19.4-7.4-41.2-20C54.9,480.2,38,468.6,38.9,467c0.9-1.6,19.4,7.4,41.2,20C102,499.7,118.9,511.3,118,512.9z"/>

                            <radialGradient id="SVGID_00000006688959229258623210000010282136651070560161_" cx="502.3949" cy="500.082" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000006688959229258623210000010282136651070560161_);" d="M120.9,510.4
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C104.8,497.2,121.8,508.8,120.9,510.4z"
                            />

                            <radialGradient id="SVGID_00000061470550185636989880000007083242736958593163_" cx="502.655" cy="486.3576" r="13.1623" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000061470550185636989880000007083242736958593163_);" d="M123.4,507.8
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C107.4,494.7,124.3,506.2,123.4,507.8z"
                            />
						</g>
                        <g>

								<radialGradient id="SVGID_00000022535039060110697210000009572858797486843011_" cx="747.8071" cy="-1421.4594" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000022535039060110697210000009572858797486843011_);" d="M129.5,513.9
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C145.5,500.8,128.6,512.3,129.5,513.9z"
                            />

                            <radialGradient id="SVGID_00000018944401315528420180000014610181556233218743_" cx="748.1721" cy="-1435.4473" r="13.1624" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000018944401315528420180000014610181556233218743_);" d="M126.6,511.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C142.6,498.3,125.7,509.9,126.6,511.5z"
                            />

                            <radialGradient id="SVGID_00000009552320516753978950000009355270337402628273_" cx="748.4323" cy="-1449.1724" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000009552320516753978950000009355270337402628273_);" d="M124.1,508.9
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C140.1,495.7,123.2,507.3,124.1,508.9z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000145766261823646087990000017304425436748796045_" gradientUnits="userSpaceOnUse" x1="744.4755" y1="849.1789" x2="821.0217" y2="981.7608" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000145766261823646087990000017304425436748796045_);" d="M56,448.4l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C50.8,443.2,52.4,446.3,56,448.4z"/>

                        <linearGradient id="SVGID_00000007421806141913935630000011294059638897183157_" gradientUnits="userSpaceOnUse" x1="747.4366" y1="838.4821" x2="828.0347" y2="978.082" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000007421806141913935630000011294059638897183157_);" d="M51.1,438.2l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C44.5,432.1,46.6,435.6,51.1,438.2z"/>
                        <g>
							<path class="st97" d="M44.8,419.7c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C44.8,425.3,44.8,422.6,44.8,419.7z"/>
                            <path class="st98" d="M44.8,411c0-1,0-2,0-2.8h0C44.8,409.2,44.8,410.2,44.8,411z"/>
						</g>

                        <linearGradient id="SVGID_00000065033841913095482650000015704362050640433854_" gradientUnits="userSpaceOnUse" x1="746.0248" y1="840.0732" x2="846.7463" y2="964.4542" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000065033841913095482650000015704362050640433854_);" d="M51.1,416.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L50.3,395c0,0-5.4,9.1-5.6,12.1
							C44.5,410.5,46.6,414,51.1,416.6z"/>

                        <linearGradient id="SVGID_00000001641813089833976730000010150594481282759848_" gradientUnits="userSpaceOnUse" x1="878.5698" y1="915.1666" x2="749.6088" y2="857.7491" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000001641813089833976730000010150594481282759848_);" d="M56,405.2l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7L139.6,357c-8-4.6-20.9-4.6-28.9,0L56,388.6C48,393.2,48,400.6,56,405.2
							z"/>
                        <g>
							<path class="st48" d="M125.1,425.4c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7s1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7s-1.4,4.2-4,5.7l-35.7,20.6
								C132.1,424.6,128.7,425.4,125.1,425.4z M125.1,368.9c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C131.9,369.7,128.6,368.9,125.1,368.9z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000067207632986012102330000009508835941865946534_" cx="495.9263" cy="371.0744" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000067207632986012102330000009508835941865946534_);" d="M118,470.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C102,457.5,118.9,469,118,470.6z"/>

                            <radialGradient id="SVGID_00000053535897604260164870000011156107727547687600_" cx="496.2913" cy="357.086" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000053535897604260164870000011156107727547687600_);" d="M120.9,468.2
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C104.8,455,121.8,466.6,120.9,468.2z"/>

                            <radialGradient id="SVGID_00000103955578266268693550000007331310963631585681_" cx="496.5514" cy="343.3611" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000103955578266268693550000007331310963631585681_);" d="M123.4,465.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C107.4,452.4,124.3,464,123.4,465.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000086655843734124868610000008689176441710024638_" cx="741.7036" cy="-1564.4567" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000086655843734124868610000008689176441710024638_);" d="M129.5,471.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C145.5,458.5,128.6,470.1,129.5,471.7z"
                            />

                            <radialGradient id="SVGID_00000010309184246774595070000011412942064891724691_" cx="742.0685" cy="-1578.4446" r="13.1621" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000010309184246774595070000011412942064891724691_);" d="M126.6,469.3
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C142.6,456.1,125.7,467.7,126.6,469.3z"
                            />

                            <radialGradient id="SVGID_00000183244823565693163910000003042154148018548371_" cx="742.3287" cy="-1592.1685" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000183244823565693163910000003042154148018548371_);" d="M124.1,466.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C140.1,453.5,123.2,465.1,124.1,466.7z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000115507344741663379010000010916079786693057692_" gradientUnits="userSpaceOnUse" x1="774.1924" y1="819.462" x2="850.7386" y2="952.0439" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000115507344741663379010000010916079786693057692_);" d="M56,406.3l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C50.8,401.2,52.4,404.3,56,406.3z"/>

                        <linearGradient id="SVGID_00000168091697476638420570000004227317035252925333_" gradientUnits="userSpaceOnUse" x1="777.1534" y1="808.7651" x2="857.7515" y2="948.3651" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000168091697476638420570000004227317035252925333_);" d="M51.1,396.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C44.5,390.1,46.6,393.5,51.1,396.1z"/>
                        <g>
							<path class="st97" d="M44.8,377.6c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C44.8,383.3,44.8,380.5,44.8,377.6z"/>
                            <path class="st98" d="M44.8,369c0-1,0-2,0-2.8h0C44.8,367.2,44.8,368.2,44.8,369z"/>
						</g>

                        <linearGradient id="SVGID_00000043459727544029629260000011457310711755696054_" gradientUnits="userSpaceOnUse" x1="775.7417" y1="810.3563" x2="876.4631" y2="934.7374" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000043459727544029629260000011457310711755696054_);" d="M51.1,374.6l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L50.3,353c0,0-5.4,9.1-5.6,12.1
							C44.5,368.5,46.6,372,51.1,374.6z"/>

                        <linearGradient id="SVGID_00000120537567710887085250000012597481961137595288_" gradientUnits="userSpaceOnUse" x1="908.2867" y1="885.4495" x2="779.3257" y2="828.0321" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000120537567710887085250000012597481961137595288_);" d="M56,363.2l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7L139.6,315c-8-4.6-20.9-4.6-28.9,0L56,346.5C48,351.1,48,358.6,56,363.2
							z"/>
                        <g>
							<path class="st48" d="M125.1,383.4c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C132.1,382.6,128.7,383.4,125.1,383.4z M125.1,326.9c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C131.9,327.6,128.6,326.9,125.1,326.9z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000080201860760965075190000011667183907556261035_" cx="489.8498" cy="228.7141" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000080201860760965075190000011667183907556261035_);" d="M118,428.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C102,415.4,118.9,427,118,428.6z"/>

                            <radialGradient id="SVGID_00000146462641497243740440000013686228368430379649_" cx="490.2148" cy="214.7257" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000146462641497243740440000013686228368430379649_);" d="M120.9,426.2
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C104.8,413,121.8,424.6,120.9,426.2z"/>

                            <radialGradient id="SVGID_00000021814407613233708970000016173760364522208152_" cx="490.4749" cy="201.0013" r="13.1624" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000021814407613233708970000016173760364522208152_);" d="M123.4,423.6
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C107.4,410.4,124.3,422,123.4,423.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000013159256470967493210000004001425323151007398_" cx="735.6271" cy="-1706.8165" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000013159256470967493210000004001425323151007398_);" d="M129.5,429.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C145.5,416.5,128.6,428.1,129.5,429.7z"
                            />

                            <radialGradient id="SVGID_00000165946138910016840140000011236369155483342248_" cx="735.9921" cy="-1720.8049" r="13.1621" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000165946138910016840140000011236369155483342248_);" d="M126.6,427.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20S125.7,425.6,126.6,427.2z"/>

                            <radialGradient id="SVGID_00000078030448605906551880000007367574188479569556_" cx="736.2522" cy="-1734.5287" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000078030448605906551880000007367574188479569556_);" d="M124.1,424.7
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C140.1,411.5,123.2,423.1,124.1,424.7z"
                            />
						</g>
					</g>
				</g>
                <g>
					<g>
						<path class="st53" d="M509.1,319.6c4.5-2.6,4.6-6.9,0-9.5l-74.5-42.5c-4.5-2.6-11.9-2.6-16.4,0l-71.9,43
							c-4.5,2.6-4.6,6.9,0,9.5l69.9,39.9c7.6,3.9,19.4,4.7,26.9-0.9L509.1,319.6z"/>
                        <path class="st54" d="M508.8,319.4c4.5-2.6,4.5-6.9,0-9.5l-74.2-42.3c-4.5-2.6-11.8-2.6-16.4,0l-71.6,42.7
							c-4.5,2.6-4.6,6.9,0,9.5l69.5,39.6c7.5,3.9,19.5,4.7,26.9-0.8L508.8,319.4z"/>
                        <path class="st55" d="M508.5,319.2c4.5-2.6,4.5-6.8,0-9.5l-73.8-42.2c-4.5-2.6-11.8-2.6-16.3,0l-71.3,42.5
							c-4.5,2.6-4.5,6.8,0,9.5l69,39.4c7.4,3.8,19.6,4.7,27-0.7L508.5,319.2z"/>
                        <path class="st56" d="M508.2,319c4.5-2.6,4.5-6.8,0-9.4l-73.5-42c-4.5-2.6-11.8-2.6-16.3,0l-70.9,42.2c-4.5,2.6-4.5,6.8,0,9.4
							l68.6,39.2c7.3,3.8,19.7,4.7,27-0.6L508.2,319z"/>
                        <path class="st57" d="M507.9,318.8c4.5-2.6,4.5-6.8,0-9.4l-73.2-41.8c-4.5-2.6-11.7-2.6-16.2,0l-70.6,42
							c-4.5,2.6-4.5,6.8,0,9.4l68.2,39c7.3,3.8,19.9,4.7,27-0.6L507.9,318.8z"/>
                        <path class="st58" d="M507.7,318.7c4.5-2.6,4.5-6.8,0-9.4l-72.9-41.7c-4.5-2.6-11.7-2.6-16.2,0l-70.3,41.8
							c-4.5,2.6-4.5,6.8,0,9.4l67.8,38.8c7.2,3.7,20,4.7,27.1-0.5L507.7,318.7z"/>
                        <path class="st59" d="M507.4,318.5c4.5-2.6,4.5-6.8,0-9.4l-72.6-41.5c-4.5-2.6-11.7-2.6-16.2,0l-70,41.5
							c-4.5,2.6-4.5,6.8,0,9.4l67.4,38.5c7.1,3.7,20.1,4.7,27.1-0.4L507.4,318.5z"/>
                        <path class="st60" d="M507.1,318.3c4.5-2.6,4.5-6.8,0-9.3l-72.2-41.3c-4.4-2.6-11.7-2.6-16.1,0l-69.6,41.3
							c-4.5,2.6-4.5,6.8,0,9.3l67,38.3c7,3.6,20.3,4.7,27.2-0.4L507.1,318.3z"/>
                        <path class="st61" d="M506.8,318.1c4.4-2.6,4.5-6.7,0-9.3l-71.9-41.1c-4.4-2.6-11.6-2.6-16.1,0l-69.3,41
							c-4.4,2.6-4.5,6.7,0,9.3l66.6,38.1c6.9,3.6,20.4,4.7,27.2-0.3L506.8,318.1z"/>
                        <path class="st62" d="M506.5,317.9c4.4-2.6,4.5-6.7,0-9.3l-71.6-41c-4.4-2.6-11.6-2.6-16,0l-69,40.8c-4.4,2.6-4.5,6.7,0,9.3
							l66.2,37.9c6.8,3.6,20.5,4.7,27.3-0.2L506.5,317.9z"/>
                        <path class="st63" d="M506.2,317.8c4.4-2.6,4.4-6.7,0-9.3L435,267.7c-4.4-2.6-11.6-2.5-16,0l-68.7,40.6
							c-4.4,2.6-4.4,6.7,0,9.3l65.8,37.6c6.7,3.5,20.6,4.7,27.3-0.1L506.2,317.8z"/>
                        <path class="st64" d="M505.9,317.6c4.4-2.6,4.4-6.7,0-9.2l-71-40.6c-4.4-2.5-11.5-2.5-15.9,0l-68.4,40.3
							c-4.4,2.6-4.4,6.7,0,9.2l65.3,37.4c6.6,3.5,20.8,4.6,27.3-0.1L505.9,317.6z"/>
                        <path class="st65" d="M505.6,317.4c4.4-2.5,4.4-6.7,0-9.2L435,267.7c-4.4-2.5-11.5-2.5-15.9,0l-68,40.1
							c-4.4,2.5-4.4,6.7,0,9.2l64.9,37.2c6.6,3.4,20.9,4.6,27.4,0L505.6,317.4z"/>
                        <path class="st66" d="M505.3,317.2c4.4-2.5,4.4-6.7,0-9.2l-70.3-40.3c-4.4-2.5-11.5-2.5-15.9,0l-67.7,39.8
							c-4.4,2.5-4.4,6.7,0,9.2l64.5,37c6.5,3.4,21,4.6,27.4,0.1L505.3,317.2z"/>
                        <path class="st67" d="M505.1,317c4.4-2.5,4.4-6.6,0-9.2l-70-40.1c-4.4-2.5-11.4-2.5-15.8,0l-67.4,39.6c-4.4,2.5-4.4,6.6,0,9.2
							l64.1,36.7c6.4,3.4,21.2,4.6,27.5,0.1L505.1,317z"/>
                        <path class="st68" d="M504.8,316.9c4.4-2.5,4.4-6.6,0-9.1l-69.7-40c-4.3-2.5-11.4-2.5-15.8,0l-67.1,39.4
							c-4.4,2.5-4.4,6.6,0,9.1l63.7,36.5c6.3,3.3,21.3,4.6,27.5,0.2L504.8,316.9z"/>
                        <path class="st69" d="M504.5,316.7c4.4-2.5,4.4-6.6,0-9.1l-69.3-39.8c-4.3-2.5-11.4-2.5-15.7,0l-66.7,39.1
							c-4.4,2.5-4.4,6.6,0,9.1l63.3,36.3c6.2,3.3,21.4,4.6,27.6,0.3L504.5,316.7z"/>
                        <path class="st70" d="M504.2,316.5c4.3-2.5,4.4-6.6,0-9.1l-69-39.6c-4.3-2.5-11.3-2.5-15.7,0l-66.4,38.9
							c-4.3,2.5-4.4,6.6,0,9.1l62.9,36.1c6.1,3.3,21.5,4.6,27.6,0.4L504.2,316.5z"/>
                        <path class="st71" d="M503.9,316.3c4.3-2.5,4.3-6.6,0-9.1l-68.7-39.4c-4.3-2.5-11.3-2.5-15.6,0l-66.1,38.7
							c-4.3,2.5-4.3,6.6,0,9.1l62.5,35.9c6,3.2,21.7,4.6,27.7,0.4L503.9,316.3z"/>
                        <path class="st72" d="M503.6,316.1c4.3-2.5,4.3-6.5,0-9l-68.4-39.3c-4.3-2.5-11.3-2.5-15.6,0l-65.8,38.4c-4.3,2.5-4.3,6.5,0,9
							l62.1,35.6c5.9,3.2,21.8,4.6,27.7,0.5L503.6,316.1z"/>
                        <path class="st73" d="M503.3,316c4.3-2.5,4.3-6.5,0-9l-68.1-39.1c-4.3-2.5-11.3-2.5-15.6,0L354.3,306c-4.3,2.5-4.3,6.5,0,9
							l61.6,35.4c5.9,3.1,21.9,4.6,27.7,0.6L503.3,316z"/>
                        <path class="st74" d="M503,315.8c4.3-2.5,4.3-6.5,0-9l-67.7-38.9c-4.3-2.5-11.2-2.5-15.5,0l-65.1,37.9c-4.3,2.5-4.3,6.5,0,9
							l61.2,35.2c5.8,3.1,22,4.6,27.8,0.6L503,315.8z"/>
                        <path class="st75" d="M502.7,315.6c4.3-2.5,4.3-6.5,0-9l-67.4-38.8c-4.3-2.5-11.2-2.5-15.5,0l-64.8,37.7c-4.3,2.5-4.3,6.5,0,9
							l60.8,35c5.7,3.1,22.2,4.6,27.8,0.7L502.7,315.6z"/>
                        <path class="st76" d="M502.5,315.4c4.3-2.5,4.3-6.5,0-8.9l-67.1-38.6c-4.3-2.5-11.2-2.5-15.4,0l-64.5,37.5
							c-4.3,2.5-4.3,6.5,0,8.9l60.4,34.7c5.6,3,22.3,4.6,27.9,0.8L502.5,315.4z"/>
                        <path class="st77" d="M502.2,315.3c4.3-2.5,4.3-6.5,0-8.9l-66.8-38.4c-4.2-2.5-11.1-2.5-15.4,0l-64.2,37.2
							c-4.3,2.5-4.3,6.5,0,8.9l60,34.5c5.5,3,22.4,4.5,27.9,0.9L502.2,315.3z"/>
                        <path class="st78" d="M501.9,315.1c4.2-2.5,4.3-6.4,0-8.9l-66.4-38.3c-4.2-2.5-11.1-2.4-15.3,0l-63.8,37
							c-4.2,2.5-4.3,6.4,0,8.9l59.6,34.3c5.4,3,22.6,4.5,28,0.9L501.9,315.1z"/>
                        <path class="st79" d="M501.6,314.9c4.2-2.5,4.3-6.4,0-8.9l-66.1-38.1c-4.2-2.4-11.1-2.4-15.3,0l-63.5,36.7
							c-4.2,2.5-4.3,6.4,0,8.9l59.2,34.1c5.3,2.9,22.7,4.5,28,1L501.6,314.9z"/>
                        <path class="st80" d="M501.3,314.7c4.2-2.4,4.2-6.4,0-8.8L435.5,268c-4.2-2.4-11-2.4-15.3,0l-63.2,36.5
							c-4.2,2.4-4.2,6.4,0,8.8l58.8,33.9c5.3,2.9,22.8,4.5,28,1.1L501.3,314.7z"/>
                        <path class="st81" d="M501,314.5c4.2-2.4,4.2-6.4,0-8.8L435.6,268c-4.2-2.4-11-2.4-15.2,0l-62.9,36.3c-4.2,2.4-4.2,6.4,0,8.8
							l58.4,33.6c5.2,2.8,22.9,4.5,28.1,1.1L501,314.5z"/>
                        <path class="st82" d="M500.7,314.4c4.2-2.4,4.2-6.4,0-8.8L435.6,268c-4.2-2.4-11-2.4-15.2,0l-62.5,36c-4.2,2.4-4.2,6.4,0,8.8
							l57.9,33.4c5.1,2.8,23.1,4.5,28.1,1.2L500.7,314.4z"/>
                        <path class="st83" d="M500.4,314.2c4.2-2.4,4.2-6.3,0-8.8L435.6,268c-4.2-2.4-10.9-2.4-15.1,0l-62.2,35.8
							c-4.2,2.4-4.2,6.3,0,8.8l57.5,33.2c5,2.8,23.2,4.5,28.2,1.3L500.4,314.2z"/>
                        <path class="st84" d="M500.1,314c4.2-2.4,4.2-6.3,0-8.7L435.7,268c-4.2-2.4-10.9-2.4-15.1,0l-61.9,35.5
							c-4.2,2.4-4.2,6.3,0,8.7l57.1,33c4.9,2.7,23.3,4.5,28.2,1.4L500.1,314z"/>
                        <path class="st85" d="M499.9,313.8c4.2-2.4,4.2-6.3,0-8.7L435.7,268c-4.1-2.4-10.9-2.4-15,0l-61.6,35.3
							c-4.2,2.4-4.2,6.3,0,8.7l56.7,32.7c4.8,2.7,23.4,4.5,28.3,1.4L499.9,313.8z"/>
                        <path class="st86" d="M499.6,313.6c4.2-2.4,4.2-6.3,0-8.7l-63.9-36.9c-4.1-2.4-10.9-2.4-15,0l-61.3,35.1
							c-4.2,2.4-4.2,6.3,0,8.7l56.3,32.5c4.7,2.6,23.6,4.5,28.3,1.5L499.6,313.6z"/>
                        <path class="st87" d="M499.3,313.5c4.1-2.4,4.2-6.3,0-8.7l-63.5-36.7c-4.1-2.4-10.8-2.4-15,0l-60.9,34.8
							c-4.1,2.4-4.2,6.3,0,8.7l55.9,32.3c4.6,2.6,23.7,4.5,28.3,1.6L499.3,313.5z"/>
                        <path class="st88" d="M499,313.3c4.1-2.4,4.1-6.3,0-8.6l-63.2-36.6c-4.1-2.4-10.8-2.4-14.9,0l-60.6,34.6
							c-4.1,2.4-4.1,6.3,0,8.6l55.5,32.1c4.6,2.6,23.8,4.5,28.4,1.6L499,313.3z"/>
                        <path class="st89" d="M498.7,313.1c4.1-2.4,4.1-6.2,0-8.6l-62.9-36.4c-4.1-2.4-10.8-2.4-14.9,0l-60.3,34.4
							c-4.1,2.4-4.1,6.2,0,8.6l55.1,31.8c4.5,2.5,24,4.5,28.4,1.7L498.7,313.1z"/>
                        <path class="st90" d="M498.4,312.9c4.1-2.4,4.1-6.2,0-8.6l-62.6-36.2c-4.1-2.4-10.7-2.4-14.8,0l-60,34.1
							c-4.1,2.4-4.1,6.2,0,8.6l54.7,31.6c4.4,2.5,24.1,4.5,28.5,1.8L498.4,312.9z"/>
                        <path class="st91" d="M498.1,312.7c4.1-2.4,4.1-6.2,0-8.6l-62.3-36c-4.1-2.4-10.7-2.4-14.8,0L361.5,302
							c-4.1,2.4-4.1,6.2,0,8.6l54.2,31.4c4.3,2.5,24.2,4.4,28.5,1.9L498.1,312.7z"/>
                        <path class="st92" d="M497.8,312.6c4.1-2.4,4.1-6.2,0-8.5l-61.9-35.9c-4.1-2.4-10.7-2.3-14.7,0l-59.3,33.6
							c-4.1,2.4-4.1,6.2,0,8.5l53.8,31.2c4.2,2.4,24.3,4.4,28.6,1.9L497.8,312.6z"/>
                        <path class="st93" d="M497.5,312.4c4.1-2.4,4.1-6.2,0-8.5L436,268.2c-4.1-2.3-10.6-2.3-14.7,0l-59,33.4
							c-4.1,2.4-4.1,6.2,0,8.5l53.4,31c4.1,2.4,24.5,4.4,28.6,2L497.5,312.4z"/>
                        <path class="st94" d="M497.2,312.2c4.1-2.3,4.1-6.1,0-8.5L436,268.2c-4-2.3-10.6-2.3-14.7,0l-58.7,33.2
							c-4.1,2.3-4.1,6.1,0,8.5l53,30.7c4,2.3,24.6,4.4,28.7,2.1L497.2,312.2z"/>
					</g>
                    <g>

							<linearGradient id="SVGID_00000098186772671734377120000006192397950579272872_" gradientUnits="userSpaceOnUse" x1="626.0693" y1="536.6552" x2="702.6155" y2="669.2372" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000098186772671734377120000006192397950579272872_);" d="M360.7,311.1l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C355.5,305.9,357.1,309,360.7,311.1z"/>

                        <linearGradient id="SVGID_00000098184637613830029130000007119000184550541706_" gradientUnits="userSpaceOnUse" x1="629.0305" y1="525.9585" x2="709.6285" y2="665.5585" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000098184637613830029130000007119000184550541706_);" d="M355.8,300.9l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C349.2,294.8,351.3,298.3,355.8,300.9z"/>
                        <g>
							<path class="st97" d="M349.5,282.4c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C349.5,288.1,349.5,285.3,349.5,282.4z"/>
                            <path class="st98" d="M349.5,273.7c0-1,0-2,0-2.8h0C349.5,272,349.5,272.9,349.5,273.7z"/>
						</g>

                        <linearGradient id="SVGID_00000171680002464235849180000006411202594242529666_" gradientUnits="userSpaceOnUse" x1="627.6188" y1="527.5496" x2="728.3403" y2="651.9306" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000171680002464235849180000006411202594242529666_);" d="M355.8,279.3l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L355,257.7c0,0-5.4,9.1-5.6,12.1
							C349.2,273.3,351.3,276.7,355.8,279.3z"/>

                        <linearGradient id="SVGID_00000150810901606552648210000008038561772806384516_" gradientUnits="userSpaceOnUse" x1="760.1638" y1="602.6428" x2="631.2028" y2="545.2254" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000150810901606552648210000008038561772806384516_);" d="M360.7,268l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0L499,268c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C352.7,255.9,352.7,263.4,360.7,268z"/>
                        <g>
							<path class="st48" d="M429.8,288.2c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3L475,254c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C436.8,287.4,433.4,288.2,429.8,288.2z M429.8,231.6c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C436.7,232.4,433.4,231.6,429.8,231.6z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000082356441305323913810000010971245928882052495_" cx="551.9611" cy="-692.9668" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000082356441305323913810000010971245928882052495_);" d="M422.7,333.4
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C406.7,320.2,423.6,331.8,422.7,333.4z"
                            />

                            <radialGradient id="SVGID_00000114071669022008362970000013205283011138802579_" cx="552.326" cy="-706.9552" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000114071669022008362970000013205283011138802579_);" d="M425.6,330.9
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C409.6,317.8,426.5,329.3,425.6,330.9z"
                            />

                            <radialGradient id="SVGID_00000145029155012403783290000012820394781832905375_" cx="552.5861" cy="-720.6799" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000145029155012403783290000012820394781832905375_);" d="M428.1,328.4
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C412.1,315.2,429,326.8,428.1,328.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000159431602709486250960000010906737573091053196_" cx="645.9761" cy="-1430.3447" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000159431602709486250960000010906737573091053196_);" d="M434.2,334.5
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C450.2,321.3,433.3,332.9,434.2,334.5z"
                            />

                            <radialGradient id="SVGID_00000124156878968835015870000003366807247629125567_" cx="646.3411" cy="-1444.333" r="13.1622" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000124156878968835015870000003366807247629125567_);" d="M431.3,332
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C447.4,318.8,430.4,330.4,431.3,332z"/>

                            <radialGradient id="SVGID_00000101782126167312987110000007875977078235292347_" cx="646.6012" cy="-1458.0579" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000101782126167312987110000007875977078235292347_);" d="M428.8,329.4
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C444.8,316.3,427.9,327.8,428.8,329.4z"
                            />
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000062897801239923159340000011285368063547539586_" gradientUnits="userSpaceOnUse" x1="655.919" y1="506.8055" x2="732.4652" y2="639.3875" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000062897801239923159340000011285368063547539586_);" d="M360.7,268.9l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C355.5,263.7,357.1,266.8,360.7,268.9z"/>

                        <linearGradient id="SVGID_00000092434321567686046790000012958330446962494112_" gradientUnits="userSpaceOnUse" x1="658.8802" y1="496.1088" x2="739.4783" y2="635.7088" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000092434321567686046790000012958330446962494112_);" d="M355.8,258.7l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C349.2,252.6,351.3,256.1,355.8,258.7z"/>
                        <g>
							<path class="st97" d="M349.5,240.2c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.5c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C349.5,245.9,349.5,243.1,349.5,240.2z"/>
                            <path class="st98" d="M349.5,231.5c0-1,0-2,0-2.8h0C349.5,229.8,349.5,230.7,349.5,231.5z"/>
						</g>

                        <linearGradient id="SVGID_00000106850846824486974230000000767234462594421157_" gradientUnits="userSpaceOnUse" x1="657.4684" y1="497.7" x2="758.1898" y2="622.081" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000106850846824486974230000000767234462594421157_);" d="M355.8,237.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L355,215.5c0,0-5.4,9.1-5.6,12.1
							C349.2,231.1,351.3,234.5,355.8,237.1z"/>

                        <linearGradient id="SVGID_00000011728848103463384440000014066254089547399308_" gradientUnits="userSpaceOnUse" x1="790.0135" y1="572.7932" x2="661.0525" y2="515.3758" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000011728848103463384440000014066254089547399308_);" d="M360.7,225.8l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C352.7,213.7,352.7,221.2,360.7,225.8z"/>
                        <g>
							<path class="st48" d="M429.8,246c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C436.8,245.1,433.4,246,429.8,246z M429.8,189.4c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C436.7,190.2,433.4,189.4,429.8,189.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000072254024786596479720000009714578991048331448_" cx="545.8575" cy="-835.9628" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000072254024786596479720000009714578991048331448_);" d="M422.7,291.2
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C406.7,278,423.6,289.6,422.7,291.2z"/>

                            <radialGradient id="SVGID_00000098943593686324817010000006020217344218833287_" cx="546.2224" cy="-849.9512" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000098943593686324817010000006020217344218833287_);" d="M425.6,288.7
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C409.6,275.5,426.5,287.1,425.6,288.7z"
                            />

                            <radialGradient id="SVGID_00000126300391927151545680000003763884353836074914_" cx="546.4825" cy="-863.6759" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000126300391927151545680000003763884353836074914_);" d="M428.1,286.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C412.1,273,429,284.5,428.1,286.1z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000141425499003775261890000010168666020680305067_" cx="639.8725" cy="-1573.3416" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000141425499003775261890000010168666020680305067_);" d="M434.2,292.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C450.2,279.1,433.3,290.6,434.2,292.2z"
                            />

                            <radialGradient id="SVGID_00000129168822218664943640000010923655892415572106_" cx="640.2375" cy="-1587.3303" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000129168822218664943640000010923655892415572106_);" d="M431.3,289.8
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C447.4,276.6,430.4,288.2,431.3,289.8z"
                            />

                            <radialGradient id="SVGID_00000087404199913387982150000001955697393507292571_" cx="640.4976" cy="-1601.0538" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000087404199913387982150000001955697393507292571_);" d="M428.8,287.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C444.8,274,427.9,285.6,428.8,287.2z"/>
						</g>
					</g>
                    <g>

							<linearGradient id="SVGID_00000066487511255246226770000015258852098331939760_" gradientUnits="userSpaceOnUse" x1="685.6359" y1="477.0887" x2="762.1822" y2="609.6706" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                                <stop  offset="0.5785" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000066487511255246226770000015258852098331939760_);" d="M360.7,226.9l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c3.6-2.1,5.4-5.6,6.7-8c1.8-3.1,3.4-7,3.4-7l-64.8-33.3c-8-4.6-20.9-4.6-28.9,0l-65,32.6
							c0,0,1.5,3.9,3.8,8.1C355.5,221.7,357.1,224.8,360.7,226.9z"/>

                        <linearGradient id="SVGID_00000058572445263975212540000016121632355475798152_" gradientUnits="userSpaceOnUse" x1="688.597" y1="466.392" x2="769.1951" y2="605.9919" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#194DB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000058572445263975212540000016121632355475798152_);" d="M355.8,216.7l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3,0-21.6,0-21.6l-160.8,0.4c0,0,0.1,17.5-0.1,20.5
							C349.2,210.6,351.3,214.1,355.8,216.7z"/>
                        <g>
							<path class="st97" d="M349.5,198.2c0-2.4,0-5.2,0-7.6c0.4,2.9,2.5,5.7,6.3,7.9l58.6,33.8c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8
								c4.2-2.4,6.4-5.6,6.4-8.8c0-0.2,0-0.4,0-0.6c0,2.6,0,6.5,0,10.2c0,2.5,0,4.6,0,5.6c-0.1,3.2-2.2,6.4-6.4,8.8l-58.6,33.8
								c-8.5,4.9-22.4,4.9-30.9,0l-58.6-33.8c-3.8-2.2-5.9-5.1-6.3-8C349.5,203.8,349.5,201.1,349.5,198.2z"/>
                            <path class="st98" d="M349.5,189.5c0-1,0-2,0-2.8h0C349.5,187.7,349.5,188.7,349.5,189.5z"/>
						</g>

                        <linearGradient id="SVGID_00000046301931601235059050000009663173062297150143_" gradientUnits="userSpaceOnUse" x1="687.1854" y1="467.9831" x2="787.9067" y2="592.3641" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#0E2EA1"/>
                            <stop  offset="0.4291" style="stop-color:#0090C4"/>
                            <stop  offset="1" style="stop-color:#ABFFFC"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000046301931601235059050000009663173062297150143_);" d="M355.8,195.1l58.6,33.8
							c8.5,4.9,22.4,4.9,30.9,0l58.6-33.8c4.2-2.4,6.4-5.6,6.4-8.8c0.1-3.3-5.8-13.2-5.8-13.2L355,173.5c0,0-5.4,9.1-5.6,12.1
							C349.2,189,351.3,192.5,355.8,195.1z"/>

                        <linearGradient id="SVGID_00000030476186459121027870000000464762489388612276_" gradientUnits="userSpaceOnUse" x1="819.7303" y1="543.0763" x2="690.7693" y2="485.6589" gradientTransform="matrix(-0.7071 -0.7071 -0.7071 0.7071 1327.5883 345.722)">
							<stop  offset="0" style="stop-color:#1C54C7"/>
                            <stop  offset="0.3755" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000030476186459121027870000000464762489388612276_);" d="M360.7,183.7l54.7,31.6
							c8,4.6,20.9,4.6,28.9,0l54.7-31.6c8-4.6,8-12.1,0-16.7l-54.7-31.6c-8-4.6-20.9-4.6-28.9,0l-54.7,31.6
							C352.7,171.7,352.7,179.1,360.7,183.7z"/>
                        <g>
							<path class="st48" d="M429.8,203.9c-3.6,0-7-0.8-9.6-2.3l-35.7-20.6c-2.6-1.5-4-3.5-4-5.7c0-2.2,1.4-4.2,4-5.7l35.7-20.6
								c2.6-1.5,5.9-2.3,9.6-2.3c3.6,0,7,0.8,9.6,2.3l35.7,20.6c2.6,1.5,4,3.5,4,5.7c0,2.2-1.4,4.2-4,5.7l-35.7,20.6
								C436.8,203.1,433.4,203.9,429.8,203.9z M429.8,147.4c-3.5,0-6.8,0.8-9.3,2.2l-35.7,20.6c-2.4,1.4-3.8,3.3-3.8,5.2
								c0,2,1.3,3.8,3.8,5.2l35.7,20.6c2.5,1.4,5.8,2.2,9.3,2.2c3.5,0,6.8-0.8,9.3-2.2l35.7-20.6c2.4-1.4,3.8-3.3,3.8-5.2
								c0-2-1.3-3.8-3.8-5.2l-35.7-20.6C436.7,148.2,433.4,147.4,429.8,147.4z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000034777261881725916210000016511918088253515161_" cx="539.781" cy="-978.3231" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000034777261881725916210000016511918088253515161_);" d="M422.7,249.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C406.7,236,423.6,247.5,422.7,249.1z"/>

                            <radialGradient id="SVGID_00000132787246654470449340000016032999016686871998_" cx="540.1459" cy="-992.3115" r="13.1625" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000132787246654470449340000016032999016686871998_);" d="M425.6,246.7
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C409.6,233.5,426.5,245.1,425.6,246.7z"
                            />

                            <radialGradient id="SVGID_00000146459973715615516280000016247417173910590385_" cx="540.4061" cy="-1006.0362" r="13.1621" gradientTransform="matrix(3.0035 1.7432 -0.1282 0.2208 -1363.505 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000146459973715615516280000016247417173910590385_);" d="M428.1,244.1
								c-0.9,1.6-19.4-7.4-41.2-20c-21.8-12.7-38.8-24.2-37.8-25.9c0.9-1.6,19.4,7.4,41.2,20C412.1,230.9,429,242.5,428.1,244.1z"/>
						</g>
                        <g>

								<radialGradient id="SVGID_00000176003640303922349720000013706948245616026529_" cx="633.796" cy="-1715.7019" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                    <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                    <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000176003640303922349720000013706948245616026529_);" d="M434.2,250.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C450.2,237,433.3,248.6,434.2,250.2z"/>

                            <radialGradient id="SVGID_00000103256835125513057360000003818030063709406648_" cx="634.1611" cy="-1729.6906" r="13.1625" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000103256835125513057360000003818030063709406648_);" d="M431.3,247.8
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C447.4,234.6,430.4,246.2,431.3,247.8z"
                            />

                            <radialGradient id="SVGID_00000158009079677672820480000007020611476376368058_" cx="634.4212" cy="-1743.4141" r="13.1623" gradientTransform="matrix(-3.0035 1.7432 0.1282 0.2208 2597.322 -498.7282)" gradientUnits="userSpaceOnUse">
								<stop  offset="0" style="stop-color:#85EEFF"/>
                                <stop  offset="0.3602" style="stop-color:#11DEFF"/>
                                <stop  offset="0.8582" style="stop-color:#000000"/>
							</radialGradient>
                            <path style="fill:url(#SVGID_00000158009079677672820480000007020611476376368058_);" d="M428.8,245.2
								c0.9,1.6,19.4-7.4,41.2-20c21.8-12.7,38.8-24.2,37.8-25.9c-0.9-1.6-19.4,7.4-41.2,20C444.8,232,427.9,243.6,428.8,245.2z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
        <g id="coin__x26__laptop_00000170989907018246851830000010169824190980857273_">
			<g id="laptop_00000171682603136829322300000011079251453210422949_">
				<g>
					<path class="st53" d="M351.1,447.8c-7.9-4.6-8-12-0.1-16.6l130.3-74.3c7.9-4.6,20.8-4.6,28.7,0l204.2,118.4
						c7.9,4.6,8,12,0.1,16.6L584,566.2c-7.9,4.6-20.8,4.6-28.7,0L351.1,447.8z"/>
                    <path class="st54" d="M351.6,447.5c-7.9-4.6-8-12-0.1-16.6l129.7-74c7.9-4.6,20.7-4.6,28.6,0l203.6,118.1
						c7.9,4.6,8,12,0.1,16.6l-129.7,74c-7.9,4.6-20.7,4.6-28.6,0L351.6,447.5z"/>
                    <path class="st55" d="M352.1,447.2c-7.9-4.6-7.9-12-0.1-16.5l129.2-73.7c7.9-4.6,20.7-4.6,28.6,0l203.1,117.8
						c7.9,4.6,7.9,12,0.1,16.5L583.8,565c-7.9,4.6-20.6,4.5-28.5,0L352.1,447.2z"/>
                    <path class="st56" d="M352.6,446.9c-7.9-4.6-7.9-11.9-0.1-16.5l128.6-73.5c7.9-4.6,20.6-4.5,28.5,0l202.6,117.5
						c7.9,4.6,7.9,11.9,0.1,16.5l-128.6,73.5c-7.8,4.5-20.6,4.5-28.5,0L352.6,446.9z"/>
                    <path class="st57" d="M353.1,446.5c-7.9-4.6-7.9-11.9-0.1-16.5l128-73.2c7.8-4.5,20.5-4.5,28.4,0l202,117.1
						c7.9,4.6,7.9,11.9,0.1,16.5l-128,73.2c-7.8,4.5-20.5,4.5-28.4,0L353.1,446.5z"/>
                    <path class="st58" d="M353.6,446.2c-7.8-4.5-7.9-11.9-0.1-16.4L481,357c7.8-4.5,20.5-4.5,28.3,0l201.5,116.8
						c7.8,4.5,7.9,11.9,0.1,16.4l-127.5,72.9c-7.8,4.5-20.5,4.5-28.3,0L353.6,446.2z"/>
                    <path class="st59" d="M354.1,445.9c-7.8-4.5-7.9-11.9-0.1-16.4L481,357c7.8-4.5,20.4-4.5,28.3,0l201,116.5
						c7.8,4.5,7.9,11.9,0.1,16.4l-126.9,72.6c-7.8,4.5-20.4,4.5-28.2,0L354.1,445.9z"/>
                    <path class="st60" d="M354.6,445.6c-7.8-4.5-7.8-11.8-0.1-16.3L480.9,357c7.8-4.5,20.4-4.5,28.2,0l200.4,116.2
						c7.8,4.5,7.8,11.8,0.1,16.3l-126.3,72.3c-7.8,4.5-20.4,4.5-28.2,0L354.6,445.6z"/>
                    <path class="st61" d="M355.1,445.3c-7.8-4.5-7.8-11.8-0.1-16.3l125.8-72c7.8-4.5,20.3-4.5,28.1,0L708.9,473
						c7.8,4.5,7.8,11.8,0.1,16.3l-125.8,72c-7.7,4.5-20.3,4.5-28.1,0L355.1,445.3z"/>
                    <path class="st62" d="M355.6,445c-7.8-4.5-7.8-11.8-0.1-16.2l125.2-71.7c7.7-4.5,20.3-4.5,28,0l199.4,115.6
						c7.8,4.5,7.8,11.8,0.1,16.2L583,560.6c-7.7,4.5-20.3,4.5-28,0L355.6,445z"/>
                    <path class="st63" d="M356.1,444.7c-7.7-4.5-7.8-11.7-0.1-16.2l124.7-71.4c7.7-4.5,20.2-4.5,28,0l198.8,115.3
						c7.7,4.5,7.8,11.7,0.1,16.2L582.9,560c-7.7,4.5-20.2,4.4-28,0L356.1,444.7z"/>
                    <path class="st64" d="M356.7,444.3c-7.7-4.5-7.7-11.7-0.1-16.1l124.1-71.1c7.7-4.5,20.2-4.4,27.9,0l198.3,115
						c7.7,4.5,7.8,11.7,0.1,16.2l-124.1,71.1c-7.7,4.5-20.2,4.4-27.9,0L356.7,444.3z"/>
                    <path class="st65" d="M357.2,444c-7.7-4.5-7.7-11.7-0.1-16.1l123.5-70.8c7.7-4.4,20.1-4.4,27.8,0l197.8,114.7
						c7.7,4.5,7.7,11.7,0.1,16.1l-123.5,70.8c-7.7,4.4-20.1,4.4-27.8,0L357.2,444z"/>
                    <path class="st66" d="M357.7,443.7c-7.7-4.4-7.7-11.6-0.1-16.1l123-70.5c7.6-4.4,20.1-4.4,27.7,0l197.3,114.4
						c7.7,4.4,7.7,11.6,0.1,16.1l-123,70.5c-7.6,4.4-20,4.4-27.7,0L357.7,443.7z"/>
                    <path class="st67" d="M358.2,443.4c-7.7-4.4-7.7-11.6-0.1-16l122.4-70.2c7.6-4.4,20-4.4,27.7,0l196.7,114.1
						c7.7,4.4,7.7,11.6,0.1,16l-122.4,70.2c-7.6,4.4-20,4.4-27.7,0L358.2,443.4z"/>
                    <path class="st68" d="M358.7,443.1c-7.6-4.4-7.7-11.6-0.1-16l121.8-69.9c7.6-4.4,20-4.4,27.6,0L704.2,471
						c7.6,4.4,7.7,11.6,0.1,16l-121.8,69.9c-7.6,4.4-19.9,4.4-27.6,0L358.7,443.1z"/>
                    <path class="st69" d="M359.2,442.8c-7.6-4.4-7.6-11.5-0.1-15.9l121.3-69.6c7.6-4.4,19.9-4.4,27.5,0l195.7,113.4
						c7.6,4.4,7.6,11.5,0.1,15.9l-121.3,69.6c-7.6,4.4-19.9,4.4-27.5,0L359.2,442.8z"/>
                    <path class="st70" d="M359.7,442.5c-7.6-4.4-7.6-11.5-0.1-15.9l120.7-69.3c7.6-4.4,19.8-4.4,27.4,0l195.1,113.1
						c7.6,4.4,7.6,11.5,0.1,15.9l-120.7,69.3c-7.6,4.4-19.8,4.4-27.4,0L359.7,442.5z"/>
                    <path class="st71" d="M360.2,442.2c-7.6-4.4-7.6-11.5-0.1-15.8l120.2-69c7.5-4.4,19.8-4.4,27.4,0l194.6,112.8
						c7.6,4.4,7.6,11.5,0.1,15.8l-120.2,69c-7.5,4.4-19.8,4.4-27.4,0L360.2,442.2z"/>
                    <path class="st72" d="M360.7,441.8c-7.6-4.4-7.6-11.4-0.1-15.8l119.6-68.7c7.5-4.4,19.7-4.3,27.3,0l194.1,112.5
						c7.6,4.4,7.6,11.4,0.1,15.8L582,554.4c-7.5,4.4-19.7,4.3-27.3,0L360.7,441.8z"/>
                    <path class="st73" d="M361.2,441.5c-7.5-4.4-7.6-11.4-0.1-15.8l119-68.4c7.5-4.3,19.7-4.3,27.2,0l193.5,112.2
						c7.5,4.4,7.6,11.4,0.1,15.8l-119,68.4c-7.5,4.3-19.7,4.3-27.2,0L361.2,441.5z"/>
                    <path class="st74" d="M361.7,441.2c-7.5-4.3-7.5-11.4-0.1-15.7l118.5-68.1c7.5-4.3,19.6-4.3,27.1,0l193,111.9
						c7.5,4.3,7.5,11.4,0.1,15.7l-118.5,68.1c-7.5,4.3-19.6,4.3-27.1,0L361.7,441.2z"/>
                    <path class="st75" d="M362.2,440.9c-7.5-4.3-7.5-11.4-0.1-15.7L480,357.4c7.5-4.3,19.6-4.3,27.1,0L699.6,469
						c7.5,4.3,7.5,11.4,0.1,15.7l-117.9,67.8c-7.5,4.3-19.6,4.3-27.1,0L362.2,440.9z"/>
                    <path class="st76" d="M362.7,440.6c-7.5-4.3-7.5-11.3-0.1-15.6L480,357.5c7.4-4.3,19.5-4.3,27,0l191.9,111.3
						c7.5,4.3,7.5,11.3,0.1,15.6l-117.3,67.5c-7.4,4.3-19.5,4.3-27,0L362.7,440.6z"/>
                    <path class="st77" d="M363.2,440.3c-7.4-4.3-7.5-11.3-0.1-15.6l116.8-67.2c7.4-4.3,19.5-4.3,26.9,0l191.4,111
						c7.4,4.3,7.5,11.3,0.1,15.6l-116.8,67.2c-7.4,4.3-19.5,4.3-26.9,0L363.2,440.3z"/>
                    <path class="st78" d="M363.7,440c-7.4-4.3-7.5-11.3-0.1-15.5l116.2-66.9c7.4-4.3,19.4-4.3,26.8,0l190.9,110.7
						c7.4,4.3,7.5,11.3,0.1,15.5l-116.2,66.9c-7.4,4.3-19.4,4.3-26.8,0L363.7,440z"/>
                    <path class="st79" d="M364.2,439.6c-7.4-4.3-7.4-11.2-0.1-15.5l115.7-66.6c7.4-4.3,19.4-4.3,26.8,0l190.3,110.4
						c7.4,4.3,7.4,11.2,0.1,15.5L581.3,550c-7.4,4.3-19.3,4.3-26.8,0L364.2,439.6z"/>
                    <path class="st80" d="M364.7,439.3c-7.4-4.3-7.4-11.2-0.1-15.5l115.1-66.3c7.4-4.3,19.3-4.3,26.7,0l189.8,110
						c7.4,4.3,7.4,11.2,0.1,15.5l-115.1,66.3c-7.3,4.3-19.3,4.2-26.7,0L364.7,439.3z"/>
                    <path class="st81" d="M365.3,439c-7.4-4.3-7.4-11.2-0.1-15.4l114.5-66c7.3-4.3,19.2-4.2,26.6,0l189.3,109.7
						c7.4,4.3,7.4,11.2,0.1,15.4l-114.5,66c-7.3,4.2-19.2,4.2-26.6,0L365.3,439z"/>
                    <path class="st82" d="M365.8,438.7c-7.3-4.3-7.4-11.1-0.1-15.4l114-65.7c7.3-4.2,19.2-4.2,26.5,0l188.7,109.4
						c7.3,4.3,7.4,11.1,0.1,15.4l-114,65.7c-7.3,4.2-19.2,4.2-26.5,0L365.8,438.7z"/>
                    <path class="st83" d="M366.3,438.4c-7.3-4.2-7.4-11.1-0.1-15.3l113.4-65.4c7.3-4.2,19.1-4.2,26.5,0l188.2,109.1
						c7.3,4.2,7.4,11.1,0.1,15.3l-113.4,65.4c-7.3,4.2-19.1,4.2-26.5,0L366.3,438.4z"/>
                    <path class="st84" d="M366.8,438.1c-7.3-4.2-7.3-11.1-0.1-15.3l112.8-65.1c7.3-4.2,19.1-4.2,26.4,0l187.7,108.8
						c7.3,4.2,7.3,11.1,0.1,15.3l-112.8,65.1c-7.3,4.2-19.1,4.2-26.4,0L366.8,438.1z"/>
                    <path class="st85" d="M367.3,437.8c-7.3-4.2-7.3-11-0.1-15.2l112.3-64.8c7.3-4.2,19-4.2,26.3,0l187.1,108.5
						c7.3,4.2,7.3,11,0.1,15.2l-112.3,64.8c-7.2,4.2-19,4.2-26.3,0L367.3,437.8z"/>
                    <path class="st86" d="M367.8,437.5c-7.3-4.2-7.3-11-0.1-15.2l111.7-64.5c7.2-4.2,19-4.2,26.2,0l186.6,108.2
						c7.3,4.2,7.3,11,0.1,15.2l-111.7,64.5c-7.2,4.2-19,4.2-26.2,0L367.8,437.5z"/>
                    <path class="st87" d="M368.3,437.1c-7.2-4.2-7.3-11-0.1-15.2l111.1-64.2c7.2-4.2,18.9-4.2,26.2,0l186.1,107.9
						c7.2,4.2,7.3,11,0.1,15.2l-111.1,64.2c-7.2,4.2-18.9,4.2-26.2,0L368.3,437.1z"/>
                    <path class="st88" d="M368.8,436.8c-7.2-4.2-7.2-10.9-0.1-15.1l110.6-63.9c7.2-4.2,18.9-4.2,26.1,0l185.5,107.6
						c7.2,4.2,7.3,10.9,0.1,15.1l-110.6,63.9c-7.2,4.2-18.9,4.2-26.1,0L368.8,436.8z"/>
                    <path class="st89" d="M369.3,436.5c-7.2-4.2-7.2-10.9-0.1-15.1l110-63.6c7.2-4.2,18.8-4.1,26,0l185,107.3
						c7.2,4.2,7.2,10.9,0.1,15.1l-110,63.6c-7.2,4.2-18.8,4.1-26,0L369.3,436.5z"/>
                    <path class="st90" d="M369.8,436.2c-7.2-4.2-7.2-10.9-0.1-15l109.5-63.3c7.2-4.1,18.8-4.1,25.9,0l184.5,107
						c7.2,4.2,7.2,10.9,0.1,15l-109.5,63.3c-7.1,4.1-18.8,4.1-25.9,0L369.8,436.2z"/>
                    <path class="st91" d="M370.3,435.9c-7.2-4.1-7.2-10.8-0.1-15l108.9-63c7.1-4.1,18.7-4.1,25.9,0L689,464.5
						c7.2,4.1,7.2,10.8,0.1,15l-108.9,63c-7.1,4.1-18.7,4.1-25.9,0L370.3,435.9z"/>
                    <path class="st92" d="M370.8,435.6c-7.1-4.1-7.2-10.8-0.1-14.9l108.3-62.7c7.1-4.1,18.7-4.1,25.8,0l183.4,106.3
						c7.1,4.1,7.2,10.8,0.1,14.9L580,541.9c-7.1,4.1-18.6,4.1-25.8,0L370.8,435.6z"/>
                    <path class="st93" d="M371.3,435.3c-7.1-4.1-7.1-10.8-0.1-14.9L479,357.9c7.1-4.1,18.6-4.1,25.7,0l182.9,106
						c7.1,4.1,7.1,10.8,0.1,14.9l-107.8,62.4c-7.1,4.1-18.6,4.1-25.7,0L371.3,435.3z"/>
                    <path class="st94" d="M371.8,434.9c-7.1-4.1-7.1-10.8-0.1-14.8L479,358c7.1-4.1,18.5-4.1,25.6,0L687,463.7
						c7.1,4.1,7.1,10.8,0.1,14.9l-107.2,62.1c-7.1,4.1-18.5,4.1-25.6,0L371.8,434.9z"/>
				</g>
                <g>
					<g>
						<g class="st277">

								<linearGradient id="SVGID_00000024709004494287285050000011069813374269406378_" gradientUnits="userSpaceOnUse" x1="355.7766" y1="343.6515" x2="470.4224" y2="542.2239" gradientTransform="matrix(1 0 0 1 117.6668 0)">
								<stop  offset="0" style="stop-color:#0E2EA1"/>
                                    <stop  offset="4.376323e-03" style="stop-color:#0E30A2"/>
                                    <stop  offset="9.201355e-02" style="stop-color:#0952AE"/>
                                    <stop  offset="0.1812" style="stop-color:#056DB8"/>
                                    <stop  offset="0.2714" style="stop-color:#0281BF"/>
                                    <stop  offset="0.3634" style="stop-color:#018CC3"/>
                                    <stop  offset="0.4598" style="stop-color:#0090C4"/>
                                    <stop  offset="1" style="stop-color:#99FFFC"/>
							</linearGradient>
                            <path style="fill:url(#SVGID_00000024709004494287285050000011069813374269406378_);" d="M701.1,468.4l-116.3,67.4
								c-7.7,4.4-20.1,4.4-27.8,0L359.2,421.1c-3.9-2.2-5.8-5.2-5.8-8.1l0,8.3c0,2.9,1.9,5.9,5.8,8.1L557,544.1
								c7.7,4.5,20.1,4.5,27.8,0l116.3-67.4c3.8-2.2,5.7-5.1,5.7-8l0-8.3C706.8,463.3,704.9,466.2,701.1,468.4z"/>
                            <path class="st279" d="M359.2,422.8c-7.7-4.5-7.7-11.7-0.1-16.1l116.3-67.4c7.7-4.4,20.1-4.4,27.8,0L701,453.3
								c7.7,4.5,7.7,12.3,0.1,16.7l-116.3,67.4c-7.7,4.4-20.1,4.4-27.8,0L359.2,422.8z"/>

                            <linearGradient id="SVGID_00000054954540034060938740000002744367364953805747_" gradientUnits="userSpaceOnUse" x1="172.3241" y1="436.6905" x2="525.7673" y2="436.6905" gradientTransform="matrix(-1 0 0 1 879.1326 0)">
								<stop  offset="0" style="stop-color:#2452D1"/>
                                <stop  offset="0.5287" style="stop-color:#0087B8"/>
                                <stop  offset="1" style="stop-color:#7ADCFF"/>
							</linearGradient>
                            <path style="fill:url(#SVGID_00000054954540034060938740000002744367364953805747_);" d="M359.2,421.1
								c-7.7-4.5-7.7-11.7-0.1-16.1l116.3-67.4c7.7-4.4,20.1-4.4,27.8,0L701,452.3c7.7,4.5,7.7,11.7,0.1,16.1l-116.3,67.4
								c-7.7,4.4-20.1,4.4-27.8,0L359.2,421.1z"/>
						</g>
                        <g>
							<path class="st281" d="M488.1,490.2l-44.9-25.9c-2.7-1.6-2.5-3.5,0.2-5.1l29.3-17.1c2.7-1.6,6.7-1.5,9.4,0.1l45,25.8
								c2.7,1.6,2.9,3.6,0.2,5.2l-29.4,17C495.2,491.8,490.8,491.8,488.1,490.2z"/>
                            <path class="st282" d="M527.3,469.3l-44.9-25.9c-2.7-1.6-7.1-1.6-9.8,0l-29.4,17c-1,0.6-1.6,1.2-1.8,2
								c-0.5-1.3,0.1-2.7,1.8-3.7l29.4-17c2.7-1.6,7.1-1.6,9.8,0l44.9,25.9c1.7,1,2.3,2.4,1.9,3.7
								C528.9,470.6,528.3,469.9,527.3,469.3z"/>
						</g>
                        <g>
							<path class="st283" d="M556.5,471.5c-0.7,0-1.4-0.2-1.9-0.5l-70.1-40.5c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3
								l8.5-4.9c1-0.6,2.7-0.6,3.7,0l70.1,40.5c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9
								C557.9,471.3,557.2,471.5,556.5,471.5z M494.9,423.4c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6
								c0,0.2,0.2,0.4,0.5,0.6l70.1,40.5c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-70.1-40.5
								C495.9,423.5,495.4,423.4,494.9,423.4z"/>
                            <path class="st283" d="M526.8,381.9c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C528.1,381.8,527.5,381.9,526.8,381.9z
								 M526.8,369.4c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C527.8,369.5,527.3,369.4,526.8,369.4z"/>
                            <path class="st283" d="M542.2,390.8c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C543.5,390.7,542.9,390.8,542.2,390.8z
								 M542.2,378.3c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C543.2,378.4,542.7,378.3,542.2,378.3z"/>
                            <path class="st283" d="M557.6,399.7c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C558.9,399.5,558.3,399.7,557.6,399.7z
								 M557.6,387.2c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C558.6,387.3,558.1,387.2,557.6,387.2z"/>
                            <path class="st283" d="M573,408.6c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C574.3,408.4,573.7,408.6,573,408.6z
								 M573,396.1c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C574,396.2,573.5,396.1,573,396.1z"/>
                            <path class="st283" d="M588.4,417.5c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C589.7,417.3,589.1,417.5,588.4,417.5z
								 M588.4,405c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C589.4,405.1,588.9,405,588.4,405z"/>
                            <path class="st283" d="M603.8,426.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C605.1,426.2,604.5,426.4,603.8,426.4z
								 M603.8,413.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C604.8,414,604.3,413.9,603.8,413.9z
								"/>
                            <path class="st283" d="M619.2,435.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C620.5,435.1,619.9,435.3,619.2,435.3z
								 M619.2,422.8c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C620.2,422.9,619.7,422.8,619.2,422.8z"/>
                            <path class="st283" d="M634.6,444.2c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C635.9,444,635.3,444.2,634.6,444.2z
								 M634.6,431.7c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6L636,432C635.6,431.8,635.1,431.7,634.6,431.7z"/>
                            <path class="st283" d="M650,453.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C651.3,452.9,650.7,453.1,650,453.1z
								 M650,440.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C651,440.7,650.5,440.6,650,440.6z"/>
                            <path class="st283" d="M665.4,462c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C666.7,461.8,666.1,462,665.4,462z
								 M665.4,449.5c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C666.4,449.6,665.9,449.5,665.4,449.5z"/>
                            <path class="st283" d="M511.1,391c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C512.4,390.8,511.8,391,511.1,391z
								 M511.1,378.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C512.1,378.6,511.6,378.5,511.1,378.5z"/>
                            <path class="st283" d="M526.5,399.9c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C527.8,399.7,527.2,399.9,526.5,399.9z
								 M526.5,387.4c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C527.5,387.5,527,387.4,526.5,387.4z
								"/>
                            <path class="st283" d="M541.9,408.8c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C543.2,408.6,542.6,408.8,541.9,408.8z
								 M541.9,396.3c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C542.9,396.4,542.4,396.3,541.9,396.3z"/>
                            <path class="st283" d="M557.3,417.6c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C558.7,417.5,558,417.6,557.3,417.6z
								 M557.3,405.1c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C558.3,405.3,557.8,405.1,557.3,405.1z"/>
                            <path class="st283" d="M572.7,426.5c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C574.1,426.4,573.4,426.5,572.7,426.5z
								 M572.7,414c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C573.7,414.2,573.2,414,572.7,414z"/>
                            <path class="st283" d="M588.1,435.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3L590,435C589.5,435.3,588.8,435.4,588.1,435.4z
								 M588.1,422.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C589.1,423.1,588.6,422.9,588.1,422.9z"/>
                            <path class="st283" d="M603.5,444.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C604.9,444.2,604.2,444.3,603.5,444.3z
								 M603.5,431.8c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C604.6,431.9,604,431.8,603.5,431.8z
								"/>
                            <path class="st283" d="M618.9,453.2c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C620.3,453.1,619.6,453.2,618.9,453.2z
								 M618.9,440.7c-0.5,0-1,0.1-1.4,0.3L609,446c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C620,440.8,619.4,440.7,618.9,440.7z"/>
                            <path class="st283" d="M634.3,462.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C635.7,461.9,635,462.1,634.3,462.1z
								 M634.3,449.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C635.4,449.7,634.8,449.6,634.3,449.6z"/>
                            <path class="st283" d="M649.7,471c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C651.1,470.8,650.4,471,649.7,471z
								 M649.7,458.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C650.8,458.6,650.2,458.5,649.7,458.5z"/>
                            <path class="st283" d="M495.4,400c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C496.8,399.9,496.1,400,495.4,400z
								 M495.4,387.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C496.5,387.6,496,387.5,495.4,387.5z"/>
                            <path class="st283" d="M510.8,408.9c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C512.2,408.7,511.5,408.9,510.8,408.9z
								 M510.8,396.4c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C511.9,396.5,511.4,396.4,510.8,396.4z"/>
                            <path class="st283" d="M526.2,417.8c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C527.6,417.6,526.9,417.8,526.2,417.8z
								 M526.2,405.3c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C527.3,405.4,526.8,405.3,526.2,405.3z"/>
                            <path class="st283" d="M541.6,426.7c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C543,426.5,542.3,426.7,541.6,426.7z
								 M541.6,414.2c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C542.7,414.3,542.2,414.2,541.6,414.2z"/>
                            <path class="st283" d="M557,435.6c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C558.4,435.4,557.7,435.6,557,435.6z
								 M557,423.1c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6s-0.2-0.4-0.5-0.6l-8.5-4.9C558.1,423.2,557.6,423.1,557,423.1z"/>
                            <path class="st283" d="M572.4,444.5c-0.7,0-1.4-0.2-1.9-0.4l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C573.8,444.3,573.1,444.5,572.4,444.5z
								 M572.4,432c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C573.5,432.1,573,432,572.4,432z"/>
                            <path class="st283" d="M587.8,453.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C589.2,453.2,588.5,453.4,587.8,453.4z
								 M587.8,440.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C588.9,441,588.4,440.9,587.8,440.9z
								"/>
                            <path class="st283" d="M603.2,462.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C604.6,462.1,603.9,462.3,603.2,462.3z
								 M603.2,449.8c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C604.3,449.9,603.8,449.8,603.2,449.8z"/>
                            <path class="st283" d="M618.6,471.2c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C620,471,619.3,471.2,618.6,471.2z
								 M618.6,458.7c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C619.7,458.8,619.2,458.7,618.6,458.7z"/>
                            <path class="st283" d="M634,480c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C635.4,479.9,634.7,480,634,480z
								 M634,467.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C635.1,467.7,634.6,467.5,634,467.5z"/>
                            <path class="st283" d="M479.8,409.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C481.1,408.9,480.4,409.1,479.8,409.1z
								 M479.8,396.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6s0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6s-0.2-0.4-0.5-0.6l-8.5-4.9C480.8,396.7,480.3,396.6,479.8,396.6z"/>
                            <path class="st283" d="M495.2,418c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C496.5,417.8,495.8,418,495.2,418z
								 M495.2,405.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C496.2,405.6,495.7,405.5,495.2,405.5z"/>
                            <path class="st283" d="M510.6,426.8c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C511.9,426.7,511.3,426.8,510.6,426.8z
								 M510.6,414.3c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C511.6,414.5,511.1,414.3,510.6,414.3z"/>
                            <path class="st283" d="M526,435.7c-0.7,0-1.4-0.2-1.9-0.4l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C527.3,435.6,526.7,435.7,526,435.7z
								 M526,423.2c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C527,423.4,526.5,423.2,526,423.2z"/>
                            <path class="st283" d="M541.4,444.6c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C542.7,444.5,542.1,444.6,541.4,444.6z
								 M541.4,432.1c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C542.4,432.3,541.9,432.1,541.4,432.1z"/>
                            <path class="st283" d="M556.8,453.5c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C558.1,453.4,557.5,453.5,556.8,453.5z
								 M556.8,441c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C557.8,441.1,557.3,441,556.8,441z"/>
                            <path class="st283" d="M572.2,462.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3L574,462C573.5,462.3,572.9,462.4,572.2,462.4z
								 M572.2,449.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C573.2,450,572.7,449.9,572.2,449.9z
								"/>
                            <path class="st283" d="M587.6,471.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C588.9,471.1,588.3,471.3,587.6,471.3z
								 M587.6,458.8c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C588.6,458.9,588.1,458.8,587.6,458.8z"/>
                            <path class="st283" d="M603,480.2c-0.7,0-1.4-0.2-1.9-0.4l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C604.3,480,603.7,480.2,603,480.2z
								 M603,467.7c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C604,467.8,603.5,467.7,603,467.7z"/>
                            <path class="st283" d="M618.4,489.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C619.7,488.9,619.1,489.1,618.4,489.1z
								 M618.4,476.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C619.4,476.7,618.9,476.6,618.4,476.6z"/>
                            <path class="st283" d="M464.1,418.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C465.4,417.9,464.8,418.1,464.1,418.1z
								 M464.1,405.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C465.1,405.7,464.6,405.6,464.1,405.6z"/>
                            <path class="st283" d="M479.5,427c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C480.8,426.8,480.2,427,479.5,427z
								 M479.5,414.5c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C480.5,414.6,480,414.5,479.5,414.5z"/>
                            <path class="st283" d="M496.5,364.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C497.9,364.2,497.2,364.3,496.5,364.3z
								 M496.5,351.8c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C497.6,351.9,497.1,351.8,496.5,351.8z"/>
                            <path class="st283" d="M511.9,373.2c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C513.3,373.1,512.6,373.2,511.9,373.2z
								 M511.9,360.7c-0.5,0-1,0.1-1.4,0.3L502,366c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C513,360.8,512.5,360.7,511.9,360.7z"/>
                            <path class="st283" d="M480.9,373.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C482.2,373.2,481.6,373.4,480.9,373.4z
								 M480.9,360.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C481.9,361,481.4,360.9,480.9,360.9z
								"/>
                            <path class="st283" d="M496.3,382.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C497.6,382.1,497,382.3,496.3,382.3z
								 M496.3,369.8c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C497.3,369.9,496.8,369.8,496.3,369.8z"/>
                            <path class="st283" d="M465.2,382.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C466.6,382.3,465.9,382.4,465.2,382.4z
								 M465.2,369.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6s0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6s-0.2-0.4-0.5-0.6l-8.5-4.9C466.3,370,465.7,369.9,465.2,369.9z"/>
                            <path class="st283" d="M480.6,391.3c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C482,391.2,481.3,391.3,480.6,391.3z
								 M480.6,378.8c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C481.7,378.9,481.1,378.8,480.6,378.8z"/>
                            <path class="st283" d="M449.5,391.5c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C450.9,391.3,450.2,391.5,449.5,391.5z
								 M449.5,379c-0.5,0-1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C450.6,379.1,450.1,379,449.5,379z"/>
                            <path class="st283" d="M464.9,400.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C466.3,400.2,465.6,400.4,464.9,400.4z
								 M464.9,387.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C466,388,465.5,387.9,464.9,387.9z"
                            />
                            <path class="st283" d="M433.9,400.5c-0.7,0-1.4-0.2-1.9-0.4l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3s0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3s-0.3,1-0.9,1.3l-8.5,4.9C435.2,400.4,434.6,400.5,433.9,400.5z
								 M433.9,388c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9c0.7,0.4,2.1,0.4,2.8,0
								l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C434.9,388.1,434.4,388,433.9,388z"/>
                            <path class="st283" d="M449.3,409.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C450.6,409.2,450,409.4,449.3,409.4z
								 M449.3,396.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C450.3,397,449.8,396.9,449.3,396.9z
								"/>
                            <path class="st283" d="M571.9,480.4c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C573.3,480.2,572.6,480.4,571.9,480.4z
								 M571.9,467.9c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9C572.9,468,572.4,467.9,571.9,467.9z
								"/>
                            <path class="st283" d="M587.3,489.2c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C588.6,489.1,588,489.2,587.3,489.2z
								 M587.3,476.7c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C588.3,476.9,587.8,476.7,587.3,476.7z"/>
                            <path class="st283" d="M602.7,498.1c-0.7,0-1.4-0.2-1.9-0.5l-8.5-4.9c-0.6-0.3-0.9-0.8-0.9-1.3c0-0.5,0.3-1,0.9-1.3l8.5-4.9
								c1-0.6,2.7-0.6,3.7,0l8.5,4.9c0.6,0.3,0.9,0.8,0.9,1.3c0,0.5-0.3,1-0.9,1.3l-8.5,4.9C604.1,498,603.4,498.1,602.7,498.1z
								 M602.7,485.6c-0.5,0-1.1,0.1-1.4,0.3l-8.5,4.9c-0.3,0.2-0.5,0.4-0.5,0.6c0,0.2,0.2,0.4,0.5,0.6l8.5,4.9
								c0.7,0.4,2.1,0.4,2.8,0l8.5-4.9c0.3-0.2,0.5-0.4,0.5-0.6c0-0.2-0.2-0.4-0.5-0.6l-8.5-4.9
								C603.7,485.8,603.2,485.6,602.7,485.6z"/>
						</g>
                        <g>
							<path class="st48" d="M554.9,469.2l-70.1-40.5c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l70.1,40.5
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C557.2,469.8,555.8,469.8,554.9,469.2z"/>
                            <path class="st48" d="M525.1,379.7l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C527.5,380.2,526,380.2,525.1,379.7z"/>
                            <path class="st48" d="M540.5,388.6l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C542.9,389.1,541.4,389.1,540.5,388.6z"/>
                            <path class="st48" d="M555.9,397.5l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C558.3,398,556.8,398,555.9,397.5z"/>
                            <path class="st48" d="M571.3,406.4l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C573.7,406.9,572.2,406.9,571.3,406.4z"/>
                            <path class="st48" d="M586.7,415.3l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C589.1,415.8,587.6,415.8,586.7,415.3z"/>
                            <path class="st48" d="M602.1,424.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C604.5,424.7,603,424.7,602.1,424.2z"/>
                            <path class="st48" d="M617.5,433l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C619.9,433.6,618.4,433.6,617.5,433z"/>
                            <path class="st48" d="M632.9,441.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C635.3,442.5,633.8,442.5,632.9,441.9z"/>
                            <path class="st48" d="M648.3,450.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C650.7,451.4,649.2,451.4,648.3,450.8z"/>
                            <path class="st48" d="M663.7,459.7l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C666.1,460.2,664.6,460.2,663.7,459.7z"/>
                            <path class="st48" d="M509.4,388.7l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C511.8,389.3,510.4,389.3,509.4,388.7z"/>
                            <path class="st48" d="M524.8,397.6l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C527.2,398.2,525.8,398.2,524.8,397.6z"/>
                            <path class="st48" d="M540.3,406.5l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C542.6,407,541.2,407,540.3,406.5z"/>
                            <path class="st48" d="M555.7,415.4l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C558,415.9,556.6,415.9,555.7,415.4z"/>
                            <path class="st48" d="M571.1,424.3l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C573.4,424.8,572,424.8,571.1,424.3z"/>
                            <path class="st48" d="M586.5,433.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C588.8,433.7,587.4,433.7,586.5,433.2z"/>
                            <path class="st48" d="M601.9,442.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C604.2,442.6,602.8,442.6,601.9,442.1z"/>
                            <path class="st48" d="M617.3,451l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C619.6,451.5,618.2,451.5,617.3,451z"/>
                            <path class="st48" d="M632.7,459.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C635,460.4,633.6,460.4,632.7,459.9z"/>
                            <path class="st48" d="M648.1,468.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C650.4,469.3,649,469.3,648.1,468.8z"/>
                            <path class="st48" d="M493.8,397.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C496.2,398.3,494.7,398.3,493.8,397.8z"/>
                            <path class="st48" d="M509.2,406.7l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C511.6,407.2,510.1,407.2,509.2,406.7z"/>
                            <path class="st48" d="M524.6,415.6l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C527,416.1,525.5,416.1,524.6,415.6z"/>
                            <path class="st48" d="M540,424.5l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C542.4,425,540.9,425,540,424.5z"/>
                            <path class="st48" d="M555.4,433.4l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C557.8,433.9,556.3,433.9,555.4,433.4z"/>
                            <path class="st48" d="M570.8,442.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C573.2,442.8,571.7,442.8,570.8,442.2z"/>
                            <path class="st48" d="M586.2,451.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C588.6,451.7,587.1,451.7,586.2,451.1z"/>
                            <path class="st48" d="M601.6,460l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C604,460.6,602.5,460.6,601.6,460z"/>
                            <path class="st48" d="M617,468.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C619.4,469.4,617.9,469.4,617,468.9z"/>
                            <path class="st48" d="M632.4,477.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C634.8,478.3,633.3,478.3,632.4,477.8z"/>
                            <path class="st48" d="M478.1,406.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C480.5,407.4,479,407.4,478.1,406.8z"/>
                            <path class="st48" d="M493.5,415.7l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C495.9,416.3,494.4,416.3,493.5,415.7z"/>
                            <path class="st48" d="M508.9,424.6l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C511.3,425.1,509.8,425.1,508.9,424.6z"/>
                            <path class="st48" d="M524.3,433.5l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C526.7,434,525.2,434,524.3,433.5z"/>
                            <path class="st48" d="M539.7,442.4l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C542.1,442.9,540.6,442.9,539.7,442.4z"/>
                            <path class="st48" d="M555.1,451.3l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C557.5,451.8,556,451.8,555.1,451.3z"/>
                            <path class="st48" d="M570.5,460.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C572.9,460.7,571.4,460.7,570.5,460.2z"/>
                            <path class="st48" d="M585.9,469.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C588.3,469.6,586.8,469.6,585.9,469.1z"/>
                            <path class="st48" d="M601.3,478l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C603.7,478.5,602.2,478.5,601.3,478z"/>
                            <path class="st48" d="M616.7,486.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C619.1,487.4,617.6,487.4,616.7,486.9z"/>
                            <path class="st48" d="M462.4,415.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C464.8,416.4,463.3,416.4,462.4,415.9z"/>
                            <path class="st48" d="M477.8,424.8l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C480.2,425.3,478.7,425.3,477.8,424.8z"/>
                            <path class="st48" d="M494.9,362.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C497.3,362.6,495.8,362.6,494.9,362.1z"/>
                            <path class="st48" d="M510.3,371l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C512.7,371.5,511.2,371.5,510.3,371z"/>
                            <path class="st48" d="M479.2,371.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C481.6,371.7,480.1,371.7,479.2,371.1z"/>
                            <path class="st48" d="M494.6,380l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C497,380.6,495.5,380.6,494.6,380z"/>
                            <path class="st48" d="M463.6,380.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C465.9,380.7,464.5,380.7,463.6,380.2z"/>
                            <path class="st48" d="M479,389.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C481.3,389.6,479.9,389.6,479,389.1z"/>
                            <path class="st48" d="M447.9,389.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C450.3,389.8,448.8,389.8,447.9,389.2z"/>
                            <path class="st48" d="M463.3,398.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C465.7,398.7,464.2,398.7,463.3,398.1z"/>
                            <path class="st48" d="M432.2,398.3l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C434.6,398.8,433.1,398.8,432.2,398.3z"/>
                            <path class="st48" d="M447.6,407.2l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C450,407.7,448.5,407.7,447.6,407.2z"/>
                            <path class="st48" d="M570.3,478.1l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C572.6,478.7,571.2,478.7,570.3,478.1z"/>
                            <path class="st48" d="M585.7,487l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C588,487.5,586.6,487.5,585.7,487z"/>
                            <path class="st48" d="M601.1,495.9l-8.5-4.9c-0.9-0.5-0.9-1.4,0-1.9l8.5-4.9c0.9-0.5,2.4-0.5,3.3,0l8.5,4.9
								c0.9,0.5,0.9,1.4,0,1.9l-8.5,4.9C603.4,496.4,602,496.4,601.1,495.9z"/>
						</g>
                        <path class="st284" d="M514.4,349.5L676.2,443c0.5,0.3,1.1,0.3,1.5,0l3.3-1.9l-163.8-94.7l-2.9,1.7
							C513.4,349,514.4,349.5,514.4,349.5z"/>
					</g>
                    <g>
						<g>

								<linearGradient id="SVGID_00000176040325601510373110000005073443809302796685_" gradientUnits="userSpaceOnUse" x1="171.6874" y1="456.2794" x2="267.1425" y2="144.0597" gradientTransform="matrix(-1 0 0 1 879.1326 0)">
								<stop  offset="0" style="stop-color:#0E2EA1"/>
                                    <stop  offset="4.287156e-02" style="stop-color:#0B43A8"/>
                                    <stop  offset="0.1663" style="stop-color:#037ABC"/>
                                    <stop  offset="0.2261" style="stop-color:#0090C4"/>
                                    <stop  offset="1" style="stop-color:#99FFFC"/>
							</linearGradient>
                            <path style="fill:url(#SVGID_00000176040325601510373110000005073443809302796685_);" d="M718.8,441.6l26.8-132.8
								c1.5-8.9-1.2-17.3-13.9-24.1L537.2,172.5c-3.6-2.1-7.4-2.4-10.7-1l0,0c0,0,1.7-1.1,5.2-2.7c3.3-1.6,7.3-1.4,11.1,0.8
								l196.4,113.6c12.7,6.8,15.4,15.2,13.9,24.1l-26.6,132.1c-1.1,6-3.2,10.7-6.4,12.8c-1.6,1-5.6,1.7-7.8,2.3
								C715.6,452.4,717.7,447.7,718.8,441.6z"/>
                            <path class="st286" d="M711,455.1c-0.1,0.1-0.2,0.1-0.2,0.1C710.9,455.2,710.9,455.2,711,455.1z"/>
						</g>
                        <path class="st279" d="M539.1,171.5c-7.7-4.4-16.1-0.9-18.4,10.2L493.8,315c-2.7,13.9,6.2,19.6,13.9,24.1l198,114.3
							c8.2,4,13.1-2.5,14.9-12.8l26.8-132.8c1.5-8.9-1.2-17.3-13.9-24.1L539.1,171.5z"/>

                        <linearGradient id="SVGID_00000045601967552911297980000003155877860715551405_" gradientUnits="userSpaceOnUse" x1="133.1517" y1="313.1241" x2="387.6896" y2="313.1241" gradientTransform="matrix(-1 0 0 1 879.1326 0)">
							<stop  offset="0" style="stop-color:#7ADCFF"/>
                            <stop  offset="0.4215" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#193BB5"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000045601967552911297980000003155877860715551405_);" d="M537.2,172.5
							c-7.7-4.4-16.1-0.9-18.4,10.2L491.9,316c-2.7,13.9,6.2,19.6,13.9,24.1l198,114.3c8.2,4,13.1-2.5,14.9-12.8l26.8-132.8
							c1.5-8.9-1.2-17.3-13.9-24.1L537.2,172.5z"/>

                        <linearGradient id="SVGID_00000014611486777384228390000003826054646883480739_" gradientUnits="userSpaceOnUse" x1="242.4456" y1="167.7314" x2="148.8029" y2="455.9339" gradientTransform="matrix(-1 0 0 1 815.7446 0)">
							<stop  offset="0" style="stop-color:#40C6FF"/>
                            <stop  offset="5.511527e-02" style="stop-color:#37ADEA"/>
                            <stop  offset="0.1854" style="stop-color:#2378BC"/>
                            <stop  offset="0.3072" style="stop-color:#144E98"/>
                            <stop  offset="0.4167" style="stop-color:#09307E"/>
                            <stop  offset="0.5102" style="stop-color:#021E6F"/>
                            <stop  offset="0.5766" style="stop-color:#001769"/>
                            <stop  offset="1" style="stop-color:#19003B"/>
						</linearGradient>
                        <polygon style="fill:url(#SVGID_00000014611486777384228390000003826054646883480739_);" points="534.3,180.4 503.9,326.8
							706.4,443.1 736.3,296.9 						"/>

                        <linearGradient id="SVGID_00000142174585952753944210000006606493856548567481_" gradientUnits="userSpaceOnUse" x1="397.9075" y1="316.3783" x2="325.7662" y2="191.426" gradientTransform="matrix(-1 0 0 1 879.1326 0)">
							<stop  offset="0" style="stop-color:#99FFFC"/>
                            <stop  offset="0.5402" style="stop-color:#0090C4"/>
                            <stop  offset="0.6366" style="stop-color:#018CC3"/>
                            <stop  offset="0.7286" style="stop-color:#0281BF"/>
                            <stop  offset="0.8188" style="stop-color:#056DB8"/>
                            <stop  offset="0.908" style="stop-color:#0952AE"/>
                            <stop  offset="0.9956" style="stop-color:#0E30A2"/>
                            <stop  offset="1" style="stop-color:#0E2EA1"/>
						</linearGradient>
                        <polygon style="fill:url(#SVGID_00000142174585952753944210000006606493856548567481_);" points="501.1,327.8 531.6,178.8
							534.3,180.4 504.3,326.7 						"/>

                        <linearGradient id="SVGID_00000008123704409311029090000005764206527811798656_" gradientUnits="userSpaceOnUse" x1="172.7178" y1="386.2502" x2="378.0664" y2="386.2502" gradientTransform="matrix(-1 0 0 1 879.1326 0)">
							<stop  offset="0" style="stop-color:#194DB5"/>
                            <stop  offset="0.5785" style="stop-color:#0087B8"/>
                            <stop  offset="1" style="stop-color:#7ADCFF"/>
						</linearGradient>
                        <polygon style="fill:url(#SVGID_00000008123704409311029090000005764206527811798656_);" points="504.3,326.7 706.4,443.1
							705.9,445.8 501.1,327.8 						"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
                <g id="fire">
	<g>
		<g>
			<path class="st291" d="M605.8,346.2c-0.5,0-1-0.2-1.5-0.5l-80.9-54c-1.7-1.2-2.7-4.1-2.2-6.7l10.8-55.5c0.4-2,1.7-3.4,3.2-3.3
				c0.5,0,1,0.2,1.5,0.5l80.9,54c1.7,1.2,2.7,4.1,2.2,6.7L609,342.8C608.6,344.9,607.3,346.2,605.8,346.2z M535,227.3
				c-0.8,0-1.5,0.9-1.8,2.2L522.4,285c-0.4,2.1,0.4,4.8,1.8,5.7l80.9,54c0.3,0.2,0.6,0.3,0.9,0.3c0.8,0,1.5-0.9,1.8-2.2l10.8-55.5
				c0.4-2.1-0.4-4.8-1.8-5.7l-80.9-54C535.6,227.4,535.3,227.3,535,227.3z"/>
		</g>
        <path class="st292" d="M606.2,344.5c-0.2,0-0.4-0.1-0.7-0.2l-80.9-54c-1.3-0.9-2-3.2-1.7-5.2l10.8-55.5c0.2-0.8,0.6-1.7,1.2-1.7
			c0.2,0,0.4,0.1,0.7,0.2l80.9,54c1.3,0.9,2,3.2,1.7,5.2l-10.8,55.5C607.2,343.7,606.7,344.5,606.2,344.5z"/>

        <linearGradient id="SVGID_00000088096177989263920390000013780033037179799466_" gradientUnits="userSpaceOnUse" x1="553.1949" y1="293.4007" x2="630.0137" y2="293.4007" gradientTransform="matrix(0.9998 1.745241e-02 -0.1938 0.9968 35.4377 -8.2601)">
			<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
            <stop  offset="1" style="stop-color:#4E00D4"/>
		</linearGradient>
        <path style="fill:url(#SVGID_00000088096177989263920390000013780033037179799466_);" d="M533,287.4l6.5,4.3l3.3-16.7l-6.5-4.3
			L533,287.4z M596.6,318.8l-1.9,9.8l6.5,4.3l1.9-9.8L596.6,318.8z M543.2,294.3l6.5,4.3l6-30.7l-6.5-4.3L543.2,294.3z M553.5,301.1
			l6.5,4.3l8.7-44.6l-6.5-4.3L553.5,301.1z M563.8,308l6.5,4.3l4.1-20.9l-6.5-4.3L563.8,308z M574.1,314.9l6.5,4.3l7.1-36.5
			l-6.5-4.3L574.1,314.9z M584.4,321.7l6.5,4.3l5.3-27.4l-6.5-4.3L584.4,321.7z"/>
	</g>
                    <g>
		<g>
			<path class="st291" d="M705.9,396.3c-0.7,0-1.4-0.2-2-0.6l-119.3-73c-2.5-1.5-4-5.7-3.4-9.3l13.5-81c0.5-2.8,2.1-4.7,4.1-4.7
				c0.7,0,1.4,0.2,2,0.6l119.3,73c2.5,1.5,4,5.7,3.4,9.3l-13.5,81C709.5,394.4,707.9,396.2,705.9,396.3z M598.6,228.8
				c-1.4,0-2.5,1.5-2.9,3.6l-13.5,81c-0.5,3.3,0.8,7,3,8.4l119.3,73c0.5,0.3,1,0.5,1.5,0.4c1.4,0,2.5-1.5,2.9-3.6l13.5-81
				c0.5-3.3-0.8-7-3-8.4l-119.3-73C599.6,228.9,599.1,228.8,598.6,228.8z"/>
		</g>
                        <path class="st292" d="M706.2,394.1c-0.3,0-0.6-0.1-1-0.3l-119.3-73c-1.9-1.2-3.1-4.6-2.6-7.4l13.5-81c0.2-1.2,0.8-2.5,1.6-2.5
			c0.3,0,0.6,0.1,1,0.3l119.3,73c1.9,1.2,3.1,4.6,2.6,7.4l-13.5,81C707.6,392.8,707,394.1,706.2,394.1z"/>
                        <g>

				<linearGradient id="SVGID_00000025413508159521045640000009584581660135557311_" gradientUnits="userSpaceOnUse" x1="77.7388" y1="2729.5564" x2="140.7892" y2="2729.5564" gradientTransform="matrix(0.7829 0.4791 -0.1937 1.1588 1127.2211 -2884.6406)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                    <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000025413508159521045640000009584581660135557311_);" d="M678.8,362
				c-13.6-8.3-22.3-29.2-19.4-46.5c2.9-17.3,16.3-24.7,29.9-16.3c13.6,8.3,22.3,29.2,19.4,46.5S692.5,370.4,678.8,362z M689,301.5
				c-12.6-7.7-25.1-0.9-27.7,15.1c-2.7,16.1,5.4,35.4,18,43.1c12.6,7.7,25.1,0.9,27.7-15.1C709.7,328.5,701.6,309.2,689,301.5z"/>

                            <linearGradient id="SVGID_00000179636130510240454860000002330415907857534344_" gradientUnits="userSpaceOnUse" x1="84.3452" y1="2738.5757" x2="117.5589" y2="2738.5757" gradientTransform="matrix(0.7829 0.4791 -0.1937 1.1588 1127.2211 -2884.6406)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="opacity:0.7;fill:url(#SVGID_00000179636130510240454860000002330415907857534344_);" d="M681.2,348
				c-7.6-4.6-12.4-16.2-10.8-25.8c0.2-0.9,0.4-1.8,0.6-2.6l-5.5-4.7c-1.4,4.1-1.8,8.2-1.3,13.2c1.5,15,11.5,28.4,22.3,29.9l-0.8-8.2
				C684.3,349.6,682.8,349,681.2,348z"/>

                            <linearGradient id="SVGID_00000111908210162197267050000016865510318877646772_" gradientUnits="userSpaceOnUse" x1="724.9821" y1="327.9106" x2="734.6781" y2="373.6971" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000111908210162197267050000016865510318877646772_);" d="M699.5,319.5l-4.4,3.2
				c2.4,5,3.5,11,2.6,16.3c-0.5,3.3-1.8,5.9-3.5,7.8l4.3,6.6C705.1,345.8,705.5,331.7,699.5,319.5z"/>

                            <linearGradient id="SVGID_00000157268273942745513630000013548647587567324035_" gradientUnits="userSpaceOnUse" x1="732.8714" y1="343.5554" x2="708.093" y2="303.1558" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000157268273942745513630000013548647587567324035_);" d="M687,313.1c3.4,2.1,6.2,5.5,8.1,9.5
				l4.4-3.2c-3-6.1-6.7-10.5-11.5-13.4l-1.2,7C686.9,313.1,687,313.1,687,313.1z"/>

                            <linearGradient id="SVGID_00000155859519340308999640000000855849882678648207_" gradientUnits="userSpaceOnUse" x1="697.799" y1="311.0273" x2="718.8068" y2="330.1497" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000155859519340308999640000000855849882678648207_);" d="M686.9,313.1l1.2-7
				c-9.5-5.8-18.8-2.2-22.5,8.7l5.5,4.7C673.5,311.9,680.1,309,686.9,313.1z"/>

                            <linearGradient id="SVGID_00000085241443256191686340000016257042245403027373_" gradientUnits="userSpaceOnUse" x1="723.3177" y1="339.5579" x2="702.0407" y2="313.9716" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000085241443256191686340000016257042245403027373_);" d="M677.2,316.4l4,8.2
				c1.1-0.7,2.5-0.8,3.9,0.1c0.9,0.6,1.7,1.4,2.4,2.5l4.4-5.1c-1.4-2.3-3.3-4.2-5.4-5.5C683.1,314.5,679.7,314.6,677.2,316.4z"/>

                            <linearGradient id="SVGID_00000065790337320709000340000010676845643775699608_" gradientUnits="userSpaceOnUse" x1="5703.8262" y1="-1123.8428" x2="5719.8359" y2="-1123.8428" gradientTransform="matrix(0.1937 -1.1588 0.7829 0.4791 461.5396 7495.1787)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="opacity:0.7;fill:url(#SVGID_00000065790337320709000340000010676845643775699608_);" d="M688.7,333.4
				c-0.5,3.3-3.1,4.6-5.6,3.1c-0.2-0.1-0.4-0.3-0.6-0.4l-2.4,7.3c0.5,0.4,1.1,0.8,1.7,1.2c6.1,3.7,12,0.4,13.3-7.3
				c0.3-1.6,0.3-3.3,0.2-4.9l-6.4-0.9C688.9,332.1,688.8,332.8,688.7,333.4z"/>

                            <linearGradient id="SVGID_00000176015621418469982140000004810920961772654218_" gradientUnits="userSpaceOnUse" x1="5703.9688" y1="-1137.1671" x2="5715.7627" y2="-1137.1671" gradientTransform="matrix(0.1937 -1.1588 0.7829 0.4791 461.5396 7495.1787)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000176015621418469982140000004810920961772654218_);" d="M679.5,327.9l-6.4-3.9
				c-1.1,7,2,15.1,7,19.4l2.4-7.3C680.4,334.3,679,330.9,679.5,327.9z"/>

                            <linearGradient id="SVGID_00000108303686033530854720000014241185291791713462_" gradientUnits="userSpaceOnUse" x1="695.9628" y1="321.1185" x2="712.6615" y2="330.2758" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000108303686033530854720000014241185291791713462_);" d="M679.5,327.8c0.2-1.5,0.9-2.5,1.7-3.1
				l-4-8.2c-2,1.4-3.5,4-4.1,7.4c0,0.1,0,0.1,0,0.2l6.4,3.9C679.5,327.9,679.5,327.8,679.5,327.8z"/>
		</g>

                        <linearGradient id="SVGID_00000125593396438428393940000017935482275058739640_" gradientUnits="userSpaceOnUse" x1="616.376" y1="295.903" x2="681.0639" y2="295.903" gradientTransform="matrix(1.0009 -2.616631e-02 -0.1677 1.0035 27.6399 13.537)">
			<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                            <stop  offset="1" style="stop-color:#4E00D4"/>
		</linearGradient>
                        <path style="fill:url(#SVGID_00000125593396438428393940000017935482275058739640_);" d="M601.1,257.6l-0.6,3.4l58.5,35.8l0.6-3.4
			L601.1,257.6z M637.6,288.7l-37.8-23.2l-0.6,3.4l37.8,23.2L637.6,288.7z M640.4,271.9l-37.8-23.2l-0.6,3.4l37.8,23.2L640.4,271.9z
			 M597.9,276.8l49.2,30.1l0.6-3.4l-49.2-30.1L597.9,276.8z M592.6,308.4l49.2,30.1l0.6-3.4L593.1,305L592.6,308.4z M596.5,284.7
			l33.7,20.6l0.6-3.4l-33.7-20.6L596.5,284.7z M617.1,302.2l-21.3-13.1l-0.6,3.4l21.3,13.1L617.1,302.2z M593.9,300.5l27.5,16.8
			l0.6-3.4l-27.5-16.8L593.9,300.5z"/>
	</g>
                    <g>
		<g>
			<path class="st291" d="M689.1,420.6c-0.7,0-1.4-0.2-2.1-0.6l-117.3-70c-2.5-1.5-4-5.5-3.3-9.2l8-48c0.5-2.8,2.2-4.8,4.2-4.9
				c0.7,0,1.4,0.2,2.1,0.6l117.3,70c2.5,1.5,4,5.5,3.3,9.2l-8,48C692.9,418.6,691.2,420.5,689.1,420.6z M578.5,289.3
				c-1.3,0.1-2.3,1.4-2.7,3.5l-8,48c-0.5,3.2,0.8,6.8,2.9,8.1l117.3,70c0.5,0.3,1,0.4,1.4,0.4c1.3-0.1,2.3-1.4,2.7-3.5l8-48
				c0.5-3.2-0.8-6.8-2.9-8.1l-117.3-70C579.4,289.4,578.9,289.2,578.5,289.3z"/>
		</g>
                        <path class="st292" d="M689.5,418.3c-0.3,0-0.6-0.1-1-0.3l-117.3-70c-1.9-1.1-3-4.5-2.5-7.3l8-48c0.2-1.2,0.8-2.5,1.6-2.5
			c0.3,0,0.6,0.1,1,0.3l117.3,70c1.9,1.1,3,4.5,2.5,7.3l-8,48C690.9,417.1,690.3,418.3,689.5,418.3z"/>
                        <g>

				<linearGradient id="SVGID_00000132785836922986677430000012230123383523304892_" gradientUnits="userSpaceOnUse" x1="604.9275" y1="367.0616" x2="721.8959" y2="367.0616" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                    <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <polygon style="fill:url(#SVGID_00000132785836922986677430000012230123383523304892_);" points="657.8,389.5 647,342.3
				625.2,353.5 616,337.5 596.9,354.1 587.4,341.5 578.8,342.1 579,340.9 588.1,340.3 597.3,352.3 616.5,335.6 625.7,351.7
				647.9,340.3 658.8,387.4 677,373.2 687.6,385.1 686.6,386 676.6,374.9 			"/>

                            <linearGradient id="SVGID_00000004537054134280160460000011531012798140979896_" gradientUnits="userSpaceOnUse" x1="671.9842" y1="346.3556" x2="676.0554" y2="346.3556" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000004537054134280160460000011531012798140979896_);" d="M649.2,342.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C648.8,339.6,649.5,341.2,649.2,342.5z"/>

                            <linearGradient id="SVGID_00000183230832102249921330000015946644986105291431_" gradientUnits="userSpaceOnUse" x1="651.7591" y1="356.4702" x2="655.8304" y2="356.4702" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000183230832102249921330000015946644986105291431_);" d="M627.3,353.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C626.9,350.7,627.6,352.2,627.3,353.5z"/>

                            <linearGradient id="SVGID_00000040566596862382194000000017272671360956284294_" gradientUnits="userSpaceOnUse" x1="639.6766" y1="340.1508" x2="643.7479" y2="340.1508" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000040566596862382194000000017272671360956284294_);" d="M618,337.6c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C617.6,334.8,618.2,336.3,618,337.6z"/>

                            <linearGradient id="SVGID_00000131335148595575774010000011070491234453806480_" gradientUnits="userSpaceOnUse" x1="691.0272" y1="393.6844" x2="695.0985" y2="393.6844" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000131335148595575774010000011070491234453806480_);" d="M660.3,389.3c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C659.9,386.5,660.5,388,660.3,389.3z"/>

                            <linearGradient id="SVGID_00000093900013510264644550000006787497102774291609_" gradientUnits="userSpaceOnUse" x1="707.1755" y1="380.4023" x2="711.2468" y2="380.4023" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000093900013510264644550000006787497102774291609_);" d="M678.7,375.3c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C678.2,372.4,678.9,373.9,678.7,375.3z"/>

                            <linearGradient id="SVGID_00000174560436604909113730000009244445339498924938_" gradientUnits="userSpaceOnUse" x1="719.455" y1="392.0883" x2="723.5262" y2="392.0883" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000174560436604909113730000009244445339498924938_);" d="M689,386.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C688.5,383.7,689.2,385.2,689,386.5z"/>

                            <linearGradient id="SVGID_00000076564340958110972640000016644390959327713929_" gradientUnits="userSpaceOnUse" x1="623.2548" y1="355.8369" x2="627.326" y2="355.8369" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000076564340958110972640000016644390959327713929_);" d="M599,354.1c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C598.5,351.3,599.2,352.8,599,354.1z"/>

                            <linearGradient id="SVGID_00000014635960478707296810000009400427599040462209_" gradientUnits="userSpaceOnUse" x1="611.6319" y1="343.023" x2="615.7031" y2="343.023" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000014635960478707296810000009400427599040462209_);" d="M589.5,341.7c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C589.1,338.9,589.7,340.4,589.5,341.7z"/>

                            <linearGradient id="SVGID_00000066473531147829578470000005017405817914630799_" gradientUnits="userSpaceOnUse" x1="602.6356" y1="343.3297" x2="606.707" y2="343.3297" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000066473531147829578470000005017405817914630799_);" d="M580.5,342.4c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C580,339.6,580.7,341.1,580.5,342.4z"/>
		</g>
                        <g>

				<linearGradient id="SVGID_00000062912631201829406740000011690339251124158908_" gradientUnits="userSpaceOnUse" x1="604.9275" y1="367.0616" x2="721.8959" y2="367.0616" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                    <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <polygon style="fill:url(#SVGID_00000062912631201829406740000011690339251124158908_);" points="657.8,389.5 647,342.3
				625.2,353.5 616,337.5 596.9,354.1 587.4,341.5 578.8,342.1 579,340.9 588.1,340.3 597.3,352.3 616.5,335.6 625.7,351.7
				647.9,340.3 658.8,387.4 677,373.2 687.6,385.1 686.6,386 676.6,374.9 			"/>

                            <linearGradient id="SVGID_00000122711966163771339340000000103144628958934413_" gradientUnits="userSpaceOnUse" x1="671.9842" y1="346.3556" x2="676.0554" y2="346.3556" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000122711966163771339340000000103144628958934413_);" d="M649.2,342.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C648.8,339.6,649.5,341.2,649.2,342.5z"/>

                            <linearGradient id="SVGID_00000092452254136581908450000016946996831100184764_" gradientUnits="userSpaceOnUse" x1="651.7591" y1="356.4702" x2="655.8304" y2="356.4702" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000092452254136581908450000016946996831100184764_);" d="M627.3,353.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C626.9,350.7,627.6,352.2,627.3,353.5z"/>

                            <linearGradient id="SVGID_00000176035329694189361220000013990836820796789148_" gradientUnits="userSpaceOnUse" x1="639.6766" y1="340.1508" x2="643.7479" y2="340.1508" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000176035329694189361220000013990836820796789148_);" d="M618,337.6c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C617.6,334.8,618.2,336.3,618,337.6z"/>

                            <linearGradient id="SVGID_00000183217868783748291180000009982775624936395928_" gradientUnits="userSpaceOnUse" x1="691.0272" y1="393.6844" x2="695.0985" y2="393.6844" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000183217868783748291180000009982775624936395928_);" d="M660.3,389.3c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C659.9,386.5,660.5,388,660.3,389.3z"/>

                            <linearGradient id="SVGID_00000050649729779380009690000015341628511999681421_" gradientUnits="userSpaceOnUse" x1="707.1755" y1="380.4023" x2="711.2468" y2="380.4023" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000050649729779380009690000015341628511999681421_);" d="M678.7,375.3c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C678.2,372.4,678.9,373.9,678.7,375.3z"/>

                            <linearGradient id="SVGID_00000110429339365999985670000010842550827381017249_" gradientUnits="userSpaceOnUse" x1="719.455" y1="392.0883" x2="723.5262" y2="392.0883" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000110429339365999985670000010842550827381017249_);" d="M689,386.5c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C688.5,383.7,689.2,385.2,689,386.5z"/>

                            <linearGradient id="SVGID_00000014615846163987071410000001612670681130907324_" gradientUnits="userSpaceOnUse" x1="623.2548" y1="355.8369" x2="627.326" y2="355.8369" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000014615846163987071410000001612670681130907324_);" d="M599,354.1c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C598.5,351.3,599.2,352.8,599,354.1z"/>

                            <linearGradient id="SVGID_00000129912066705199350550000003084409234496853427_" gradientUnits="userSpaceOnUse" x1="611.6319" y1="343.023" x2="615.7031" y2="343.023" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000129912066705199350550000003084409234496853427_);" d="M589.5,341.7c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C589.1,338.9,589.7,340.4,589.5,341.7z"/>

                            <linearGradient id="SVGID_00000000915788565673660970000018234753714471567243_" gradientUnits="userSpaceOnUse" x1="602.6356" y1="343.3297" x2="606.707" y2="343.3297" gradientTransform="matrix(0.999 -4.361939e-02 -0.1687 1.0083 32.4778 21.5219)">
				<stop  offset="1.010100e-02" style="stop-color:#2AF6FF"/>
                                <stop  offset="1" style="stop-color:#4E00D4"/>
			</linearGradient>
                            <path style="fill:url(#SVGID_00000000915788565673660970000018234753714471567243_);" d="M580.5,342.4c-0.2,1.3-1.2,1.9-2.2,1.3
				c-1-0.6-1.7-2.2-1.4-3.5c0.2-1.3,1.2-1.9,2.2-1.3C580,339.6,580.7,341.1,580.5,342.4z"/>
		</g>
	</g>
                    <g id="circle">
		<defs>

				<filter id="Adobe_OpacityMaskFilter_00000072248431661633414390000001123023408938768295_" filterUnits="userSpaceOnUse" x="418.6" y="18" width="337.3" height="506.1">
				<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
			</filter>
		</defs>

                        <mask maskUnits="userSpaceOnUse" x="418.6" y="18" width="337.3" height="506.1" id="SVGID_00000169523040117898573420000006233134629276567191_">
			<g style="filter:url(#Adobe_OpacityMaskFilter_00000072248431661633414390000001123023408938768295_);">
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000096771087474488664330000002268897896572163980_" filterUnits="userSpaceOnUse" x="418.6" y="18" width="337.3" height="506.1">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="418.6" y="18" width="337.3" height="506.1" id="SVGID_00000169523040117898573420000006233134629276567191_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000096771087474488664330000002268897896572163980_);">
					</g>
				</mask>

                <radialGradient id="SVGID_00000139273977386447532690000016490686236033972922_" cx="589.5303" cy="268.3504" r="216.6985" gradientTransform="matrix(0.7571 0.6459 -0.1797 0.9725 189.1584 -370.7622)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#EDEDED"/>
                    <stop  offset="0.3073" style="stop-color:#FFFFFF"/>
                    <stop  offset="1" style="stop-color:#000000"/>
				</radialGradient>

                <path style="mask:url(#SVGID_00000169523040117898573420000006233134629276567191_);fill:url(#SVGID_00000139273977386447532690000016490686236033972922_);" d="
					M751.4,411c-21.5,116.4-112.4,148.1-203,70.8C457.7,404.5,401.7,247.4,423.2,131C444.7,14.6,535.6-17,626.2,60.3
					C716.8,137.6,772.9,294.6,751.4,411z"/>
			</g>
		</mask>

                        <radialGradient id="SVGID_00000030468579126225222560000010476453954346565252_" cx="589.5303" cy="268.3504" r="216.6985" gradientTransform="matrix(0.7571 0.6459 -0.1797 0.9725 189.1584 -370.7622)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.3073" style="stop-color:#DF1C00"/>
                            <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
		</radialGradient>
                        <path style="opacity:0.7;fill:url(#SVGID_00000030468579126225222560000010476453954346565252_);" d="M751.4,411
			c-21.5,116.4-112.4,148.1-203,70.8C457.7,404.5,401.7,247.4,423.2,131C444.7,14.6,535.6-17,626.2,60.3
			C716.8,137.6,772.9,294.6,751.4,411z"/>
                        <g>
			<path class="st48" d="M577.7,323.2c-22.4-19.1-36.3-58.1-31-86.9s27.9-36.6,50.3-17.5c22.4,19.1,36.3,58.1,31,86.8
				C622.6,334.4,600.1,342.3,577.7,323.2z M595.6,226.3c-19.2-16.4-38.5-9.6-43.1,15c-4.6,24.7,7.4,58.1,26.6,74.4
				c19.2,16.4,38.5,9.6,43.1-15C626.7,276.1,614.8,242.7,595.6,226.3z"/>
                            <path class="st48" d="M570.8,360.3c-38.3-32.7-62.1-99.3-53-148.5c9.1-49.2,47.7-62.7,86-30c38.3,32.7,62.1,99.3,53,148.5
				C647.7,379.5,609.1,393,570.8,360.3z M603.1,185.5c-36.7-31.3-73.7-18.4-82.4,28.7c-8.7,47.2,14.1,111,50.8,142.3
				c36.7,31.3,73.7,18.4,82.4-28.7C662.6,280.7,639.8,216.8,603.1,185.5z"/>
		</g>
	</g>
                    <path class="st328" d="M501.4,477.3c-12.8,5.4-19.2,1.1-28.8-4.5c-9.6-5.6-10.7-11-3.3-14.5c14-6.5,21.9,0.1,31.6,5.6
		C510.5,469.5,509,474.2,501.4,477.3z"/>

                    <radialGradient id="SVGID_00000152978496633889693980000011158138501675614911_" cx="7137.9673" cy="346.868" r="3.7479" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000152978496633889693980000011158138501675614911_);" d="M461.3,346.9c0,1.7,1.4,3.1,3.1,3.1
		c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1C462.7,343.8,461.3,345.2,461.3,346.9z"/>
                    <g id="arm2">

			<linearGradient id="SVGID_00000178909474398544908490000010243231859565375373_" gradientUnits="userSpaceOnUse" x1="351.2554" y1="702.7872" x2="334.7705" y2="708.969" gradientTransform="matrix(0.998 6.290000e-02 -6.290000e-02 0.998 161.9393 -324.6961)">
			<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                <stop  offset="0.4264" style="stop-color:#B395D6"/>
                <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                <stop  offset="0.6111" style="stop-color:#8969C3"/>
                <stop  offset="0.755" style="stop-color:#9471C6"/>
                <stop  offset="1" style="stop-color:#B086CC"/>
		</linearGradient>
                        <path style="fill:url(#SVGID_00000178909474398544908490000010243231859565375373_);" d="M457.4,391.4c-1.1,0.3-1.5,0.6-1.4,1.6
			c0.1,1,0,4.8-0.1,6.4c-0.1,1.6,1.3,5.3,1.3,5.3s0.1,1.5,0.7,2.2c0.6,0.8,1,0.5,1.2,0.3c0.2-0.2,0.1-0.9,0-1.3
			c-0.1-0.4-0.2-2.3-0.2-2.3s0.7,2.6,0.9,3.6c0.2,1,0.9,1.9,1.5,2c0.6,0,0.9-0.5,0.8-0.8c-0.1-0.2-0.6-1.4-0.6-2.1s-0.1-1.7-0.1-1.7
			s0.2,2.2,0.8,3.5c0.3,0.6,0.9,2.9,2,2.3c0.8-0.4-0.2-2.5-0.4-3.1c-0.5-2-0.6-5.3-0.3-6.7c0.2-1.4,0.7-2,2-0.8
			c1.3,1.2,2.5,2,2.8,1.3c0.3-0.7-0.9-2.2-1.7-3.2c-0.6-0.7-2.1-2.1-3.1-2.7c-1.9-1.2-2-3.4-3.2-4.1
			C459.2,390.8,457.8,391.3,457.4,391.4z"/>

                        <radialGradient id="SVGID_00000108309920551253924580000015554874542801209521_" cx="152.8143" cy="652.2592" r="9.5574" gradientTransform="matrix(0.9441 5.950000e-02 -5.950000e-02 0.9441 358.6475 -222.388)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#972A74"/>
                            <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                            <stop  offset="0.1136" style="stop-color:#671D4F"/>
                            <stop  offset="0.212" style="stop-color:#471437"/>
                            <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                            <stop  offset="0.4342" style="stop-color:#190713"/>
                            <stop  offset="0.5661" style="stop-color:#0B0308"/>
                            <stop  offset="0.7271" style="stop-color:#020102"/>
                            <stop  offset="1" style="stop-color:#000000"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000108309920551253924580000015554874542801209521_);" d="M457.4,391.4c-1.1,0.3-1.5,0.6-1.4,1.6
			c0.1,1,0,4.8-0.1,6.4c-0.1,1.6,1.3,5.3,1.3,5.3s0.1,1.5,0.7,2.2c0.6,0.8,1,0.5,1.2,0.3c0.2-0.2,0.1-0.9,0-1.3
			c-0.1-0.4-0.2-2.3-0.2-2.3s0.7,2.6,0.9,3.6c0.2,1,0.9,1.9,1.5,2c0.6,0,0.9-0.5,0.8-0.8c-0.1-0.2-0.6-1.4-0.6-2.1s-0.1-1.7-0.1-1.7
			s0.2,2.2,0.8,3.5c0.3,0.6,0.9,2.9,2,2.3c0.8-0.4-0.2-2.5-0.4-3.1c-0.5-2-0.6-5.3-0.3-6.7c0.2-1.4,0.7-2,2-0.8
			c1.3,1.2,2.5,2,2.8,1.3c0.3-0.7-0.9-2.2-1.7-3.2c-0.6-0.7-2.1-2.1-3.1-2.7c-1.9-1.2-2-3.4-3.2-4.1
			C459.2,390.8,457.8,391.3,457.4,391.4z"/>

                        <radialGradient id="SVGID_00000180336271997554935410000013883104445580910517_" cx="7144.2085" cy="390.923" r="3.1168" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
			<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                            <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                            <stop  offset="1" style="stop-color:#12054E"/>
                            <stop  offset="1" style="stop-color:#10054D"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000180336271997554935410000013883104445580910517_);" d="M455.4,390.9c0,1.4,1.1,2.5,2.5,2.5
			c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5C456.6,388.4,455.4,389.5,455.4,390.9z"/>

                        <linearGradient id="SVGID_00000003080128628899166790000016020075902380501388_" gradientUnits="userSpaceOnUse" x1="462.5179" y1="378.4143" x2="451.4941" y2="378.3272">
			<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                            <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                            <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                            <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                            <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                            <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                            <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                            <stop  offset="0.4264" style="stop-color:#B395D6"/>
                            <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                            <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                            <stop  offset="0.6111" style="stop-color:#8969C3"/>
                            <stop  offset="0.755" style="stop-color:#9471C6"/>
                            <stop  offset="1" style="stop-color:#B086CC"/>
		</linearGradient>
                        <path style="fill:url(#SVGID_00000003080128628899166790000016020075902380501388_);" d="M455.3,365.7c-1.1,0.5-1.5,2.6-1.3,9.1
			c0.3,6.3,0.4,15.2,1.2,16c0.7,0.8,4.7,0.1,5.3-0.8c0.6-0.9,0.4-5.6,0.6-10.4c0.2-5.5,0.9-8.8,0.1-10.4
			C460.3,367.5,457.2,364.9,455.3,365.7z"/>

                        <radialGradient id="SVGID_00000088130216643900538820000008826986894086359219_" cx="-1721.5657" cy="378.3658" r="8.8673" gradientTransform="matrix(0.6042 0 0 1 1499.2067 0)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#972A74"/>
                            <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                            <stop  offset="0.1136" style="stop-color:#671D4F"/>
                            <stop  offset="0.212" style="stop-color:#471437"/>
                            <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                            <stop  offset="0.4342" style="stop-color:#190713"/>
                            <stop  offset="0.5661" style="stop-color:#0B0308"/>
                            <stop  offset="0.7271" style="stop-color:#020102"/>
                            <stop  offset="1" style="stop-color:#000000"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000088130216643900538820000008826986894086359219_);" d="M457.7,366.5c-0.6,0.5-0.9,2.5-0.7,8.6
			c0.1,5.9,0.2,14.2,0.7,15c0.4,0.8,2.7,0.1,3-0.7c0.3-0.9,0.2-5.2,0.3-9.8c0.1-5.1,0.5-8.2,0-9.8
			C460.5,368.2,458.7,365.7,457.7,366.5z"/>

                        <radialGradient id="SVGID_00000066481265365766609180000014680912168752380085_" cx="7143.7036" cy="365.8495" r="3.7479" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
			<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                            <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                            <stop  offset="1" style="stop-color:#12054E"/>
                            <stop  offset="1" style="stop-color:#10054D"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000066481265365766609180000014680912168752380085_);" d="M455.5,365.8c0,1.7,1.4,3.1,3.1,3.1
			c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1C456.9,362.8,455.5,364.2,455.5,365.8z"/>

                        <linearGradient id="SVGID_00000018194816737654262800000018336346840810402690_" gradientUnits="userSpaceOnUse" x1="467.995" y1="358.2636" x2="455.3784" y2="354.571">
			<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                            <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                            <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                            <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                            <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                            <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                            <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                            <stop  offset="0.4264" style="stop-color:#B395D6"/>
                            <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                            <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                            <stop  offset="0.6111" style="stop-color:#8969C3"/>
                            <stop  offset="0.755" style="stop-color:#9471C6"/>
                            <stop  offset="1" style="stop-color:#B086CC"/>
		</linearGradient>
                        <path style="fill:url(#SVGID_00000018194816737654262800000018336346840810402690_);" d="M460.8,345.7c-1.1-0.2-1.8,2.4-2.3,5.5
			c-0.5,3-2.1,11.3-2.2,12.1c-0.1,1.1,3.9,3.4,5.2,3.5c1.2,0.2,2.8-6.9,3.4-9.4c0.7-3.1,1.1-5.5,0.6-6.5
			C464.9,349.9,462,345.9,460.8,345.7z"/>

                        <radialGradient id="SVGID_00000001623934672490605280000015940957804644862373_" cx="-1211.252" cy="631.7348" r="6.3267" gradientTransform="matrix(0.568 3.000000e-03 -0.1759 1.19 1261.6194 -390.7339)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#972A74"/>
                            <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                            <stop  offset="0.1136" style="stop-color:#671D4F"/>
                            <stop  offset="0.212" style="stop-color:#471437"/>
                            <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                            <stop  offset="0.4342" style="stop-color:#190713"/>
                            <stop  offset="0.5661" style="stop-color:#0B0308"/>
                            <stop  offset="0.7271" style="stop-color:#020102"/>
                            <stop  offset="1" style="stop-color:#000000"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000001623934672490605280000015940957804644862373_);" d="M463.9,347.7c-0.5-0.2-1.1,2.2-1.8,5.1
			c-0.6,2.7-2.5,10.4-2.6,11.1c-0.2,1,1.3,3.1,1.8,3.3c0.5,0.2,2.2-6.3,2.8-8.6c0.7-2.8,1.2-5,1.1-6
			C465.1,351.6,464.4,347.9,463.9,347.7z"/>
	</g>

                    <linearGradient id="SVGID_00000103225936767939990960000005547816250563000993_" gradientUnits="userSpaceOnUse" x1="493.6307" y1="465.9777" x2="491.5682" y2="479.298">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000103225936767939990960000005547816250563000993_);" d="M483.7,469c-1.4,1.3-2,5.8-0.2,7.4
		c1.8,1.6,3.6,0.1,7.6,0c4-0.1,11.6-1.7,11.8-4.4c0.2-2.7-3.1-2.9-5.8-3.2c-2.6-0.2-5.1-1.5-6.7-1.6
		C488.9,467,485.4,467.5,483.7,469z"/>

                    <radialGradient id="SVGID_00000081608977319629180800000005064955417985076871_" cx="493.7039" cy="8886.3311" r="9.7019" gradientTransform="matrix(1 0 0 0.5 0 -3972.9575)" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000081608977319629180800000005064955417985076871_);" d="M483.7,469c-1.4,1.3-2,5.8-0.2,7.4
		c1.8,1.6,3.6,0.1,7.6,0c4-0.1,11.6-1.7,11.8-4.4c0.2-2.7-3.1-2.9-5.8-3.2c-2.6-0.2-5.1-1.5-6.7-1.6
		C488.9,467,485.4,467.5,483.7,469z"/>

                    <radialGradient id="SVGID_00000181794994517260997130000006323706287775778454_" cx="7115.9458" cy="467.9546" r="3.7479" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000181794994517260997130000006323706287775778454_);" d="M483.3,468c0,1.7,1.4,3.1,3.1,3.1
		c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1C484.7,464.9,483.3,466.3,483.3,468z"/>

                    <linearGradient id="SVGID_00000007394533537921358730000007235003767547125655_" gradientUnits="userSpaceOnUse" x1="474.9593" y1="457.3739" x2="477.8991" y2="471.8642">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000007394533537921358730000007235003767547125655_);" d="M471.3,461.5c-1.2,1.1-2.4,7.7-0.1,8.8
		c2.3,1,4.8-0.7,5.6-1.9c0.8-1.2,2.1-2.4,3.6-3.2c1.5-0.8,3.5-4,1.8-5.5c-1.6-1.4-4.5,0.3-5.6,0.3S472.9,460,471.3,461.5z"/>

                    <radialGradient id="SVGID_00000087413361068799340950000014511137577791706300_" cx="478.2933" cy="460.1665" r="4.8264" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000087413361068799340950000014511137577791706300_);" d="M471.3,461.5c-1.2,1.1-0.8,4.9,1.5,6
		c2.3,1,6.1-1.5,7.6-2.3c1.5-0.8,3.5-4,1.8-5.5c-1.6-1.4-4.5,0.3-5.6,0.3S472.9,460,471.3,461.5z"/>

                    <radialGradient id="SVGID_00000114036792047463142090000008092438038447807630_" cx="7128.02" cy="460.2949" r="3.7479" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000114036792047463142090000008092438038447807630_);" d="M471.2,460.3c0,1.7,1.4,3.1,3.1,3.1
		c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1C472.6,457.2,471.2,458.6,471.2,460.3z"/>

                    <linearGradient id="SVGID_00000145023429347119965740000015094302638514621060_" gradientUnits="userSpaceOnUse" x1="481.947" y1="442.8828" x2="468.4458" y2="441.2218">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000145023429347119965740000015094302638514621060_);" d="M473.8,425.1c-3.3,3.3-3.8,33.3-2.3,34.6
		c1.6,1.2,5.3,1,5.8-0.6c0.5-1.6,1-7.5,2.3-16.4c1.4-9.4,2.8-12.9,2.1-15.6C481,424.1,476.4,422.5,473.8,425.1z"/>

                    <radialGradient id="SVGID_00000166640388338320006640000017918888290901740718_" cx="60.6274" cy="-2700.0066" r="9.5847" gradientTransform="matrix(0.8884 0 0 1.5991 423.9496 4760.7949)" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000166640388338320006640000017918888290901740718_);" d="M474.9,426.8c-2.7,2.6-3.2,29.2-2,30.3
		c1.2,1,4,0.9,4.4-0.6c0.4-1.4,0.6-6.9,1.4-14.5c0.9-8.5,2-12.6,1.8-13.5C480.1,425.9,478,423.8,474.9,426.8z"/>

                    <radialGradient id="SVGID_00000098187560635503207010000007951672010988715178_" cx="7123.937" cy="424.6216" r="5.4215" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000098187560635503207010000007951672010988715178_);" d="M474.7,424.4c0,2.2,1.7,3.9,3.9,3.9
		c2.2,0,3.9-1.7,3.9-3.9c0-2.2-1.7-3.9-3.9-3.9C476.4,420.5,474.7,422.2,474.7,424.4z"/>

                    <linearGradient id="SVGID_00000092451250429072536400000007750035524604571530_" gradientUnits="userSpaceOnUse" x1="488.6547" y1="399.4219" x2="468.8157" y2="401.4573">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000092451250429072536400000007750035524604571530_);" d="M474.4,422.6c0.7,4.4,8.1,4,9.1,0.9
		c1.1-3.1,0.3-26.3,0.3-32.9c0-6.1-0.2-16.2-7-15.5c-6.8,0.7-9.4,5.8-8.9,11.2c0.5,5.4,4.6,17.6,5.5,24.4
		C474.2,417.5,474.1,421,474.4,422.6z"/>

                    <linearGradient id="SVGID_00000050655489172139472440000010175660879956059273_" gradientUnits="userSpaceOnUse" x1="493.8601" y1="375.1097" x2="468.7235" y2="376.7856">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000050655489172139472440000010175660879956059273_);" d="M469.5,361.7c0.5,2.6,4.1,22,7.7,26.6
		c2.2,2.8,9.8,3,12.3,1.3c3.3-2.2,3.5-18.3,3.5-18.3L469.5,361.7z"/>

                    <radialGradient id="SVGID_00000023966946711657678660000015469541454272516777_" cx="498.0531" cy="340.8411" r="40.2993" gradientUnits="userSpaceOnUse">
		<stop  offset="1.010100e-02" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1617" style="stop-color:#E6D7F0"/>
                        <stop  offset="0.2847" style="stop-color:#D7BDE7"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4766" style="stop-color:#C4A4DC"/>
                        <stop  offset="0.7057" style="stop-color:#A17BC9"/>
                        <stop  offset="0.7172" style="stop-color:#9F79C8"/>
                        <stop  offset="0.8107" style="stop-color:#A37CC9"/>
                        <stop  offset="0.8979" style="stop-color:#AE84CC"/>
                        <stop  offset="0.9091" style="stop-color:#B086CC"/>
                        <stop  offset="0.9569" style="stop-color:#AD84CB"/>
                        <stop  offset="0.9884" style="stop-color:#A57DC9"/>
                        <stop  offset="1" style="stop-color:#9F79C8"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000023966946711657678660000015469541454272516777_);" d="M473.6,337.5c-3.6-0.3-11.3,0.1-11.8,4.2
		c-0.5,4.1,2.8,7.7,3.5,9.8c0.8,2.1,1.3,8.9,2.1,11.3c0.8,2.4,1.9,6.3,9.2,8.6c7.3,2.2,15,2.4,16.8,0.6c1.7-1.8,6.3-14.7,5.4-20.3
		c-1-5.6-7.9-10.3-13.1-11.9C480.3,338.2,478.2,337.8,473.6,337.5z"/>

                    <linearGradient id="SVGID_00000113333777897870154730000006671260302222765997_" gradientUnits="userSpaceOnUse" x1="479.2369" y1="353.1899" x2="473.9088" y2="374.8461">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000113333777897870154730000006671260302222765997_);" d="M473.6,337.5c-3.6-0.3-11.3,0.1-11.8,4.2
		c-0.5,4.1,2.8,7.7,3.5,9.8c0.8,2.1,1.3,8.9,2.1,11.3c0.8,2.4,1.9,6.3,9.2,8.6c7.3,2.2,15,2.4,16.8,0.6c1.7-1.8,6.3-14.7,5.4-20.3
		c-1-5.6-7.9-10.3-13.1-11.9C480.3,338.2,478.2,337.8,473.6,337.5z"/>

                    <radialGradient id="SVGID_00000127731354418366657940000018069728670395106721_" cx="489.8386" cy="341.3251" r="21.3901" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000127731354418366657940000018069728670395106721_);" d="M473.6,337.5c-3.6-0.3-11.3,0.1-11.8,4.2
		c-0.5,4.1,5.9,7.9,8,8.6c11,4,29.9,7,28.9,1.4c-1-5.6-7.9-10.3-13.1-11.9C480.3,338.2,478.2,337.8,473.6,337.5z"/>

                    <linearGradient id="SVGID_00000083783466770312059340000010609607081773462408_" gradientUnits="userSpaceOnUse" x1="488.2669" y1="372.9812" x2="494.0677" y2="357.8992">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000083783466770312059340000010609607081773462408_);" d="M498.8,353.6c-0.3-1.4-1,3.5-4.6,4.5
		c-3.9,1.1-6.3,1.1-6.7,3.5c-0.2,1.7-0.7,7.7,1.3,11.2c2.1,0.1,3.7-0.1,4.4-0.9C494.9,370.4,498.7,359.7,498.8,353.6z"/>

                    <radialGradient id="SVGID_00000108305728768443020100000001197898812566404262_" cx="496.4964" cy="359.8172" r="5.0339" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000108305728768443020100000001197898812566404262_);" d="M492.6,358.6c2.2-0.1,5-3,5-3.3
		s0.3,0.5,2.2,1.2c1.8,0.7,3.3,4.5,1.2,5.7c-2.1,1.2-5.4,2.9-7.8,1.6C490.9,362.7,489.9,358.8,492.6,358.6z"/>

                    <linearGradient id="SVGID_00000020373771940597158970000012399079789126692771_" gradientUnits="userSpaceOnUse" x1="494.9252" y1="451.2879" x2="483.3375" y2="448.924">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000020373771940597158970000012399079789126692771_);" d="M483.8,467.6c1.3,1,5.4,0.2,5.7-0.8
		c0.3-1,2.2-9.8,3.9-16.8c2-8.2,3.7-12.8,3.4-14.8c-0.3-2.2-4.3-3.5-6.4-3.1c-2.1,0.4-2.8,1.7-3.3,4.5c-0.5,2.8-2.4,13.2-2.8,19
		C483.8,460.7,482.7,466.8,483.8,467.6z"/>

                    <radialGradient id="SVGID_00000131347456746343720470000017770729869658130073_" cx="-750.097" cy="-3407.8833" r="9.1054" gradientTransform="matrix(0.7432 5.608600e-02 -0.1434 1.9003 560.349 6966.4863)" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000131347456746343720470000017770729869658130073_);" d="M484.7,467.2c0.9,1,4,0.5,4.3-0.5
		c0.3-1,2.3-9.7,4.1-16.6c2.1-8,3.7-12.6,3.7-14.5c-0.1-2.2-3-3.7-4.5-3.4c-1.6,0.3-2.2,1.6-2.8,4.3c-0.6,2.8-2.7,13.1-3.5,18.8
		C485.2,460.3,484,466.3,484.7,467.2z"/>

                    <radialGradient id="SVGID_00000106147580541247640410000004538608118157479821_" cx="7108.6841" cy="432.1101" r="4.7714" gradientTransform="matrix(-1 0 0 1 7601.606 0)" gradientUnits="userSpaceOnUse">
		<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                        <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                        <stop  offset="1" style="stop-color:#12054E"/>
                        <stop  offset="1" style="stop-color:#10054D"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000106147580541247640410000004538608118157479821_);" d="M489.9,432.1c0,2.2,1.7,3.9,3.9,3.9
		c2.2,0,3.9-1.7,3.9-3.9c0-2.2-1.7-3.9-3.9-3.9C491.7,428.2,489.9,430,489.9,432.1z"/>

                    <linearGradient id="SVGID_00000182511330760121399670000012629532553451777967_" gradientUnits="userSpaceOnUse" x1="501.8733" y1="405.9726" x2="482.1718" y2="409.1282">
		<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                        <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                        <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                        <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                        <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                        <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                        <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                        <stop  offset="0.4264" style="stop-color:#B395D6"/>
                        <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                        <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                        <stop  offset="0.6111" style="stop-color:#8969C3"/>
                        <stop  offset="0.755" style="stop-color:#9471C6"/>
                        <stop  offset="1" style="stop-color:#B086CC"/>
	</linearGradient>
                    <path style="fill:url(#SVGID_00000182511330760121399670000012629532553451777967_);" d="M489.6,430.9c1.5,2.5,4.1,3.1,6.7,2.6
		c2.2-0.4,3.2-2.4,3.2-4.8c0-2.4-0.1-22.2-0.6-28.9c-0.4-4.8-0.4-15.2-5.6-17.4c-8.4-3.5-14.7,4.1-13.2,10.1
		c1.3,5.4,6,12.5,7.2,20.5C488.5,420.9,488.4,428.9,489.6,430.9z"/>

                    <radialGradient id="SVGID_00000070078015810281369710000011471691338918382774_" cx="-1604.9889" cy="-1272.9659" r="17.8385" gradientTransform="matrix(0.6098 -8.575000e-03 1.749700e-02 1.2443 1497.6301 1974.6992)" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style="stop-color:#972A74"/>
                        <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                        <stop  offset="0.1136" style="stop-color:#671D4F"/>
                        <stop  offset="0.212" style="stop-color:#471437"/>
                        <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                        <stop  offset="0.4342" style="stop-color:#190713"/>
                        <stop  offset="0.5661" style="stop-color:#0B0308"/>
                        <stop  offset="0.7271" style="stop-color:#020102"/>
                        <stop  offset="1" style="stop-color:#000000"/>
	</radialGradient>
                    <path style="fill:url(#SVGID_00000070078015810281369710000011471691338918382774_);" d="M493.7,428.9c0.9,2.3,2.3,2.8,3.8,2.3
		c1.2-0.4,1.7-2.2,1.7-4.5s-0.6-19.8-1-26c-0.3-4.4,0-15.4-3.1-16.3c-5-1.4-7.6,4.2-7.3,9.3c0.3,4.1,3.5,11.4,4.3,18.7
		C493,419.8,493.1,427.1,493.7,428.9z"/>
                    <g id="head_00000038388589659688301110000005945005596514585254_">

			<radialGradient id="SVGID_00000027586790391574513620000000884561326818538123_" cx="490.8314" cy="323.676" r="19.8748" gradientUnits="userSpaceOnUse">
			<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                <stop  offset="1" style="stop-color:#12054E"/>
                <stop  offset="1" style="stop-color:#10054D"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000027586790391574513620000000884561326818538123_);" d="M478,317.3c-2.8,1.8-3.9,5.9-2.4,9.5
			c1.5,3.6,3.4,4.5,2.4,7.9c-0.9,3.5-1.9,3.6-1.6,4.6c0.4,1,1.5,1.6,4.1,2c2.6,0.4,5,0.3,5.5-0.3c0.6-0.6,0.1-3.1,1-4.8
			c0.5-0.9,1.2-2.3,1.2-2.3S485.3,312.6,478,317.3z"/>
                        <g id="_x3C_Group_x3E__00000072249184419594266420000017073443687474715013_">

				<radialGradient id="head_00000030454115271374995080000010096284141006233003_" cx="489.8386" cy="318.7783" r="19.4037" gradientTransform="matrix(1 5.362411e-03 -5.362411e-03 1 1.7487 -2.5907)" gradientUnits="userSpaceOnUse">
				<stop  offset="1.010100e-02" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1617" style="stop-color:#E6D7F0"/>
                    <stop  offset="0.2847" style="stop-color:#D7BDE7"/>
                    <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                    <stop  offset="0.4766" style="stop-color:#C4A4DC"/>
                    <stop  offset="0.7057" style="stop-color:#A17BC9"/>
                    <stop  offset="0.7172" style="stop-color:#9F79C8"/>
                    <stop  offset="0.99" style="stop-color:#9F79C8"/>
                    <stop  offset="1" style="stop-color:#9F79C8"/>
			</radialGradient>
                            <path id="head" style="fill:url(#head_00000030454115271374995080000010096284141006233003_);" d="M485.9,334.6
				c0.9,0.6,4.1,0.9,5.2,0.2c1.1-0.6,3.7-10.8,1.8-15.2c-1.9-4.4-10.4-7.4-15.5-3.2c-4,3.4-2.9,7.3-2.4,7.4c1.1,0.2,7.2,1.8,8,3.4
				C483.7,328.8,483.9,333.2,485.9,334.6z"/>

                            <linearGradient id="head_00000121967552315238842040000003104048263992138376_" gradientUnits="userSpaceOnUse" x1="481.735" y1="319.3759" x2="482.0788" y2="335.5319">
				<stop  offset="0" style="stop-color:#FFFFFF"/>
                                <stop  offset="1" style="stop-color:#B086CC"/>
			</linearGradient>

                            <path id="head_00000165230525455400041530000002926658418143254427_" style="fill:url(#head_00000121967552315238842040000003104048263992138376_);" d="
				M488.4,334.6c-1.4-0.9-3.4-4.5-4.3-9.9c-0.6-3.7-5.9-4.6-9.2-4.8c-0.9,2.2-0.2,4,0.1,4.1c1.1,0.2,7.2,1.8,8,3.4
				c0.8,1.6,1,6,3,7.3c0.6,0.4,2.1,0.6,3.5,0.5C489,335,488.7,334.8,488.4,334.6z"/>
		</g>
	</g>
                    <path class="st362" d="M595.2,349.3"/>
                    <g id="logo">
		<circle class="st363" cx="603.4" cy="244" r="17.4"/>
                        <circle class="st363" cx="558.2" cy="268.9" r="17.4"/>
                        <circle class="st363" cx="603" cy="294.7" r="17.4"/>
                        <path class="st363" d="M589,253.7c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2c0.2-7.3,9.6-9.3,9.6-9.3L589,253.7z"/>
	</g>
                    <g id="arm">
		<g id="_x3C_Group_x3E_">

				<radialGradient id="_x3C_Path_x3E__00000096756388941234955740000006209407166434053513_" cx="535.8417" cy="321.567" r="14.1" gradientTransform="matrix(1 5.362411e-03 -5.362411e-03 1 1.8328 -2.79)" gradientUnits="userSpaceOnUse">
				<stop  offset="1.010100e-02" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1617" style="stop-color:#E6D7F0"/>
                    <stop  offset="0.2847" style="stop-color:#D7BDE7"/>
                    <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                    <stop  offset="0.4766" style="stop-color:#C4A4DC"/>
                    <stop  offset="0.7057" style="stop-color:#A17BC9"/>
                    <stop  offset="0.7172" style="stop-color:#9F79C8"/>
                    <stop  offset="0.8107" style="stop-color:#A37CC9"/>
                    <stop  offset="0.8979" style="stop-color:#AE84CC"/>
                    <stop  offset="0.9091" style="stop-color:#B086CC"/>
                    <stop  offset="0.9569" style="stop-color:#AD84CB"/>
                    <stop  offset="0.9884" style="stop-color:#A57DC9"/>
                    <stop  offset="1" style="stop-color:#9F79C8"/>
			</radialGradient>

            <path id="_x3C_Path_x3E__00000078031585901086967310000017944203958827593919_" style="fill:url(#_x3C_Path_x3E__00000096756388941234955740000006209407166434053513_);" d="
				M537.1,331.9c-0.3-1-0.2-1.3,0-2.6c0.2-1.3-0.8-2.7-0.8-4.8c0-2.1,0.5-3.7,0.6-4.8c0-1.1,0.4-1.6,1.3-1c0.9,0.6,0.5,3.9,1,4.4
				c0.6,0.5,2.7-1.8,4.3-4.4c1.6-2.6,2.2-4.8,3-4.8c0.8,0,0.9,1,0.3,2.4c-0.6,1.4-1.6,3.6-1.6,3.6s1.3-1.7,1.8-2.8
				c0.4-0.8,0.3-1.2,0.8-1.4c0.6-0.2,0.9,1.3,0.4,2.9c-0.5,1.6-1.3,2.9-1.3,2.9s0.8-0.9,1.1-1.6c0.3-0.7,0.3-0.8,0.7-0.8
				c0.4,0,0.5,1.7,0,2.6c-0.5,0.9-0.8,1.5-0.8,1.5s0.7-1.3,1-1.2c0.3,0.1-0.5,2.3-0.8,2.9c-0.3,0.6-1.9,3.2-3.4,4.8
				s-2.7,4.5-3.7,4.9C540.1,334.9,537.3,333.2,537.1,331.9z"/>

            <radialGradient id="_x3C_Path_x3E__00000068665665993940998900000007538528215655187087_" cx="540.6541" cy="322.4264" r="6.8233" gradientTransform="matrix(1 5.362411e-03 -5.362411e-03 1 1.8328 -2.79)" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style="stop-color:#972A74"/>
                <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                <stop  offset="0.1136" style="stop-color:#671D4F"/>
                <stop  offset="0.212" style="stop-color:#471437"/>
                <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                <stop  offset="0.4342" style="stop-color:#190713"/>
                <stop  offset="0.5661" style="stop-color:#0B0308"/>
                <stop  offset="0.7271" style="stop-color:#020102"/>
                <stop  offset="1" style="stop-color:#000000"/>
			</radialGradient>

            <path id="_x3C_Path_x3E__00000062191075681944951450000008349737032791121319_" style="fill:url(#_x3C_Path_x3E__00000068665665993940998900000007538528215655187087_);" d="
				M537.1,331.9c-0.3-1-0.2-1.3,0-2.6c0.2-1.3-0.8-2.7-0.8-4.8c0-2.1,0.5-3.7,0.6-4.8c0-1.1,0.4-1.6,1.3-1c0.9,0.6,0.5,3.9,1,4.4
				c0.6,0.5,2.7-1.8,4.3-4.4c1.6-2.6,2.2-4.8,3-4.8c0.8,0,0.9,1,0.3,2.4c-0.6,1.4-1.6,3.6-1.6,3.6s1.3-1.7,1.8-2.8
				c0.4-0.8,0.3-1.2,0.8-1.4c0.6-0.2,0.9,1.3,0.4,2.9c-0.5,1.6-1.3,2.9-1.3,2.9s0.8-0.9,1.1-1.6c0.3-0.7,0.3-0.8,0.7-0.8
				c0.4,0,0.5,1.7,0,2.6c-0.5,0.9-0.8,1.5-0.8,1.5s0.7-1.3,1-1.2c0.3,0.1-0.5,2.3-0.8,2.9c-0.3,0.6-1.9,3.2-3.4,4.8
				s-2.7,4.5-3.7,4.9C540.1,334.9,537.3,333.2,537.1,331.9z"/>

            <radialGradient id="_x3C_Path_x3E__00000090989129893647026110000002146472526105291415_" cx="7064.0103" cy="334.0822" r="3.1168" gradientTransform="matrix(-1 -5.362411e-03 -5.362411e-03 1 7603.3296 37.9729)" gradientUnits="userSpaceOnUse">
				<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                <stop  offset="1" style="stop-color:#12054E"/>
                <stop  offset="1" style="stop-color:#10054D"/>
			</radialGradient>

            <path id="_x3C_Path_x3E__00000023242789290185646450000008008435462932205454_" style="fill:url(#_x3C_Path_x3E__00000090989129893647026110000002146472526105291415_);" d="
				M535.7,334.2c0,1.4,1.1,2.6,2.5,2.6c1.4,0,2.6-1.1,2.6-2.5c0-1.4-1.1-2.6-2.5-2.6S535.7,332.8,535.7,334.2z"/>

            <linearGradient id="_x3C_Path_x3E__00000005242687686575494520000013345953315698395776_" gradientUnits="userSpaceOnUse" x1="522.6516" y1="343.0251" x2="531.8914" y2="351.6164" gradientTransform="matrix(1 5.362411e-03 -5.362411e-03 1 1.8328 -2.79)">
				<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                <stop  offset="0.4264" style="stop-color:#B395D6"/>
                <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                <stop  offset="0.6111" style="stop-color:#8969C3"/>
                <stop  offset="0.755" style="stop-color:#9471C6"/>
                <stop  offset="1" style="stop-color:#B086CC"/>
			</linearGradient>

            <path id="_x3C_Path_x3E__00000047754560139275088960000017875104228551340699_" style="fill:url(#_x3C_Path_x3E__00000005242687686575494520000013345953315698395776_);" d="
				M536.2,332.6c1-0.2,3.3,1.9,3.5,3.2c0.3,2.3-17.4,24.1-22.5,24.4c-3.8,0.2-6-4-2.5-7.4C516.7,350.9,534,333.2,536.2,332.6z"/>

            <radialGradient id="_x3C_Path_x3E__00000076588614348962336610000018123912638996436864_" cx="222.9623" cy="-566.6658" r="12.3699" gradientTransform="matrix(0.7837 -4.619836e-02 4.032611e-02 0.6852 374.799 743.627)" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style="stop-color:#972A74"/>
                <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                <stop  offset="0.1136" style="stop-color:#671D4F"/>
                <stop  offset="0.212" style="stop-color:#471437"/>
                <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                <stop  offset="0.4342" style="stop-color:#190713"/>
                <stop  offset="0.5661" style="stop-color:#0B0308"/>
                <stop  offset="0.7271" style="stop-color:#020102"/>
                <stop  offset="1" style="stop-color:#000000"/>
			</radialGradient>
            <path id="_x3C_Path_x3E_" style="fill:url(#_x3C_Path_x3E__00000076588614348962336610000018123912638996436864_);" d="
				M533.2,335.8c0.7-0.2,2.2,1.7,2.4,2.5c0.3,1.4-11.2,15.5-14.8,15.9c-2.7,0.3-4.2-2.9-1.9-5.1
				C520.2,347.8,531.6,336.2,533.2,335.8z"/>
		</g>

                        <radialGradient id="SVGID_00000140707629780083619820000005929434865396700323_" cx="7088.2344" cy="357.2854" r="3.7479" gradientTransform="matrix(-1 -5.362411e-03 -5.362411e-03 1 7603.3296 37.9729)" gradientUnits="userSpaceOnUse">
			<stop  offset="2.020200e-02" style="stop-color:#364F87"/>
                            <stop  offset="0.4293" style="stop-color:#1B2B69"/>
                            <stop  offset="1" style="stop-color:#12054E"/>
                            <stop  offset="1" style="stop-color:#10054D"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000140707629780083619820000005929434865396700323_);" d="M510.9,357.2c0,1.7,1.4,3.1,3,3.1
			c1.7,0,3.1-1.4,3.1-3c0-1.7-1.4-3.1-3-3.1C512.3,354.2,510.9,355.5,510.9,357.2z"/>

                        <linearGradient id="SVGID_00000147196528456490775480000008220563703738488735_" gradientUnits="userSpaceOnUse" x1="503.8455" y1="351.2715" x2="504.7478" y2="365.1934" gradientTransform="matrix(1 5.362411e-03 -5.362411e-03 1 1.8328 -2.79)">
			<stop  offset="1.010100e-02" style="stop-color:#C1A1D5"/>
                            <stop  offset="4.878611e-02" style="stop-color:#C8ABDA"/>
                            <stop  offset="0.1149" style="stop-color:#DAC6E6"/>
                            <stop  offset="0.1998" style="stop-color:#F7F2F9"/>
                            <stop  offset="0.2222" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.2513" style="stop-color:#F9F5FB"/>
                            <stop  offset="0.3001" style="stop-color:#E9DBF2"/>
                            <stop  offset="0.3586" style="stop-color:#D1B4E3"/>
                            <stop  offset="0.4264" style="stop-color:#B395D6"/>
                            <stop  offset="0.4949" style="stop-color:#9C7DCB"/>
                            <stop  offset="0.5583" style="stop-color:#8E6EC5"/>
                            <stop  offset="0.6111" style="stop-color:#8969C3"/>
                            <stop  offset="0.755" style="stop-color:#9471C6"/>
                            <stop  offset="1" style="stop-color:#B086CC"/>
		</linearGradient>
                        <path style="fill:url(#SVGID_00000147196528456490775480000008220563703738488735_);" d="M512.9,354.1c1.8,0.2,2,2.9,1.7,4.6
			c-0.3,1.5-1.1,2.6-4.1,3.3c-2.6,0.7-13.6,2.6-15.7,2.2s-0.6-5,1.4-7c1.9-1.9,2.3-2.4,4.9-2.4C504,354.9,510.2,353.8,512.9,354.1z"
                        />

                        <radialGradient id="SVGID_00000182506312834868457670000001831839321014573967_" cx="505.0397" cy="6187.3608" r="12.5206" gradientTransform="matrix(1 5.362411e-03 -2.681205e-03 0.5 16.5094 -2739.6794)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#972A74"/>
                            <stop  offset="2.275687e-02" style="stop-color:#8C276C"/>
                            <stop  offset="0.1136" style="stop-color:#671D4F"/>
                            <stop  offset="0.212" style="stop-color:#471437"/>
                            <stop  offset="0.3179" style="stop-color:#2D0D23"/>
                            <stop  offset="0.4342" style="stop-color:#190713"/>
                            <stop  offset="0.5661" style="stop-color:#0B0308"/>
                            <stop  offset="0.7271" style="stop-color:#020102"/>
                            <stop  offset="1" style="stop-color:#000000"/>
		</radialGradient>
                        <path style="fill:url(#SVGID_00000182506312834868457670000001831839321014573967_);" d="M512.9,354.4c1.8,0.2,2,2.5,1.7,4
			c-0.3,1.3-1.1,2.2-4.1,2.9c-2.6,0.6-13.6,2.3-15.7,1.9c-2.1-0.3-0.2-4.6,1.8-6.1c2-1.5,1.9-2.1,4.5-2
			C504,355.1,510.2,354.1,512.9,354.4z"/>
	</g>
                    <g id="logo01">
		<circle class="st363" cx="446.1" cy="127" r="17.4"/>
                        <circle class="st363" cx="400.9" cy="151.9" r="17.4"/>
                        <circle class="st363" cx="445.7" cy="177.7" r="17.4"/>
                        <path class="st363" d="M431.7,136.7c0,0,3.2,7.1-3.4,11.1s-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2s9.6-9.3,9.6-9.3L431.7,136.7z"/>
	</g>
                    <g id="logo02">
		<circle class="st363" cx="140.6" cy="307.5" r="17.4"/>
                        <circle class="st363" cx="95.4" cy="332.4" r="17.4"/>
                        <circle class="st363" cx="140.2" cy="358.3" r="17.4"/>
                        <path class="st363" d="M126.2,317.2c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2c0.2-7.3,9.6-9.3,9.6-9.3L126.2,317.2z"/>
	</g>
                    <g id="logo03">
		<circle class="st363" cx="261.1" cy="556.5" r="17.4"/>
                        <circle class="st363" cx="215.9" cy="581.3" r="17.4"/>
                        <circle class="st363" cx="260.6" cy="607.2" r="17.4"/>
                        <path class="st363" d="M246.7,566.1c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2c0.2-7.3,9.6-9.3,9.6-9.3L246.7,566.1z"/>
	</g>
                    <g id="logo04">
		<circle class="st363" cx="676.7" cy="620.5" r="17.4"/>
                        <circle class="st363" cx="631.5" cy="645.4" r="17.4"/>
                        <circle class="st363" cx="676.3" cy="671.3" r="17.4"/>
                        <path class="st363" d="M662.3,630.2c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2s9.6-9.3,9.6-9.3L662.3,630.2z"/>
	</g>
                    <g id="logo05">
		<circle class="st363" cx="993.2" cy="443" r="17.4"/>
                        <circle class="st363" cx="947.9" cy="467.9" r="17.4"/>
                        <circle class="st363" cx="992.7" cy="493.7" r="17.4"/>
                        <path class="st363" d="M978.7,452.7c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			s8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2s9.6-9.3,9.6-9.3L978.7,452.7z"/>
	</g>
                    <g id="logo06">
		<circle class="st363" cx="878.5" cy="193.1" r="17.4"/>
                        <circle class="st363" cx="833.3" cy="218" r="17.4"/>
                        <circle class="st363" cx="878.1" cy="243.9" r="17.4"/>
                        <path class="st363" d="M864.1,202.8c0,0,3.2,7.1-3.4,11.1c-6.6,4-13.7-5.6-13.7-5.6l0.8,18.1c0,0,2.4-4.6,8.6-3.8
			c6.3,0.7,8.5,5.7,8.7,11.4l10.8-6.7c0,0-7.7-1.9-7.5-9.2c0.2-7.3,9.6-9.3,9.6-9.3L864.1,202.8z"/>
	</g>
</g>
                <g id="line">
	<g id="line01">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000049195653428552212840000018249340635434963885_" filterUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9" id="SVGID_00000135672260068671967520000001532758717912550025_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000049195653428552212840000018249340635434963885_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000018917881184991587130000011734125692268199072_" filterUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9" id="SVGID_00000135672260068671967520000001532758717912550025_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000018917881184991587130000011734125692268199072_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000085964322102969299760000002909630720876213899_" cx="236.3007" cy="189.5619" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000135672260068671967520000001532758717912550025_);fill:url(#SVGID_00000085964322102969299760000002909630720876213899_);" d="
						M282.3,325.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C269.2,324.2,276.5,322.1,282.3,325.4z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000097494528553954679710000016833049070372916655_" filterUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9" id="SVGID_00000118396670604087034360000002343070824528769460_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000097494528553954679710000016833049070372916655_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000001664824239353876660000004977501419549206180_" filterUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="264.4" y="323.8" width="23.9" height="23.9" id="SVGID_00000118396670604087034360000002343070824528769460_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000001664824239353876660000004977501419549206180_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000098189639665229084560000009882990887664105869_" cx="236.3007" cy="189.5619" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000118396670604087034360000002343070824528769460_);fill:url(#SVGID_00000098189639665229084560000009882990887664105869_);" d="
							M282.3,325.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C269.2,324.2,276.5,322.1,282.3,325.4z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000031888836016468240980000007490538384632615593_" cx="236.3007" cy="189.5619" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000031888836016468240980000007490538384632615593_);" d="M282.3,325.4
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C269.2,324.2,276.5,322.1,282.3,325.4z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000072993338477233554430000002291617270371679368_" filterUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9" id="SVGID_00000155139118713682953460000000273460254681848743_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000072993338477233554430000002291617270371679368_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000151544830837334920490000000518900152644052157_" filterUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9" id="SVGID_00000155139118713682953460000000273460254681848743_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000151544830837334920490000000518900152644052157_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000139976483957222428820000000474618299929254026_" cx="223.7093" cy="182.2775" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000155139118713682953460000000273460254681848743_);fill:url(#SVGID_00000139976483957222428820000000474618299929254026_);" d="
						M269.8,332.7c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C256.7,331.5,264,329.5,269.8,332.7z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000021116068625531142350000012362419330275981747_" filterUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9" id="SVGID_00000119822043984553504880000001943430138795365052_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000021116068625531142350000012362419330275981747_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000062157073331437120260000010535381049459683743_" filterUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="251.9" y="331.2" width="23.9" height="23.9" id="SVGID_00000119822043984553504880000001943430138795365052_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000062157073331437120260000010535381049459683743_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000124842759835793674890000005155604649596754072_" cx="223.7093" cy="182.2775" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000119822043984553504880000001943430138795365052_);fill:url(#SVGID_00000124842759835793674890000005155604649596754072_);" d="
							M269.8,332.7c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C256.7,331.5,264,329.5,269.8,332.7z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000074407820891400899450000003595875628611276972_" cx="223.7093" cy="182.2775" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000074407820891400899450000003595875628611276972_);" d="M269.8,332.7
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C256.7,331.5,264,329.5,269.8,332.7z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000060001232274569517980000002475313305218090413_" filterUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9" id="SVGID_00000137132512148013254250000004026305949425156749_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000060001232274569517980000002475313305218090413_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000044137117186808284020000006542975364623499907_" filterUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9" id="SVGID_00000137132512148013254250000004026305949425156749_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000044137117186808284020000006542975364623499907_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000053534774241076481700000011595806896612652981_" cx="211.1178" cy="174.993" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000137132512148013254250000004026305949425156749_);fill:url(#SVGID_00000053534774241076481700000011595806896612652981_);" d="
						M257.3,340.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C244.3,338.9,251.6,336.9,257.3,340.1z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000157309852131685759860000015337999628178423186_" filterUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9" id="SVGID_00000021082130591587430360000001759149289423863952_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000157309852131685759860000015337999628178423186_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000077293587898022237940000011671449462241218176_" filterUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="239.5" y="338.6" width="23.9" height="23.9" id="SVGID_00000021082130591587430360000001759149289423863952_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000077293587898022237940000011671449462241218176_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000016798257988023498600000014907326264238451089_" cx="211.1178" cy="174.993" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000021082130591587430360000001759149289423863952_);fill:url(#SVGID_00000016798257988023498600000014907326264238451089_);" d="
							M257.3,340.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C244.3,338.9,251.6,336.9,257.3,340.1z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000070815256046746354140000005200371484889184952_" cx="211.1178" cy="174.993" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000070815256046746354140000005200371484889184952_);" d="M257.3,340.1
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C244.3,338.9,251.6,336.9,257.3,340.1z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000109741888266728237140000011128179222128852913_" filterUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9" id="SVGID_00000099642099004974665670000013683976207020388795_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000109741888266728237140000011128179222128852913_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000063605060644152599700000000689318519808493209_" filterUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9" id="SVGID_00000099642099004974665670000013683976207020388795_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000063605060644152599700000000689318519808493209_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000020400099657946845870000004255981412085255812_" cx="198.5264" cy="167.7084" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000099642099004974665670000013683976207020388795_);fill:url(#SVGID_00000020400099657946845870000004255981412085255812_);" d="
						M244.9,347.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C231.8,346.3,239.1,344.2,244.9,347.5z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000101095719955780211540000012193094402753488295_" filterUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9" id="SVGID_00000013192590697582033230000003183196561131602320_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000101095719955780211540000012193094402753488295_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000147914264977323550110000001039794068469811616_" filterUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="227" y="345.9" width="23.9" height="23.9" id="SVGID_00000013192590697582033230000003183196561131602320_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000147914264977323550110000001039794068469811616_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000016044407196076774490000017641227719599790976_" cx="198.5264" cy="167.7084" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000013192590697582033230000003183196561131602320_);fill:url(#SVGID_00000016044407196076774490000017641227719599790976_);" d="
							M244.9,347.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C231.8,346.3,239.1,344.2,244.9,347.5z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000062914853699705316960000018179638501600537985_" cx="198.5264" cy="167.7084" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000062914853699705316960000018179638501600537985_);" d="M244.9,347.5
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C231.8,346.3,239.1,344.2,244.9,347.5z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000014622995411101640990000007280123037476450177_" filterUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9" id="SVGID_00000129193421539306689710000012456733756277417138_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000014622995411101640990000007280123037476450177_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000040562966554095149450000003957350610166247325_" filterUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9" id="SVGID_00000129193421539306689710000012456733756277417138_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000040562966554095149450000003957350610166247325_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000117663291942449249110000002528496849689713571_" cx="185.935" cy="160.424" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000129193421539306689710000012456733756277417138_);fill:url(#SVGID_00000117663291942449249110000002528496849689713571_);" d="
						M232.4,354.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C219.3,353.6,226.6,351.6,232.4,354.8z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000149362153053129907540000017289437232490845097_" filterUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9" id="SVGID_00000181051273684414840400000014427391049871467395_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000149362153053129907540000017289437232490845097_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000183928937006997756880000007262264820401545358_" filterUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="214.6" y="353.3" width="23.9" height="23.9" id="SVGID_00000181051273684414840400000014427391049871467395_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000183928937006997756880000007262264820401545358_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000150794162199689532660000011092685244580724133_" cx="185.935" cy="160.424" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000181051273684414840400000014427391049871467395_);fill:url(#SVGID_00000150794162199689532660000011092685244580724133_);" d="
							M232.4,354.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C219.3,353.6,226.6,351.6,232.4,354.8z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000044154110391770998730000003830938893688031618_" cx="185.935" cy="160.424" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000044154110391770998730000003830938893688031618_);" d="M232.4,354.8
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C219.3,353.6,226.6,351.6,232.4,354.8z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000026144100603386483850000003270607591029114784_" filterUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9" id="SVGID_00000114062289696897105580000016994080666321876882_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000026144100603386483850000003270607591029114784_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000057849381244368242620000004444954414095577991_" filterUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9" id="SVGID_00000114062289696897105580000016994080666321876882_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000057849381244368242620000004444954414095577991_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000167356259122701500890000010034948952231752846_" cx="173.3436" cy="153.1394" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000114062289696897105580000016994080666321876882_);fill:url(#SVGID_00000167356259122701500890000010034948952231752846_);" d="
						M219.9,362.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C206.9,361,214.2,359,219.9,362.2z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000128445600130557634910000011713057593007947450_" filterUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9" id="SVGID_00000172441584387509358040000001218486059871894934_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000128445600130557634910000011713057593007947450_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000042700538354774569340000003196305632527536264_" filterUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="202.1" y="360.7" width="23.9" height="23.9" id="SVGID_00000172441584387509358040000001218486059871894934_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000042700538354774569340000003196305632527536264_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000026852746908476986630000005250624972126131612_" cx="173.3436" cy="153.1394" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000172441584387509358040000001218486059871894934_);fill:url(#SVGID_00000026852746908476986630000005250624972126131612_);" d="
							M219.9,362.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C206.9,361,214.2,359,219.9,362.2z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000100358063888941933230000007427326609530624683_" cx="173.3436" cy="153.1394" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000100358063888941933230000007427326609530624683_);" d="M219.9,362.2
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C206.9,361,214.2,359,219.9,362.2z"/>
			</g>
		</g>
        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000026128097397718187160000008952019538589192361_" filterUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9" id="SVGID_00000101805310427434980860000006979840199688932992_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000026128097397718187160000008952019538589192361_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000119099340654811051890000008731263154237757322_" filterUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9" id="SVGID_00000101805310427434980860000006979840199688932992_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000119099340654811051890000008731263154237757322_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000177460392777661867170000001639821933522529965_" cx="311.5555" cy="233.163" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000101805310427434980860000006979840199688932992_);fill:url(#SVGID_00000177460392777661867170000001639821933522529965_);" d="
						M356.8,281.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C343.7,280.2,351,278.2,356.8,281.4z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000111186707610773055600000010794898719598299834_" filterUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9" id="SVGID_00000114053246807603772900000016066690247116446131_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000111186707610773055600000010794898719598299834_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000073704559878505681930000013186079224541573781_" filterUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="339" y="279.9" width="23.9" height="23.9" id="SVGID_00000114053246807603772900000016066690247116446131_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000073704559878505681930000013186079224541573781_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000132794450836675966500000015058009098117375636_" cx="311.5555" cy="233.163" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000114053246807603772900000016066690247116446131_);fill:url(#SVGID_00000132794450836675966500000015058009098117375636_);" d="
							M356.8,281.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C343.7,280.2,351,278.2,356.8,281.4z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000173157498682620536170000004358593091079122111_" cx="311.5555" cy="233.163" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000173157498682620536170000004358593091079122111_);" d="M356.8,281.4
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C343.7,280.2,351,278.2,356.8,281.4z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000152961247257370945500000017688688053181701530_" filterUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9" id="SVGID_00000176020583238174274910000006405038372701412998_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000152961247257370945500000017688688053181701530_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000176764991849558804210000016254574650223904397_" filterUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9" id="SVGID_00000176020583238174274910000006405038372701412998_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000176764991849558804210000016254574650223904397_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000038401087504710907010000000802617608468210363_" cx="298.9641" cy="225.8785" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000176020583238174274910000006405038372701412998_);fill:url(#SVGID_00000038401087504710907010000000802617608468210363_);" d="
						M344.3,288.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C331.3,287.6,338.6,285.5,344.3,288.8z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000081650061304690479490000003549799236261021105_" filterUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9" id="SVGID_00000057860995602371196530000007388851337540669865_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000081650061304690479490000003549799236261021105_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000113328298302710193870000008679046500066632094_" filterUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="326.5" y="287.2" width="23.9" height="23.9" id="SVGID_00000057860995602371196530000007388851337540669865_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000113328298302710193870000008679046500066632094_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000042703927644120070590000013134617393221946249_" cx="298.9641" cy="225.8785" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000057860995602371196530000007388851337540669865_);fill:url(#SVGID_00000042703927644120070590000013134617393221946249_);" d="
							M344.3,288.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C331.3,287.6,338.6,285.5,344.3,288.8z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000163035912786149351830000004453344013929868447_" cx="298.9641" cy="225.8785" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000163035912786149351830000004453344013929868447_);" d="M344.3,288.8
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C331.3,287.6,338.6,285.5,344.3,288.8z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000113343992512197377000000018079064938485276552_" filterUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9" id="SVGID_00000155825887364027084400000016349704144356966541_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000113343992512197377000000018079064938485276552_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000064352752410354255760000013168492291919644321_" filterUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9" id="SVGID_00000155825887364027084400000016349704144356966541_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000064352752410354255760000013168492291919644321_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000075161915586471060500000000437129000435885977_" cx="286.3726" cy="218.5941" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000155825887364027084400000016349704144356966541_);fill:url(#SVGID_00000075161915586471060500000000437129000435885977_);" d="
						M331.9,296.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C318.8,294.9,326.1,292.9,331.9,296.1z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000070837519487334598260000010588699810743157181_" filterUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9" id="SVGID_00000135681494327157795410000000597198728332570780_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000070837519487334598260000010588699810743157181_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000047034724015053184870000000733403604613061521_" filterUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="314" y="294.6" width="23.9" height="23.9" id="SVGID_00000135681494327157795410000000597198728332570780_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000047034724015053184870000000733403604613061521_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000093176327796918666000000009340182776538936198_" cx="286.3726" cy="218.5941" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000135681494327157795410000000597198728332570780_);fill:url(#SVGID_00000093176327796918666000000009340182776538936198_);" d="
							M331.9,296.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C318.8,294.9,326.1,292.9,331.9,296.1z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000054245152243196546610000018007862666610970511_" cx="286.3726" cy="218.5941" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000054245152243196546610000018007862666610970511_);" d="M331.9,296.1
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C318.8,294.9,326.1,292.9,331.9,296.1z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000160881278955284818710000001817064055057067176_" filterUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9" id="SVGID_00000121259633496036658240000016832638502963982467_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000160881278955284818710000001817064055057067176_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000090255723426931081780000017800156362706017688_" filterUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9" id="SVGID_00000121259633496036658240000016832638502963982467_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000090255723426931081780000017800156362706017688_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000141422957501147663390000007431364643874844828_" cx="349.6517" cy="254.2691" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000121259633496036658240000016832638502963982467_);fill:url(#SVGID_00000141422957501147663390000007431364643874844828_);" d="
						M393.7,258.7c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C380.6,257.5,387.9,255.4,393.7,258.7z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000142141909333238562400000015712855511410721455_" filterUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9" id="SVGID_00000090255885809060704600000000260296970695779976_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000142141909333238562400000015712855511410721455_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000021826822216361464660000003785446428929889949_" filterUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="375.9" y="257.1" width="23.9" height="23.9" id="SVGID_00000090255885809060704600000000260296970695779976_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000021826822216361464660000003785446428929889949_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000178909119877620877720000012807813898854644883_" cx="349.6517" cy="254.2691" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000090255885809060704600000000260296970695779976_);fill:url(#SVGID_00000178909119877620877720000012807813898854644883_);" d="
							M393.7,258.7c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C380.6,257.5,387.9,255.4,393.7,258.7z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000069357800794165373470000011243002302439580335_" cx="349.6517" cy="254.2691" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000069357800794165373470000011243002302439580335_);" d="M393.7,258.7
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C380.6,257.5,387.9,255.4,393.7,258.7z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000093159971260487068870000001095844472655260308_" filterUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9" id="SVGID_00000031891294145629424710000008662234067926010530_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000093159971260487068870000001095844472655260308_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000171683721662634043100000015059265901233346208_" filterUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9" id="SVGID_00000031891294145629424710000008662234067926010530_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000171683721662634043100000015059265901233346208_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000134226823392243647400000011896995396954624696_" cx="337.0603" cy="246.9846" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000031891294145629424710000008662234067926010530_);fill:url(#SVGID_00000134226823392243647400000011896995396954624696_);" d="
						M381.2,266c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C368.2,264.8,375.5,262.8,381.2,266z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000018223763655970369680000008763404607669459587_" filterUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9" id="SVGID_00000174562061091358360740000003779325950469676471_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000018223763655970369680000008763404607669459587_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000078026972655834984490000004195261393900116410_" filterUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="363.4" y="264.5" width="23.9" height="23.9" id="SVGID_00000174562061091358360740000003779325950469676471_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000078026972655834984490000004195261393900116410_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000179632250925384931150000009572206012509969592_" cx="337.0603" cy="246.9846" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000174562061091358360740000003779325950469676471_);fill:url(#SVGID_00000179632250925384931150000009572206012509969592_);" d="
							M381.2,266c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C368.2,264.8,375.5,262.8,381.2,266z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000156550833450886481880000011450731964919773327_" cx="337.0603" cy="246.9846" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000156550833450886481880000011450731964919773327_);" d="M381.2,266c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C368.2,264.8,375.5,262.8,381.2,266z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000081635126618662215850000016626463999412693157_" filterUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9" id="SVGID_00000080909966971372606520000007802161178626823841_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000081635126618662215850000016626463999412693157_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000165926059484623525940000003667383689546187700_" filterUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9" id="SVGID_00000080909966971372606520000007802161178626823841_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000165926059484623525940000003667383689546187700_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000120516527594619152980000016275810864210101410_" cx="324.4688" cy="239.7002" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000080909966971372606520000007802161178626823841_);fill:url(#SVGID_00000120516527594619152980000016275810864210101410_);" d="
						M368.8,273.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C355.7,272.2,363,270.2,368.8,273.4z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000025418491564145022700000017660987863585825467_" filterUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9" id="SVGID_00000070107792411062123740000011211472221659476392_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000025418491564145022700000017660987863585825467_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000037661792461326789620000008303152527227135158_" filterUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="350.9" y="271.9" width="23.9" height="23.9" id="SVGID_00000070107792411062123740000011211472221659476392_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000037661792461326789620000008303152527227135158_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000176025710971352004600000016629771091021423273_" cx="324.4688" cy="239.7002" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000070107792411062123740000011211472221659476392_);fill:url(#SVGID_00000176025710971352004600000016629771091021423273_);" d="
							M368.8,273.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C355.7,272.2,363,270.2,368.8,273.4z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000151544711681960545170000003998647326460080042_" cx="324.4688" cy="239.7002" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000151544711681960545170000003998647326460080042_);" d="M368.8,273.4
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C355.7,272.2,363,270.2,368.8,273.4z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000112626086985198059570000015105075239928525700_" filterUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9" id="SVGID_00000049196119094391687200000008097644387564914312_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000112626086985198059570000015105075239928525700_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000070106271389355958680000007769788285166419633_" filterUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9" id="SVGID_00000049196119094391687200000008097644387564914312_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000070106271389355958680000007769788285166419633_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000105388492807862615020000012368966953083291790_" cx="273.7812" cy="211.3095" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000049196119094391687200000008097644387564914312_);fill:url(#SVGID_00000105388492807862615020000012368966953083291790_);" d="
						M319.4,303.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C306.4,302.3,313.7,300.3,319.4,303.5z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000035512464396693779590000012298040236829869967_" filterUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9" id="SVGID_00000087372863912163863860000009643807253612493232_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000035512464396693779590000012298040236829869967_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000150097518537424423930000016057168592893085846_" filterUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="301.6" y="302" width="23.9" height="23.9" id="SVGID_00000087372863912163863860000009643807253612493232_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000150097518537424423930000016057168592893085846_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000077292454552456280600000007078525248513507460_" cx="273.7812" cy="211.3095" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000087372863912163863860000009643807253612493232_);fill:url(#SVGID_00000077292454552456280600000007078525248513507460_);" d="
							M319.4,303.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C306.4,302.3,313.7,300.3,319.4,303.5z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000052070655113116297130000003844804072558797730_" cx="273.7812" cy="211.3095" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000052070655113116297130000003844804072558797730_);" d="M319.4,303.5
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C306.4,302.3,313.7,300.3,319.4,303.5z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000157268879554090510940000001078618954892788868_" filterUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9" id="SVGID_00000072253003726396105310000001396151972697693312_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000157268879554090510940000001078618954892788868_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000139973041343265930590000006931305028984985268_" filterUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9" id="SVGID_00000072253003726396105310000001396151972697693312_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000139973041343265930590000006931305028984985268_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000094594994665417374730000014769255484725426074_" cx="261.1897" cy="204.025" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000072253003726396105310000001396151972697693312_);fill:url(#SVGID_00000094594994665417374730000014769255484725426074_);" d="
						M307,310.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C293.9,309.7,301.2,307.6,307,310.9z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000018941456296200522260000004469449799051783348_" filterUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9" id="SVGID_00000108283196388499678830000006262897614453505930_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000018941456296200522260000004469449799051783348_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000137822493250944000250000000434858377468018565_" filterUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="289.1" y="309.3" width="23.9" height="23.9" id="SVGID_00000108283196388499678830000006262897614453505930_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000137822493250944000250000000434858377468018565_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000115482141465370904890000008227175721954066561_" cx="261.1897" cy="204.025" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000108283196388499678830000006262897614453505930_);fill:url(#SVGID_00000115482141465370904890000008227175721954066561_);" d="
							M307,310.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C293.9,309.7,301.2,307.6,307,310.9z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000051375848215952986140000016395448082547579548_" cx="261.1897" cy="204.025" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000051375848215952986140000016395448082547579548_);" d="M307,310.9c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C293.9,309.7,301.2,307.6,307,310.9z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000145052201879405750100000012946321377615473592_" filterUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9" id="SVGID_00000178912661107724932190000002419618567379629199_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000145052201879405750100000012946321377615473592_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000015352506261427147180000002099995490556544915_" filterUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9" id="SVGID_00000178912661107724932190000002419618567379629199_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000015352506261427147180000002099995490556544915_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000053518374786251265060000011008600867118845327_" cx="248.5984" cy="196.7405" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000178912661107724932190000002419618567379629199_);fill:url(#SVGID_00000053518374786251265060000011008600867118845327_);" d="
						M294.5,318.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C281.4,317,288.7,315,294.5,318.2z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000070834885097625793780000017604778766818887316_" filterUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9" id="SVGID_00000129902179764909901320000004995167383360527015_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000070834885097625793780000017604778766818887316_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000047765304200703735120000008366278091976039042_" filterUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="276.6" y="316.7" width="23.9" height="23.9" id="SVGID_00000129902179764909901320000004995167383360527015_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000047765304200703735120000008366278091976039042_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000147907006138560440850000015875107527944877456_" cx="248.5984" cy="196.7405" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000129902179764909901320000004995167383360527015_);fill:url(#SVGID_00000147907006138560440850000015875107527944877456_);" d="
							M294.5,318.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C281.4,317,288.7,315,294.5,318.2z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000077312547414160892810000000155424669995571080_" cx="248.5984" cy="196.7405" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000077312547414160892810000000155424669995571080_);" d="M294.5,318.2
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C281.4,317,288.7,315,294.5,318.2z"/>
			</g>
		</g>
	</g>
                    <g id="line04">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000075156683901909434550000018409960021693453214_" filterUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9" id="SVGID_00000034049390511035289990000008491987961799825332_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000075156683901909434550000018409960021693453214_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000110472611731877134210000010845754718065029302_" filterUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9" id="SVGID_00000034049390511035289990000008491987961799825332_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000110472611731877134210000010845754718065029302_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000173874997720724400440000014195648947136201856_" cx="224.7435" cy="813.6964" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000034049390511035289990000008491987961799825332_);fill:url(#SVGID_00000173874997720724400440000014195648947136201856_);" d="
						M817.9,640.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C804.8,638.9,812.1,636.8,817.9,640.1z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000066501975983108517150000007548118598314772107_" filterUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9" id="SVGID_00000096741148635222759240000004741958416777502358_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000066501975983108517150000007548118598314772107_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000127040444551253294020000014255072825864219305_" filterUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="800.1" y="638.5" width="23.9" height="23.9" id="SVGID_00000096741148635222759240000004741958416777502358_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000127040444551253294020000014255072825864219305_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000073681016787249204170000009469915660040367548_" cx="224.7435" cy="813.6964" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000096741148635222759240000004741958416777502358_);fill:url(#SVGID_00000073681016787249204170000009469915660040367548_);" d="
							M817.9,640.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C804.8,638.9,812.1,636.8,817.9,640.1z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000101796119174246475190000010345450650696494252_" cx="224.7435" cy="813.6964" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000101796119174246475190000010345450650696494252_);" d="M817.9,640.1
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C804.8,638.9,812.1,636.8,817.9,640.1z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000038378850782668982610000006966176391554757549_" filterUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9" id="SVGID_00000119094849369432014540000003695784338955049147_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000038378850782668982610000006966176391554757549_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000031901560824292029430000009105119525732823188_" filterUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9" id="SVGID_00000119094849369432014540000003695784338955049147_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000031901560824292029430000009105119525732823188_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000063617030051889869890000008445157193664331651_" cx="212.1522" cy="806.4119" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000119094849369432014540000003695784338955049147_);fill:url(#SVGID_00000063617030051889869890000008445157193664331651_);" d="
						M805.4,647.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C792.4,646.2,799.7,644.2,805.4,647.4z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000125590524852572885410000016354919643446911408_" filterUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9" id="SVGID_00000051377381738168179830000014301652068198078140_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000125590524852572885410000016354919643446911408_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000083051518482116687680000001866901348662851260_" filterUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="787.6" y="645.9" width="23.9" height="23.9" id="SVGID_00000051377381738168179830000014301652068198078140_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000083051518482116687680000001866901348662851260_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000064339156580734599400000001859473154367895197_" cx="212.1522" cy="806.4119" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000051377381738168179830000014301652068198078140_);fill:url(#SVGID_00000064339156580734599400000001859473154367895197_);" d="
							M805.4,647.4c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C792.4,646.2,799.7,644.2,805.4,647.4z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000172422910176411573200000016095284689318620054_" cx="212.1522" cy="806.4119" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000172422910176411573200000016095284689318620054_);" d="M805.4,647.4
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C792.4,646.2,799.7,644.2,805.4,647.4z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000022556358928606358620000010470571861202361773_" filterUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9" id="SVGID_00000033357542813616862690000007874886737217256383_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000022556358928606358620000010470571861202361773_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000074441942953631786840000002384257503886175931_" filterUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9" id="SVGID_00000033357542813616862690000007874886737217256383_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000074441942953631786840000002384257503886175931_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000134971352804453400830000006944001007851474346_" cx="199.5607" cy="799.1275" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000033357542813616862690000007874886737217256383_);fill:url(#SVGID_00000134971352804453400830000006944001007851474346_);" d="
						M793,654.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C779.9,653.6,787.2,651.6,793,654.8z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000115492935377025082060000010829010735031189654_" filterUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9" id="SVGID_00000021837722235382406780000000608439469287577502_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000115492935377025082060000010829010735031189654_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000132089456094195092950000012199577362681978286_" filterUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="775.1" y="653.3" width="23.9" height="23.9" id="SVGID_00000021837722235382406780000000608439469287577502_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000132089456094195092950000012199577362681978286_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000161606904187258442500000007686415151932035251_" cx="199.5607" cy="799.1275" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000021837722235382406780000000608439469287577502_);fill:url(#SVGID_00000161606904187258442500000007686415151932035251_);" d="
							M793,654.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C779.9,653.6,787.2,651.6,793,654.8z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000033338700331006814300000003182529959470346933_" cx="199.5607" cy="799.1275" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000033338700331006814300000003182529959470346933_);" d="M793,654.8c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C779.9,653.6,787.2,651.6,793,654.8z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000139270168536043519010000012312164214675797394_" filterUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9" id="SVGID_00000087401596586638390020000003411646023977178282_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000139270168536043519010000012312164214675797394_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000174564011225906200550000008466733129360389817_" filterUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9" id="SVGID_00000087401596586638390020000003411646023977178282_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000174564011225906200550000008466733129360389817_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000000914382100016889900000005747142929433074618_" cx="186.9693" cy="791.8429" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000087401596586638390020000003411646023977178282_);fill:url(#SVGID_00000000914382100016889900000005747142929433074618_);" d="
						M780.5,662.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6s-7.8-10.5-4.6-16.3C767.4,661,774.7,658.9,780.5,662.2z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000122712046269956247730000014786927187105446079_" filterUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9" id="SVGID_00000075142205849222358290000000461376196399520925_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000122712046269956247730000014786927187105446079_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000180330908189410127210000014170559254921732992_" filterUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="762.7" y="660.6" width="23.9" height="23.9" id="SVGID_00000075142205849222358290000000461376196399520925_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000180330908189410127210000014170559254921732992_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000003104003357062859650000016080752781911329200_" cx="186.9693" cy="791.8429" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000075142205849222358290000000461376196399520925_);fill:url(#SVGID_00000003104003357062859650000016080752781911329200_);" d="
							M780.5,662.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6s-7.8-10.5-4.6-16.3C767.4,661,774.7,658.9,780.5,662.2z"
                        />
					</g>
				</mask>

                <radialGradient id="SVGID_00000178887648355428496810000014821880186505001140_" cx="186.9693" cy="791.8429" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000178887648355428496810000014821880186505001140_);" d="M780.5,662.2
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6s-7.8-10.5-4.6-16.3C767.4,661,774.7,658.9,780.5,662.2z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000080925944447732135130000012814928208046726800_" filterUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9" id="SVGID_00000164505735232628291220000011058294544110624416_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000080925944447732135130000012814928208046726800_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000119812934431830333890000004384294163208415935_" filterUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9" id="SVGID_00000164505735232628291220000011058294544110624416_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000119812934431830333890000004384294163208415935_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000084524051444313203770000011567748306827961758_" cx="174.3778" cy="784.5585" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000164505735232628291220000011058294544110624416_);fill:url(#SVGID_00000084524051444313203770000011567748306827961758_);" d="
						M768,669.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C755,668.3,762.3,666.3,768,669.5
						z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000036246543462009086970000008347914333150853524_" filterUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9" id="SVGID_00000154418484874899216700000012920556686574969019_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000036246543462009086970000008347914333150853524_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000025421898620037542390000012289731000328898968_" filterUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="750.2" y="668" width="23.9" height="23.9" id="SVGID_00000154418484874899216700000012920556686574969019_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000025421898620037542390000012289731000328898968_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000176009442594296284660000003307531115689701525_" cx="174.3778" cy="784.5585" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000154418484874899216700000012920556686574969019_);fill:url(#SVGID_00000176009442594296284660000003307531115689701525_);" d="
							M768,669.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C755,668.3,762.3,666.3,768,669.5z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000167389510177312032190000001113462007718479237_" cx="174.3778" cy="784.5585" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000167389510177312032190000001113462007718479237_);" d="M768,669.5c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C755,668.3,762.3,666.3,768,669.5z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000139293118472997608550000012208114748350414737_" filterUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9" id="SVGID_00000051374911481912793150000018186152013178685834_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000139293118472997608550000012208114748350414737_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000128453928012565151260000003114108310884135074_" filterUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9" id="SVGID_00000051374911481912793150000018186152013178685834_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000128453928012565151260000003114108310884135074_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000052790042682146581370000013540261231446056628_" cx="161.7864" cy="777.2739" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000051374911481912793150000018186152013178685834_);fill:url(#SVGID_00000052790042682146581370000013540261231446056628_);" d="
						M755.6,676.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C742.5,675.7,749.8,673.7,755.6,676.9z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000003794481832436275580000017807054602052558748_" filterUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9" id="SVGID_00000110460998954689737850000000770252840887951252_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000003794481832436275580000017807054602052558748_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000161614957083208669150000006057207833997088151_" filterUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="737.7" y="675.4" width="23.9" height="23.9" id="SVGID_00000110460998954689737850000000770252840887951252_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000161614957083208669150000006057207833997088151_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000027597092109205841260000012588641679125402027_" cx="161.7864" cy="777.2739" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000110460998954689737850000000770252840887951252_);fill:url(#SVGID_00000027597092109205841260000012588641679125402027_);" d="
							M755.6,676.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C742.5,675.7,749.8,673.7,755.6,676.9z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000099632893053621972760000002471448798481252754_" cx="161.7864" cy="777.2739" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000099632893053621972760000002471448798481252754_);" d="M755.6,676.9
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C742.5,675.7,749.8,673.7,755.6,676.9z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000096038527633132916380000000750389667585535890_" filterUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9" id="SVGID_00000055682347990976258930000002958282452305481902_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000096038527633132916380000000750389667585535890_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000147179501099070392990000017081859141667865985_" filterUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9" id="SVGID_00000055682347990976258930000002958282452305481902_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000147179501099070392990000017081859141667865985_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000179639928509957249890000008159932464124809883_" cx="299.9983" cy="857.2975" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000055682347990976258930000002958282452305481902_);fill:url(#SVGID_00000179639928509957249890000008159932464124809883_);" d="
						M892.4,596.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C879.4,594.9,886.7,592.9,892.4,596.1z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000103233251155111085400000011465545111760245133_" filterUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9" id="SVGID_00000176028558868387389950000000198441621566758303_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000103233251155111085400000011465545111760245133_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000131365432517722500080000016501397616623233693_" filterUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="874.6" y="594.6" width="23.9" height="23.9" id="SVGID_00000176028558868387389950000000198441621566758303_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000131365432517722500080000016501397616623233693_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000133497802512452854900000003944414192829995398_" cx="299.9983" cy="857.2975" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000176028558868387389950000000198441621566758303_);fill:url(#SVGID_00000133497802512452854900000003944414192829995398_);" d="
							M892.4,596.1c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C879.4,594.9,886.7,592.9,892.4,596.1z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000021799389888854560410000016639345384365438396_" cx="299.9983" cy="857.2975" r="12.0288" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000021799389888854560410000016639345384365438396_);" d="M892.4,596.1
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C879.4,594.9,886.7,592.9,892.4,596.1z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000031888782087900675230000000896592630916699525_" filterUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9" id="SVGID_00000093148974271481628160000003974645377647644065_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000031888782087900675230000000896592630916699525_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000116220961358812277340000016192682861373138357_" filterUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9" id="SVGID_00000093148974271481628160000003974645377647644065_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000116220961358812277340000016192682861373138357_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000078766914599403838840000012403365554436120254_" cx="287.407" cy="850.013" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000093148974271481628160000003974645377647644065_);fill:url(#SVGID_00000078766914599403838840000012403365554436120254_);" d="
						M880,603.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C866.9,602.3,874.2,600.2,880,603.5z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000147930282025499529270000015535912307419960507_" filterUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9" id="SVGID_00000174563122570892093870000016912952974288843440_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000147930282025499529270000015535912307419960507_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000162317468542293153080000000585066743267509147_" filterUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="862.1" y="601.9" width="23.9" height="23.9" id="SVGID_00000174563122570892093870000016912952974288843440_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000162317468542293153080000000585066743267509147_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000173138812793720087930000009054414423893996724_" cx="287.407" cy="850.013" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000174563122570892093870000016912952974288843440_);fill:url(#SVGID_00000173138812793720087930000009054414423893996724_);" d="
							M880,603.5c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C866.9,602.3,874.2,600.2,880,603.5z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000086650618175469001870000008252374787737199244_" cx="287.407" cy="850.013" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000086650618175469001870000008252374787737199244_);" d="M880,603.5c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C866.9,602.3,874.2,600.2,880,603.5z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000017517424353160230200000007436121494246536862_" filterUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9" id="SVGID_00000018953809569025236970000010898853420948539050_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000017517424353160230200000007436121494246536862_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000011735669024150969400000001222269598334142623_" filterUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9" id="SVGID_00000018953809569025236970000010898853420948539050_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000011735669024150969400000001222269598334142623_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000010282398975007016290000011065843344398361268_" cx="274.8154" cy="842.7286" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000018953809569025236970000010898853420948539050_);fill:url(#SVGID_00000010282398975007016290000011065843344398361268_);" d="
						M867.5,610.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C854.5,609.6,861.8,607.6,867.5,610.8z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000066505001467094997640000006524695458504038287_" filterUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9" id="SVGID_00000151524467221084195050000001548873564233151678_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000066505001467094997640000006524695458504038287_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000086665151693431385380000016165201401665119125_" filterUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="849.7" y="609.3" width="23.9" height="23.9" id="SVGID_00000151524467221084195050000001548873564233151678_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000086665151693431385380000016165201401665119125_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000072981644216479972090000000270382693873792184_" cx="274.8154" cy="842.7286" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000151524467221084195050000001548873564233151678_);fill:url(#SVGID_00000072981644216479972090000000270382693873792184_);" d="
							M867.5,610.8c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C854.5,609.6,861.8,607.6,867.5,610.8z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000111174099991203895680000004247043850073970564_" cx="274.8154" cy="842.7286" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000111174099991203895680000004247043850073970564_);" d="M867.5,610.8
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C854.5,609.6,861.8,607.6,867.5,610.8z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000171687048257434483640000008687909394716743338_" filterUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9" id="SVGID_00000142895692135900443120000008033989814913781915_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000171687048257434483640000008687909394716743338_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000156562317693936334300000003845946169454135686_" filterUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9" id="SVGID_00000142895692135900443120000008033989814913781915_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000156562317693936334300000003845946169454135686_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000092415550379351298410000017124988228421038724_" cx="262.2241" cy="835.444" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000142895692135900443120000008033989814913781915_);fill:url(#SVGID_00000092415550379351298410000017124988228421038724_);" d="
						M855.1,618.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C842,617,849.3,615,855.1,618.2
						z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000041997148048154724550000002137368675870029466_" filterUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9" id="SVGID_00000103227795318210523920000010340897893859255947_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000041997148048154724550000002137368675870029466_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000092418270845411029730000008503682569267783850_" filterUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="837.2" y="616.7" width="23.9" height="23.9" id="SVGID_00000103227795318210523920000010340897893859255947_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000092418270845411029730000008503682569267783850_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000178926655508226557240000001173909559446058130_" cx="262.2241" cy="835.444" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000103227795318210523920000010340897893859255947_);fill:url(#SVGID_00000178926655508226557240000001173909559446058130_);" d="
							M855.1,618.2c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C842,617,849.3,615,855.1,618.2z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000032606297019712560540000015822671180335476377_" cx="262.2241" cy="835.444" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000032606297019712560540000015822671180335476377_);" d="M855.1,618.2
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C842,617,849.3,615,855.1,618.2z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000006710094766734687230000002299191536685708981_" filterUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9" id="SVGID_00000023253808742908530620000017599607556281445024_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000006710094766734687230000002299191536685708981_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000016050727162995086040000012565754355066266790_" filterUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9" id="SVGID_00000023253808742908530620000017599607556281445024_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000016050727162995086040000012565754355066266790_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000068654864974696378640000018199122837191543173_" cx="249.6326" cy="828.1595" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000023253808742908530620000017599607556281445024_);fill:url(#SVGID_00000068654864974696378640000018199122837191543173_);" d="
						M842.6,625.6c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C829.5,624.4,836.8,622.3,842.6,625.6z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000057138299533135037650000006013513601938329776_" filterUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9" id="SVGID_00000111886826810675917840000009707809784267280570_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000057138299533135037650000006013513601938329776_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000129907862592131218020000006861652230793564294_" filterUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="824.7" y="624" width="23.9" height="23.9" id="SVGID_00000111886826810675917840000009707809784267280570_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000129907862592131218020000006861652230793564294_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000057110219967339132800000014065232543837531820_" cx="249.6326" cy="828.1595" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000111886826810675917840000009707809784267280570_);fill:url(#SVGID_00000057110219967339132800000014065232543837531820_);" d="
							M842.6,625.6c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C829.5,624.4,836.8,622.3,842.6,625.6z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000047746511966239504640000015524225933296966054_" cx="249.6326" cy="828.1595" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000047746511966239504640000015524225933296966054_);" d="M842.6,625.6
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C829.5,624.4,836.8,622.3,842.6,625.6z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000011737943842409003700000011606272209616857511_" filterUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9" id="SVGID_00000152951965854739356890000015760762985320716735_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000011737943842409003700000011606272209616857511_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000142149269454090388470000012048754213574088081_" filterUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9" id="SVGID_00000152951965854739356890000015760762985320716735_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000142149269454090388470000012048754213574088081_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000025420875554113853900000009566901072946515613_" cx="237.0412" cy="820.8749" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000152951965854739356890000015760762985320716735_);fill:url(#SVGID_00000025420875554113853900000009566901072946515613_);" d="
						M830.1,632.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C817.1,631.7,824.4,629.7,830.1,632.9z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000049200204701953819670000002429959360173865657_" filterUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9" id="SVGID_00000134954671998599217890000003397954934000066708_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000049200204701953819670000002429959360173865657_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000085967503267726028400000016351154280958607784_" filterUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="812.3" y="631.4" width="23.9" height="23.9" id="SVGID_00000134954671998599217890000003397954934000066708_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000085967503267726028400000016351154280958607784_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000114059613444729034100000007575143068745486745_" cx="237.0412" cy="820.8749" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000134954671998599217890000003397954934000066708_);fill:url(#SVGID_00000114059613444729034100000007575143068745486745_);" d="
							M830.1,632.9c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C817.1,631.7,824.4,629.7,830.1,632.9z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000169551982096218844140000006346246358195032208_" cx="237.0412" cy="820.8749" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000169551982096218844140000006346246358195032208_);" d="M830.1,632.9
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C817.1,631.7,824.4,629.7,830.1,632.9z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000111872467035354852480000007757934045833966240_" filterUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9" id="SVGID_00000119106451477854600080000004580524015484331654_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000111872467035354852480000007757934045833966240_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000068677037011770652990000000278196049066274740_" filterUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9" id="SVGID_00000119106451477854600080000004580524015484331654_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000068677037011770652990000000278196049066274740_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000144305992159253446890000013909022625675542697_" cx="339.6975" cy="878.9702" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000119106451477854600080000004580524015484331654_);fill:url(#SVGID_00000144305992159253446890000013909022625675542697_);" d="
						M930.6,572.3c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C917.6,571.1,924.9,569,930.6,572.3z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000041982607370138271920000017426329901963498373_" filterUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9" id="SVGID_00000078739856646344301820000007120915612584048513_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000041982607370138271920000017426329901963498373_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000108299568295977082120000005383316217708995217_" filterUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="912.8" y="570.7" width="23.9" height="23.9" id="SVGID_00000078739856646344301820000007120915612584048513_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000108299568295977082120000005383316217708995217_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000097475781139813587560000010363846898734663871_" cx="339.6975" cy="878.9702" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000078739856646344301820000007120915612584048513_);fill:url(#SVGID_00000097475781139813587560000010363846898734663871_);" d="
							M930.6,572.3c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C917.6,571.1,924.9,569,930.6,572.3z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000103959974264821642190000010339244137720889519_" cx="339.6975" cy="878.9702" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000103959974264821642190000010339244137720889519_);" d="M930.6,572.3
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C917.6,571.1,924.9,569,930.6,572.3z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000018216323950158694610000005152186457605260193_" filterUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9" id="SVGID_00000165942444872059731110000001527713302000321702_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000018216323950158694610000005152186457605260193_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000183959458860410559240000016282166781615710609_" filterUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9" id="SVGID_00000165942444872059731110000001527713302000321702_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000183959458860410559240000016282166781615710609_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000093176915581115278130000002218302457350147713_" cx="327.106" cy="871.6857" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000165942444872059731110000001527713302000321702_);fill:url(#SVGID_00000093176915581115278130000002218302457350147713_);" d="
						M918.2,579.6c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C905.1,578.4,912.4,576.4,918.2,579.6z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000155863644701809944600000000903889654555973539_" filterUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9" id="SVGID_00000048492242353327326790000009183477948269237937_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000155863644701809944600000000903889654555973539_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000176020313154771886900000001342916891025780138_" filterUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="900.3" y="578.1" width="23.9" height="23.9" id="SVGID_00000048492242353327326790000009183477948269237937_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000176020313154771886900000001342916891025780138_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000160904364627095769350000007689627227420512897_" cx="327.106" cy="871.6857" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000048492242353327326790000009183477948269237937_);fill:url(#SVGID_00000160904364627095769350000007689627227420512897_);" d="
							M918.2,579.6c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C905.1,578.4,912.4,576.4,918.2,579.6z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000073679928366815540910000008395212483736065698_" cx="327.106" cy="871.6857" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000073679928366815540910000008395212483736065698_);" d="M918.2,579.6
					c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C905.1,578.4,912.4,576.4,918.2,579.6z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000169535926279071857070000000640227822304685751_" filterUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9" id="SVGID_00000096043673775844937570000012835793276387562398_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000169535926279071857070000000640227822304685751_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000175321550425178560550000012025964393930589841_" filterUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9" id="SVGID_00000096043673775844937570000012835793276387562398_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000175321550425178560550000012025964393930589841_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000058580856825972718290000004061855546804097410_" cx="314.5146" cy="864.4011" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000096043673775844937570000012835793276387562398_);fill:url(#SVGID_00000058580856825972718290000004061855546804097410_);" d="
						M905.7,587c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
						C892.6,585.8,899.9,583.7,905.7,587z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000151501756480699696290000007940172174728582574_" filterUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9" id="SVGID_00000047745746905377037410000014985428279883969437_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000151501756480699696290000007940172174728582574_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000171685602304673693740000007810128660264779393_" filterUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="887.8" y="585.4" width="23.9" height="23.9" id="SVGID_00000047745746905377037410000014985428279883969437_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000171685602304673693740000007810128660264779393_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000155123136146656795050000007938774632104398270_" cx="314.5146" cy="864.4011" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000047745746905377037410000014985428279883969437_);fill:url(#SVGID_00000155123136146656795050000007938774632104398270_);" d="
							M905.7,587c5.8,3.2,7.8,10.5,4.6,16.3c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3
							C892.6,585.8,899.9,583.7,905.7,587z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000120516616173840430160000008302632946476521145_" cx="314.5146" cy="864.4011" r="12.0287" gradientTransform="matrix(0.4882 -0.8672 0.8672 0.4882 -3.3642 448.2123)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000120516616173840430160000008302632946476521145_);" d="M905.7,587c5.8,3.2,7.8,10.5,4.6,16.3
					c-3.2,5.8-10.5,7.8-16.3,4.6c-5.8-3.2-7.8-10.5-4.6-16.3C892.6,585.8,899.9,583.7,905.7,587z"/>
			</g>
		</g>
	</g>
                    <g id="line03">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000033356371527843871720000008819568273469676688_" filterUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9" id="SVGID_00000060730727336638022930000014390204945184040882_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000033356371527843871720000008819568273469676688_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000085212979611586879970000005508761981434494113_" filterUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9" id="SVGID_00000060730727336638022930000014390204945184040882_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000085212979611586879970000005508761981434494113_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000103965562924230860630000012580498591122134709_" cx="96.4823" cy="633.8545" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000060730727336638022930000014390204945184040882_);fill:url(#SVGID_00000103965562924230860630000012580498591122134709_);" d="
						M385.6,688.4c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C376.3,679.3,383.2,682.3,385.6,688.4z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000096046308298563427020000006049776579391280060_" filterUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9" id="SVGID_00000160901644574462137270000003181704882629374354_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000096046308298563427020000006049776579391280060_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000026859797380011720190000003149463273075151253_" filterUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="362.5" y="680.8" width="23.9" height="23.9" id="SVGID_00000160901644574462137270000003181704882629374354_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000026859797380011720190000003149463273075151253_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000135671680729114167420000018327953121235357368_" cx="96.4823" cy="633.8545" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000160901644574462137270000003181704882629374354_);fill:url(#SVGID_00000135671680729114167420000018327953121235357368_);" d="
							M385.6,688.4c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C376.3,679.3,383.2,682.3,385.6,688.4z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000096045730305633052760000004015306483105278596_" cx="96.4823" cy="633.8545" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000096045730305633052760000004015306483105278596_);" d="M385.6,688.4
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C376.3,679.3,383.2,682.3,385.6,688.4z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000025401148276801961790000002488225507317881223_" filterUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9" id="SVGID_00000111880656126389666610000006334211800596111291_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000025401148276801961790000002488225507317881223_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000107575593540397449710000003409871142552496776_" filterUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9" id="SVGID_00000111880656126389666610000006334211800596111291_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000107575593540397449710000003409871142552496776_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000136411843906052090120000005383422585083573122_" cx="83.891" cy="626.5701" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000111880656126389666610000006334211800596111291_);fill:url(#SVGID_00000136411843906052090120000005383422585083573122_);" d="
						M371.3,686.3c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C361.9,677.1,368.9,680.1,371.3,686.3z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000174601226194394196540000018097925937132599707_" filterUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9" id="SVGID_00000136389431672128285050000013539189714338434192_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000174601226194394196540000018097925937132599707_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000091002080972227433400000010234968205805490091_" filterUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="348.2" y="678.7" width="23.9" height="23.9" id="SVGID_00000136389431672128285050000013539189714338434192_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000091002080972227433400000010234968205805490091_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000081618217618100023270000012382951739521120447_" cx="83.891" cy="626.5701" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000136389431672128285050000013539189714338434192_);fill:url(#SVGID_00000081618217618100023270000012382951739521120447_);" d="
							M371.3,686.3c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C361.9,677.1,368.9,680.1,371.3,686.3z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000062191891974266558380000010994872890156000699_" cx="83.891" cy="626.5701" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000062191891974266558380000010994872890156000699_);" d="M371.3,686.3
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C361.9,677.1,368.9,680.1,371.3,686.3z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000071544451663857096670000005586813596250026130_" filterUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9" id="SVGID_00000018216413187798534090000006391576956523261838_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000071544451663857096670000005586813596250026130_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000027604135378323566190000002911664508016387225_" filterUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9" id="SVGID_00000018216413187798534090000006391576956523261838_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000027604135378323566190000002911664508016387225_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000079459630485713348140000010854478357760772025_" cx="71.2995" cy="619.2856" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000018216413187798534090000006391576956523261838_);fill:url(#SVGID_00000079459630485713348140000010854478357760772025_);" d="
						M357,684.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C347.6,675,354.6,678,357,684.2z"
                    />
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000069368650273086281390000004297221335600197541_" filterUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9" id="SVGID_00000072251288008451266470000015830632145518543774_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000069368650273086281390000004297221335600197541_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000145774361067249918080000004893495969800837804_" filterUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="333.9" y="676.6" width="23.9" height="23.9" id="SVGID_00000072251288008451266470000015830632145518543774_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000145774361067249918080000004893495969800837804_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000154386280871509220750000013055234575483517369_" cx="71.2995" cy="619.2856" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000072251288008451266470000015830632145518543774_);fill:url(#SVGID_00000154386280871509220750000013055234575483517369_);" d="
							M357,684.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C347.6,675,354.6,678,357,684.2z
							"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000159461002317878774760000001531562939185108103_" cx="71.2995" cy="619.2856" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000159461002317878774760000001531562939185108103_);" d="M357,684.2c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C347.6,675,354.6,678,357,684.2z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000005955008560711205320000017612147188615553927_" filterUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9" id="SVGID_00000016772474040632037290000014514322565506808208_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000005955008560711205320000017612147188615553927_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000119111522002479406660000003050744351320953511_" filterUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9" id="SVGID_00000016772474040632037290000014514322565506808208_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000119111522002479406660000003050744351320953511_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000151538360025904937500000010607231847546633601_" cx="58.7081" cy="612.001" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000016772474040632037290000014514322565506808208_);fill:url(#SVGID_00000151538360025904937500000010607231847546633601_);" d="
						M342.7,682c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C333.3,672.9,340.3,675.9,342.7,682z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000029724453623723803620000016727391335698895248_" filterUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9" id="SVGID_00000141424515553777465190000012163094205344034690_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000029724453623723803620000016727391335698895248_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000077288208205723318290000018186221825676990387_" filterUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="319.6" y="674.5" width="23.9" height="23.9" id="SVGID_00000141424515553777465190000012163094205344034690_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000077288208205723318290000018186221825676990387_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000091699554767578347660000007945306026773824657_" cx="58.7081" cy="612.001" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000141424515553777465190000012163094205344034690_);fill:url(#SVGID_00000091699554767578347660000007945306026773824657_);" d="
							M342.7,682c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C333.3,672.9,340.3,675.9,342.7,682z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000180335971098063614510000009335073525797625766_" cx="58.7081" cy="612.001" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000180335971098063614510000009335073525797625766_);" d="M342.7,682c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C333.3,672.9,340.3,675.9,342.7,682z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000152974784841065543900000000885789670263434123_" filterUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9" id="SVGID_00000034774512641664281570000016655482174894910141_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000152974784841065543900000000885789670263434123_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000174576199490870319330000007840212180660998071_" filterUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9" id="SVGID_00000034774512641664281570000016655482174894910141_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000174576199490870319330000007840212180660998071_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000163052132490050988950000009598642313465180556_" cx="46.1166" cy="604.7166" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000034774512641664281570000016655482174894910141_);fill:url(#SVGID_00000163052132490050988950000009598642313465180556_);" d="
						M328.4,679.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C319,670.8,325.9,673.8,328.4,679.9z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000160162376269306531570000002292128692493342884_" filterUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9" id="SVGID_00000116936192109333904020000008241746734358287502_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000160162376269306531570000002292128692493342884_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000008856922978614269380000008271327443354150799_" filterUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="305.3" y="672.3" width="23.9" height="23.9" id="SVGID_00000116936192109333904020000008241746734358287502_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000008856922978614269380000008271327443354150799_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000168103434445576639770000002752624808583102630_" cx="46.1166" cy="604.7166" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000116936192109333904020000008241746734358287502_);fill:url(#SVGID_00000168103434445576639770000002752624808583102630_);" d="
							M328.4,679.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C319,670.8,325.9,673.8,328.4,679.9z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000011004860981999625820000018347481747961930939_" cx="46.1166" cy="604.7166" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000011004860981999625820000018347481747961930939_);" d="M328.4,679.9
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C319,670.8,325.9,673.8,328.4,679.9z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000170957615677535084680000014152605558902537867_" filterUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9" id="SVGID_00000059280924563172474690000017232150629379942588_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000170957615677535084680000014152605558902537867_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000093161925838451283740000000293920797634831521_" filterUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9" id="SVGID_00000059280924563172474690000017232150629379942588_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000093161925838451283740000000293920797634831521_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000111167668851461702750000001319245178050542724_" cx="33.5252" cy="597.432" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000059280924563172474690000017232150629379942588_);fill:url(#SVGID_00000111167668851461702750000001319245178050542724_);" d="
						M314,677.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C304.7,668.6,311.6,671.6,314,677.8z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000143602734679307359240000002121943549413691011_" filterUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9" id="SVGID_00000019661407567701403950000005403673218848801415_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000143602734679307359240000002121943549413691011_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000016040944051871570460000006948355322976070568_" filterUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="290.9" y="670.2" width="23.9" height="23.9" id="SVGID_00000019661407567701403950000005403673218848801415_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000016040944051871570460000006948355322976070568_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000051350609207027070340000012962000505990700478_" cx="33.5252" cy="597.432" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000019661407567701403950000005403673218848801415_);fill:url(#SVGID_00000051350609207027070340000012962000505990700478_);" d="
							M314,677.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C304.7,668.6,311.6,671.6,314,677.8z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000120529928094056019430000012993996928821690528_" cx="33.5252" cy="597.432" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000120529928094056019430000012993996928821690528_);" d="M314,677.8c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C304.7,668.6,311.6,671.6,314,677.8z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000065794643737064494690000012473971088503608717_" filterUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9" id="SVGID_00000042698006784657950110000012694217188981321654_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000065794643737064494690000012473971088503608717_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000164507715410471014390000000964545462132186552_" filterUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9" id="SVGID_00000042698006784657950110000012694217188981321654_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000164507715410471014390000000964545462132186552_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000081627427919713326150000012478391223634666115_" cx="171.7371" cy="677.4556" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000042698006784657950110000012694217188981321654_);fill:url(#SVGID_00000081627427919713326150000012478391223634666115_);" d="
						M471.3,701.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C461.9,692,468.8,695,471.3,701.2z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000153703006156734884190000005422548359023552429_" filterUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9" id="SVGID_00000047038249297497289720000010236975604331984540_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000153703006156734884190000005422548359023552429_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000099630864844311211530000003281264957667741111_" filterUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="448.2" y="693.6" width="23.9" height="23.9" id="SVGID_00000047038249297497289720000010236975604331984540_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000099630864844311211530000003281264957667741111_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000059287929321697022150000017118254698645509272_" cx="171.7371" cy="677.4556" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000047038249297497289720000010236975604331984540_);fill:url(#SVGID_00000059287929321697022150000017118254698645509272_);" d="
							M471.3,701.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C461.9,692,468.8,695,471.3,701.2z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000052077390340522565150000010416980774791322296_" cx="171.7371" cy="677.4556" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000052077390340522565150000010416980774791322296_);" d="M471.3,701.2
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C461.9,692,468.8,695,471.3,701.2z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000060028195637819433770000014429316893695150526_" filterUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9" id="SVGID_00000054947501222536641790000010508894299023266717_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000060028195637819433770000014429316893695150526_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000028298792345306423160000007052541012951316608_" filterUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9" id="SVGID_00000054947501222536641790000010508894299023266717_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000028298792345306423160000007052541012951316608_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000157285662428592197180000004691676689550755487_" cx="159.1457" cy="670.1711" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000054947501222536641790000010508894299023266717_);fill:url(#SVGID_00000157285662428592197180000004691676689550755487_);" d="
						M456.9,699c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C447.5,689.9,454.5,692.9,456.9,699z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000126289993292135263570000016987292510731159466_" filterUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9" id="SVGID_00000047739425280845633090000011656063862592792461_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000126289993292135263570000016987292510731159466_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000054231645352554373790000007761236988777899698_" filterUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="433.8" y="691.5" width="23.9" height="23.9" id="SVGID_00000047739425280845633090000011656063862592792461_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000054231645352554373790000007761236988777899698_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000094587817980402535130000012007581752135703194_" cx="159.1457" cy="670.1711" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000047739425280845633090000011656063862592792461_);fill:url(#SVGID_00000094587817980402535130000012007581752135703194_);" d="
							M456.9,699c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C447.5,689.9,454.5,692.9,456.9,699z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000047756152963490824810000014980792894161599360_" cx="159.1457" cy="670.1711" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000047756152963490824810000014980792894161599360_);" d="M456.9,699c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C447.5,689.9,454.5,692.9,456.9,699z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000077290455980600363510000000516241413994253202_" filterUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9" id="SVGID_00000137818693896323552640000010608876776729763509_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000077290455980600363510000000516241413994253202_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000057850871127798163510000004059553330043397038_" filterUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9" id="SVGID_00000137818693896323552640000010608876776729763509_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000057850871127798163510000004059553330043397038_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000137116166786217306740000006734950500570154902_" cx="146.5542" cy="662.8867" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000137818693896323552640000010608876776729763509_);fill:url(#SVGID_00000137116166786217306740000006734950500570154902_);" d="
						M442.6,696.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C433.2,687.8,440.2,690.8,442.6,696.9z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000148656469182682281600000008474385338903488928_" filterUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9" id="SVGID_00000122683507855364550970000012054015934925185168_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000148656469182682281600000008474385338903488928_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000063610197371278010090000000511993590722444956_" filterUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="419.5" y="689.4" width="23.9" height="23.9" id="SVGID_00000122683507855364550970000012054015934925185168_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000063610197371278010090000000511993590722444956_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000074416216797030749370000012655766973913059505_" cx="146.5542" cy="662.8867" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000122683507855364550970000012054015934925185168_);fill:url(#SVGID_00000074416216797030749370000012655766973913059505_);" d="
							M442.6,696.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C433.2,687.8,440.2,690.8,442.6,696.9z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000042003612737852430730000006791258230655854777_" cx="146.5542" cy="662.8867" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000042003612737852430730000006791258230655854777_);" d="M442.6,696.9
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C433.2,687.8,440.2,690.8,442.6,696.9z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000127754851803389547050000004811670178835665581_" filterUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9" id="SVGID_00000142872994672770947970000014711571963967490456_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000127754851803389547050000004811670178835665581_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000100382720902101344600000014984609061099645615_" filterUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9" id="SVGID_00000142872994672770947970000014711571963967490456_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000100382720902101344600000014984609061099645615_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000014624423477358105590000014735589365290020485_" cx="133.9629" cy="655.6021" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000142872994672770947970000014711571963967490456_);fill:url(#SVGID_00000014624423477358105590000014735589365290020485_);" d="
						M428.3,694.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C418.9,685.6,425.9,688.6,428.3,694.8z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000114073808144580545020000017907474929306785725_" filterUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9" id="SVGID_00000117646616515517619080000015679119801802848957_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000114073808144580545020000017907474929306785725_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000159471094480113068310000005299326314776423605_" filterUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="405.2" y="687.2" width="23.9" height="23.9" id="SVGID_00000117646616515517619080000015679119801802848957_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000159471094480113068310000005299326314776423605_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000058571817851374946370000017898511722572439994_" cx="133.9629" cy="655.6021" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000117646616515517619080000015679119801802848957_);fill:url(#SVGID_00000058571817851374946370000017898511722572439994_);" d="
							M428.3,694.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C418.9,685.6,425.9,688.6,428.3,694.8z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000000221169158658205870000002154694146210214586_" cx="133.9629" cy="655.6021" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000000221169158658205870000002154694146210214586_);" d="M428.3,694.8
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C418.9,685.6,425.9,688.6,428.3,694.8z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000036218327430147966540000008198319806745837466_" filterUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9" id="SVGID_00000095313897627413461820000005826118349389307270_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000036218327430147966540000008198319806745837466_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000120550796220988209640000007888040131995116194_" filterUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9" id="SVGID_00000095313897627413461820000005826118349389307270_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000120550796220988209640000007888040131995116194_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000039117233949218087000000015547118842172584123_" cx="121.3714" cy="648.3176" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000095313897627413461820000005826118349389307270_);fill:url(#SVGID_00000039117233949218087000000015547118842172584123_);" d="
						M414,692.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C404.6,683.5,411.5,686.5,414,692.7z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000126320692163634265290000007991694214635104182_" filterUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9" id="SVGID_00000039099871003227268590000004173548361027520183_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000126320692163634265290000007991694214635104182_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000108275301013945009630000001850150238255772039_" filterUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="390.9" y="685.1" width="23.9" height="23.9" id="SVGID_00000039099871003227268590000004173548361027520183_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000108275301013945009630000001850150238255772039_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000080897764374727813520000015786699457521418129_" cx="121.3714" cy="648.3176" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000039099871003227268590000004173548361027520183_);fill:url(#SVGID_00000080897764374727813520000015786699457521418129_);" d="
							M414,692.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C404.6,683.5,411.5,686.5,414,692.7z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000126286677256423665710000009315811276202006440_" cx="121.3714" cy="648.3176" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000126286677256423665710000009315811276202006440_);" d="M414,692.7c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C404.6,683.5,411.5,686.5,414,692.7z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000055676013257587629250000000988687001742510741_" filterUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9" id="SVGID_00000094581188526030416590000003857129939413413768_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000055676013257587629250000000988687001742510741_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000155112203892123610150000015424583221061318528_" filterUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9" id="SVGID_00000094581188526030416590000003857129939413413768_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000155112203892123610150000015424583221061318528_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000054237234422721790380000016708488322505578375_" cx="108.78" cy="641.0331" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000094581188526030416590000003857129939413413768_);fill:url(#SVGID_00000054237234422721790380000016708488322505578375_);" d="
						M399.7,690.5c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C390.3,681.4,397.2,684.4,399.7,690.5z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000054966251662857789250000001766105293147682445_" filterUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9" id="SVGID_00000142883712565309233730000010401649955102612138_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000054966251662857789250000001766105293147682445_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000078755144618839846030000014528903639095587201_" filterUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="376.6" y="683" width="23.9" height="23.9" id="SVGID_00000142883712565309233730000010401649955102612138_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000078755144618839846030000014528903639095587201_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000155850784853448647990000010901026602482136975_" cx="108.78" cy="641.0331" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000142883712565309233730000010401649955102612138_);fill:url(#SVGID_00000155850784853448647990000010901026602482136975_);" d="
							M399.7,690.5c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C390.3,681.4,397.2,684.4,399.7,690.5z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000129172173520805989410000000293786795014816182_" cx="108.78" cy="641.0331" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000129172173520805989410000000293786795014816182_);" d="M399.7,690.5
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C390.3,681.4,397.2,684.4,399.7,690.5z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000013187441053140407190000009707008262771784873_" filterUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9" id="SVGID_00000127728764102704493840000002942464396492905092_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000013187441053140407190000009707008262771784873_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000137098068811274487340000016381114677002844835_" filterUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9" id="SVGID_00000127728764102704493840000002942464396492905092_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000137098068811274487340000016381114677002844835_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000125584072888507848500000006318965705051901855_" cx="195.672" cy="692.2892" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000127728764102704493840000002942464396492905092_);fill:url(#SVGID_00000125584072888507848500000006318965705051901855_);" d="
						M498.8,706.1c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C489.4,697,496.4,700,498.8,706.1z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000140011134328088305470000010408027959322385853_" filterUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9" id="SVGID_00000179612883086902453650000001257992633992315271_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000140011134328088305470000010408027959322385853_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000164490501788373237420000009019790930037292445_" filterUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="475.7" y="698.6" width="23.9" height="23.9" id="SVGID_00000179612883086902453650000001257992633992315271_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000164490501788373237420000009019790930037292445_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000010311934074854211180000016073736763590829187_" cx="195.672" cy="692.2892" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000179612883086902453650000001257992633992315271_);fill:url(#SVGID_00000010311934074854211180000016073736763590829187_);" d="
							M498.8,706.1c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C489.4,697,496.4,700,498.8,706.1z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000024712701168509234830000013177530966350024078_" cx="195.672" cy="692.2892" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000024712701168509234830000013177530966350024078_);" d="M498.8,706.1
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C489.4,697,496.4,700,498.8,706.1z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000110470170615143738840000004457370262529910453_" filterUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9" id="SVGID_00000064316387340619591440000016741901707827119260_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000110470170615143738840000004457370262529910453_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000129927349471944255010000003730776691745326475_" filterUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9" id="SVGID_00000064316387340619591440000016741901707827119260_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000129927349471944255010000003730776691745326475_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000170261349445499443900000000059546101159622785_" cx="183.0806" cy="685.0048" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000064316387340619591440000016741901707827119260_);fill:url(#SVGID_00000170261349445499443900000000059546101159622785_);" d="
						M484.5,704c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C475.1,694.8,482.1,697.9,484.5,704z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000163753532306556166440000013073913141859200158_" filterUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9" id="SVGID_00000163050454872727853560000003919364129780597651_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000163753532306556166440000013073913141859200158_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000020381868196474791800000016286080398944545971_" filterUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="461.4" y="696.4" width="23.9" height="23.9" id="SVGID_00000163050454872727853560000003919364129780597651_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000020381868196474791800000016286080398944545971_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000088127467471402121130000013813224997132697760_" cx="183.0806" cy="685.0048" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000163050454872727853560000003919364129780597651_);fill:url(#SVGID_00000088127467471402121130000013813224997132697760_);" d="
							M484.5,704c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C475.1,694.8,482.1,697.9,484.5,704z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000025402363992562779950000002954248262253268908_" cx="183.0806" cy="685.0048" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000025402363992562779950000002954248262253268908_);" d="M484.5,704c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C475.1,694.8,482.1,697.9,484.5,704z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000142176538062937311910000018254492084210561724_" filterUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9" id="SVGID_00000119081046133991080420000014262752002186954416_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000142176538062937311910000018254492084210561724_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000164480780605172216600000009012853049014686860_" filterUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9" id="SVGID_00000119081046133991080420000014262752002186954416_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000164480780605172216600000009012853049014686860_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000152254798161744241880000011406205679721488784_" cx="221.1301" cy="707.5123" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000119081046133991080420000014262752002186954416_);fill:url(#SVGID_00000152254798161744241880000011406205679721488784_);" d="
						M528,710.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C518.6,701.7,525.5,704.7,528,710.9z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000044154941574220938670000012955916742142909847_" filterUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9" id="SVGID_00000000941195122877102940000006171636524593350334_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000044154941574220938670000012955916742142909847_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000142160631177188948680000005350014770108737427_" filterUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="504.9" y="703.3" width="23.9" height="23.9" id="SVGID_00000000941195122877102940000006171636524593350334_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000142160631177188948680000005350014770108737427_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000034047623961155211300000000196907480742609811_" cx="221.1301" cy="707.5123" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000000941195122877102940000006171636524593350334_);fill:url(#SVGID_00000034047623961155211300000000196907480742609811_);" d="
							M528,710.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C518.6,701.7,525.5,704.7,528,710.9z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000027565070134327146880000008529851067843231414_" cx="221.1301" cy="707.5123" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000027565070134327146880000008529851067843231414_);" d="M528,710.9c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C518.6,701.7,525.5,704.7,528,710.9z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000067238532255398197490000008021673175578383787_" filterUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9" id="SVGID_00000085969324881542351110000010219907659665567664_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000067238532255398197490000008021673175578383787_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000127006269830068156200000010077280827177442982_" filterUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9" id="SVGID_00000085969324881542351110000010219907659665567664_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000127006269830068156200000010077280827177442982_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000099663090871776882330000007046378144505788305_" cx="208.5387" cy="700.2279" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000085969324881542351110000010219907659665567664_);fill:url(#SVGID_00000099663090871776882330000007046378144505788305_);" d="
						M513.7,708.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C504.3,699.6,511.2,702.6,513.7,708.8z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000033340281510986199830000008281613553833074339_" filterUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9" id="SVGID_00000001627693136309530380000005038419240191430017_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000033340281510986199830000008281613553833074339_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000029740027092449943370000000947863064556130704_" filterUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="490.5" y="701.2" width="23.9" height="23.9" id="SVGID_00000001627693136309530380000005038419240191430017_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000029740027092449943370000000947863064556130704_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000091725909028286921600000014190827676184908959_" cx="208.5387" cy="700.2279" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000001627693136309530380000005038419240191430017_);fill:url(#SVGID_00000091725909028286921600000014190827676184908959_);" d="
							M513.7,708.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C504.3,699.6,511.2,702.6,513.7,708.8z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000123402995954765102330000002518459407393276094_" cx="208.5387" cy="700.2279" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000123402995954765102330000002518459407393276094_);" d="M513.7,708.8
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C504.3,699.6,511.2,702.6,513.7,708.8z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000167382365628106980080000017959221168498284197_" filterUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9" id="SVGID_00000121995228740969749850000001321005018485526965_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000167382365628106980080000017959221168498284197_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000139258373353320533600000012015453126172105385_" filterUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9" id="SVGID_00000121995228740969749850000001321005018485526965_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000139258373353320533600000012015453126172105385_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000168799894165430110880000003770855531194025090_" cx="245.065" cy="722.346" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000121995228740969749850000001321005018485526965_);fill:url(#SVGID_00000168799894165430110880000003770855531194025090_);" d="
						M555.6,715.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C546.2,706.7,553.1,709.7,555.6,715.8z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000183232951076081073020000003171419266591052953_" filterUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9" id="SVGID_00000091718078808857550000000009172877280718573212_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000183232951076081073020000003171419266591052953_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000016755911126490286650000016809969719402199468_" filterUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="532.5" y="708.3" width="23.9" height="23.9" id="SVGID_00000091718078808857550000000009172877280718573212_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000016755911126490286650000016809969719402199468_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000106124358215191682310000001732132576541566908_" cx="245.065" cy="722.346" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000091718078808857550000000009172877280718573212_);fill:url(#SVGID_00000106124358215191682310000001732132576541566908_);" d="
							M555.6,715.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C546.2,706.7,553.1,709.7,555.6,715.8z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000135661877505140214020000005831162491450523270_" cx="245.065" cy="722.346" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000135661877505140214020000005831162491450523270_);" d="M555.6,715.8
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C546.2,706.7,553.1,709.7,555.6,715.8z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000011738600627173456260000010525295574468822152_" filterUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9" id="SVGID_00000041998730623942992710000006382719396816359316_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000011738600627173456260000010525295574468822152_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000017494025970753094650000005191527981265284493_" filterUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9" id="SVGID_00000041998730623942992710000006382719396816359316_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000017494025970753094650000005191527981265284493_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000127724266437624498320000017699076549230124210_" cx="232.4736" cy="715.0615" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000041998730623942992710000006382719396816359316_);fill:url(#SVGID_00000127724266437624498320000017699076549230124210_);" d="
						M541.2,713.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C531.8,704.6,538.8,707.6,541.2,713.7z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000018958803601111022070000012287246175412790699_" filterUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9" id="SVGID_00000118360733175149110730000007634056093371110537_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000018958803601111022070000012287246175412790699_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000161627310834231257710000000835496287110361515_" filterUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="518.1" y="706.1" width="23.9" height="23.9" id="SVGID_00000118360733175149110730000007634056093371110537_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000161627310834231257710000000835496287110361515_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000117667445717293158020000000373934385063148478_" cx="232.4736" cy="715.0615" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000118360733175149110730000007634056093371110537_);fill:url(#SVGID_00000117667445717293158020000000373934385063148478_);" d="
							M541.2,713.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C531.8,704.6,538.8,707.6,541.2,713.7z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000160889717842314207760000001154344832436891549_" cx="232.4736" cy="715.0615" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000160889717842314207760000001154344832436891549_);" d="M541.2,713.7
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C531.8,704.6,538.8,707.6,541.2,713.7z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000005259320072497396010000005555948338392898995_" filterUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9" id="SVGID_00000080894978294771285640000007792058424308792244_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000005259320072497396010000005555948338392898995_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000157281432058590148490000010537249045917944457_" filterUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9" id="SVGID_00000080894978294771285640000007792058424308792244_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000157281432058590148490000010537249045917944457_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000103234913070609413740000002995523713452989089_" cx="270.6283" cy="737.1466" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000080894978294771285640000007792058424308792244_);fill:url(#SVGID_00000103234913070609413740000002995523713452989089_);" d="
						M584.6,720.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C575.2,711,582.2,714,584.6,720.2z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000021819896751026435910000001541275707169475499_" filterUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9" id="SVGID_00000018225488256843000900000003610348806043501711_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000021819896751026435910000001541275707169475499_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000158738009979728260610000018107435358530358917_" filterUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="561.5" y="712.6" width="23.9" height="23.9" id="SVGID_00000018225488256843000900000003610348806043501711_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000158738009979728260610000018107435358530358917_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000046320145602626084570000007505571174506546564_" cx="270.6283" cy="737.1466" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000018225488256843000900000003610348806043501711_);fill:url(#SVGID_00000046320145602626084570000007505571174506546564_);" d="
							M584.6,720.2c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C575.2,711,582.2,714,584.6,720.2z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000173132673873865545050000008764218142820634558_" cx="270.6283" cy="737.1466" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000173132673873865545050000008764218142820634558_);" d="M584.6,720.2
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C575.2,711,582.2,714,584.6,720.2z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000123436268190509439630000014962041592297422251_" filterUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9" id="SVGID_00000026858342548123824030000008138105376772887430_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000123436268190509439630000014962041592297422251_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000142885645418883164050000006677233395694971839_" filterUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9" id="SVGID_00000026858342548123824030000008138105376772887430_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000142885645418883164050000006677233395694971839_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000043435420543094337730000014015006832940792717_" cx="258.037" cy="729.8621" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000026858342548123824030000008138105376772887430_);fill:url(#SVGID_00000043435420543094337730000014015006832940792717_);" d="
						M570.3,718c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C560.9,708.9,567.9,711.9,570.3,718z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000008115478342831364780000010896885558894398639_" filterUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9" id="SVGID_00000084525344799683720520000011504794089219866752_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000008115478342831364780000010896885558894398639_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000032611763805704392220000001875442912136823191_" filterUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="547.2" y="710.5" width="23.9" height="23.9" id="SVGID_00000084525344799683720520000011504794089219866752_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000032611763805704392220000001875442912136823191_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000001652635867768543020000004166977301491820201_" cx="258.037" cy="729.8621" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000084525344799683720520000011504794089219866752_);fill:url(#SVGID_00000001652635867768543020000004166977301491820201_);" d="
							M570.3,718c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C560.9,708.9,567.9,711.9,570.3,718z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000165220637732893134520000004631450819930636177_" cx="258.037" cy="729.8621" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000165220637732893134520000004631450819930636177_);" d="M570.3,718c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C560.9,708.9,567.9,711.9,570.3,718z"/>
			</g>
		</g>
	</g>
                    <g id="line02">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000047049274719329537830000016087552264869186698_" filterUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9" id="SVGID_00000028285773495473441770000005479370858856805559_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000047049274719329537830000016087552264869186698_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000170275736528016799430000007110488522080503205_" filterUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9" id="SVGID_00000028285773495473441770000005479370858856805559_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000170275736528016799430000007110488522080503205_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000159427432103828839160000018218814979025930428_" cx="233.6727" cy="-13.4389" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000028285773495473441770000005479370858856805559_);fill:url(#SVGID_00000159427432103828839160000018218814979025930428_);" d="
						M198.3,527.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C195.1,540.4,194.2,532.9,198.3,527.7z
						"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000091008086785207626470000013069526609686441356_" filterUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9" id="SVGID_00000132772606688342341340000018169734279120503956_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000091008086785207626470000013069526609686441356_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000157302491313706395650000013083699992353502340_" filterUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="195.7" y="523.1" width="23.9" height="23.9" id="SVGID_00000132772606688342341340000018169734279120503956_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000157302491313706395650000013083699992353502340_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000091005532232547943760000000581494146275167661_" cx="233.6727" cy="-13.4389" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000132772606688342341340000018169734279120503956_);fill:url(#SVGID_00000091005532232547943760000000581494146275167661_);" d="
							M198.3,527.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C195.1,540.4,194.2,532.9,198.3,527.7
							z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000009559371617071728760000000484910204571040159_" cx="233.6727" cy="-13.4389" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000009559371617071728760000000484910204571040159_);" d="M198.3,527.7c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C195.1,540.4,194.2,532.9,198.3,527.7z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000101788729525922418390000011765091719664234418_" filterUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9" id="SVGID_00000145743871953211331720000017449067575601797546_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000101788729525922418390000011765091719664234418_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000036963538783310736670000006870962298338102146_" filterUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9" id="SVGID_00000145743871953211331720000017449067575601797546_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000036963538783310736670000006870962298338102146_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000163769694048488148650000002768370255003239849_" cx="221.0813" cy="-20.7234" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000145743871953211331720000017449067575601797546_);fill:url(#SVGID_00000163769694048488148650000002768370255003239849_);" d="
						M203.7,541.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C200.5,553.9,199.6,546.3,203.7,541.1z
						"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000034807813256405524780000001443019459471152267_" filterUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9" id="SVGID_00000174580680790691017300000002785776198681829265_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000034807813256405524780000001443019459471152267_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000107576196687701410300000004628908093807408573_" filterUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="201.1" y="536.6" width="23.9" height="23.9" id="SVGID_00000174580680790691017300000002785776198681829265_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000107576196687701410300000004628908093807408573_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000004519512184402450160000013028070372195531687_" cx="221.0813" cy="-20.7234" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000174580680790691017300000002785776198681829265_);fill:url(#SVGID_00000004519512184402450160000013028070372195531687_);" d="
							M203.7,541.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C200.5,553.9,199.6,546.3,203.7,541.1
							z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000007421751458481219280000015234446737883772814_" cx="221.0813" cy="-20.7234" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000007421751458481219280000015234446737883772814_);" d="M203.7,541.1c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C200.5,553.9,199.6,546.3,203.7,541.1z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000027562505152667912930000008196951875180953265_" filterUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9" id="SVGID_00000099664135787166188530000009045984512384915898_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000027562505152667912930000008196951875180953265_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000089572739500864935120000008098057781966504113_" filterUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9" id="SVGID_00000099664135787166188530000009045984512384915898_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000089572739500864935120000008098057781966504113_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000152962333945559772540000011793010043355684494_" cx="308.9275" cy="30.1621" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000099664135787166188530000009045984512384915898_);fill:url(#SVGID_00000152962333945559772540000011793010043355684494_);" d="
						M166.3,447.2c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C163.1,460,162.2,452.4,166.3,447.2z"
                    />
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000024681372494598643620000007521789293952290195_" filterUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9" id="SVGID_00000049907506036203404850000011507679705199287441_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000024681372494598643620000007521789293952290195_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000183209951433525950570000009504185547021527717_" filterUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="163.8" y="442.7" width="23.9" height="23.9" id="SVGID_00000049907506036203404850000011507679705199287441_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000183209951433525950570000009504185547021527717_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000029739571539546587350000004889556242309914780_" cx="308.9275" cy="30.1621" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000049907506036203404850000011507679705199287441_);fill:url(#SVGID_00000029739571539546587350000004889556242309914780_);" d="
							M166.3,447.2c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C163.1,460,162.2,452.4,166.3,447.2z"
                        />
					</g>
				</mask>

                                <radialGradient id="SVGID_00000102532510322789911740000000021410086331434400_" cx="308.9275" cy="30.1621" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000102532510322789911740000000021410086331434400_);" d="M166.3,447.2c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C163.1,460,162.2,452.4,166.3,447.2z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000028290138958732496350000003358420101000551816_" filterUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9" id="SVGID_00000082331620906367446480000012163852687862122913_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000028290138958732496350000003358420101000551816_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000046297382362106868010000005320922826723884673_" filterUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9" id="SVGID_00000082331620906367446480000012163852687862122913_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000046297382362106868010000005320922826723884673_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000074400647395025294090000004416050661751073199_" cx="296.3361" cy="22.8777" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000082331620906367446480000012163852687862122913_);fill:url(#SVGID_00000074400647395025294090000004416050661751073199_);" d="
						M171.7,460.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C168.5,473.4,167.6,465.9,171.7,460.7z
						"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000085239594962111422880000005680835919734799491_" filterUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9" id="SVGID_00000071521273842698829170000000727262935169209490_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000085239594962111422880000005680835919734799491_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000148655023334841035590000015053951638533810088_" filterUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="169.1" y="456.1" width="23.9" height="23.9" id="SVGID_00000071521273842698829170000000727262935169209490_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000148655023334841035590000015053951638533810088_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000023990033640835102300000001442733659088211842_" cx="296.3361" cy="22.8777" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000071521273842698829170000000727262935169209490_);fill:url(#SVGID_00000023990033640835102300000001442733659088211842_);" d="
							M171.7,460.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C168.5,473.4,167.6,465.9,171.7,460.7
							z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000023978368244660916990000005983611246745089153_" cx="296.3361" cy="22.8777" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000023978368244660916990000005983611246745089153_);" d="M171.7,460.7c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C168.5,473.4,167.6,465.9,171.7,460.7z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000104674716287908366490000018296892736751061159_" filterUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9" id="SVGID_00000121993917193695847640000015420213647306762423_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000104674716287908366490000018296892736751061159_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000076590732317424708030000015945272503033603744_" filterUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9" id="SVGID_00000121993917193695847640000015420213647306762423_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000076590732317424708030000015945272503033603744_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000168077110669236971840000016060643520873191845_" cx="283.7446" cy="15.5932" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000121993917193695847640000015420213647306762423_);fill:url(#SVGID_00000168077110669236971840000016060643520873191845_);" d="
						M177,474.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C173.8,486.9,173,479.3,177,474.1z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000093140680468680185390000015668079286684307598_" filterUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9" id="SVGID_00000112597824745470219810000016149124972796967067_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000093140680468680185390000015668079286684307598_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000084526827372586994650000014341073905279680434_" filterUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="174.5" y="469.6" width="23.9" height="23.9" id="SVGID_00000112597824745470219810000016149124972796967067_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000084526827372586994650000014341073905279680434_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000008842167987449424140000006786294734745968533_" cx="283.7446" cy="15.5932" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000112597824745470219810000016149124972796967067_);fill:url(#SVGID_00000008842167987449424140000006786294734745968533_);" d="
							M177,474.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C173.8,486.9,173,479.3,177,474.1z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000102536617509008123660000000689831564740125606_" cx="283.7446" cy="15.5932" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000102536617509008123660000000689831564740125606_);" d="M177,474.1c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C173.8,486.9,173,479.3,177,474.1z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000049204468611205145620000010382437721507339916_" filterUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9" id="SVGID_00000056415073327428594080000000951843243255859357_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000049204468611205145620000010382437721507339916_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000169553859255187925130000010419278446344845748_" filterUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9" id="SVGID_00000056415073327428594080000000951843243255859357_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000169553859255187925130000010419278446344845748_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000115508756708386680060000005499902570483858324_" cx="271.1533" cy="8.3087" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000056415073327428594080000000951843243255859357_);fill:url(#SVGID_00000115508756708386680060000005499902570483858324_);" d="
						M182.4,487.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C179.2,500.3,178.3,492.8,182.4,487.6z
						"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000000920263188613315680000013533308345454224058_" filterUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9" id="SVGID_00000012452054322364599120000013453203001541741219_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000000920263188613315680000013533308345454224058_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000070097260285516727260000001137889662572731550_" filterUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="179.8" y="483" width="23.9" height="23.9" id="SVGID_00000012452054322364599120000013453203001541741219_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000070097260285516727260000001137889662572731550_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000084502883793648074090000016316142761957135762_" cx="271.1533" cy="8.3087" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000012452054322364599120000013453203001541741219_);fill:url(#SVGID_00000084502883793648074090000016316142761957135762_);" d="
							M182.4,487.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C179.2,500.3,178.3,492.8,182.4,487.6
							z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000131363166366621389970000005780293864487638971_" cx="271.1533" cy="8.3087" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000131363166366621389970000005780293864487638971_);" d="M182.4,487.6c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C179.2,500.3,178.3,492.8,182.4,487.6z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000003064082169406862050000017598874611441037186_" filterUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9" id="SVGID_00000156574176285314250650000002608931718118147968_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000003064082169406862050000017598874611441037186_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000116225495051298302180000003608520070341225911_" filterUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9" id="SVGID_00000156574176285314250650000002608931718118147968_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000116225495051298302180000003608520070341225911_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000113346109949459968500000012439546633736825773_" cx="258.5618" cy="1.0242" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000156574176285314250650000002608931718118147968_);fill:url(#SVGID_00000113346109949459968500000012439546633736825773_);" d="
						M187.8,501c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C184.6,513.8,183.7,506.2,187.8,501z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000158008956931387324720000010037125296265860007_" filterUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9" id="SVGID_00000105422544313780007700000000427404198208243356_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000158008956931387324720000010037125296265860007_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000020401040777360759110000006658790407744724667_" filterUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="185.2" y="496.5" width="23.9" height="23.9" id="SVGID_00000105422544313780007700000000427404198208243356_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000020401040777360759110000006658790407744724667_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000016046742751793133050000015965376888760489372_" cx="258.5618" cy="1.0242" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000105422544313780007700000000427404198208243356_);fill:url(#SVGID_00000016046742751793133050000015965376888760489372_);" d="
							M187.8,501c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C184.6,513.8,183.7,506.2,187.8,501z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000175310966738526971460000009413926381651442343_" cx="258.5618" cy="1.0242" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000175310966738526971460000009413926381651442343_);" d="M187.8,501c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C184.6,513.8,183.7,506.2,187.8,501z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000035521116012530511220000010003043503170070709_" filterUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9" id="SVGID_00000059288562421685431180000002912671800258054320_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000035521116012530511220000010003043503170070709_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000086669210191145995660000006085989177825741983_" filterUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9" id="SVGID_00000059288562421685431180000002912671800258054320_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000086669210191145995660000006085989177825741983_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000103233596273511124060000005761668604952752310_" cx="245.9704" cy="-6.2604" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000059288562421685431180000002912671800258054320_);fill:url(#SVGID_00000103233596273511124060000005761668604952752310_);" d="
						M193.1,514.5c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C189.9,527.2,189,519.7,193.1,514.5z"
                    />
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000129200758533029585400000002453611180390286728_" filterUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9" id="SVGID_00000110428965102435966350000004579515001239674800_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000129200758533029585400000002453611180390286728_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000163784169976655974550000004827114737742552997_" filterUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="190.5" y="509.9" width="23.9" height="23.9" id="SVGID_00000110428965102435966350000004579515001239674800_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000163784169976655974550000004827114737742552997_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000154399119335360301810000016075683299470067340_" cx="245.9704" cy="-6.2604" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000110428965102435966350000004579515001239674800_);fill:url(#SVGID_00000154399119335360301810000016075683299470067340_);" d="
							M193.1,514.5c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C189.9,527.2,189,519.7,193.1,514.5z"
                        />
					</g>
				</mask>

                                <radialGradient id="SVGID_00000088100463710905369910000014078550595760950946_" cx="245.9704" cy="-6.2604" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000088100463710905369910000014078550595760950946_);" d="M193.1,514.5c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C189.9,527.2,189,519.7,193.1,514.5z"/>
			</g>
		</g>
	</g>
                    <g id="line05">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000112609639019319010110000003190501829157714337_" filterUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9" id="SVGID_00000157271171143254530330000009940719862266713222_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000112609639019319010110000003190501829157714337_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000016766285434619796780000013714803445701742264_" filterUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9" id="SVGID_00000157271171143254530330000009940719862266713222_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000016766285434619796780000013714803445701742264_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000031167439089150515870000016230464428165096339_" cx="-269.6935" cy="536.1789" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000157271171143254530330000009940719862266713222_);fill:url(#SVGID_00000031167439089150515870000016230464428165096339_);" d="
						M930.3,408.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C927.1,420.8,926.2,413.3,930.3,408.1z
						"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000013884943179951461290000008791187905068575675_" filterUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9" id="SVGID_00000051341613427729590170000009460762232865784194_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000013884943179951461290000008791187905068575675_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000049909868579565092300000005193383279810798772_" filterUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="927.7" y="403.6" width="23.9" height="23.9" id="SVGID_00000051341613427729590170000009460762232865784194_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000049909868579565092300000005193383279810798772_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000176721957710612470930000013594599380386639234_" cx="-269.6935" cy="536.1789" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000051341613427729590170000009460762232865784194_);fill:url(#SVGID_00000176721957710612470930000013594599380386639234_);" d="
							M930.3,408.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C927.1,420.8,926.2,413.3,930.3,408.1
							z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000106129090964765652010000005704244220059409332_" cx="-269.6935" cy="536.1789" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000106129090964765652010000005704244220059409332_);" d="M930.3,408.1c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C927.1,420.8,926.2,413.3,930.3,408.1z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000005261505723231321850000013984022745990876047_" filterUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9" id="SVGID_00000054986984217417488190000011446903130300584587_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000005261505723231321850000013984022745990876047_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000030486367735502877520000009039681579733021110_" filterUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9" id="SVGID_00000054986984217417488190000011446903130300584587_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000030486367735502877520000009039681579733021110_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000092450111106880664890000005718349629545359275_" cx="-282.2848" cy="528.8944" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000054986984217417488190000011446903130300584587_);fill:url(#SVGID_00000092450111106880664890000005718349629545359275_);" d="
						M935.7,421.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C932.5,434.3,931.6,426.8,935.7,421.6z
						"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000091696240849276466240000006449094501108586382_" filterUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9" id="SVGID_00000062873883209277640610000010882574670925053612_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000091696240849276466240000006449094501108586382_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000133502905384938950910000017537218710781377664_" filterUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="933.1" y="417" width="23.9" height="23.9" id="SVGID_00000062873883209277640610000010882574670925053612_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000133502905384938950910000017537218710781377664_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000124142442723512863660000009492413549742916236_" cx="-282.2848" cy="528.8944" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000062873883209277640610000010882574670925053612_);fill:url(#SVGID_00000124142442723512863660000009492413549742916236_);" d="
							M935.7,421.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C932.5,434.3,931.6,426.8,935.7,421.6
							z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000087408141185432700590000012693790843564815763_" cx="-282.2848" cy="528.8944" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000087408141185432700590000012693790843564815763_);" d="M935.7,421.6c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C932.5,434.3,931.6,426.8,935.7,421.6z"/>
			</g>
            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000130647059057286124500000014867235479546692010_" filterUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9" id="SVGID_00000055686446008243065080000014153485159156886960_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000130647059057286124500000014867235479546692010_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000053527046846764178760000011291583728633142167_" filterUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9" id="SVGID_00000055686446008243065080000014153485159156886960_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000053527046846764178760000011291583728633142167_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000087397208808760112760000002017135235779360917_" cx="-295.2985" cy="521.0657" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000055686446008243065080000014153485159156886960_);fill:url(#SVGID_00000087397208808760112760000002017135235779360917_);" d="
						M941,435.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C937.8,448.4,936.9,440.9,941,435.7z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000116957133453042735440000006393445285934420633_" filterUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9" id="SVGID_00000037681822738042006440000001779116705756498050_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000116957133453042735440000006393445285934420633_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000110463008625276924950000008858430124439556799_" filterUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="938.5" y="431.1" width="23.9" height="23.9" id="SVGID_00000037681822738042006440000001779116705756498050_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000110463008625276924950000008858430124439556799_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000052804009475482405670000017037101704479642523_" cx="-295.2985" cy="521.0657" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000037681822738042006440000001779116705756498050_);fill:url(#SVGID_00000052804009475482405670000017037101704479642523_);" d="
							M941,435.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C937.8,448.4,936.9,440.9,941,435.7z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000114037494387437274360000004905928621856782009_" cx="-295.2985" cy="521.0657" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000114037494387437274360000004905928621856782009_);" d="M941,435.7c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C937.8,448.4,936.9,440.9,941,435.7z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000114786009917910575880000015854835165369646248_" filterUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9" id="SVGID_00000096042788515856461550000009788614303241671577_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000114786009917910575880000015854835165369646248_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000106122764838867791670000003563890873328713909_" filterUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9" id="SVGID_00000096042788515856461550000009788614303241671577_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000106122764838867791670000003563890873328713909_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000164495404975618161590000009283205015757412752_" cx="-194.4387" cy="579.78" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000096042788515856461550000009788614303241671577_);fill:url(#SVGID_00000164495404975618161590000009283205015757412752_);" d="
						M898.3,327.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C895.1,340.4,894.3,332.9,898.3,327.7z
						"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000082349501262429572370000009125885190543371169_" filterUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9" id="SVGID_00000078042022537622603500000006344257780150491267_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000082349501262429572370000009125885190543371169_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000000216951591280877520000005791579308294936193_" filterUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="895.8" y="323.1" width="23.9" height="23.9" id="SVGID_00000078042022537622603500000006344257780150491267_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000000216951591280877520000005791579308294936193_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000119080736597617411950000015889414259943967875_" cx="-194.4387" cy="579.78" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000078042022537622603500000006344257780150491267_);fill:url(#SVGID_00000119080736597617411950000015889414259943967875_);" d="
							M898.3,327.7c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C895.1,340.4,894.3,332.9,898.3,327.7
							z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000101814713136704755770000009854872870244838065_" cx="-194.4387" cy="579.78" r="12.0288" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000101814713136704755770000009854872870244838065_);" d="M898.3,327.7c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C895.1,340.4,894.3,332.9,898.3,327.7z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000154414545890251630710000016654673161083572101_" filterUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9" id="SVGID_00000088813270843744234580000015866713727523669412_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000154414545890251630710000016654673161083572101_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000135671828210134211940000010124841538190432178_" filterUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9" id="SVGID_00000088813270843744234580000015866713727523669412_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000135671828210134211940000010124841538190432178_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000021118761749290449170000003446891728383809448_" cx="-207.03" cy="572.4955" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000088813270843744234580000015866713727523669412_);fill:url(#SVGID_00000021118761749290449170000003446891728383809448_);" d="
						M903.7,341.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C900.5,353.9,899.6,346.3,903.7,341.1z
						"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000011753769101960406690000010301616419139488675_" filterUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9" id="SVGID_00000097491266939205569640000003298147275498415509_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000011753769101960406690000010301616419139488675_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000104665805178280912180000001125890903167677369_" filterUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="901.1" y="336.6" width="23.9" height="23.9" id="SVGID_00000097491266939205569640000003298147275498415509_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000104665805178280912180000001125890903167677369_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000050638643107005092890000017901516421903823535_" cx="-207.03" cy="572.4955" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000097491266939205569640000003298147275498415509_);fill:url(#SVGID_00000050638643107005092890000017901516421903823535_);" d="
							M903.7,341.1c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C900.5,353.9,899.6,346.3,903.7,341.1
							z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000170236164057468296660000010506514282366755002_" cx="-207.03" cy="572.4955" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000170236164057468296660000010506514282366755002_);" d="M903.7,341.1c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C900.5,353.9,899.6,346.3,903.7,341.1z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000011728733065543909700000005655553922363508657_" filterUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9" id="SVGID_00000102534794310596349580000001448599156386165637_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000011728733065543909700000005655553922363508657_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000004529749259777933190000000407359887536956578_" filterUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9" id="SVGID_00000102534794310596349580000001448599156386165637_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000004529749259777933190000000407359887536956578_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000156552339670240688060000016125467012524240282_" cx="-219.6215" cy="565.2111" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000102534794310596349580000001448599156386165637_);fill:url(#SVGID_00000156552339670240688060000016125467012524240282_);" d="
						M909.1,354.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C905.9,367.3,905,359.8,909.1,354.6z"
                    />
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000011026203842996324100000017848403057161233342_" filterUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9" id="SVGID_00000168839433052293667120000000557090076870101939_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000011026203842996324100000017848403057161233342_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000078745010583267283210000010089673559823858857_" filterUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="906.5" y="350" width="23.9" height="23.9" id="SVGID_00000168839433052293667120000000557090076870101939_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000078745010583267283210000010089673559823858857_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000178190104117523997330000005480783998933998748_" cx="-219.6215" cy="565.2111" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000168839433052293667120000000557090076870101939_);fill:url(#SVGID_00000178190104117523997330000005480783998933998748_);" d="
							M909.1,354.6c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C905.9,367.3,905,359.8,909.1,354.6z"
                        />
					</g>
				</mask>

                                <radialGradient id="SVGID_00000136384422705214157630000010454652006434301601_" cx="-219.6215" cy="565.2111" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000136384422705214157630000010454652006434301601_);" d="M909.1,354.6c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C905.9,367.3,905,359.8,909.1,354.6z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000049919571753098568770000013193477361120443577_" filterUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9" id="SVGID_00000152983669034261183020000003715068014934774681_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000049919571753098568770000013193477361120443577_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000031171598848090423920000006287251284790134665_" filterUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9" id="SVGID_00000152983669034261183020000003715068014934774681_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000031171598848090423920000006287251284790134665_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000124863973634529446780000004205079456970836376_" cx="-232.2129" cy="557.9265" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000152983669034261183020000003715068014934774681_);fill:url(#SVGID_00000124863973634529446780000004205079456970836376_);" d="
						M914.4,368c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8s-11.6,6.1-16.8,2C911.2,380.8,910.3,373.2,914.4,368z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000104672004609673536100000017808694108082546863_" filterUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9" id="SVGID_00000036955242358242064180000006376980178457002374_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000104672004609673536100000017808694108082546863_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000026140424997098889130000015357836771342695338_" filterUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="911.8" y="363.5" width="23.9" height="23.9" id="SVGID_00000036955242358242064180000006376980178457002374_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000026140424997098889130000015357836771342695338_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000058586730399179442370000015053211754101091256_" cx="-232.2129" cy="557.9265" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000036955242358242064180000006376980178457002374_);fill:url(#SVGID_00000058586730399179442370000015053211754101091256_);" d="
							M914.4,368c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8s-11.6,6.1-16.8,2C911.2,380.8,910.3,373.2,914.4,368z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000163793482349146124020000014730782920147388837_" cx="-232.2129" cy="557.9265" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000163793482349146124020000014730782920147388837_);" d="M914.4,368c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8s-11.6,6.1-16.8,2C911.2,380.8,910.3,373.2,914.4,368z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000166664949459993436490000007352850473585430703_" filterUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9" id="SVGID_00000098215358778307631280000007541425443772805027_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000166664949459993436490000007352850473585430703_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000075881993620309730120000006942412702294239872_" filterUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9" id="SVGID_00000098215358778307631280000007541425443772805027_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000075881993620309730120000006942412702294239872_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000157276353244731344940000014117622381099373441_" cx="-244.8044" cy="550.642" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000098215358778307631280000007541425443772805027_);fill:url(#SVGID_00000157276353244731344940000014117622381099373441_);" d="
						M919.8,381.5c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C916.6,394.2,915.7,386.7,919.8,381.5z
						"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000137103287779252503290000009868856366583520682_" filterUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9" id="SVGID_00000009583768648406692320000012866133455492919181_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000137103287779252503290000009868856366583520682_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000068679024989698907440000001694232139459658152_" filterUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="917.2" y="376.9" width="23.9" height="23.9" id="SVGID_00000009583768648406692320000012866133455492919181_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000068679024989698907440000001694232139459658152_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000063619778484071842960000002744563087339539084_" cx="-244.8044" cy="550.642" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000009583768648406692320000012866133455492919181_);fill:url(#SVGID_00000063619778484071842960000002744563087339539084_);" d="
							M919.8,381.5c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C916.6,394.2,915.7,386.7,919.8,381.5
							z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000060718996112547093460000013673489591171103886_" cx="-244.8044" cy="550.642" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000060718996112547093460000013673489591171103886_);" d="M919.8,381.5c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C916.6,394.2,915.7,386.7,919.8,381.5z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000065777566369855312040000003346318591330366363_" filterUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9" id="SVGID_00000158713795682368695520000007006428581386941080_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000065777566369855312040000003346318591330366363_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000014636278561272250760000017343119484213732228_" filterUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9" id="SVGID_00000158713795682368695520000007006428581386941080_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000014636278561272250760000017343119484213732228_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000133515358930574250510000000719166743506485669_" cx="-257.3958" cy="543.3574" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000158713795682368695520000007006428581386941080_);fill:url(#SVGID_00000133515358930574250510000000719166743506485669_);" d="
						M925.1,394.9c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C921.9,407.7,921,400.1,925.1,394.9z"
                    />
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000160889547378032343020000014045300787832434864_" filterUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9" id="SVGID_00000117645708785324772570000014072351070789129105_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000160889547378032343020000014045300787832434864_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000078017465336659552820000002907786514725482159_" filterUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="922.6" y="390.4" width="23.9" height="23.9" id="SVGID_00000117645708785324772570000014072351070789129105_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000078017465336659552820000002907786514725482159_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000178923913520381575250000018176470342797178804_" cx="-257.3958" cy="543.3574" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000117645708785324772570000014072351070789129105_);fill:url(#SVGID_00000178923913520381575250000018176470342797178804_);" d="
							M925.1,394.9c4.1-5.2,11.6-6.1,16.8-2c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C921.9,407.7,921,400.1,925.1,394.9z"
                        />
					</g>
				</mask>

                                <radialGradient id="SVGID_00000058581418459552604550000013008514985704832663_" cx="-257.3958" cy="543.3574" r="12.0287" gradientTransform="matrix(-0.7817 -0.616 0.616 -0.7817 398.636 668.5238)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000058581418459552604550000013008514985704832663_);" d="M925.1,394.9c4.1-5.2,11.6-6.1,16.8-2
					c5.2,4.1,6.1,11.6,2,16.8c-4.1,5.2-11.6,6.1-16.8,2C921.9,407.7,921,400.1,925.1,394.9z"/>
			</g>
		</g>
	</g>
                    <g id="line06">
		<g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000076581683448275063590000003393224582443050887_" filterUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

            <mask maskUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9" id="SVGID_00000024695095767320152160000014119945215058018967_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000076581683448275063590000003393224582443050887_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000101815773426973681050000011540211430566903734_" filterUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9" id="SVGID_00000024695095767320152160000014119945215058018967_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000101815773426973681050000011540211430566903734_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000053506978067117477890000005274462902909792699_" cx="378.8503" cy="268.266" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000024695095767320152160000014119945215058018967_);fill:url(#SVGID_00000053506978067117477890000005274462902909792699_);" d="
						M512.9,246.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C503.5,237.5,510.5,240.5,512.9,246.7z"/>
				</g>
			</mask>
            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000116235271611027142090000014426652595477948831_" filterUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                <mask maskUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9" id="SVGID_00000091720448274967103250000001366713662950594712_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000116235271611027142090000014426652595477948831_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000013887887826861320090000007582737728856214440_" filterUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="489.8" y="239.1" width="23.9" height="23.9" id="SVGID_00000091720448274967103250000001366713662950594712_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000013887887826861320090000007582737728856214440_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000109729370390203205910000000724397882230946222_" cx="378.8503" cy="268.266" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000091720448274967103250000001366713662950594712_);fill:url(#SVGID_00000109729370390203205910000000724397882230946222_);" d="
							M512.9,246.7c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C503.5,237.5,510.5,240.5,512.9,246.7z"/>
					</g>
				</mask>

                <radialGradient id="SVGID_00000077314600423027792560000017782075743145843594_" cx="378.8503" cy="268.266" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                <path style="fill:url(#SVGID_00000077314600423027792560000017782075743145843594_);" d="M512.9,246.7
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C503.5,237.5,510.5,240.5,512.9,246.7z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000102530012842019401370000008449882097855310526_" filterUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9" id="SVGID_00000153690936994489559380000009736646240479011253_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000102530012842019401370000008449882097855310526_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000152970948014134526600000003629940379243714959_" filterUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9" id="SVGID_00000153690936994489559380000009736646240479011253_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000152970948014134526600000003629940379243714959_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000060723657367048422070000006729071047661224871_" cx="367.3311" cy="259.6309" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000153690936994489559380000009736646240479011253_);fill:url(#SVGID_00000060723657367048422070000006729071047661224871_);" d="
						M499.1,242.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C489.7,233.7,496.7,236.7,499.1,242.9z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000024715432669398112800000008790931065671325595_" filterUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9" id="SVGID_00000133512202657911826480000014083920238036750980_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000024715432669398112800000008790931065671325595_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000062885511461590905390000010545797757273788606_" filterUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="476" y="235.3" width="23.9" height="23.9" id="SVGID_00000133512202657911826480000014083920238036750980_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000062885511461590905390000010545797757273788606_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000183240168692509001220000017516576674316109730_" cx="367.3311" cy="259.6309" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000133512202657911826480000014083920238036750980_);fill:url(#SVGID_00000183240168692509001220000017516576674316109730_);" d="
							M499.1,242.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C489.7,233.7,496.7,236.7,499.1,242.9z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000169534135690626954780000014103606953965034902_" cx="367.3311" cy="259.6309" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000169534135690626954780000014103606953965034902_);" d="M499.1,242.9
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C489.7,233.7,496.7,236.7,499.1,242.9z"/>
			</g>
		</g>
                        <g>
			<defs>

					<filter id="Adobe_OpacityMaskFilter_00000035494852412365047900000014473468579655097491_" filterUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9" id="SVGID_00000173880100699338253400000007853820088855065268_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000035494852412365047900000014473468579655097491_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000041277856057932950100000006330329851489026749_" filterUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9" id="SVGID_00000173880100699338253400000007853820088855065268_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000041277856057932950100000006330329851489026749_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000140002016606927976930000015052432450283070646_" cx="615.9534" cy="407.9806" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000173880100699338253400000007853820088855065268_);fill:url(#SVGID_00000140002016606927976930000015052432450283070646_);" d="
						M783.5,289c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C774.1,279.9,781.1,282.9,783.5,289z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000164500133887582233690000009991472890350384517_" filterUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9" id="SVGID_00000018219785344947184810000013102267271270779026_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000164500133887582233690000009991472890350384517_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000128449512328557791120000001689007779000901519_" filterUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="760.4" y="281.5" width="23.9" height="23.9" id="SVGID_00000018219785344947184810000013102267271270779026_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000128449512328557791120000001689007779000901519_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000173124521559277456360000017003371850230781860_" cx="615.9534" cy="407.9806" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000018219785344947184810000013102267271270779026_);fill:url(#SVGID_00000173124521559277456360000017003371850230781860_);" d="
							M783.5,289c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C774.1,279.9,781.1,282.9,783.5,289z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000168804781097436620620000009199191836278046599_" cx="615.9534" cy="407.9806" r="12.0288" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000168804781097436620620000009199191836278046599_);" d="M783.5,289c2.4,6.1-0.6,13.1-6.7,15.5
					c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C774.1,279.9,781.1,282.9,783.5,289z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000044880286714301505700000001280316602021255858_" filterUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9" id="SVGID_00000070084968531025839200000001478459349321613450_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000044880286714301505700000001280316602021255858_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000075864098309830045770000017037836953778054819_" filterUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9" id="SVGID_00000070084968531025839200000001478459349321613450_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000075864098309830045770000017037836953778054819_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000021106617073093216190000008755538565922390173_" cx="603.362" cy="400.6961" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000070084968531025839200000001478459349321613450_);fill:url(#SVGID_00000021106617073093216190000008755538565922390173_);" d="
						M769.2,286.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C759.8,277.8,766.8,280.8,769.2,286.9z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000090270676702322632270000003196764972935026831_" filterUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9" id="SVGID_00000111150781984458544220000001396496463825325728_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000090270676702322632270000003196764972935026831_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000001655528808724943560000010973905029644837537_" filterUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="746.1" y="279.4" width="23.9" height="23.9" id="SVGID_00000111150781984458544220000001396496463825325728_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000001655528808724943560000010973905029644837537_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000158742994742025185790000001171467395350452883_" cx="603.362" cy="400.6961" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000111150781984458544220000001396496463825325728_);fill:url(#SVGID_00000158742994742025185790000001171467395350452883_);" d="
							M769.2,286.9c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C759.8,277.8,766.8,280.8,769.2,286.9z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000148648552799538635550000015228073363486504358_" cx="603.362" cy="400.6961" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000148648552799538635550000015228073363486504358_);" d="M769.2,286.9
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C759.8,277.8,766.8,280.8,769.2,286.9z"/>
			</g>
                            <defs>

					<filter id="Adobe_OpacityMaskFilter_00000047775120181141004950000006685213323687561661_" filterUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9">
					<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>

                            <mask maskUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9" id="SVGID_00000014632677552480939350000001214650347056987286_">
				<g style="filter:url(#Adobe_OpacityMaskFilter_00000047775120181141004950000006685213323687561661_);">
					<defs>

							<filter id="Adobe_OpacityMaskFilter_00000085214118399143142230000013438150651589131453_" filterUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9">
							<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
						</filter>
					</defs>

                    <mask maskUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9" id="SVGID_00000014632677552480939350000001214650347056987286_">
						<g style="filter:url(#Adobe_OpacityMaskFilter_00000085214118399143142230000013438150651589131453_);">
						</g>
					</mask>

                    <radialGradient id="SVGID_00000150077735955893461190000010671137743121807520_" cx="590.0877" cy="393.1704" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
						<stop  offset="0" style="stop-color:#FFFFFF"/>
                        <stop  offset="0.1592" style="stop-color:#F0F0F0"/>
                        <stop  offset="1" style="stop-color:#000000"/>
					</radialGradient>

                    <path style="mask:url(#SVGID_00000014632677552480939350000001214650347056987286_);fill:url(#SVGID_00000150077735955893461190000010671137743121807520_);" d="
						M754.2,284.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
						C744.8,275.7,751.7,278.7,754.2,284.8z"/>
				</g>
			</mask>
                            <g>
				<defs>

						<filter id="Adobe_OpacityMaskFilter_00000119110968076409874760000010152726146342454460_" filterUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9">
						<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                            <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
					</filter>
				</defs>

                                <mask maskUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9" id="SVGID_00000050651443324672227020000002965644105525437057_">
					<g style="filter:url(#Adobe_OpacityMaskFilter_00000119110968076409874760000010152726146342454460_);">
						<defs>

								<filter id="Adobe_OpacityMaskFilter_00000090973078252986758360000006317785390798672037_" filterUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9">
								<feFlood  style="flood-color:white;flood-opacity:1" result="back"/>
                                    <feBlend  in="SourceGraphic" in2="back" mode="normal"/>
							</filter>
						</defs>

                        <mask maskUnits="userSpaceOnUse" x="731.1" y="277.3" width="23.9" height="23.9" id="SVGID_00000050651443324672227020000002965644105525437057_">
							<g style="filter:url(#Adobe_OpacityMaskFilter_00000090973078252986758360000006317785390798672037_);">
							</g>
						</mask>

                        <radialGradient id="SVGID_00000119802370685864759020000016676087145050162319_" cx="590.0877" cy="393.1704" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
							<stop  offset="0" style="stop-color:#FFFFFF"/>
                            <stop  offset="0.1592" style="stop-color:#FFFFFF"/>
                            <stop  offset="1" style="stop-color:#000000"/>
						</radialGradient>

                        <path style="mask:url(#SVGID_00000050651443324672227020000002965644105525437057_);fill:url(#SVGID_00000119802370685864759020000016676087145050162319_);" d="
							M754.2,284.8c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5
							C744.8,275.7,751.7,278.7,754.2,284.8z"/>
					</g>
				</mask>

                                <radialGradient id="SVGID_00000093161514511540640320000011025039351807310490_" cx="590.0877" cy="393.1704" r="12.0287" gradientTransform="matrix(0.9253 -0.3665 0.3665 0.9253 52.9541 141.6904)" gradientUnits="userSpaceOnUse">
					<stop  offset="0" style="stop-color:#FFFFFF"/>
                                    <stop  offset="0.1592" style="stop-color:#D21A00"/>
                                    <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
				</radialGradient>
                                <path style="fill:url(#SVGID_00000093161514511540640320000011025039351807310490_);" d="M754.2,284.8
					c2.4,6.1-0.6,13.1-6.7,15.5c-6.1,2.4-13.1-0.6-15.5-6.7c-2.4-6.1,0.6-13.1,6.7-15.5C744.8,275.7,751.7,278.7,754.2,284.8z"/>
			</g>
		</g>
	</g>
</g>
	</svg>
        </div>
        <JoinWithUs></JoinWithUs>
        <WithDrawal></WithDrawal>
        <YourPlayXRP></YourPlayXRP>
        <YourReferral></YourReferral>
        <PlanPDFVideo></PlanPDFVideo>
    </div><!-- // #ctWrap 닫음 -->
</template>
<style>
    .up-st0{fill:#FFFFFF;}
    .up-st1{fill:#EF5F4B;}
    .down-st0{fill:#FFFFFF;}
    .down-st1{fill:#223757;}
    .delete-st0{fill:#FFFFFF;}
    .delete-st1{fill:#223757;}
    .delete-st2{fill:#EF5F4B;}
    .man-st0{opacity:0.5;fill:#AFCAF2;}
    .man-st1{fill:#EDCBB9;}
    .man-st2{fill:#224289;}
    .man-st3{fill:#FFFFFF;}
    .man-st4{fill:#9ABCE5;}
    .man-st5{fill:none;stroke:#224289;stroke-width:1.6461;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .man-st6{fill:#2D71F0;}
    .man-st7{fill:#C2DBFF;stroke:#224289;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .man-st8{fill:none;stroke:#4844E3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .man-st9{fill:none;stroke:#B3B3B3;stroke-width:1.7424;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<style>
    .h1_color {
        color:#fff;
    }
</style>
<style>
    /*@import "/css/svg.css";*/
    @import "/css/ani.css";
</style>

<script>
import {eventBus} from "@/main.js";
import axios from 'axios'
import JoinWithUs from "./components/JoinWithUs";
import WithDrawal from "./components/WithDrawal";
import YourPlayXRP from "./components/YourPlayXRP";
import YourReferral from "./components/YourReferral";
import PlanPDFVideo from "./components/PlanPDFVideo";
export default {
    components: {
        JoinWithUs,
        WithDrawal,
        YourPlayXRP,
        YourReferral,
        PlanPDFVideo,
    },
    data: () =>{
        return {
            loginEmail: '',
            loginPassword: '',
            popup: {
                show: true,
            }
        }
    },
    created() {
        $("#app").addClass('main');
    },
    mounted() {
        $("#gnb").show();
    },
    computed: {
        popupShow: {
            get ()
            {
                // 2022/05/10 팝업내리기
                return false;
                /*
                if (this.$data.popup.show === false) {
                    return false;
                }
                const cookie = this.$cookies.get("closetoday");
                if (cookie) {
                    return false;
                } else {
                    return true;
                }*/
            },
            set (value) {
                const now = new Date();
                const end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),23,59,59);
                const nt = now.getTime();
                const et = end.getTime();
                const sec =parseInt((et - nt) / 1000);
                this.$cookies.set("closetoday", "1" , sec);
                const cookie = this.$cookies.get("closetoday");
                // 팝업을 닫아준다.
                this.$data.popup.show = false;
            }
        }
    },
    methods:{
        closePopup: function() {
            this.popup.show = false;
        },
        closeToday: function() {
            this.popupShow = false;
        },
        login:function(){
            if (!this.loginEmail) {
                alert("Please, Input login-id");
                return;
            }
            if (!this.loginPassword) {
                alert("Please, Input login-password");
                return;
            }
            axios.post("/auth/v1/signin", {
                email: this.loginEmail,
                password: this.loginPassword,
            }) // 아니면 스프링 부트 RESTful API에 POST 콜
                .then(response => {
                    console.log(response)
                    // 로그인 했으면 메인화면으로 전환하자..
                    this.$router.push('/');
                })
                .catch(error => {
                    console.log(error)
                    alert("Login Failed: The login-id or password are incorrect.");
                })
            /*
            this.$store
                .dispatch("login", {
                    email: this.loginEmail,
                    password: this.loginPassword,
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push({
                            name: "/profile",
                        })
                    }
                })
                .catch(({ message }) => alert(message))*/
        }
    }
};
</script>
<style>
    .normal-tb tbody tr:hover td, .table-hover tbody tr:hover th {
        background-color: #6aa7ff;
        color : #222;
    }
    .rowclick-tb tbody tr:hover td, .table-hover tbody tr:hover th {
        background-color: #6aa7ff;
        color : #222;
        cursor: pointer;
    }
</style>
